import { ɵɵinject, ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, ɵɵdefineComponent, ɵɵelementStart, ɵɵtext, ɵɵelementEnd, Component, ɵɵdirectiveInject, ɵɵlistener, ɵɵelement, Input, ɵɵgetCurrentView, ɵɵrestoreView, ɵɵnextContext, ɵɵproperty, ɵɵelementContainerStart, ɵɵtemplate, ɵɵelementContainerEnd, ɵɵadvance, ɵɵclassProp, ɵɵtextInterpolate1, ɵɵviewQuery, ɵɵqueryRefresh, ɵɵloadQuery, ViewChild, ɵɵsanitizeUrl, ɵɵtextInterpolate, ɵɵtextInterpolate2, ɵɵpipe, ɵɵpipeBind1, ɵɵpureFunction1, ɵɵtemplateRefExtractor, ɵɵreference, ɵɵpropertyInterpolate1, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule, EventEmitter, ElementRef, ChangeDetectorRef, Renderer2, ɵɵstaticViewQuery, ɵɵresolveWindow, ɵɵprojectionDef, ɵɵprojection, ɵɵclassMapInterpolate2, ɵɵstyleProp, ɵɵpureFunction5, ɵɵattribute, HostListener, ViewContainerRef, ComponentFactoryResolver, ApplicationRef, Injector, ɵɵdefineDirective, ɵɵresolveDocument, ɵɵNgOnChangesFeature, Directive, Output, ɵɵdefinePipe, Pipe, ɵɵelementContainer, ɵɵpipeBind2, ɵɵpipeBind3, ɵɵcontentQuery, TemplateRef, ɵɵProvidersFeature, forwardRef, ɵɵpureFunction2, ViewEncapsulation, ContentChild, ɵɵsanitizeHtml, ɵɵpropertyInterpolate, ɵɵpipeBind4, ɵɵsanitizeResourceUrl, ɵɵpureFunction0, NgZone, ɵɵpropertyInterpolate2 } from '@angular/core';
import { HttpClient, HttpHeaders, HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { NgIf, NgForOf, NgSwitch, NgSwitchCase, AsyncPipe, NgClass, CommonModule, NgTemplateOutlet, NgStyle, DatePipe } from '@angular/common';
import { RequiredValidator, NgControlStatus, NgModel, FormsModule, NG_VALUE_ACCESSOR, DefaultValueAccessor, ReactiveFormsModule, Validators, FormBuilder, ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, FormControlName } from '@angular/forms';
import { IonGrid, IonRow, IonCol, PopoverController, IonSlides, IonIcon, IonSlide, IonButton, AlertController, IonSkeletonText, IonInput, TextValueAccessor, IonicModule, IonCheckbox, BooleanValueAccessor, IonCard, IonCardContent, IonTextarea, MenuController, ModalController, NavParams, IonContent, IonLabel, NumericValueAccessor, IonItem, ActionSheetController, Platform, IonFab, IonSegment, SelectValueAccessor, IonSegmentButton, IonFabButton } from '@ionic/angular';
import { MessagesService, MessagesComponent, UtilLibModule, DateFormatPipe } from 'util-lib';
import { __awaiter } from 'tslib';
import { combineLatest, BehaviorSubject, fromEvent, Observable, of, throwError, from } from 'rxjs';
import { map, filter, debounceTime, first, tap, shareReplay, withLatestFrom, concatMap, catchError } from 'rxjs/operators';
import { NgAddToCalendarService } from '@trademe/ng-add-to-calendar';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthStoreService, AuthLibModule } from 'auth-lib';
import { Router, ActivatedRoute } from '@angular/router';
import { FeatureToggleLibModule } from 'feature-toggle-lib';
import { format, isWithinInterval, subMinutes, addMinutes, isAfter, isBefore as isBefore$1, isSameDay } from 'date-fns';
import { MapsAPILoader } from '@agm/core';
import { createAction, props, createFeatureSelector, createSelector, Store, select, createReducer, on, StoreModule, StoreFeatureModule } from '@ngrx/store';
import { CKEditorComponent, CKEditorModule } from 'ckeditor4-angular';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { ɵc, MbscModule, MbscEventcalendar } from '@mobiscroll/angular';
import { CloudinaryModule, Cloudinary as Cloudinary$1, CloudinaryImage } from '@cloudinary/angular-5.x';
import { createEffect, ofType, Actions, EffectsModule, EffectsFeatureModule } from '@ngrx/effects';
import { Cloudinary } from 'cloudinary-core';
import { TerraCohortsService } from 'data-model';
import isBefore from 'date-fns/isBefore';
import addHours from 'date-fns/addHours';
import format$1 from 'date-fns/format';
import isAfter$1 from 'date-fns/isAfter';
import { FileUploader, FileSelectDirective, FileUploadModule } from 'ng2-file-upload';
import { v4 } from 'uuid';
import addDays from 'date-fns/addDays';
import { AngularFireAuth } from '@angular/fire/auth';
import { combineLatest as combineLatest$1 } from 'rxjs/internal/observable/combineLatest';
import { throwError as throwError$1 } from 'rxjs/internal/observable/throwError';

class TerraUIService {
    constructor(http) {
        this.http = http;
        this.headers = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        };
        this.shareableLink = null;
    }
    getShareableLink(uID) {
        const url = "https://www.terra.do/referral?utm_medium=referral&utm_campaign=" + uID;
        return this.http.get("https://tinyurl.com/api-create.php?url=" + url, { responseType: 'text' });
    }
}
TerraUIService.ɵfac = function TerraUIService_Factory(t) { return new (t || TerraUIService)(ɵɵinject(HttpClient)); };
TerraUIService.ɵprov = ɵɵdefineInjectable({ token: TerraUIService, factory: TerraUIService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TerraUIService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: HttpClient }]; }, null); })();

class TerraUIComponent {
    constructor() { }
    ngOnInit() { }
}
TerraUIComponent.ɵfac = function TerraUIComponent_Factory(t) { return new (t || TerraUIComponent)(); };
TerraUIComponent.ɵcmp = ɵɵdefineComponent({ type: TerraUIComponent, selectors: [["terra-ui"]], decls: 2, vars: 0, template: function TerraUIComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "p");
        ɵɵtext(1, "terra-ui works!");
        ɵɵelementEnd();
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TerraUIComponent, [{
        type: Component,
        args: [{
                selector: 'terra-ui',
                template: ` <p>terra-ui works!</p> `,
                styles: [],
            }]
    }], function () { return []; }, null); })();

class AddToCalendarComponent {
    constructor(_addToCalendarService, _sanitizer, auth) {
        this._addToCalendarService = _addToCalendarService;
        this._sanitizer = _sanitizer;
        this.auth = auth;
    }
    ngOnInit() {
        // empty
    }
    logFire(type = '', newEvent) {
        combineLatest([this.auth.profileDetail$, this.auth.user$])
            .pipe(map(([profileDetail, userFire]) => {
            if (profileDetail != null && userFire != null) {
                this.auth.logAuthUserAction(Object.assign({ type: 'event_add_to_calender', shareto: type, event: -1 }, newEvent));
            }
        }))
            .subscribe();
    }
    addeventGotoUrl(service) {
        const newEvent = {
            // Event title
            title: this.eventDetails.summary,
            // Event start date
            start: new Date(this.eventDetails.startDateTime),
            // Event duration (IN MINUTES)
            duration: 120,
            // If an end time is set, this will take precedence over duration (optional)
            end: new Date(this.eventDetails.endDateTime),
            // Event Description (optional)
            description: this.eventDetails.description,
        };
        let getHrefFor = 0;
        switch (service) {
            case 'apple':
                getHrefFor = this._addToCalendarService.calendarType.iCalendar;
                break;
            case 'google':
                getHrefFor = this._addToCalendarService.calendarType.google;
                break;
            // case 'office365':
            // 	getHrefFor = this._addToCalendarService.calendarType.google;
            // 	break;
            case 'outlook':
                getHrefFor = this._addToCalendarService.calendarType.outlook;
                break;
            case 'outlookcom':
                getHrefFor = this._addToCalendarService.calendarType.outlookLive;
                break;
            case 'yahoo':
                getHrefFor = this._addToCalendarService.calendarType.yahoo;
                break;
            default:
                getHrefFor = 0;
                break;
        }
        this.logFire(service, newEvent);
        const URL = this._addToCalendarService.getHrefFor(getHrefFor, newEvent);
        const sanitizeUrl = this._sanitizer.bypassSecurityTrustUrl(URL);
        window.open(sanitizeUrl.changingThisBreaksApplicationSecurity, '_blank');
        // 	window.open(
        // 		`https://www.addevent.com/dir/?client=CLIENT&
        //   start=${this.eventDetails.startDateTime}&
        //   end=${this.eventDetails.endDateTime}&
        //   title=${this.eventDetails.summary}&
        //   service=${service}`,
        // 		'_blank',
        // 	);
    }
}
AddToCalendarComponent.ɵfac = function AddToCalendarComponent_Factory(t) { return new (t || AddToCalendarComponent)(ɵɵdirectiveInject(NgAddToCalendarService), ɵɵdirectiveInject(DomSanitizer), ɵɵdirectiveInject(AuthStoreService)); };
AddToCalendarComponent.ɵcmp = ɵɵdefineComponent({ type: AddToCalendarComponent, selectors: [["terra-add-to-calendar"]], inputs: { eventDetails: "eventDetails" }, decls: 37, vars: 0, consts: [["size", "12", 3, "click"], ["src", "/assets/calendar/apple.svg", 1, "hw24"], ["src", "/assets/calendar/google.svg", 1, "hw24"], ["src", "/assets/calendar/outlook.svg", 1, "hw24"], ["src", "/assets/calendar/outlookcom.svg", 1, "hw24"], ["src", "/assets/calendar/yahoo.svg", 1, "hw24"]], template: function AddToCalendarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "ion-grid");
        ɵɵelementStart(1, "ion-row");
        ɵɵelementStart(2, "ion-col", 0);
        ɵɵlistener("click", function AddToCalendarComponent_Template_ion_col_click_2_listener() { return ctx.addeventGotoUrl("apple"); });
        ɵɵelement(3, "img", 1);
        ɵɵelementStart(4, "span");
        ɵɵelementStart(5, "b");
        ɵɵtext(6, "Apple");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(7, "hr");
        ɵɵelementEnd();
        ɵɵelementStart(8, "ion-col", 0);
        ɵɵlistener("click", function AddToCalendarComponent_Template_ion_col_click_8_listener() { return ctx.addeventGotoUrl("google"); });
        ɵɵelement(9, "img", 2);
        ɵɵelementStart(10, "span");
        ɵɵelementStart(11, "b");
        ɵɵtext(12, "Google");
        ɵɵelementEnd();
        ɵɵelementStart(13, "em");
        ɵɵtext(14, " (online)");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(15, "hr");
        ɵɵelementEnd();
        ɵɵelementStart(16, "ion-col", 0);
        ɵɵlistener("click", function AddToCalendarComponent_Template_ion_col_click_16_listener() { return ctx.addeventGotoUrl("outlook"); });
        ɵɵelement(17, "img", 3);
        ɵɵelementStart(18, "span");
        ɵɵelementStart(19, "b");
        ɵɵtext(20, "Outlook");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(21, "hr");
        ɵɵelementEnd();
        ɵɵelementStart(22, "ion-col", 0);
        ɵɵlistener("click", function AddToCalendarComponent_Template_ion_col_click_22_listener() { return ctx.addeventGotoUrl("outlookcom"); });
        ɵɵelement(23, "img", 4);
        ɵɵelementStart(24, "span");
        ɵɵelementStart(25, "b");
        ɵɵtext(26, "Outlook.com");
        ɵɵelementEnd();
        ɵɵelementStart(27, "em");
        ɵɵtext(28, " (online)");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(29, "hr");
        ɵɵelementEnd();
        ɵɵelementStart(30, "ion-col", 0);
        ɵɵlistener("click", function AddToCalendarComponent_Template_ion_col_click_30_listener() { return ctx.addeventGotoUrl("yahoo"); });
        ɵɵelement(31, "img", 5);
        ɵɵelementStart(32, "span");
        ɵɵelementStart(33, "b");
        ɵɵtext(34, "Yahoo");
        ɵɵelementEnd();
        ɵɵelementStart(35, "em");
        ɵɵtext(36, " (online)");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } }, directives: [IonGrid, IonRow, IonCol], styles: [".hw24[_ngcontent-%COMP%]{height:24px;margin-right:10px;vertical-align:bottom;width:24px}hr[_ngcontent-%COMP%]{margin-left:15%;margin-top:5px;max-width:85%}*[_ngcontent-%COMP%]{cursor:pointer}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AddToCalendarComponent, [{
        type: Component,
        args: [{
                selector: 'terra-add-to-calendar',
                templateUrl: './add-to-calendar.component.html',
                styleUrls: ['./add-to-calendar.component.css'],
            }]
    }], function () { return [{ type: NgAddToCalendarService }, { type: DomSanitizer }, { type: AuthStoreService }]; }, { eventDetails: [{
            type: Input
        }] }); })();

class AddToCalendarService {
    constructor(popoverController) {
        this.popoverController = popoverController;
    }
    addToCalendar(ev, event) {
        return __awaiter(this, void 0, void 0, function* () {
            const popover = yield this.popoverController.create({
                component: AddToCalendarComponent,
                cssClass: 'my-custom-class',
                event: ev,
                componentProps: {
                    eventDetails: event,
                },
                translucent: true,
            });
            return yield popover.present();
        });
    }
}
AddToCalendarService.ɵfac = function AddToCalendarService_Factory(t) { return new (t || AddToCalendarService)(ɵɵinject(PopoverController)); };
AddToCalendarService.ɵprov = ɵɵdefineInjectable({ token: AddToCalendarService, factory: AddToCalendarService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AddToCalendarService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: PopoverController }]; }, null); })();

function BannerComponent_ion_grid_0_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 6);
    ɵɵlistener("click", function BannerComponent_ion_grid_0_button_1_Template_button_click_0_listener() { ɵɵrestoreView(_r5); const ctx_r4 = ɵɵnextContext(2); return ctx_r4.slides.slidePrev(); });
    ɵɵelement(1, "ion-icon", 7);
    ɵɵelementEnd();
} }
function BannerComponent_ion_grid_0_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 8);
    ɵɵlistener("click", function BannerComponent_ion_grid_0_button_2_Template_button_click_0_listener() { ɵɵrestoreView(_r7); const ctx_r6 = ɵɵnextContext(2); return ctx_r6.slides.slideNext(); });
    ɵɵelement(1, "ion-icon", 9);
    ɵɵelementEnd();
} }
function BannerComponent_ion_grid_0_ion_slide_4_img_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 24);
} }
function BannerComponent_ion_grid_0_ion_slide_4_img_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 25);
} }
function BannerComponent_ion_grid_0_ion_slide_4_img_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 26);
} }
function BannerComponent_ion_grid_0_ion_slide_4_img_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 26);
} }
function BannerComponent_ion_grid_0_ion_slide_4_img_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 27);
} }
function BannerComponent_ion_grid_0_ion_slide_4_img_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 28);
} }
function BannerComponent_ion_grid_0_ion_slide_4_img_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 29);
} }
function BannerComponent_ion_grid_0_ion_slide_4_img_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 30);
} }
function BannerComponent_ion_grid_0_ion_slide_4_img_11_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 31);
} }
function BannerComponent_ion_grid_0_ion_slide_4_ion_button_16_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-button", 32);
    ɵɵelementStart(1, "span");
    ɵɵtext(2, "Go");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const banners_r8 = ɵɵnextContext().$implicit;
    ɵɵproperty("href", banners_r8.announcementAction);
} }
function BannerComponent_ion_grid_0_ion_slide_4_ion_button_17_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-button", 33);
    ɵɵlistener("click", function BannerComponent_ion_grid_0_ion_slide_4_ion_button_17_Template_ion_button_click_0_listener() { ɵɵrestoreView(_r23); const banners_r8 = ɵɵnextContext().$implicit; const ctx_r21 = ɵɵnextContext(2); return ctx_r21.openProfile(banners_r8.announcementAction); });
    ɵɵelementStart(1, "span");
    ɵɵtext(2, "Set up profile");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function BannerComponent_ion_grid_0_ion_slide_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-slide");
    ɵɵelementStart(1, "div", 10);
    ɵɵelementContainerStart(2, 11);
    ɵɵtemplate(3, BannerComponent_ion_grid_0_ion_slide_4_img_3_Template, 1, 0, "img", 12);
    ɵɵtemplate(4, BannerComponent_ion_grid_0_ion_slide_4_img_4_Template, 1, 0, "img", 13);
    ɵɵtemplate(5, BannerComponent_ion_grid_0_ion_slide_4_img_5_Template, 1, 0, "img", 14);
    ɵɵtemplate(6, BannerComponent_ion_grid_0_ion_slide_4_img_6_Template, 1, 0, "img", 14);
    ɵɵtemplate(7, BannerComponent_ion_grid_0_ion_slide_4_img_7_Template, 1, 0, "img", 15);
    ɵɵtemplate(8, BannerComponent_ion_grid_0_ion_slide_4_img_8_Template, 1, 0, "img", 16);
    ɵɵtemplate(9, BannerComponent_ion_grid_0_ion_slide_4_img_9_Template, 1, 0, "img", 17);
    ɵɵtemplate(10, BannerComponent_ion_grid_0_ion_slide_4_img_10_Template, 1, 0, "img", 18);
    ɵɵtemplate(11, BannerComponent_ion_grid_0_ion_slide_4_img_11_Template, 1, 0, "img", 19);
    ɵɵelementContainerEnd();
    ɵɵelementStart(12, "div", 20);
    ɵɵtext(13);
    ɵɵelementEnd();
    ɵɵelementStart(14, "div", 21);
    ɵɵtext(15);
    ɵɵelementEnd();
    ɵɵtemplate(16, BannerComponent_ion_grid_0_ion_slide_4_ion_button_16_Template, 3, 1, "ion-button", 22);
    ɵɵtemplate(17, BannerComponent_ion_grid_0_ion_slide_4_ion_button_17_Template, 3, 0, "ion-button", 23);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const banners_r8 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵclassProp("mentorship", banners_r8.announcementType == "mentorship")("my-dashboard", banners_r8.announcementType == "my-dashboard")("survey", banners_r8.announcementType == "survey")("feedback", banners_r8.announcementType == "feedback")("s1_1", banners_r8.announcementType == "s1_1")("special_events", banners_r8.announcementType == null)("special_events1", banners_r8.announcementType == "special_events")("fireside_chats", banners_r8.announcementType == "fireside_chats")("setup_profile", banners_r8.announcementType == "setup_profile");
    ɵɵadvance(1);
    ɵɵproperty("ngSwitch", banners_r8.announcementType);
    ɵɵadvance(1);
    ɵɵproperty("ngSwitchCase", "mentorship");
    ɵɵadvance(1);
    ɵɵproperty("ngSwitchCase", "my-dashboard");
    ɵɵadvance(1);
    ɵɵproperty("ngSwitchCase", "survey");
    ɵɵadvance(1);
    ɵɵproperty("ngSwitchCase", "feedback");
    ɵɵadvance(1);
    ɵɵproperty("ngSwitchCase", "s1_1");
    ɵɵadvance(1);
    ɵɵproperty("ngSwitchCase", null);
    ɵɵadvance(1);
    ɵɵproperty("ngSwitchCase", "special_events");
    ɵɵadvance(1);
    ɵɵproperty("ngSwitchCase", "fireside_chats");
    ɵɵadvance(1);
    ɵɵproperty("ngSwitchCase", "setup_profile");
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", banners_r8.summary, " ");
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", banners_r8.description, " ");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", banners_r8.announcementAction && banners_r8.announcementType != "setup_profile");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", banners_r8.announcementAction && banners_r8.announcementType == "setup_profile");
} }
function BannerComponent_ion_grid_0_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-grid", 1);
    ɵɵtemplate(1, BannerComponent_ion_grid_0_button_1_Template, 2, 0, "button", 2);
    ɵɵtemplate(2, BannerComponent_ion_grid_0_button_2_Template, 2, 0, "button", 3);
    ɵɵelementStart(3, "ion-slides", 4);
    ɵɵlistener("ionSlideDidChange", function BannerComponent_ion_grid_0_Template_ion_slides_ionSlideDidChange_3_listener() { ɵɵrestoreView(_r25); const ctx_r24 = ɵɵnextContext(); return ctx_r24.slideChanged(); });
    ɵɵtemplate(4, BannerComponent_ion_grid_0_ion_slide_4_Template, 18, 32, "ion-slide", 5);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.isFirstSlide);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.isLastSlide);
    ɵɵadvance(2);
    ɵɵproperty("ngForOf", ctx_r0.banner);
} }
class BannerComponent {
    constructor(router) {
        this.router = router;
        this.banner = [];
        this.isFirstSlide = false;
        this.isLastSlide = false;
        this.slideOpts = {
            initialSlide: 1,
            speed: 400,
        };
        // empty
    }
    ngOnInit() {
        this.isLastSlide = this.banner.length > 1;
    }
    slideChanged() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isFirstSlide = !(yield this.slides.isBeginning());
            this.isLastSlide = this.banner.length > 1 && !(yield this.slides.isEnd());
        });
    }
    openProfile(profile) {
        this.router.navigate(['/people/me']);
    }
}
BannerComponent.ɵfac = function BannerComponent_Factory(t) { return new (t || BannerComponent)(ɵɵdirectiveInject(Router)); };
BannerComponent.ɵcmp = ɵɵdefineComponent({ type: BannerComponent, selectors: [["terra-banner"]], viewQuery: function BannerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(IonSlides, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.slides = _t.first);
    } }, inputs: { banner: "banner" }, decls: 1, vars: 1, consts: [["class", "ion-no-padding", 4, "ngIf"], [1, "ion-no-padding"], ["class", "slider-button left", 3, "click", 4, "ngIf"], ["class", "slider-button right", 3, "click", 4, "ngIf"], [3, "ionSlideDidChange"], [4, "ngFor", "ngForOf"], [1, "slider-button", "left", 3, "click"], ["name", "arrow-back-outline"], [1, "slider-button", "right", 3, "click"], ["name", "arrow-forward-outline"], [1, "slide", "banner-padding"], [3, "ngSwitch"], ["src", "/assets/announcements/MentorshipBanner.svg", 4, "ngSwitchCase"], ["src", "/assets/announcements/my-dashboard.svg", 4, "ngSwitchCase"], ["src", "/assets/announcements/Surveyorfeedback.svg", 4, "ngSwitchCase"], ["src", "/assets/announcements/11s.svg", 4, "ngSwitchCase"], ["src", "/assets/announcements/Specialevents.svg", 4, "ngSwitchCase"], ["src", "/assets/announcements/Specialevents.png", 4, "ngSwitchCase"], ["src", "/assets/announcements/Firesidechats.svg", 4, "ngSwitchCase"], ["src", "/assets/announcements/setup_profile.svg", 4, "ngSwitchCase"], [1, "title1"], [1, "title2"], ["class", "applynow btn-white-small", 3, "href", 4, "ngIf"], ["class", "applynow btn-white-small", 3, "click", 4, "ngIf"], ["src", "/assets/announcements/MentorshipBanner.svg"], ["src", "/assets/announcements/my-dashboard.svg"], ["src", "/assets/announcements/Surveyorfeedback.svg"], ["src", "/assets/announcements/11s.svg"], ["src", "/assets/announcements/Specialevents.svg"], ["src", "/assets/announcements/Specialevents.png"], ["src", "/assets/announcements/Firesidechats.svg"], ["src", "/assets/announcements/setup_profile.svg"], [1, "applynow", "btn-white-small", 3, "href"], [1, "applynow", "btn-white-small", 3, "click"]], template: function BannerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, BannerComponent_ion_grid_0_Template, 5, 3, "ion-grid", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", (ctx.banner == null ? null : ctx.banner.length) != 0);
    } }, directives: [NgIf, IonGrid, IonSlides, NgForOf, IonIcon, IonSlide, NgSwitch, NgSwitchCase, IonButton], styles: ["*[_ngcontent-%COMP%]{font-family:var(--ion-font-family-text);font-style:normal}ion-slide[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{min-height:196px;position:relative;width:100%}ion-slide[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{bottom:0;height:20vh;max-width:20vh;position:absolute;right:0}.title1[_ngcontent-%COMP%]{font-size:18px;font-weight:700;line-height:140%}.title1[_ngcontent-%COMP%], .title2[_ngcontent-%COMP%]{font-style:normal}.title2[_ngcontent-%COMP%]{-webkit-box-orient:vertical;-webkit-line-clamp:2;display:-webkit-box;font-size:16px;font-weight:400;line-height:150%;overflow:hidden;text-overflow:ellipsis;width:calc(100% - 22vh)}.slide[_ngcontent-%COMP%]{text-align:left}.applynow[_ngcontent-%COMP%], .slide[_ngcontent-%COMP%]{border-radius:4px}.applynow[_ngcontent-%COMP%]{--background:transparent;font-size:16px;letter-spacing:0;line-height:150%;margin:0}.fireside_chats[_ngcontent-%COMP%]{background:var(--ion-color-due)}.mentorship[_ngcontent-%COMP%], .my-dashboard[_ngcontent-%COMP%]{background:var(--ion-color-mentorship)}.feedback[_ngcontent-%COMP%], .survey[_ngcontent-%COMP%]{background:var(--ion-color-surveyFeedback)}.s1_1[_ngcontent-%COMP%]{background:var(--ion-color-s1_1)}.special_events[_ngcontent-%COMP%]{background:var(--ion-color-special_events)}.special_events1[_ngcontent-%COMP%]{background:var(--ion-color-special_events1)}.setup_profile[_ngcontent-%COMP%]{background:var(--ion-color-menu-selected-calendar);border:1px solid #adc8ec}.mentorship[_ngcontent-%COMP%], .my-dashboard[_ngcontent-%COMP%]   .s1_1[_ngcontent-%COMP%], .special_events[_ngcontent-%COMP%]{color:var(--ion-color-black-700)}.mentorship[_ngcontent-%COMP%]   .my-dashboard[_ngcontent-%COMP%]   .applynow[_ngcontent-%COMP%], .s1_1[_ngcontent-%COMP%]   .applynow[_ngcontent-%COMP%], .setup_profile[_ngcontent-%COMP%]   .applynow[_ngcontent-%COMP%], .special_events[_ngcontent-%COMP%]   .applynow[_ngcontent-%COMP%]{--border-color:var(--ion-color-black-600)!important;color:var(--ion-color-black-700)}.feedback[_ngcontent-%COMP%], .fireside_chats[_ngcontent-%COMP%], .survey[_ngcontent-%COMP%]{color:var(--ion-color-white-600)}.feedback[_ngcontent-%COMP%]   .applynow[_ngcontent-%COMP%], .fireside_chats[_ngcontent-%COMP%]   .applynow[_ngcontent-%COMP%], .survey[_ngcontent-%COMP%]   .applynow[_ngcontent-%COMP%]{--border-color:#fff!important;color:var(--ion-color-white-600)}.setup_profile[_ngcontent-%COMP%]   .title1[_ngcontent-%COMP%]{color:var(--ion-color-black-800)}.setup_profile[_ngcontent-%COMP%]   .title2[_ngcontent-%COMP%]{color:var(--ion-color-black-600)}.my-dashboard[_ngcontent-%COMP%]   .title1[_ngcontent-%COMP%]{color:var(--ion-color-black-800);font-family:Montserrat;font-size:20px;font-weight:700}ion-slides[_ngcontent-%COMP%]   .swiper-pagination-bullet[_ngcontent-%COMP%]{margin:0 6px}ion-grid[_ngcontent-%COMP%]{position:relative}.slider-button[_ngcontent-%COMP%]{background:transparent;font-size:24px;outline:none;position:absolute;top:50%;z-index:2}.slider-button.left[_ngcontent-%COMP%]{left:-20px}.slider-button.right[_ngcontent-%COMP%]{right:-20px}.slider-button[_ngcontent-%COMP%]   ion-icon[_ngcontent-%COMP%]{background:hsla(0,0%,100%,.82);border:.2px solid #d6d6d6;border-radius:100%;color:#797979}@media (min-width:1366px){.banner-padding[_ngcontent-%COMP%]{padding:30px 20px}.title1[_ngcontent-%COMP%], .title2[_ngcontent-%COMP%]{margin-bottom:12px}ion-slide[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:100%}.slider-button[_ngcontent-%COMP%]{display:block}}@media (min-width:576px) and (max-width:1365.98px){.banner-padding[_ngcontent-%COMP%]{padding:30px 20px}.title1[_ngcontent-%COMP%], .title2[_ngcontent-%COMP%]{margin-bottom:12px}}@media (max-width:575.98px){.banner-padding[_ngcontent-%COMP%]{padding:20px}.title1[_ngcontent-%COMP%], .title2[_ngcontent-%COMP%]{margin-bottom:8px}.title1[_ngcontent-%COMP%]{font-size:16px}.title2[_ngcontent-%COMP%]{width:calc(100% - 10vh)}ion-slide[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:10vh}}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(BannerComponent, [{
        type: Component,
        args: [{
                selector: 'terra-banner',
                templateUrl: './banner.component.html',
                styleUrls: ['./banner.component.css'],
            }]
    }], function () { return [{ type: Router }]; }, { banner: [{
            type: Input
        }], slides: [{
            type: ViewChild,
            args: [IonSlides]
        }] }); })();

function FooterComponent_ion_col_28_ion_col_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-col", 1);
    ɵɵelementStart(1, "a", 23);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const link_r3 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("href", link_r3.link, ɵɵsanitizeUrl)("target", (link_r3 == null ? null : link_r3.target) ? link_r3.target : "_blank");
    ɵɵadvance(1);
    ɵɵtextInterpolate(link_r3.subTitle);
} }
function FooterComponent_ion_col_28_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-col", 20);
    ɵɵelementStart(1, "ion-grid", 21);
    ɵɵelementStart(2, "ion-row");
    ɵɵtemplate(3, FooterComponent_ion_col_28_ion_col_3_Template, 3, 3, "ion-col", 22);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const links_r1 = ctx.$implicit;
    ɵɵadvance(3);
    ɵɵproperty("ngForOf", links_r1.link);
} }
class FooterComponent {
    constructor() {
        this.footerLinks = [
            {
                link: [
                    { subTitle: 'Home', link: '/#/home', target: '_self' },
                    { subTitle: 'About us', link: 'https://www.terra.do/about-and-team' },
                    { subTitle: 'Contact us', link: 'https://www.terra.do/contact' },
                    // {
                    // 	subTitle: 'Events',
                    // 	link: 'https://www.terra.do/climate-jobs-fair/organisations',
                    // },
                    { subTitle: 'Blog', link: 'https://blog.terra.do/' },
                ],
            },
            // {
            // 	link: [
            // 		// {
            // 		// 	subTitle: 'Climate career fair',
            // 		// 	link: 'https://www.terra.do/climate-jobs-fair/professionals',
            // 		// },
            // 		// {
            // 		// 	subTitle: 'Create with Terra',
            // 		// 	link: 'https://www.terra.do/create-climate-courses',
            // 		// },
            // 		// { subTitle: 'Testimonials', link: 'https://www.terra.do/testimonials' },
            // 		// {
            // 		// 	subTitle: 'Mentors',
            // 		// 	link:
            // 		// 		'https://www.terra.do/climate-change-learning-for-action?#mentorship',
            // 		// },
            // 		// {
            // 		// 	subTitle: 'Fellows',
            // 		// 	link:
            // 		// 		'https://www.terra.do/climate-change-learning-for-action?#testimonials',
            // 		// },
            // 	],
            // },
            {
                link: [
                    {
                        subTitle: 'Climate Change: Learning for Action',
                        link: 'https://www.terra.do/climate-change-learning-for-action',
                    },
                    {
                        subTitle: 'Climate career fair',
                        link: 'https://www.terra.do/climate-jobs-fair/professionals',
                    },
                    // {
                    // 	subTitle: 'Take our quiz',
                    // 	link:
                    // 		'https://www.terra.do/climate-change-learning-for-action#belfortTypeform',
                    // },
                    {
                        subTitle: 'Terms and Conditions',
                        link: 'https://www.terra.do/terms/',
                    },
                    {
                        subTitle: 'Privacy Policy',
                        link: 'https://www.terra.do/privacy/',
                    },
                ],
            },
        ];
        /** empty */
    }
    ngOnInit() {
        /** empty */
    }
    goToWebsite() {
        window.open('https://www.terra.do', '_blank');
    }
}
FooterComponent.ɵfac = function FooterComponent_Factory(t) { return new (t || FooterComponent)(); };
FooterComponent.ɵcmp = ɵɵdefineComponent({ type: FooterComponent, selectors: [["terra-footer"]], decls: 29, vars: 1, consts: [[1, "footer", "white", "lp132"], ["size", "12"], [1, "max-width"], [1, "first"], ["src", "./assets/icon/terra.png", "alt", "", 1, "main-img", "cursor", 3, "click"], [1, "copyright"], [1, "fw800"], [1, "sharing-img", "secound"], ["href", "https://www.linkedin.com/school/terra-do/?viewAsMember=true", "target", "_blank", 1, "link"], ["src", "./assets/icon/linked.svg", "alt", "", 1, "w40"], ["href", "https://twitter.com/terradotdo", "target", "_blank", 1, "link"], ["src", "./assets/icon/twitter.svg", "alt", "", 1, "w40"], ["href", "https://www.instagram.com/terra_dot_do/?hl=en", "target", "_blank", 1, "link"], ["src", "./assets/icon/insta.svg", "alt", "", 1, "w40"], ["href", "https://www.youtube.com/channel/UCIBMgwRV7HV551kZqTqA49Q", "target", "_blank", 1, "link"], ["src", "./assets/icon/youtube.svg", "alt", "", 1, "w40"], ["href", "https://www.facebook.com/terradotdo/", "target", "_blank", 1, "link"], ["src", "./assets/icon/facebook.svg", "alt", "", 1, "w40"], [1, "gray", "lp132", "pb60"], ["class", "po", "size-sm", "12", "size-xs", "12", "size-md", "6", "size-lg", "3", 4, "ngFor", "ngForOf"], ["size-sm", "12", "size-xs", "12", "size-md", "6", "size-lg", "3", 1, "po"], [1, "po"], ["size", "12", 4, "ngFor", "ngForOf"], [1, "link", 3, "href", "target"]], template: function FooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "ion-grid", 0);
        ɵɵelementStart(1, "ion-row");
        ɵɵelementStart(2, "ion-col", 1);
        ɵɵelementStart(3, "ion-grid", 2);
        ɵɵelementStart(4, "ion-row");
        ɵɵelementStart(5, "ion-col", 3);
        ɵɵelementStart(6, "img", 4);
        ɵɵlistener("click", function FooterComponent_Template_img_click_6_listener() { return ctx.goToWebsite(); });
        ɵɵelementEnd();
        ɵɵelementStart(7, "span", 5);
        ɵɵelementStart(8, "span", 6);
        ɵɵtext(9, "\u00A9 2021 Terra.do");
        ɵɵelementEnd();
        ɵɵelementStart(10, "span");
        ɵɵtext(11, "All rights reserved");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(12, "ion-col", 7);
        ɵɵelementStart(13, "a", 8);
        ɵɵelement(14, "img", 9);
        ɵɵelementEnd();
        ɵɵelementStart(15, "a", 10);
        ɵɵelement(16, "img", 11);
        ɵɵelementEnd();
        ɵɵelementStart(17, "a", 12);
        ɵɵelement(18, "img", 13);
        ɵɵelementEnd();
        ɵɵelementStart(19, "a", 14);
        ɵɵelement(20, "img", 15);
        ɵɵelementEnd();
        ɵɵelementStart(21, "a", 16);
        ɵɵelement(22, "img", 17);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(23, "ion-grid", 18);
        ɵɵelementStart(24, "ion-row");
        ɵɵelementStart(25, "ion-col", 1);
        ɵɵelementStart(26, "ion-grid", 2);
        ɵɵelementStart(27, "ion-row");
        ɵɵtemplate(28, FooterComponent_ion_col_28_Template, 4, 1, "ion-col", 19);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(28);
        ɵɵproperty("ngForOf", ctx.footerLinks);
    } }, directives: [IonGrid, IonRow, IonCol, NgForOf], styles: [".footer[_ngcontent-%COMP%]{border-top:2px solid #eee!important;color:var(--ion-color-414141);font-family:var(--ion-font-family-text);font-size:16px;margin:0}.po[_ngcontent-%COMP%]{padding:0}.cursor[_ngcontent-%COMP%]{cursor:pointer}.main-img[_ngcontent-%COMP%]{height:30px;margin-right:10px}.footer[_ngcontent-%COMP%]   .sharing-img[_ngcontent-%COMP%]{display:flex}.footer[_ngcontent-%COMP%]   .sharing-img[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:30px;margin-right:20px;width:30px}.copyright[_ngcontent-%COMP%]{color:var(--ion-color-black-600);position:absolute;top:12px}.pr10[_ngcontent-%COMP%]{font-family:var(--ion-font-family-text);padding-right:10px}.link[_ngcontent-%COMP%]{color:var(--ion-color-black-600);text-decoration:none}.white[_ngcontent-%COMP%]{background:var(--ion-color-white-600)}.gray[_ngcontent-%COMP%]{background:var(--ion-color-footer-bottom)}.fw800[_ngcontent-%COMP%]{font-weight:800;padding-right:2px}.max-width[_ngcontent-%COMP%]{margin:auto;max-width:1366px}.link[_ngcontent-%COMP%]{font-family:var(--ion-font-family-text)}.pb60[_ngcontent-%COMP%]{padding-bottom:60px}@media (min-width:1366px){.first[_ngcontent-%COMP%], .secound[_ngcontent-%COMP%]{flex:0 0 calc(6/var(--ion-grid-columns, 12)*100%);max-width:calc(6/var(--ion-grid-columns, 12)*100%);width:calc(6/var(--ion-grid-columns, 12)*100%)}.lp132[_ngcontent-%COMP%]{padding-left:132px}}@media (min-width:576px) and (max-width:1365.98px){.first[_ngcontent-%COMP%]{flex:0 0 calc(8/var(--ion-grid-columns, 12)*100%);max-width:calc(8/var(--ion-grid-columns, 12)*100%);width:calc(8/var(--ion-grid-columns, 12)*100%)}.secound[_ngcontent-%COMP%]{flex:0 0 calc(4/var(--ion-grid-columns, 12)*100%);max-width:calc(4/var(--ion-grid-columns, 12)*100%);width:calc(4/var(--ion-grid-columns, 12)*100%)}}@media (max-width:575.98px){.first[_ngcontent-%COMP%], .secound[_ngcontent-%COMP%]{flex:0 0 calc(12/var(--ion-grid-columns, 12)*100%);max-width:calc(12/var(--ion-grid-columns, 12)*100%);width:calc(12/var(--ion-grid-columns, 12)*100%)}.main-img[_ngcontent-%COMP%]{height:20px;margin-right:22px}.footer[_ngcontent-%COMP%]   .sharing-img[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:40px;margin-right:30px;margin-top:10px;width:40px}.copyright[_ngcontent-%COMP%]{font-size:14px;position:absolute;top:5px}}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FooterComponent, [{
        type: Component,
        args: [{
                selector: 'terra-footer',
                templateUrl: './footer.component.html',
                styleUrls: ['./footer.component.css'],
            }]
    }], function () { return []; }, null); })();

class MenuUIService {
    constructor() {
        this.mobileMenu = new BehaviorSubject(null);
        this.mobileMenu$ = this.mobileMenu.asObservable();
        this.headerPopup = new BehaviorSubject(null);
        this.headerPopup$ = this.headerPopup.asObservable();
        /** empty */
    }
    openMenu() {
        this.mobileMenu.next(true);
    }
    closeMenu() {
        this.mobileMenu.next(false);
    }
    closePopupMenu() {
        this.mobileMenu.next(true);
    }
}
MenuUIService.ɵfac = function MenuUIService_Factory(t) { return new (t || MenuUIService)(); };
MenuUIService.ɵprov = ɵɵdefineInjectable({ token: MenuUIService, factory: MenuUIService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MenuUIService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return []; }, null); })();

function HeaderPopupComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 5);
    ɵɵelementStart(1, "div", 6);
    ɵɵelement(2, "img", 7);
    ɵɵelementEnd();
    ɵɵelementStart(3, "div", 8);
    ɵɵlistener("click", function HeaderPopupComponent_div_0_div_1_Template_div_click_3_listener() { ɵɵrestoreView(_r6); const profileDetail_r4 = ctx.ngIf; const ctx_r5 = ɵɵnextContext(2); return ctx_r5.openProfile(profileDetail_r4); });
    ɵɵtext(4);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const profileDetail_r4 = ctx.ngIf;
    ɵɵadvance(2);
    ɵɵproperty("src", profileDetail_r4.multimedia, ɵɵsanitizeUrl);
    ɵɵadvance(2);
    ɵɵtextInterpolate2(" ", profileDetail_r4.firstName, " ", profileDetail_r4.lastName, " ");
} }
function HeaderPopupComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 9);
    ɵɵelementStart(1, "div", 10);
    ɵɵlistener("click", function HeaderPopupComponent_div_0_div_3_Template_div_click_1_listener() { ɵɵrestoreView(_r9); const user_r7 = ctx.ngIf; const ctx_r8 = ɵɵnextContext(2); return ctx_r8.confirmChangePassword(user_r7.email); });
    ɵɵtext(2, " Change Password ");
    ɵɵelementEnd();
    ɵɵelementStart(3, "div", 11);
    ɵɵlistener("click", function HeaderPopupComponent_div_0_div_3_Template_div_click_3_listener() { ɵɵrestoreView(_r9); const ctx_r10 = ɵɵnextContext(2); return ctx_r10.signOut(); });
    ɵɵtext(4, "Sign out");
    ɵɵelementEnd();
    ɵɵelementStart(5, "div", 12);
    ɵɵtext(6);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const user_r7 = ctx.ngIf;
    ɵɵadvance(6);
    ɵɵtextInterpolate1("You\u2019re signed in as ", user_r7.email, "");
} }
function HeaderPopupComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 2);
    ɵɵtemplate(1, HeaderPopupComponent_div_0_div_1_Template, 5, 3, "div", 3);
    ɵɵpipe(2, "async");
    ɵɵtemplate(3, HeaderPopupComponent_div_0_div_3_Template, 7, 1, "div", 4);
    ɵɵpipe(4, "async");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ɵɵpipeBind1(2, 2, ctx_r0.auth.profileDetail$));
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ɵɵpipeBind1(4, 4, ctx_r0.auth.user$));
} }
function HeaderPopupComponent_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 15);
    ɵɵlistener("click", function HeaderPopupComponent_div_1_div_1_Template_div_click_0_listener() { ɵɵrestoreView(_r14); const link_r12 = ctx.$implicit; const ctx_r13 = ɵɵnextContext(2); return ctx_r13.goTo(link_r12.link); });
    ɵɵelementStart(1, "ion-row");
    ɵɵelementStart(2, "ion-col", 16);
    ɵɵelement(3, "img", 17);
    ɵɵelementStart(4, "div", 18);
    ɵɵtext(5);
    ɵɵelementEnd();
    ɵɵelementStart(6, "div", 19);
    ɵɵtext(7);
    ɵɵelementEnd();
    ɵɵelement(8, "ion-icon", 20);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const link_r12 = ctx.$implicit;
    ɵɵadvance(3);
    ɵɵproperty("src", link_r12 == null ? null : link_r12.img, ɵɵsanitizeUrl);
    ɵɵadvance(2);
    ɵɵtextInterpolate(link_r12.subTitle);
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", link_r12.desc, " ");
} }
function HeaderPopupComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 13);
    ɵɵtemplate(1, HeaderPopupComponent_div_1_div_1_Template, 9, 3, "div", 14);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r1.type.links);
} }
class HeaderPopupComponent {
    constructor(popoverController, auth, messages, router, menuUi, alertCtrl) {
        this.popoverController = popoverController;
        this.auth = auth;
        this.messages = messages;
        this.router = router;
        this.menuUi = menuUi;
        this.alertCtrl = alertCtrl;
        this.menuUi.headerPopup$.subscribe(bool => {
            this.close({});
        });
        /* empty */
    }
    ngOnInit() {
        /* empty */
    }
    signOut() {
        this.popoverController.dismiss().then(bool => {
            this.messages.showErrors('Signing you out..');
            this.menuUi.closePopupMenu();
            this.auth.logout();
        });
    }
    close(ev) {
        return __awaiter(this, void 0, void 0, function* () {
            this.popoverController.dismiss();
        });
    }
    openProfile(profile) {
        // window.open('/#/people/' + profile.id);
        let url = this.router.serializeUrl(this.router.createUrlTree([`/people/me`]));
        url = '/#' + url;
        // window.open(url, '_blank');
        this.router.navigate(['/people/me']);
        this.popoverController.dismiss();
    }
    goTo(link) {
        window.open(link, '_blank');
    }
    confirmChangePassword(email) {
        return __awaiter(this, void 0, void 0, function* () {
            const alert = yield this.alertCtrl.create({
                header: 'Change Password',
                message: 'We will email a link to <b>' + email + '</b> to reset your password.',
                cssClass: 'alertModal',
                buttons: [
                    {
                        text: 'Cancel',
                        role: 'cancel',
                    },
                    {
                        text: 'Email Link',
                        handler: () => {
                            this.changePassword();
                        },
                    },
                ],
            });
            yield alert.present();
        });
    }
    changePassword() {
        return __awaiter(this, void 0, void 0, function* () {
            this.auth.user$.subscribe(user => {
                if (!!user) {
                    // const resetPass$ = this.auth.resetPassword(user.email);
                    this.auth.resetPassword(user.email).subscribe(() => {
                        const confirmMessage = 'We have sent a link to ' +
                            user.email +
                            ' to change your password.';
                        this.messages.showErrors(confirmMessage);
                    }, err => {
                        this.messages.showErrors(err === null || err === void 0 ? void 0 : err.message);
                    });
                }
            });
            this.popoverController.dismiss();
        });
    }
}
HeaderPopupComponent.ɵfac = function HeaderPopupComponent_Factory(t) { return new (t || HeaderPopupComponent)(ɵɵdirectiveInject(PopoverController), ɵɵdirectiveInject(AuthStoreService), ɵɵdirectiveInject(MessagesService), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(MenuUIService), ɵɵdirectiveInject(AlertController)); };
HeaderPopupComponent.ɵcmp = ɵɵdefineComponent({ type: HeaderPopupComponent, selectors: [["terra-header-popup"]], inputs: { email: "email", type: "type" }, decls: 2, vars: 2, consts: [["class", "profile", 4, "ngIf"], ["class", "popup-menu", 4, "ngIf"], [1, "profile"], ["class", "profile-main", 4, "ngIf"], ["class", "profile-sub", 4, "ngIf"], [1, "profile-main"], [1, "profile-image"], ["onerror", "this.onerror=null;this.src='/assets/default-user.png';", 3, "src"], [1, "profile-name", 3, "click"], [1, "profile-sub"], [1, "change-password", 3, "click"], [1, "sign-out", 3, "click"], [1, "signed-in"], [1, "popup-menu"], ["class", "sub-menu-title", 3, "click", 4, "ngFor", "ngForOf"], [1, "sub-menu-title", 3, "click"], ["size", "12"], [1, "image-set", 3, "src"], [1, "title"], [1, "desc"], ["name", "arrow-forward-outline", 1, "forward-icon"]], template: function HeaderPopupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, HeaderPopupComponent_div_0_Template, 5, 6, "div", 0);
        ɵɵtemplate(1, HeaderPopupComponent_div_1_Template, 2, 1, "div", 1);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.type == "account");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.type != "account");
    } }, directives: [NgIf, NgForOf, IonRow, IonCol, IonIcon], pipes: [AsyncPipe], styles: [".cursor[_ngcontent-%COMP%]{cursor:pointer}ion-col[_ngcontent-%COMP%]{padding:0}.image-set[_ngcontent-%COMP%]{font-size:18px;position:absolute;top:30%}ion-row[_ngcontent-%COMP%]:hover{background-color:#f0f6ff}.pb10[_ngcontent-%COMP%]{padding-bottom:10px}.pt10[_ngcontent-%COMP%]{padding-top:10px}.title[_ngcontent-%COMP%]{color:#3b3b3b;font-size:16px}.desc[_ngcontent-%COMP%], .title[_ngcontent-%COMP%]{font-family:Lato,sans-serif;font-weight:400;line-height:16px;margin-left:35px}.desc[_ngcontent-%COMP%]{color:#797979;font-size:14px;padding-top:3px}.profile[_ngcontent-%COMP%]{border-radius:8px 8px 0 0;box-shadow:0 0 10px rgba(0,0,0,.1)}.profile[_ngcontent-%COMP%]   .profile-main[_ngcontent-%COMP%]{background:linear-gradient(0deg,rgba(0,0,0,.02),rgba(0,0,0,.02)),#fff;padding:16px;text-align:center}.profile[_ngcontent-%COMP%]   .profile-main[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{-o-object-fit:cover;border-radius:60px;height:80px;object-fit:cover;width:80px}.profile[_ngcontent-%COMP%]   .profile-main[_ngcontent-%COMP%]   .profile-name[_ngcontent-%COMP%]{color:#000;font-size:16px;font-weight:400;line-height:24px;margin-top:8px;text-transform:capitalize}.profile[_ngcontent-%COMP%]   .profile-sub[_ngcontent-%COMP%]{background:#fff;padding:16px;text-align:left}.profile[_ngcontent-%COMP%]   .profile-sub[_ngcontent-%COMP%]   .change-password[_ngcontent-%COMP%], .profile[_ngcontent-%COMP%]   .profile-sub[_ngcontent-%COMP%]   .get-in-touch[_ngcontent-%COMP%], .profile[_ngcontent-%COMP%]   .profile-sub[_ngcontent-%COMP%]   .sign-out[_ngcontent-%COMP%]{color:#5566fb;cursor:pointer;font-size:16px;font-weight:400;line-height:24px}.profile[_ngcontent-%COMP%]   .profile-sub[_ngcontent-%COMP%]   .change-password[_ngcontent-%COMP%], .profile[_ngcontent-%COMP%]   .profile-sub[_ngcontent-%COMP%]   .get-in-touch[_ngcontent-%COMP%]{margin-bottom:16px}.profile[_ngcontent-%COMP%]   .profile-sub[_ngcontent-%COMP%]   .signed-in[_ngcontent-%COMP%]{color:rgba(0,0,0,.4);font-size:12px;font-weight:400;letter-spacing:.002em;line-height:16px;margin-top:4px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(HeaderPopupComponent, [{
        type: Component,
        args: [{
                selector: 'terra-header-popup',
                templateUrl: './header-popup.component.html',
                styleUrls: ['./header-popup.component.scss'],
            }]
    }], function () { return [{ type: PopoverController }, { type: AuthStoreService }, { type: MessagesService }, { type: Router }, { type: MenuUIService }, { type: AlertController }]; }, { email: [{
            type: Input
        }], type: [{
            type: Input
        }] }); })();

const _c0 = function (a0) { return { activeMenu: a0 }; };
function HeaderComponent_ng_container_0_ng_container_3_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "span", 8);
    ɵɵlistener("click", function HeaderComponent_ng_container_0_ng_container_3_span_1_Template_span_click_0_listener($event) { ɵɵrestoreView(_r10); const ctx_r11 = ɵɵnextContext(); const link_r5 = ctx_r11.$implicit; const i_r6 = ctx_r11.index; const ctx_r9 = ɵɵnextContext(2); return ctx_r9.presentPopover($event, link_r5, i_r6); });
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵɵnextContext();
    const i_r6 = ctx_r12.index;
    const link_r5 = ctx_r12.$implicit;
    const ctx_r7 = ɵɵnextContext(2);
    ɵɵproperty("ngClass", ɵɵpureFunction1(2, _c0, ctx_r7.activeMenu == i_r6));
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", link_r5.title, " ");
} }
function HeaderComponent_ng_container_0_ng_container_3_span_2_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "span", 8);
    ɵɵlistener("click", function HeaderComponent_ng_container_0_ng_container_3_span_2_Template_span_click_0_listener() { ɵɵrestoreView(_r15); const link_r5 = ɵɵnextContext().$implicit; const ctx_r13 = ɵɵnextContext(2); return ctx_r13.goTo(link_r5.link); });
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = ɵɵnextContext();
    const i_r6 = ctx_r16.index;
    const link_r5 = ctx_r16.$implicit;
    const ctx_r8 = ɵɵnextContext(2);
    ɵɵproperty("ngClass", ɵɵpureFunction1(2, _c0, ctx_r8.activeMenu == i_r6));
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", link_r5.title, " ");
} }
function HeaderComponent_ng_container_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, HeaderComponent_ng_container_0_ng_container_3_span_1_Template, 2, 4, "span", 7);
    ɵɵtemplate(2, HeaderComponent_ng_container_0_ng_container_3_span_2_Template, 2, 4, "span", 7);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const link_r5 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", link_r5.links.length > 0);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", link_r5.links.length == 0);
} }
function HeaderComponent_ng_container_0_span_4_ng_container_1_img_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 15);
} if (rf & 2) {
    const profileDetail_r21 = ɵɵnextContext().ngIf;
    ɵɵproperty("src", profileDetail_r21.multimedia, ɵɵsanitizeUrl);
} }
function HeaderComponent_ng_container_0_span_4_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 16);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const users_r17 = ɵɵnextContext(2).ngIf;
    const ctx_r23 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r23.displayDefaultImage(users_r17 == null ? null : users_r17.displayName), " ");
} }
function HeaderComponent_ng_container_0_span_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0, 12);
    ɵɵlistener("click", function HeaderComponent_ng_container_0_span_4_ng_container_1_Template_ng_container_click_0_listener() { ɵɵrestoreView(_r27); const profileDetail_r21 = ctx.ngIf; const ctx_r26 = ɵɵnextContext(3); return ctx_r26.setupProfile(profileDetail_r21); });
    ɵɵtemplate(1, HeaderComponent_ng_container_0_span_4_ng_container_1_img_1_Template, 1, 1, "img", 13);
    ɵɵtemplate(2, HeaderComponent_ng_container_0_span_4_ng_container_1_div_2_Template, 2, 1, "div", 14);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const profileDetail_r21 = ctx.ngIf;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", profileDetail_r21 == null ? null : profileDetail_r21.multimedia);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !profileDetail_r21.multimedia);
} }
function HeaderComponent_ng_container_0_span_4_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "ion-skeleton-text", 17);
    ɵɵelementContainerEnd();
} }
function HeaderComponent_ng_container_0_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r29 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "span", 9);
    ɵɵlistener("click", function HeaderComponent_ng_container_0_span_4_Template_span_click_0_listener($event) { ɵɵrestoreView(_r29); const ctx_r28 = ɵɵnextContext(2); return ctx_r28.presentPopover($event, "account", 4); });
    ɵɵtemplate(1, HeaderComponent_ng_container_0_span_4_ng_container_1_Template, 3, 2, "ng-container", 10);
    ɵɵpipe(2, "async");
    ɵɵtemplate(3, HeaderComponent_ng_container_0_span_4_ng_template_3_Template, 2, 0, "ng-template", null, 11, ɵɵtemplateRefExtractor);
    ɵɵelementEnd();
} if (rf & 2) {
    const _r19 = ɵɵreference(4);
    const ctx_r3 = ɵɵnextContext(2);
    ɵɵproperty("ngClass", ɵɵpureFunction1(5, _c0, ctx_r3.activeMenu == 4));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ɵɵpipeBind1(2, 3, ctx_r3.auth.profileDetail$))("ngIfElse", _r19);
} }
function HeaderComponent_ng_container_0_ng_container_7_ng_container_1_img_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 20);
} if (rf & 2) {
    const profileDetail_r32 = ɵɵnextContext().ngIf;
    ɵɵproperty("src", profileDetail_r32.multimedia, ɵɵsanitizeUrl);
} }
function HeaderComponent_ng_container_0_ng_container_7_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 21);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const users_r30 = ɵɵnextContext(2).ngIf;
    const ctx_r34 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r34.displayDefaultImage(users_r30 == null ? null : users_r30.displayName), " ");
} }
function HeaderComponent_ng_container_0_ng_container_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, HeaderComponent_ng_container_0_ng_container_7_ng_container_1_img_1_Template, 1, 1, "img", 18);
    ɵɵtemplate(2, HeaderComponent_ng_container_0_ng_container_7_ng_container_1_div_2_Template, 2, 1, "div", 19);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const profileDetail_r32 = ctx.ngIf;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", profileDetail_r32 == null ? null : profileDetail_r32.multimedia);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !profileDetail_r32.multimedia);
} }
function HeaderComponent_ng_container_0_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, HeaderComponent_ng_container_0_ng_container_7_ng_container_1_Template, 3, 2, "ng-container", 0);
    ɵɵpipe(2, "async");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ɵɵpipeBind1(2, 1, ctx_r4.auth.profileDetail$));
} }
function HeaderComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r38 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "ion-grid", 1);
    ɵɵelementStart(2, "ion-row", 2);
    ɵɵtemplate(3, HeaderComponent_ng_container_0_ng_container_3_Template, 3, 2, "ng-container", 3);
    ɵɵtemplate(4, HeaderComponent_ng_container_0_span_4_Template, 5, 7, "span", 4);
    ɵɵpipe(5, "async");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(6, "ion-grid", 5);
    ɵɵtemplate(7, HeaderComponent_ng_container_0_ng_container_7_Template, 3, 3, "ng-container", 0);
    ɵɵpipe(8, "async");
    ɵɵelementStart(9, "ion-icon", 6);
    ɵɵlistener("click", function HeaderComponent_ng_container_0_Template_ion_icon_click_9_listener() { ɵɵrestoreView(_r38); const ctx_r37 = ɵɵnextContext(); return ctx_r37.menuOpen(); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵproperty("ngForOf", ctx_r0.menuLinks);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ɵɵpipeBind1(5, 3, ctx_r0.auth.user$));
    ɵɵadvance(3);
    ɵɵproperty("ngIf", ɵɵpipeBind1(8, 5, ctx_r0.auth.user$));
} }
function HeaderComponent_ng_container_1_ion_row_2_ng_container_2_img_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 15);
} if (rf & 2) {
    const profileDetail_r46 = ɵɵnextContext().ngIf;
    ɵɵproperty("src", profileDetail_r46.multimedia, ɵɵsanitizeUrl);
} }
function HeaderComponent_ng_container_1_ion_row_2_ng_container_2_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 16);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const users_r42 = ɵɵnextContext(2).ngIf;
    const ctx_r48 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r48.displayDefaultImage(users_r42 == null ? null : users_r42.displayName), " ");
} }
function HeaderComponent_ng_container_1_ion_row_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "span", 28);
    ɵɵelementStart(2, "a");
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(4, HeaderComponent_ng_container_1_ion_row_2_ng_container_2_img_4_Template, 1, 1, "img", 13);
    ɵɵtemplate(5, HeaderComponent_ng_container_1_ion_row_2_ng_container_2_div_5_Template, 2, 1, "div", 14);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const profileDetail_r46 = ctx.ngIf;
    const users_r42 = ɵɵnextContext().ngIf;
    ɵɵadvance(3);
    ɵɵtextInterpolate1(" ", users_r42 == null ? null : users_r42.displayName, "");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", profileDetail_r46 == null ? null : profileDetail_r46.multimedia);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !profileDetail_r46.multimedia);
} }
function HeaderComponent_ng_container_1_ion_row_2_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "ion-skeleton-text", 17);
    ɵɵelementContainerEnd();
} }
function HeaderComponent_ng_container_1_ion_row_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-row");
    ɵɵelementStart(1, "ion-col", 26);
    ɵɵtemplate(2, HeaderComponent_ng_container_1_ion_row_2_ng_container_2_Template, 6, 3, "ng-container", 27);
    ɵɵpipe(3, "async");
    ɵɵtemplate(4, HeaderComponent_ng_container_1_ion_row_2_ng_template_4_Template, 2, 0, "ng-template", null, 11, ɵɵtemplateRefExtractor);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const _r44 = ɵɵreference(5);
    const ctx_r39 = ɵɵnextContext(2);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ɵɵpipeBind1(3, 2, ctx_r39.auth.profileDetail$))("ngIfElse", _r44);
} }
function HeaderComponent_ng_container_1_ion_row_4_ion_col_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-col", 30);
    ɵɵelementStart(1, "span");
    ɵɵelementStart(2, "a", 31);
    ɵɵtext(3, "My Profile");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const user_r52 = ɵɵnextContext().ngIf;
    ɵɵadvance(2);
    ɵɵpropertyInterpolate1("href", "/#/people/", user_r52.id, "", ɵɵsanitizeUrl);
} }
function HeaderComponent_ng_container_1_ion_row_4_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r58 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "ion-col", 30);
    ɵɵelementStart(2, "span");
    ɵɵelementStart(3, "a", 12);
    ɵɵlistener("click", function HeaderComponent_ng_container_1_ion_row_4_ng_container_2_Template_a_click_3_listener() { ɵɵrestoreView(_r58); const auth_r56 = ctx.ngIf; const ctx_r57 = ɵɵnextContext(3); return ctx_r57.confirmChangePassword(auth_r56.email); });
    ɵɵtext(4, "Change Password");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} }
function HeaderComponent_ng_container_1_ion_row_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-row");
    ɵɵtemplate(1, HeaderComponent_ng_container_1_ion_row_4_ion_col_1_Template, 4, 1, "ion-col", 29);
    ɵɵtemplate(2, HeaderComponent_ng_container_1_ion_row_4_ng_container_2_Template, 5, 0, "ng-container", 0);
    ɵɵpipe(3, "async");
    ɵɵelementEnd();
} if (rf & 2) {
    const user_r52 = ctx.ngIf;
    const ctx_r40 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", user_r52.id);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ɵɵpipeBind1(3, 2, ctx_r40.auth.user$));
} }
function HeaderComponent_ng_container_1_ng_container_6_ng_container_7_ion_col_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-col", 24);
    ɵɵelementStart(1, "a", 34);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const links_r63 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("href", links_r63.link, ɵɵsanitizeUrl);
    ɵɵadvance(1);
    ɵɵtextInterpolate(links_r63.subTitle);
} }
function HeaderComponent_ng_container_1_ng_container_6_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, HeaderComponent_ng_container_1_ng_container_6_ng_container_7_ion_col_1_Template, 3, 2, "ion-col", 33);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const link_r59 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", link_r59.links);
} }
function HeaderComponent_ng_container_1_ng_container_6_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    const _r67 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0, 35);
    ɵɵelementStart(1, "ion-col", 24);
    ɵɵelementStart(2, "a", 12);
    ɵɵlistener("click", function HeaderComponent_ng_container_1_ng_container_6_ng_container_8_Template_a_click_2_listener() { ɵɵrestoreView(_r67); const link_r59 = ɵɵnextContext().$implicit; const ctx_r65 = ɵɵnextContext(2); return ctx_r65.goTo(link_r59.link); });
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const link_r59 = ɵɵnextContext().$implicit;
    ɵɵadvance(3);
    ɵɵtextInterpolate1(" ", link_r59.title, "");
} }
function HeaderComponent_ng_container_1_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "ion-row");
    ɵɵelementStart(2, "ion-col", 23);
    ɵɵelementStart(3, "span");
    ɵɵtext(4);
    ɵɵelementEnd();
    ɵɵelement(5, "hr");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(6, "ion-row");
    ɵɵtemplate(7, HeaderComponent_ng_container_1_ng_container_6_ng_container_7_Template, 2, 1, "ng-container", 0);
    ɵɵtemplate(8, HeaderComponent_ng_container_1_ng_container_6_ng_container_8_Template, 4, 1, "ng-container", 32);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const link_r59 = ctx.$implicit;
    ɵɵadvance(4);
    ɵɵtextInterpolate(link_r59.title);
    ɵɵadvance(3);
    ɵɵproperty("ngIf", link_r59.links.length > 0);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", link_r59.links.length == 0);
} }
function HeaderComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r70 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "ion-grid", 22);
    ɵɵtemplate(2, HeaderComponent_ng_container_1_ion_row_2_Template, 6, 4, "ion-row", 0);
    ɵɵpipe(3, "async");
    ɵɵtemplate(4, HeaderComponent_ng_container_1_ion_row_4_Template, 4, 4, "ion-row", 0);
    ɵɵpipe(5, "async");
    ɵɵtemplate(6, HeaderComponent_ng_container_1_ng_container_6_Template, 9, 3, "ng-container", 3);
    ɵɵelementContainerStart(7);
    ɵɵelementStart(8, "ion-row");
    ɵɵelementStart(9, "ion-col", 23);
    ɵɵelementStart(10, "span");
    ɵɵtext(11, " Sign out");
    ɵɵelementEnd();
    ɵɵelement(12, "hr");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(13, "ion-row");
    ɵɵelementStart(14, "ion-col", 24);
    ɵɵelementStart(15, "a", 25);
    ɵɵlistener("click", function HeaderComponent_ng_container_1_Template_a_click_15_listener() { ɵɵrestoreView(_r70); const ctx_r69 = ɵɵnextContext(); return ctx_r69.signOut(); });
    ɵɵtext(16, " Sign out ");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ɵɵpipeBind1(3, 3, ctx_r1.auth.user$));
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ɵɵpipeBind1(5, 5, ctx_r1.auth.profileDetail$));
    ɵɵadvance(2);
    ɵɵproperty("ngForOf", ctx_r1.menuLinks);
} }
class HeaderComponent {
    constructor(popoverController, auth, menuUIService, messages, router, menuUi, alertCtrl) {
        this.popoverController = popoverController;
        this.auth = auth;
        this.menuUIService = menuUIService;
        this.messages = messages;
        this.router = router;
        this.menuUi = menuUi;
        this.alertCtrl = alertCtrl;
        this.defaultImage = '';
        this.email = false;
        this.displayName = '...';
        this.type = 'desktop';
        this.menuLinks = [
        // {
        // 	title: 'Start Learning',
        // 	links: [
        // 		{
        // 			img: '/assets/courses_icon/LFA.svg',
        // 			subTitle: 'Climate Change: Learning for Action',
        // 			desc: 'Our flagship: discover the climate landscape',
        // 			link: 'https://www.terra.do/climate-change-learning-for-action',
        // 		},
        // 		{
        // 			img: '/assets/courses_icon/h2.svg',
        // 			subTitle: 'Hydrogen and The Energy Transition',
        // 			desc: 'A rapidly emerging green energy alternative',
        // 			link: 'https://www.terra.do/green-hydrogen-and-the-energy-transition',
        // 		},
        // 		// {
        // 		// 	img: '/assets/courses_icon/Smart_building.svg',
        // 		// 	subTitle: 'Climate-Smart Buildings',
        // 		// 	desc: 'Design, construction, retrofits, and more',
        // 		// 	link: 'https://www.terra.do/climate-positive-smart-green-buildings',
        // 		// },
        // 		{
        // 			img: '/assets/courses_icon/vcs_investors.svg',
        // 			subTitle: 'Climate Change for VCs',
        // 			desc: 'Grok, develop theses, and network with peers',
        // 			link: 'https://www.terra.do/climate-change-for-vcs-and-investors',
        // 		},
        // 		// {
        // 		// 	img: '/assets/courses_icon/agriculture_chain.svg',
        // 		// 	subTitle: 'Agricultural Value Chains',
        // 		// 	desc: 'Making them adaptive and climate-resilient',
        // 		// 	link: 'https://www.terra.do/agricultural-value-chains',
        // 		// },
        // 		// {
        // 		// 	img: '/assets/courses_icon/cliamte_justice.svg',
        // 		// 	subTitle: 'Climate Justice',
        // 		// 	desc: 'Interactive 2-day workshop for practitioners',
        // 		// 	link: 'https://www.terra.do/climate-justice',
        // 		// },
        // 	],
        // },
        // {
        // 	title: 'Jobs Fair',
        // 	links: [],
        // 	link: 'https://www.terra.do/climate-jobs-fair/professionals',
        // },
        // {
        // 	title: 'Huddle',
        // 	links: [],
        // 	link: 'https://www.terra.do/huddle/',
        // },
        // {
        // 	title: 'Blog',
        // 	links: [],
        // 	link: 'https://blog.terra.do/',
        // },
        // {
        // 	title: 'About Us',
        // 	links: [],
        // 	link: 'https://www.terra.do/about-and-team',
        // },
        ];
        /* empty */
        this.auth.user$.subscribe((res) => {
            if (!!res) {
                if (!!res.email) {
                    this.email = res.email;
                }
            }
        });
    }
    displayDefaultImage(name) {
        var _a, _b, _c;
        this.displayName = name;
        if (this.displayName) {
            const displayName = this.displayName.split(' ');
            const names = (_a = displayName[0]) === null || _a === void 0 ? void 0 : _a.charAt(0);
            if ((_b = displayName[1]) === null || _b === void 0 ? void 0 : _b.charAt(0)) {
                return names + ((_c = displayName[1]) === null || _c === void 0 ? void 0 : _c.charAt(0));
            }
            else {
                return names;
            }
        }
        else {
            return '. .';
        }
    }
    ngOnInit() {
        /* empty */
        this.menuUIService.closeMenu();
    }
    menuOpen() {
        this.menuUIService.openMenu();
    }
    presentPopover(ev, menuLinks, no) {
        return __awaiter(this, void 0, void 0, function* () {
            this.activeMenu = no;
            const popover = yield this.popoverController.create({
                component: HeaderPopupComponent,
                cssClass: menuLinks === 'account' ? 'terra-header-popup' : 'header-popup',
                event: ev,
                componentProps: {
                    email: this.email,
                    type: menuLinks === 'account' ? 'account' : menuLinks,
                },
                translucent: true,
            });
            popover.onWillDismiss().then(res => {
                this.activeMenu = 10;
            });
            return yield popover.present();
        });
    }
    signOut() {
        this.messages.showErrors('Signing you out..');
        this.menuUIService.closeMenu();
        this.auth.logout();
        // setTimeout(() => {
        // 	this.router.navigateByUrl('/login/auth');
        // }, 1000);
    }
    ngOnDestroy() {
        this.menuUIService.closeMenu();
    }
    goTo(link) {
        window.open(link, '_blank');
    }
    setupProfile(profileDetail) {
        let url = this.router.serializeUrl(this.router.createUrlTree([`/people/me`]));
        url = '/#' + url;
        window.open(url, '_blank');
    }
    confirmChangePassword(email) {
        return __awaiter(this, void 0, void 0, function* () {
            const alert = yield this.alertCtrl.create({
                header: 'Change Password',
                message: 'We will email a link to <b>' + email + '</b> to reset your password.',
                cssClass: 'alertModal',
                buttons: [
                    {
                        text: 'Cancel',
                        role: 'cancel',
                    },
                    {
                        text: 'Email Link',
                        handler: () => {
                            this.changePassword();
                        },
                    },
                ],
            });
            yield alert.present();
        });
    }
    changePassword() {
        return __awaiter(this, void 0, void 0, function* () {
            this.auth.user$.subscribe(user => {
                if (!!user) {
                    // const resetPass$ = this.auth.resetPassword(user.email);
                    this.auth.resetPassword(user.email).subscribe(() => {
                        const confirmMessage = 'We have sent a link to ' +
                            user.email +
                            ' to change your password.';
                        this.messages.showErrors(confirmMessage);
                    }, err => {
                        this.messages.showErrors(err === null || err === void 0 ? void 0 : err.message);
                    });
                }
            });
        });
    }
}
HeaderComponent.ɵfac = function HeaderComponent_Factory(t) { return new (t || HeaderComponent)(ɵɵdirectiveInject(PopoverController), ɵɵdirectiveInject(AuthStoreService), ɵɵdirectiveInject(MenuUIService), ɵɵdirectiveInject(MessagesService), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(MenuUIService), ɵɵdirectiveInject(AlertController)); };
HeaderComponent.ɵcmp = ɵɵdefineComponent({ type: HeaderComponent, selectors: [["terra-header"]], inputs: { type: "type" }, decls: 2, vars: 2, consts: [[4, "ngIf"], [1, "np", "ion-hide-sm-down"], [1, "menu"], [4, "ngFor", "ngForOf"], ["class", "header-menu ion-p0 cursor", 3, "ngClass", "click", 4, "ngIf"], ["id", "main", 1, "ion-hide-sm-up"], ["name", "menu-outline", 1, "mobile-menu", 3, "click"], ["class", "header-menu cursor", 3, "ngClass", "click", 4, "ngIf"], [1, "header-menu", "cursor", 3, "ngClass", "click"], [1, "header-menu", "ion-p0", "cursor", 3, "ngClass", "click"], [3, "click", 4, "ngIf", "ngIfElse"], ["noImageFound", ""], [3, "click"], ["class", "profile-img", 3, "src", 4, "ngIf"], ["class", "defaultImage", 4, "ngIf"], [1, "profile-img", 3, "src"], [1, "defaultImage"], ["animated", "", 2, "height", "40px", "width", "40px"], ["class", "profile-img header-img", 3, "src", 4, "ngIf"], ["class", "header-default", 4, "ngIf"], [1, "profile-img", "header-img", 3, "src"], [1, "header-default"], [1, "mobile-menu-open"], [1, "left-title"], ["size", "12", 1, "right-title", "pb19"], [1, "link", 3, "click"], [1, "right-title"], [4, "ngIf", "ngIfElse"], [1, "profile-img-title"], ["size", "12", "class", "right-title pb15", 4, "ngIf"], ["size", "12", 1, "right-title", "pb15"], [3, "href"], ["class", "link", 4, "ngIf"], ["class", "right-title pb19", "size", "12", 4, "ngFor", "ngForOf"], ["target", "_blank", 1, "link", 3, "href"], [1, "link"]], template: function HeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, HeaderComponent_ng_container_0_Template, 10, 7, "ng-container", 0);
        ɵɵtemplate(1, HeaderComponent_ng_container_1_Template, 17, 7, "ng-container", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.type == "desktop");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.type == "mobile");
    } }, directives: [NgIf, IonGrid, IonRow, NgForOf, IonIcon, NgClass, IonSkeletonText, IonCol], pipes: [AsyncPipe], styles: [".np[_ngcontent-%COMP%]{padding:0!important}.menu[_ngcontent-%COMP%]{color:var(--ion-color-menu);float:right;font-family:var(--ion-font-family-text);font-size:16px;font-weight:400;letter-spacing:0;padding-right:20px}.menu[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{height:40px;padding:10px 20px}.menu[_ngcontent-%COMP%]   .menuProfile[_ngcontent-%COMP%]{display:inline-flex}.menu[_ngcontent-%COMP%]   .menuProfile[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{border-radius:100%;height:40px;width:40px}.menu[_ngcontent-%COMP%]   .menuProfile[_ngcontent-%COMP%]   ion-icon[_ngcontent-%COMP%]{color:var(--ion-color-menu-icon);padding-top:15px}.menu[_ngcontent-%COMP%]   .header-menu[_ngcontent-%COMP%]{color:var(--ion-color-black-800);font-size:16px;font-weight:500;letter-spacing:.5px;line-height:20px;text-align:right}.menu[_ngcontent-%COMP%]   .header-icon[_ngcontent-%COMP%]{vertical-align:middle}.activeMenu[_ngcontent-%COMP%]{color:var(--ion-input-email-border)!important}.mobile-menu[_ngcontent-%COMP%]{color:var(--ion-color-black-800);cursor:pointer}.mobile-menu-open[_ngcontent-%COMP%]{font-family:var(--ion-font-family-text);font-weight:500;padding:15px;z-index:100000}.mobile-menu-open[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:32px;width:32px}.mobile-menu-open[_ngcontent-%COMP%]   .right-title[_ngcontent-%COMP%]{font-size:16px;font-style:normal;font-weight:500;letter-spacing:0;text-align:right}.mobile-menu-open[_ngcontent-%COMP%]   .right-title[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:var(--ion-color-sea-600);text-decoration:none}.mobile-menu-open[_ngcontent-%COMP%]   .left-title[_ngcontent-%COMP%]{font-size:16px;font-style:normal;font-weight:500;letter-spacing:0;text-align:left}.mobile-menu-open[_ngcontent-%COMP%]   .left-title[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{background:#fff;color:var(--ion-color-black-600);padding-right:10px;position:absolute}.mobile-menu-open[_ngcontent-%COMP%]   .left-title[_ngcontent-%COMP%]   hr[_ngcontent-%COMP%]{border-top:1px solid var(--ion-color-black-600);height:0;margin-bottom:10px;margin-top:10px}.profile-img[_ngcontent-%COMP%]{-o-object-fit:cover;border-radius:100%;height:40px;object-fit:cover;width:40px}.profile-img-title[_ngcontent-%COMP%]{margin-top:-10px;position:absolute;right:55px;top:25px}.pb15[_ngcontent-%COMP%]{padding-bottom:15px}.pb19[_ngcontent-%COMP%]{padding-bottom:19px}.menu-outline[_ngcontent-%COMP%]{bottom:-5px;position:absolute;right:15px}.ion-p0[_ngcontent-%COMP%]{padding:0 0 0 5px!important}.my-dashboard[_ngcontent-%COMP%]{color:initial;text-decoration:none}.cursor[_ngcontent-%COMP%]{cursor:pointer}.defaultImage[_ngcontent-%COMP%]{background:var(--ion-color-assignment-default-member);border-radius:100%;height:40px;padding-top:10px;text-align:center;text-transform:uppercase;width:40px}@media (max-width:576.98px){.defaultImage[_ngcontent-%COMP%]{float:right;height:40px;padding-top:10px;width:40px}.defaultImage[_ngcontent-%COMP%], .header-default[_ngcontent-%COMP%]{background:var(--ion-color-assignment-default-member);border-radius:100%;text-align:center;text-transform:uppercase}.header-default[_ngcontent-%COMP%]{height:32px;padding-top:6px;top:5px;width:32px}.header-default[_ngcontent-%COMP%], .header-img[_ngcontent-%COMP%]{position:absolute;right:50px}.header-img[_ngcontent-%COMP%]{height:30px;top:8px;width:30px}}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(HeaderComponent, [{
        type: Component,
        args: [{
                selector: 'terra-header',
                templateUrl: './header.component.html',
                styleUrls: ['./header.component.css'],
            }]
    }], function () { return [{ type: PopoverController }, { type: AuthStoreService }, { type: MenuUIService }, { type: MessagesService }, { type: Router }, { type: MenuUIService }, { type: AlertController }]; }, { type: [{
            type: Input
        }] }); })();

function InviteMemberComponent_ion_col_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-col", 9);
    ɵɵelementStart(1, "span");
    ɵɵtext(2, "Thank you for taking this journey! We'd love to get to know others like you and help them become a part of the Terra community too.");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function InviteMemberComponent_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "ion-col", 10);
    ɵɵelementStart(2, "ion-icon", 11);
    ɵɵlistener("click", function InviteMemberComponent_ng_container_12_Template_ion_icon_click_2_listener() { ɵɵrestoreView(_r3); const ctx_r2 = ɵɵnextContext(); return ctx_r2.share("linkedin"); });
    ɵɵelementEnd();
    ɵɵelementStart(3, "ion-icon", 12);
    ɵɵlistener("click", function InviteMemberComponent_ng_container_12_Template_ion_icon_click_3_listener() { ɵɵrestoreView(_r3); const ctx_r4 = ɵɵnextContext(); return ctx_r4.share("twitter"); });
    ɵɵelementEnd();
    ɵɵelementStart(4, "ion-icon", 13);
    ɵɵlistener("click", function InviteMemberComponent_ng_container_12_Template_ion_icon_click_4_listener() { ɵɵrestoreView(_r3); const ctx_r5 = ɵɵnextContext(); return ctx_r5.share("facebook"); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(5, "ion-col", 14);
    ɵɵtext(6, " Invite someone personally: ");
    ɵɵelementEnd();
    ɵɵelementStart(7, "ion-col", 15);
    ɵɵelementStart(8, "ion-input", 16);
    ɵɵlistener("ngModelChange", function InviteMemberComponent_ng_container_12_Template_ion_input_ngModelChange_8_listener($event) { ɵɵrestoreView(_r3); const ctx_r6 = ɵɵnextContext(); return ctx_r6.email = $event; });
    ɵɵelementEnd();
    ɵɵelementStart(9, "ion-button", 17);
    ɵɵlistener("click", function InviteMemberComponent_ng_container_12_Template_ion_button_click_9_listener() { ɵɵrestoreView(_r3); const ctx_r7 = ɵɵnextContext(); return ctx_r7.share("email"); });
    ɵɵtext(10, "Invite ");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(8);
    ɵɵproperty("ngModel", ctx_r1.email);
} }
class InviteMemberComponent {
    constructor(terraUIService, auth, messages) {
        this.terraUIService = terraUIService;
        this.auth = auth;
        this.messages = messages;
        this.viewType = 'desktop';
        this.inviteMember = [
            {
                no: 9,
                name: 'Adam	Braun',
                icons: [],
            },
            {
                no: 4,
                name: 'Shawn	Drost',
                icons: [],
            },
            {
                no: 2,
                name: 'Zubair	Jandali',
            },
            {
                no: 2,
                name: 'Shivani	Singh',
            },
            {
                no: 1,
                name: 'Aditya Priyadarshi',
            },
            {
                no: 1,
                name: 'Antonis	Stampoulis',
            },
            {
                no: 1,
                name: 'Haryshwaran	MI',
            },
            {
                no: 1,
                name: 'Samikchhya	Kafle',
            },
            {
                no: 1,
                name: 'Aakash	Dharmadhikari',
            },
            {
                no: 1,
                name: 'Heather	Patterson',
            },
            {
                no: 1,
                name: 'Franco	Castillo-Gomez',
            },
            {
                no: 1,
                name: 'Siddharth	Sridharan',
            },
            {
                no: 1,
                name: 'Shauny	Qu',
            },
            {
                no: 1,
                name: 'Adrian	Gross',
            },
            {
                no: 1,
                name: 'Rohith	Rajagopal',
            },
            {
                no: 1,
                name: 'Remi	Bouteille',
            },
            {
                no: 1,
                name: 'Chittoor	Manian',
            },
            {
                no: 1,
                name: 'Yas	C',
            },
        ];
        // empty
        this.auth.user$.subscribe((res) => {
            if (!!res) {
                if (this.terraUIService.shareableLink == null) {
                    this.terraUIService.getShareableLink(res.uid).subscribe(response => {
                        this.terraUIService.shareableLink = response;
                    });
                }
            }
        });
    }
    ngOnInit() {
        // block
    }
    copyToClipboard(s) {
        const clistener = (e) => {
            e.clipboardData.setData('text/plain', s);
            e.preventDefault();
        };
        document.addEventListener('copy', clistener);
        document.execCommand('copy');
        document.removeEventListener('copy', clistener);
        this.messages.showSuccessMessages('Referral URL copied');
    }
    share(option) {
        if (option === 'linkedin') {
            window.open('http://www.linkedin.com/shareArticle?mini=true&url=' +
                this.terraUIService.shareableLink, '_blank');
        }
        else if (option === 'twitter') {
            window.open('https://twitter.com/intent/tweet?text=A%20deep%20dive%20into%20the%20entire%20landscape%20of%20climate%20change%20to%20help%20you%20kickstart%20your%20climate%20journey&url=' +
                this.terraUIService.shareableLink, '_blank');
        }
        else if (option === 'facebook') {
            window.FB.ui({
                method: 'share',
                href: this.terraUIService.shareableLink,
            }, response => {
                // no error handled?
            });
        }
        else if (option === 'email') {
            if (this.email) {
                this.auth.user$.subscribe((res) => {
                    if (!!res) {
                        const subject = res.email +
                            ' has invited you to join the Terra.do bootcamp on climate change';
                        const emailBody = `Hi,
						
						${res.email} has invited you to kickstart your journey into climate change by joining the Climate Change—Learning for Action bootcamp with Terra.do. Congratulations! 
						
						Terra.do is an online climate school and community which is laser focussed on helping people all over the world transition into climate change. 
						You can learn more about the Terra do vision https://www.terra.do/about-and-team and get all the details of our bootcamp https://www.terra.do/climate-change-learning-for-action. 
						
						As part of our referral policy, we will be offering you a flat 25% discount
						Note: This is over and above any scholarships you might be eligible for.
						
						https://www.terra.do/apply/cl101-november - Click to apply 
						
						Please let me know if you have any questions. I look forward to seeing you in the program soon!
						
						Cheers!
						${res.displayName}`;
                        window.open('mailto:' +
                            this.email +
                            '?subject=' +
                            subject +
                            '&body=' +
                            encodeURI(emailBody), '_blank');
                    }
                });
            }
            this.email = '';
        }
        else {
            this.messages.showErrors('Share not found');
        }
    }
}
InviteMemberComponent.ɵfac = function InviteMemberComponent_Factory(t) { return new (t || InviteMemberComponent)(ɵɵdirectiveInject(TerraUIService), ɵɵdirectiveInject(AuthStoreService), ɵɵdirectiveInject(MessagesService)); };
InviteMemberComponent.ɵcmp = ɵɵdefineComponent({ type: InviteMemberComponent, selectors: [["terra-invite-member"]], inputs: { viewType: "viewType" }, decls: 13, vars: 3, consts: [[1, "color", "max-width-invite-member"], [1, "main-box"], ["size", "12", 1, "title1"], ["size", "12", "class", "title2", 4, "ngIf"], ["size", "12", 1, "title3", "referral"], [1, "share-title"], [1, "background-white", "cursor", 3, "click"], ["name", "copy-outline", 1, "copy", "cursor"], [4, "ngIf"], ["size", "12", 1, "title2"], ["size", "12", 1, "share-icon"], ["name", "logo-linkedin", 1, "linkedin", "cursor", 3, "click"], ["name", "logo-twitter", 1, "twitter", "cursor", 3, "click"], ["name", "logo-facebook", 1, "facebook", "cursor", 3, "click"], ["size", "12", 1, "title3"], ["size", "12", 1, "title3", "flex-border"], ["clearInput", "", "placeholder", "Enter email address", "required", "", 1, "input-email", "width-70", 3, "ngModel", "ngModelChange"], ["color", "dark", "expand", "full", 1, "width-30", "p0", "m0", 3, "click"]], template: function InviteMemberComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelement(0, "util-messages");
        ɵɵelementStart(1, "ion-grid", 0);
        ɵɵelementStart(2, "ion-row", 1);
        ɵɵelementStart(3, "ion-col", 2);
        ɵɵtext(4, " Nurture the community ");
        ɵɵelementEnd();
        ɵɵtemplate(5, InviteMemberComponent_ion_col_5_Template, 3, 0, "ion-col", 3);
        ɵɵelementStart(6, "ion-col", 4);
        ɵɵelementStart(7, "span", 5);
        ɵɵtext(8, "Share your custom referral link:");
        ɵɵelementEnd();
        ɵɵelementStart(9, "div", 6);
        ɵɵlistener("click", function InviteMemberComponent_Template_div_click_9_listener() { return ctx.copyToClipboard(ctx.terraUIService.shareableLink); });
        ɵɵtext(10);
        ɵɵelement(11, "ion-icon", 7);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(12, InviteMemberComponent_ng_container_12_Template, 11, 1, "ng-container", 8);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(5);
        ɵɵproperty("ngIf", ctx.viewType != "mobile");
        ɵɵadvance(5);
        ɵɵtextInterpolate1(" ", ctx.terraUIService.shareableLink, " ");
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.viewType != "mobile");
    } }, directives: [MessagesComponent, IonGrid, IonRow, IonCol, NgIf, IonIcon, IonInput, TextValueAccessor, RequiredValidator, NgControlStatus, NgModel, IonButton], styles: [".p5[_ngcontent-%COMP%]{padding:5px}.color-ADC8EC[_ngcontent-%COMP%]{background:#adc8ec}.f18[_ngcontent-%COMP%]{font-size:18px}.cursor[_ngcontent-%COMP%]{cursor:pointer}.p10[_ngcontent-%COMP%]{padding:10px}.copy[_ngcontent-%COMP%]{font-size:19px;padding:0;position:absolute;right:20px}.color[_ngcontent-%COMP%]{background:rgba(173,200,236,.2);border-radius:4px}.title1[_ngcontent-%COMP%]{color:var(--ion-color-black-800);font-family:var(--ion-font-family-heading);font-size:18px;font-style:normal;font-weight:700;line-height:140%;padding-bottom:3px;text-align:left}.title2[_ngcontent-%COMP%]{color:var(--ion-color-black-600)}.title2[_ngcontent-%COMP%], .title3[_ngcontent-%COMP%]{font-family:var(--ion-font-family-text);font-size:16px;font-style:normal;font-weight:400;line-height:150%}.title3[_ngcontent-%COMP%]{color:var(--ion-color-black-800)}.background-white[_ngcontent-%COMP%]{background:var(--ion-color-white-600);border-radius:4px;color:var(--ion-color-sea-600);font-weight:700;line-height:140%;margin-top:8px;padding:12px 16px}.share-icon[_ngcontent-%COMP%]{font-size:33px;padding:18px 5px}.share-icon[_ngcontent-%COMP%]   ion-icon[_ngcontent-%COMP%]{padding-right:20px}.linkedin[_ngcontent-%COMP%]{color:var(--ion-color-linked-in)}.twitter[_ngcontent-%COMP%]{color:var(--ion-color-twitter)}.facebook[_ngcontent-%COMP%]{color:var(--ion-color-facebook)}.input-email[_ngcontent-%COMP%]{--padding-bottom:12px;--padding-end:12px;--padding-start:12px;--padding-top:12px;background:var(--ion-color-white-600);border-radius:4px 0 0 4px;box-sizing:border-box;font-family:var(--ion-font-family-text);font-size:16px;line-height:150%}.width-70[_ngcontent-%COMP%]{width:70%}.width-30[_ngcontent-%COMP%]{height:48px;width:30%}.p0[_ngcontent-%COMP%]{padding:0}.m0[_ngcontent-%COMP%]{margin:0}.title_member_1[_ngcontent-%COMP%]{color:var(--ion-color-black-800);letter-spacing:.2px}.title_member_1[_ngcontent-%COMP%], .title_member_2[_ngcontent-%COMP%]{font-family:var(--ion-font-family-text);font-size:16px}.title_member_2[_ngcontent-%COMP%]{color:var(--ion-color-black-600);padding:15px 20px}.title_member_2[_ngcontent-%COMP%]   .no[_ngcontent-%COMP%]{color:var(--ion-color-member-no);font-weight:700}.title_member_2[_ngcontent-%COMP%]   .name[_ngcontent-%COMP%]{color:var(--ion-color-black-600);font-weight:400;padding-left:5px}.color1[_ngcontent-%COMP%]{background:var(--ion-color-white-600);border:1px solid var(--ion-color-notification-border);border-radius:4px}.top[_ngcontent-%COMP%]{padding-top:20px;text-align:center}.p20[_ngcontent-%COMP%]{padding:20px}.max-width-invite-member[_ngcontent-%COMP%]{margin-left:var(--margin-left);margin-right:var(--margin-right);max-width:var(--max-width)}@media (max-width:575.98px){.title1[_ngcontent-%COMP%]{font-size:16px}}.pt1[_ngcontent-%COMP%]{padding-top:1px}.flex-border[_ngcontent-%COMP%]{border:1px solid var(--ion-input-email-border);border-radius:4px;display:flex;margin:1px 5px 5px;max-width:calc(100% - 10px)!important;padding:0}.flex-border[_ngcontent-%COMP%], .flex-border[_ngcontent-%COMP%]   ion-button[_ngcontent-%COMP%]{font-family:var(--ion-font-family-text)}.flex-border[_ngcontent-%COMP%]   ion-button[_ngcontent-%COMP%]{font-size:16px;max-width:111px;text-transform:capitalize}.share-title[_ngcontent-%COMP%]{color:var(--ion-color-black-700)}@media (min-width:1366px){.referral[_ngcontent-%COMP%]{padding-top:15px}.main-box[_ngcontent-%COMP%]{padding:20px}}@media (min-width:576px) and (max-width:1365.98px){.referral[_ngcontent-%COMP%]{padding-top:15px}.main-box[_ngcontent-%COMP%]{padding:20px 10px}}@media (max-width:575.98px){.referral[_ngcontent-%COMP%]{padding-top:10x}.main-box[_ngcontent-%COMP%]{padding:18px 10px}}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(InviteMemberComponent, [{
        type: Component,
        args: [{
                selector: 'terra-invite-member',
                templateUrl: './invite-member.component.html',
                styleUrls: ['./invite-member.component.css'],
            }]
    }], function () { return [{ type: TerraUIService }, { type: AuthStoreService }, { type: MessagesService }]; }, { viewType: [{
            type: Input
        }] }); })();

class TerraUIModule {
    static forRoot() {
        return {
            ngModule: TerraUIModule,
        };
    }
}
TerraUIModule.ɵmod = ɵɵdefineNgModule({ type: TerraUIModule });
TerraUIModule.ɵinj = ɵɵdefineInjector({ factory: function TerraUIModule_Factory(t) { return new (t || TerraUIModule)(); }, providers: [MessagesService, AddToCalendarService, MenuUIService], imports: [[CommonModule, IonicModule, UtilLibModule, FormsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(TerraUIModule, { declarations: [TerraUIComponent,
        HeaderComponent,
        InviteMemberComponent,
        BannerComponent,
        AddToCalendarComponent,
        FooterComponent,
        HeaderPopupComponent], imports: [CommonModule, IonicModule, UtilLibModule, FormsModule], exports: [TerraUIComponent,
        HeaderComponent,
        InviteMemberComponent,
        BannerComponent,
        FooterComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(TerraUIModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    TerraUIComponent,
                    HeaderComponent,
                    InviteMemberComponent,
                    BannerComponent,
                    AddToCalendarComponent,
                    FooterComponent,
                    HeaderPopupComponent,
                ],
                entryComponents: [AddToCalendarService, MenuUIService],
                imports: [CommonModule, IonicModule, UtilLibModule, FormsModule],
                exports: [
                    TerraUIComponent,
                    HeaderComponent,
                    InviteMemberComponent,
                    BannerComponent,
                    FooterComponent,
                ],
                providers: [MessagesService, AddToCalendarService, MenuUIService],
            }]
    }], null, null); })();

class PopoverPlacement {
}
PopoverPlacement.Bottom = 'bottom';
PopoverPlacement.BottomLeft = 'bottom-left';
PopoverPlacement.BottomRight = 'bottom-right';
PopoverPlacement.Left = 'left';
PopoverPlacement.Right = 'right';
PopoverPlacement.Top = 'top';
PopoverPlacement.TopLeft = 'top-left';
PopoverPlacement.TopRight = 'top-right';

/**
 * This is a continuation of ngx-popover
 * @Reference {github} https://github.com/pleerock/ngx-popover
 */
const _c0$1 = ["popoverDiv"];
const _c1 = function (a0, a1, a2, a3, a4) { return { sm: a0, "md-sm": a1, md: a2, lg: a3, in: a4 }; };
const _c2 = ["*"];
class PopoverContentComponent {
    // -------------------------------------------------------------------------
    // Constructor
    // -------------------------------------------------------------------------
    constructor(element, cdr, renderer) {
        this.element = element;
        this.cdr = cdr;
        this.renderer = renderer;
        this.placement = PopoverPlacement.Top;
        this.animation = true;
        this.closeOnClickOutside = false;
        this.closeOnMouseOutside = false;
        this.appendToBody = false;
        this.size = 'small';
        this.onCloseFromOutside = new EventEmitter();
        this.top = -10000;
        this.left = -10000;
        this.isIn = false;
        this.opacity = 0;
        this.transitionEnabled = false;
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
        // -------------------------------------------------------------------------
        // Anonymous
        // -------------------------------------------------------------------------
        /**
         * Closes dropdown if user clicks outside of this directive.
         */
        this.onDocumentMouseDown = (event) => {
            const element = this.element.nativeElement;
            if (!element || !this.popover) {
                return;
            }
            if (element.contains(event.target) ||
                this.popover.getElement().contains(event.target)) {
                return;
            }
            this.onCloseFromOutside.emit(undefined);
        };
    }
    // -------------------------------------------------------------------------
    // Lifecycle callbacks
    // -------------------------------------------------------------------------
    ngAfterViewInit() {
        if (this.closeOnClickOutside) {
            this.listenClickFunc = this.renderer.listen('document', 'mousedown', (event) => this.onDocumentMouseDown(event));
        }
        if (this.closeOnMouseOutside) {
            this.listenMouseFunc = this.renderer.listen('document', 'mouseover', (event) => this.onDocumentMouseDown(event));
        }
        // Always close on mobile touch event outside.
        this.listenTouchFunc = this.renderer.listen('document', 'touchstart', (event) => this.onDocumentMouseDown(event));
        this.show();
        this.cdr.detectChanges();
    }
    ngOnDestroy() {
        if (this.closeOnClickOutside && this.listenClickFunc) {
            this.listenClickFunc();
        }
        if (this.closeOnMouseOutside && this.listenMouseFunc) {
            this.listenMouseFunc();
        }
        if (!!this.listenTouchFunc) {
            this.listenTouchFunc();
        }
    }
    // -------------------------------------------------------------------------
    // Public Methods
    // -------------------------------------------------------------------------
    onResize(event) {
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
    }
    updatePosition() {
        // if visible, reposition
        if (this.opacity) {
            const p = this.positionElements(this.popover.getElement(), this.popoverDiv.nativeElement, this.placement);
            this.top = p.top;
            this.left = p.left;
        }
    }
    show() {
        if (!this.popover || !this.popover.getElement()) {
            return;
        }
        const p = this.positionElements(this.popover.getElement(), this.popoverDiv.nativeElement, this.placement);
        this.top = p.top;
        this.left = p.left;
        this.isIn = true;
        this.transitionEnabled = true;
        this.opacity = 1;
    }
    hide() {
        this.top = -10000;
        this.left = -10000;
        this.isIn = true;
        this.popover.hide();
    }
    hideFromPopover() {
        this.top = -10000;
        this.left = -10000;
        this.isIn = true;
        this.transitionEnabled = false;
        this.opacity = 0;
    }
    // -------------------------------------------------------------------------
    // Protected Methods
    // -------------------------------------------------------------------------
    positionElements(hostEl, targetEl, positionStr, appendToBody = false) {
        const positionStrParts = positionStr.split(' ');
        let pos0 = positionStrParts[0];
        const pos1 = positionStrParts[1] || 'center';
        const hostElPos = this.appendToBody || appendToBody
            ? this.offset(hostEl)
            : this.position(hostEl);
        const targetElWidth = targetEl.offsetWidth;
        const targetElHeight = targetEl.offsetHeight;
        this.effectivePlacement = pos0 = this.getEffectivePlacement(pos0, hostEl, targetEl);
        const shiftWidth = {
            center() {
                return hostElPos.left + hostElPos.width / 2 - targetElWidth / 2;
            },
            left() {
                return hostElPos.left;
            },
            right() {
                return hostElPos.left + hostElPos.width;
            },
            topOrBottomRight() {
                return hostElPos.left + hostElPos.width / 2;
            },
            topOrBottomLeft() {
                return hostElPos.left - targetElWidth + hostElPos.width / 2;
            },
        };
        const shiftHeight = {
            center() {
                return hostElPos.top + hostElPos.height / 2 - targetElHeight / 2;
            },
            top() {
                return hostElPos.top;
            },
            bottom() {
                return hostElPos.top + hostElPos.height;
            },
        };
        let targetElPos;
        switch (pos0) {
            case PopoverPlacement.Right:
                targetElPos = {
                    top: shiftHeight[pos1](),
                    left: shiftWidth[pos0](),
                };
                break;
            case PopoverPlacement.Left:
                targetElPos = {
                    top: shiftHeight[pos1](),
                    left: hostElPos.left - targetElWidth,
                };
                break;
            case PopoverPlacement.Bottom:
                targetElPos = {
                    top: shiftHeight[pos0](),
                    left: shiftWidth[pos1](),
                };
                break;
            case PopoverPlacement.TopLeft:
                targetElPos = {
                    top: hostElPos.top - targetElHeight,
                    left: shiftWidth['topOrBottomLeft'](),
                };
                break;
            case PopoverPlacement.TopRight:
                targetElPos = {
                    top: hostElPos.top - targetElHeight,
                    left: shiftWidth['topOrBottomRight'](),
                };
                break;
            case PopoverPlacement.BottomLeft:
                targetElPos = {
                    top: shiftHeight[PopoverPlacement.Bottom](),
                    left: shiftWidth['topOrBottomLeft'](),
                };
                break;
            case PopoverPlacement.BottomRight:
                targetElPos = {
                    top: shiftHeight[PopoverPlacement.Bottom](),
                    left: shiftWidth['topOrBottomRight'](),
                };
                break;
            default:
                targetElPos = {
                    top: hostElPos.top - targetElHeight,
                    left: shiftWidth[pos1](),
                };
                break;
        }
        return targetElPos;
    }
    position(nativeEl) {
        let offsetParentBCR = { top: 0, left: 0 };
        const elBCR = this.offset(nativeEl);
        const offsetParentEl = this.parentOffsetEl(nativeEl);
        if (offsetParentEl !== window.document) {
            offsetParentBCR = this.offset(offsetParentEl);
            offsetParentBCR.top +=
                offsetParentEl.clientTop - offsetParentEl.scrollTop;
            offsetParentBCR.left +=
                offsetParentEl.clientLeft - offsetParentEl.scrollLeft;
        }
        const boundingClientRect = nativeEl.getBoundingClientRect();
        return {
            width: boundingClientRect.width || nativeEl.offsetWidth,
            height: boundingClientRect.height || nativeEl.offsetHeight,
            top: elBCR.top - offsetParentBCR.top,
            left: elBCR.left - offsetParentBCR.left,
        };
    }
    offset(nativeEl) {
        const boundingClientRect = nativeEl.getBoundingClientRect();
        return {
            width: boundingClientRect.width || nativeEl.offsetWidth,
            height: boundingClientRect.height || nativeEl.offsetHeight,
            top: boundingClientRect.top +
                (window.pageYOffset || window.document.documentElement.scrollTop),
            left: boundingClientRect.left +
                (window.pageXOffset || window.document.documentElement.scrollLeft),
        };
    }
    getStyle(nativeEl, cssProp) {
        if (nativeEl.currentStyle) {
            // IE
            return nativeEl.currentStyle[cssProp];
        }
        if (window.getComputedStyle) {
            return window.getComputedStyle(nativeEl)[cssProp];
        }
        // finally try and get inline style
        return nativeEl.style[cssProp];
    }
    isStaticPositioned(nativeEl) {
        return (this.getStyle(nativeEl, 'position') || 'static') === 'static';
    }
    parentOffsetEl(nativeEl) {
        let offsetParent = nativeEl.offsetParent || window.document;
        while (offsetParent &&
            offsetParent !== window.document &&
            this.isStaticPositioned(offsetParent)) {
            offsetParent = offsetParent.offsetParent;
        }
        return offsetParent || window.document;
    }
    // Check for overflow of the viewport and reflect the position if necessary.
    getEffectivePlacement(placement, hostElement, targetElement) {
        const hostElBoundingRect = hostElement.getBoundingClientRect();
        const desiredPlacement = placement || PopoverPlacement.Top;
        // Determines if a popover overflows in a direction when in a specific position.
        const overflows = {
            positionTop: {
                top: hostElBoundingRect.top - targetElement.offsetHeight < 0,
                right: hostElBoundingRect.left +
                    hostElBoundingRect.width / 2 +
                    targetElement.offsetWidth / 2 >
                    this.windowWidth,
                left: hostElBoundingRect.left +
                    hostElBoundingRect.width / 2 -
                    targetElement.offsetWidth / 2 <
                    0,
            },
            positionTopRight: {
                top: hostElBoundingRect.top - targetElement.offsetHeight < 0,
                right: hostElBoundingRect.right + targetElement.offsetWidth >
                    this.windowWidth,
            },
            positionRight: {
                top: hostElBoundingRect.top +
                    hostElBoundingRect.height / 2 -
                    targetElement.offsetHeight / 2 <
                    0,
                right: hostElBoundingRect.right + targetElement.offsetWidth >
                    this.windowWidth,
                bottom: hostElBoundingRect.top +
                    hostElBoundingRect.height / 2 +
                    targetElement.offsetHeight / 2 >
                    this.windowHeight,
            },
            positionBottomRight: {
                right: hostElBoundingRect.right + targetElement.offsetWidth >
                    this.windowWidth,
                bottom: hostElBoundingRect.bottom + targetElement.offsetHeight >
                    this.windowHeight,
            },
            positionBottom: {
                right: hostElBoundingRect.left +
                    hostElBoundingRect.width / 2 +
                    targetElement.offsetWidth / 2 >
                    this.windowWidth,
                bottom: hostElBoundingRect.bottom + targetElement.offsetHeight >
                    this.windowHeight,
                left: hostElBoundingRect.left +
                    hostElBoundingRect.width / 2 -
                    targetElement.offsetWidth / 2 <
                    0,
            },
            positionBottomLeft: {
                bottom: hostElBoundingRect.bottom + targetElement.offsetHeight >
                    this.windowHeight,
                left: hostElBoundingRect.left - targetElement.offsetWidth < 0,
            },
            positionLeft: {
                left: hostElBoundingRect.left < targetElement.offsetWidth,
                top: hostElBoundingRect.top +
                    hostElBoundingRect.height / 2 -
                    targetElement.offsetHeight / 2 <
                    0,
                bottom: hostElBoundingRect.top +
                    hostElBoundingRect.height / 2 +
                    targetElement.offsetHeight / 2 >
                    this.windowHeight,
            },
            positionTopLeft: {
                top: hostElBoundingRect.top - targetElement.offsetHeight < 0,
                left: hostElBoundingRect.left - targetElement.offsetWidth < 0,
            },
        };
        if (desiredPlacement === PopoverPlacement.Top) {
            // If it overflows on the top AND left, go to bottom-right.
            if (overflows.positionTop.top && overflows.positionTop.left) {
                return PopoverPlacement.BottomRight;
                // If it overflows on the top AND right, go to bottom-left.
            }
            else if (overflows.positionTop.top && overflows.positionTop.right) {
                return PopoverPlacement.BottomLeft;
                // If it only overflows on the top, go to bottom.
            }
            else if (overflows.positionTop.top) {
                return PopoverPlacement.Bottom;
                // If it only overflows to the right, go to top-left.
            }
            else if (overflows.positionTop.right) {
                return PopoverPlacement.TopLeft;
                // If it only overflows to the left, go to top-right.
            }
            else if (overflows.positionTop.left) {
                return PopoverPlacement.TopRight;
            }
            else {
                return PopoverPlacement.Top;
            }
        }
        if (desiredPlacement === PopoverPlacement.TopRight) {
            // If it overflows on the top AND the right, try in the order: bottom, Bottom-left, left.
            if (overflows.positionTopRight.top && overflows.positionTopRight.right) {
                if (overflows.positionBottom.bottom) {
                    return PopoverPlacement.Left;
                }
                else if (overflows.positionBottom.right) {
                    return PopoverPlacement.BottomLeft;
                }
                else {
                    return PopoverPlacement.Bottom;
                }
                // If it only overflows on the top, try in the order: right, bottom-right.
            }
            else if (overflows.positionTopRight.top) {
                if (overflows.positionRight.top) {
                    return PopoverPlacement.BottomRight;
                }
                else {
                    return PopoverPlacement.Right;
                }
                // If it only overflows on the right, try in the order: top, top-left.
            }
            else if (overflows.positionTopRight.right) {
                if (overflows.positionTop.right) {
                    return PopoverPlacement.TopLeft;
                }
                else {
                    return PopoverPlacement.Top;
                }
            }
            else {
                return PopoverPlacement.TopRight;
            }
        }
        if (desiredPlacement === PopoverPlacement.Right) {
            // If it overflows on the right AND the top, try in the order: bottom-right, bottom, bottom-left.
            if (overflows.positionRight.right && overflows.positionRight.top) {
                if (overflows.positionBottomRight.right &&
                    overflows.positionBottom.right) {
                    return PopoverPlacement.BottomLeft;
                }
                else if (overflows.positionBottomRight.right) {
                    return PopoverPlacement.Bottom;
                }
                else {
                    return PopoverPlacement.BottomRight;
                }
                // If it overflows on the right AND the bottom, try in the order: top-right, top, top-left.
            }
            else if (overflows.positionRight.right &&
                overflows.positionRight.bottom) {
                if (overflows.positionTopRight.right && overflows.positionTop.right) {
                    return PopoverPlacement.TopLeft;
                }
                else if (overflows.positionTopRight.right) {
                    return PopoverPlacement.Top;
                }
                else {
                    return PopoverPlacement.TopRight;
                }
                // If it only overflows on the right, try all top positions from right to left, then try all bottom positions right to left.
            }
            else if (overflows.positionRight.right) {
                if (overflows.positionTop.top) {
                    if (overflows.positionBottom.right) {
                        return PopoverPlacement.BottomLeft;
                    }
                    else if (overflows.positionBottomRight.right) {
                        return PopoverPlacement.Bottom;
                    }
                    else {
                        return PopoverPlacement.BottomRight;
                    }
                }
                else {
                    if (overflows.positionTop.right) {
                        return PopoverPlacement.TopLeft;
                    }
                    else if (overflows.positionTopRight.right) {
                        return PopoverPlacement.Top;
                    }
                    else {
                        return PopoverPlacement.TopRight;
                    }
                }
                // If it only over flows on the top, go bottom-right.
            }
            else if (overflows.positionRight.top) {
                return PopoverPlacement.BottomRight;
                // If it only overflows on the bottom, go top-right.
            }
            else if (overflows.positionRight.bottom) {
                return PopoverPlacement.TopRight;
            }
            else {
                return PopoverPlacement.Right;
            }
        }
        if (desiredPlacement === PopoverPlacement.BottomRight) {
            // If it overflows on the bottom AND the right, try in the order: top, top-left, left.
            if (overflows.positionBottomRight.bottom &&
                overflows.positionBottomRight.right) {
                if (overflows.positionTop.top) {
                    return PopoverPlacement.Left;
                }
                else if (overflows.positionTop.right) {
                    return PopoverPlacement.TopLeft;
                }
                else {
                    return PopoverPlacement.Top;
                }
                // If it only overflows on the bottom, try in the order: right, top-right.
            }
            else if (overflows.positionBottomRight.bottom) {
                if (overflows.positionRight.bottom) {
                    return PopoverPlacement.TopRight;
                }
                else {
                    return PopoverPlacement.Right;
                }
                // If it only overflows on the right, try in the order: bottom, bottom-left.
            }
            else if (overflows.positionBottomRight.right) {
                if (overflows.positionBottom.right) {
                    return PopoverPlacement.BottomLeft;
                }
                else {
                    return PopoverPlacement.Bottom;
                }
            }
            else {
                return PopoverPlacement.BottomRight;
            }
        }
        if (desiredPlacement === PopoverPlacement.Bottom) {
            // If it overflows on the bottom AND left, go to top-right.
            if (overflows.positionBottom.bottom && overflows.positionBottom.left) {
                return PopoverPlacement.TopRight;
                // If it overflows on the bottom AND right, go to top-left.
            }
            else if (overflows.positionBottom.bottom &&
                overflows.positionBottom.right) {
                return PopoverPlacement.TopLeft;
                // If it only overflows on the bottom, go to top.
            }
            else if (overflows.positionBottom.bottom) {
                return PopoverPlacement.Top;
                // If it only overflows to the right, go to bottom-left.
            }
            else if (overflows.positionBottom.right) {
                return PopoverPlacement.BottomLeft;
                // If it only overflows to the left, go to bottom-right.
            }
            else if (overflows.positionBottom.left) {
                return PopoverPlacement.BottomRight;
            }
            else {
                return PopoverPlacement.Bottom;
            }
        }
        if (desiredPlacement === PopoverPlacement.BottomLeft) {
            // If it overflows on the bottom AND the left, try in the order: top, top-right, right.
            if (overflows.positionBottomLeft.bottom &&
                overflows.positionBottomLeft.left) {
                if (overflows.positionTop.top) {
                    return PopoverPlacement.Right;
                }
                else if (overflows.positionTop.left) {
                    return PopoverPlacement.TopRight;
                }
                else {
                    return PopoverPlacement.Top;
                }
                // If it only overflows on the bottom, try in the order: left, top-left.
            }
            else if (overflows.positionBottomLeft.bottom) {
                if (overflows.positionLeft.bottom) {
                    return PopoverPlacement.TopLeft;
                }
                else {
                    return PopoverPlacement.Left;
                }
                // If it only overflows on the left, try in the order: bottom, bottom-right.
            }
            else if (overflows.positionBottomLeft.left) {
                if (overflows.positionBottom.left) {
                    return PopoverPlacement.BottomRight;
                }
                else {
                    return PopoverPlacement.Bottom;
                }
            }
            else {
                return PopoverPlacement.BottomLeft;
            }
        }
        if (desiredPlacement === PopoverPlacement.Left) {
            // If it overflows on the left AND the top, try in the order: bottom-left, bottom, bottom-right.
            if (overflows.positionLeft.left && overflows.positionLeft.top) {
                if (overflows.positionBottomLeft.left &&
                    overflows.positionBottom.left) {
                    return PopoverPlacement.BottomRight;
                }
                else if (overflows.positionBottomRight.right) {
                    return PopoverPlacement.Bottom;
                }
                else {
                    return PopoverPlacement.BottomLeft;
                }
                // If it overflows on the left AND the bottom, try in the order: top-left, top, top-right.
            }
            else if (overflows.positionLeft.left && overflows.positionLeft.bottom) {
                if (overflows.positionTopLeft.left && overflows.positionTop.left) {
                    return PopoverPlacement.TopRight;
                }
                else if (overflows.positionTopLeft.left) {
                    return PopoverPlacement.Top;
                }
                else {
                    return PopoverPlacement.TopLeft;
                }
                // If it only overflows on the left, try all top positions from left to right, then try all bottom positions left to right.
            }
            else if (overflows.positionLeft.left) {
                if (overflows.positionTop.top) {
                    if (overflows.positionBottom.left) {
                        return PopoverPlacement.BottomRight;
                    }
                    else if (overflows.positionBottomLeft.left) {
                        return PopoverPlacement.Bottom;
                    }
                    else {
                        return PopoverPlacement.BottomLeft;
                    }
                }
                else {
                    if (overflows.positionTop.left) {
                        return PopoverPlacement.TopRight;
                    }
                    else if (overflows.positionTopLeft.left) {
                        return PopoverPlacement.Top;
                    }
                    else {
                        return PopoverPlacement.TopLeft;
                    }
                }
                // If it only over flows on the top, go bottom-left.
            }
            else if (overflows.positionLeft.top) {
                return PopoverPlacement.BottomLeft;
                // If it only overflows on the bottom, go top-left.
            }
            else if (overflows.positionLeft.bottom) {
                return PopoverPlacement.TopLeft;
            }
            else {
                return PopoverPlacement.Left;
            }
        }
        if (desiredPlacement === PopoverPlacement.TopLeft) {
            // If it overflows on the top AND the left, try in the order: bottom, Bottom-right, right.
            if (overflows.positionTopLeft.top && overflows.positionTopLeft.left) {
                if (overflows.positionBottom.bottom) {
                    return PopoverPlacement.Right;
                }
                else if (overflows.positionBottom.left) {
                    return PopoverPlacement.BottomRight;
                }
                else {
                    return PopoverPlacement.Bottom;
                }
                // If it only overflows on the top, try in the order: left, bottom-left.
            }
            else if (overflows.positionTopLeft.top) {
                if (overflows.positionLeft.top) {
                    return PopoverPlacement.BottomLeft;
                }
                else {
                    return PopoverPlacement.Left;
                }
                // If it only overflows on the left, try in the order: top, top-right.
            }
            else if (overflows.positionTopLeft.left) {
                if (overflows.positionTop.left) {
                    return PopoverPlacement.TopRight;
                }
                else {
                    return PopoverPlacement.Top;
                }
            }
            else {
                return PopoverPlacement.TopLeft;
            }
        }
        return desiredPlacement;
    }
}
PopoverContentComponent.ɵfac = function PopoverContentComponent_Factory(t) { return new (t || PopoverContentComponent)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(ChangeDetectorRef), ɵɵdirectiveInject(Renderer2)); };
PopoverContentComponent.ɵcmp = ɵɵdefineComponent({ type: PopoverContentComponent, selectors: [["terra-popover-content"]], viewQuery: function PopoverContentComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(_c0$1, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.popoverDiv = _t.first);
    } }, hostBindings: function PopoverContentComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵɵlistener("resize", function PopoverContentComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, ɵɵresolveWindow);
    } }, inputs: { content: "content", placement: "placement", title: "title", parentClass: "parentClass", animation: "animation", closeOnClickOutside: "closeOnClickOutside", closeOnMouseOutside: "closeOnMouseOutside", appendToBody: "appendToBody", size: "size" }, ngContentSelectors: _c2, decls: 9, vars: 26, consts: [["role", "popover", 3, "ngClass"], ["popoverDiv", ""], [1, "virtual-area", 3, "hidden"], [1, "arrow"], [1, "popover-header", 3, "hidden"], [1, "popover-body"]], template: function PopoverContentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "div", 0, 1);
        ɵɵelement(2, "div", 2);
        ɵɵelement(3, "div", 3);
        ɵɵelementStart(4, "div", 4);
        ɵɵtext(5);
        ɵɵelementEnd();
        ɵɵelementStart(6, "div", 5);
        ɵɵprojection(7);
        ɵɵtext(8);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵclassMapInterpolate2("bs-popover-", ctx.effectivePlacement, " popover-content popover ", ctx.parentClass, "");
        ɵɵstyleProp("top", ctx.top, "px")("left", ctx.left, "px")("transition", ctx.transitionEnabled ? "0.15s opacity" : "0.15s opacity")("opacity", ctx.opacity)("visibility", ctx.opacity === 0 ? "hidden" : "visible");
        ɵɵproperty("ngClass", ɵɵpureFunction5(20, _c1, ctx.size === "small", ctx.size === "medium-small", ctx.size === "medium", ctx.size === "large", ctx.isIn));
        ɵɵattribute("aria-hidden", ctx.opacity === 0);
        ɵɵadvance(2);
        ɵɵproperty("hidden", !ctx.closeOnMouseOutside);
        ɵɵadvance(2);
        ɵɵproperty("hidden", !ctx.title);
        ɵɵadvance(1);
        ɵɵtextInterpolate(ctx.title);
        ɵɵadvance(3);
        ɵɵtextInterpolate1(" ", ctx.content, " ");
    } }, directives: [NgClass], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PopoverContentComponent, [{
        type: Component,
        args: [{
                selector: 'terra-popover-content',
                template: `
		<div
			#popoverDiv
			class="bs-popover-{{ effectivePlacement }} popover-content popover {{
				parentClass
			}}"
			[ngClass]="{
				sm: size === 'small',
				'md-sm': size === 'medium-small',
				md: size === 'medium',
				lg: size === 'large',
				in: isIn
			}"
			[style.top.px]="top"
			[style.left.px]="left"
			[style.transition]="transitionEnabled ? '0.15s opacity' : '0.15s opacity'"
			[style.opacity]="opacity"
			[style.visibility]="opacity === 0 ? 'hidden':'visible'"
			[attr.aria-hidden]="opacity === 0"
			role="popover"
		>
			<div [hidden]="!closeOnMouseOutside" class="virtual-area"></div>
			<div class="arrow"></div>
			<div class="popover-header" [hidden]="!title">{{ title }}</div>
			<div class="popover-body">
				<ng-content></ng-content>
				{{ content }}
			</div>
		</div>
	`,
            }]
    }], function () { return [{ type: ElementRef }, { type: ChangeDetectorRef }, { type: Renderer2 }]; }, { content: [{
            type: Input
        }], placement: [{
            type: Input
        }], title: [{
            type: Input
        }], parentClass: [{
            type: Input
        }], animation: [{
            type: Input
        }], closeOnClickOutside: [{
            type: Input
        }], closeOnMouseOutside: [{
            type: Input
        }], appendToBody: [{
            type: Input
        }], size: [{
            type: Input
        }], popoverDiv: [{
            type: ViewChild,
            args: ['popoverDiv', { static: true }]
        }], onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }] }); })();

/**
 * This is a continuation of ngx-popover
 * @Reference {github} https://github.com/pleerock/ngx-popover
 */
/**
 * @group Basic Toolkit
 * @component Popover Directive
 */
class TerraPopoverDirective {
    // -------------------------------------------------------------------------
    // Constructor
    // -------------------------------------------------------------------------
    constructor(viewContainerRef, cdr, resolver, appRef, injector) {
        this.viewContainerRef = viewContainerRef;
        this.cdr = cdr;
        this.resolver = resolver;
        this.appRef = appRef;
        this.injector = injector;
        // -------------------------------------------------------------------------
        // Properties
        // -------------------------------------------------------------------------
        this.popoverContentComponent = PopoverContentComponent;
        this.popoverOnHover = true;
        this.inputConfigure = false;
        this.popoverDismissTimeout = 0;
        this.popoverShown = new EventEmitter();
        this.popoverHidden = new EventEmitter();
    }
    // -------------------------------------------------------------------------
    // Event listeners
    // -------------------------------------------------------------------------
    showOrHideOnClick(evt) {
        if (this.inputConfigure) {
            return;
        }
        else {
            if (this.popoverOnHover) {
                return;
            }
            if (this.popoverDisabled) {
                return;
            }
            evt.stopImmediatePropagation();
            this.toggle();
        }
    }
    showOrHideOnTouch(evt) {
        evt.stopImmediatePropagation();
        if (this.inputConfigure) {
            return;
        }
        else {
            if (!this.popoverOnHover) {
                return;
            }
            if (this.popoverDisabled) {
                return;
            }
            this.toggle();
        }
    }
    showOnFocus(evt) {
        if (this.inputConfigure) {
            this.show();
        }
        else {
            if (!this.popoverOnHover) {
                return;
            }
            if (this.popoverDisabled) {
                return;
            }
            this.show();
        }
    }
    showOnHover() {
        if (!this.popoverOnHover) {
            return;
        }
        if (this.popoverDisabled) {
            return;
        }
        this.show();
    }
    hideOnFocusOut() {
        if (this.inputConfigure) {
            setTimeout(() => {
                this.hide();
            });
        }
        else {
            if (this.popoverCloseOnMouseOutside) {
                return; // don't do anything since we do not control this
            }
            if (!this.popoverOnHover) {
                return;
            }
            if (this.popoverDisabled) {
                return;
            }
            this.hide();
        }
    }
    hideOnEnter() {
        if (this.inputConfigure) {
            this.hide();
        }
        else {
            if (this.popoverCloseOnMouseOutside) {
                return; // don't do anything since we do not control this
            }
            if (!this.popoverOnHover) {
                return;
            }
            if (this.popoverDisabled) {
                return;
            }
            this.hide();
        }
    }
    hideOnHover() {
        if (this.popoverCloseOnMouseOutside) {
            return; // don't do anything since we do not control this
        }
        if (!this.popoverOnHover) {
            return;
        }
        if (this.popoverDisabled) {
            return;
        }
        this.hide();
    }
    ngOnChanges(changes) {
        if (changes['popoverDisabled']) {
            if (changes['popoverDisabled'].currentValue) {
                this.hide();
            }
        }
    }
    createComponent(component) {
        const factory = this.resolver.resolveComponentFactory(component);
        // Create a component reference from the component
        const componentRef = this.appendToBody
            ? factory.create(this.injector)
            : this.viewContainerRef.createComponent(factory);
        if (this.appendToBody) {
            // Attach component to the appRef so that it's inside the ng component tree
            this.appRef.attachView(componentRef.hostView);
            // Get DOM element from component
            const domElem = componentRef.hostView
                .rootNodes[0];
            // Append DOM element to the body
            document.body.appendChild(domElem);
        }
        return componentRef;
    }
    removeComponent(componentRef) {
        if (this.popover) {
            if (this.appendToBody) {
                this.appRef.detachView(componentRef.hostView);
            }
            componentRef.destroy();
        }
    }
    // -------------------------------------------------------------------------
    // Public Methods
    // -------------------------------------------------------------------------
    toggle() {
        if (!this.visible) {
            this.show();
        }
        else {
            this.hide();
        }
    }
    show() {
        if (this.visible) {
            return;
        }
        this.visible = true;
        if (typeof this.contents === 'string') {
            if (!this.visible) {
                return;
            }
            this.popover = this.createComponent(this.popoverContentComponent);
            const popover = this.popover.instance;
            popover.popover = this;
            popover.content = this.contents;
            if (this.popoverPlacement !== undefined) {
                popover.placement = this.popoverPlacement;
            }
            if (this.popoverAnimation !== undefined) {
                popover.animation = this.popoverAnimation;
            }
            if (this.popoverTitle !== undefined) {
                popover.title = this.popoverTitle;
            }
            if (this.popoverCloseOnClickOutside !== undefined) {
                popover.closeOnClickOutside = this.popoverCloseOnClickOutside;
            }
            if (this.popoverCloseOnMouseOutside !== undefined) {
                popover.closeOnMouseOutside = this.popoverCloseOnMouseOutside;
            }
            if (this.popoverSize) {
                popover.size = this.popoverSize;
            }
            popover.appendToBody = this.appendToBody;
            popover.onCloseFromOutside.subscribe(() => this.hide());
            // if dismissTimeout option is set, then this popover will be dismissed in dismissTimeout time
            if (this.popoverDismissTimeout > 0) {
                setTimeout(() => this.hide(), this.popoverDismissTimeout);
            }
        }
        else {
            const popover = this.contents;
            popover.popover = this;
            if (this.popoverPlacement !== undefined) {
                popover.placement = this.popoverPlacement;
            }
            if (this.popoverAnimation !== undefined) {
                popover.animation = this.popoverAnimation;
            }
            if (this.popoverTitle !== undefined) {
                popover.title = this.popoverTitle;
            }
            if (this.popoverCloseOnClickOutside !== undefined) {
                popover.closeOnClickOutside = this.popoverCloseOnClickOutside;
            }
            if (this.popoverCloseOnMouseOutside !== undefined) {
                popover.closeOnMouseOutside = this.popoverCloseOnMouseOutside;
            }
            if (this.popoverSize) {
                popover.size = this.popoverSize;
            }
            popover.appendToBody = this.appendToBody;
            popover.onCloseFromOutside.subscribe(() => this.hide());
            // if dismissTimeout option is set, then this popover will be dismissed in dismissTimeout time
            if (this.popoverDismissTimeout > 0) {
                setTimeout(() => this.hide(), this.popoverDismissTimeout);
            }
            popover.show();
        }
        this.cdr.detectChanges();
        this.popoverShown.emit(this);
    }
    hide() {
        if (!this.visible) {
            return;
        }
        this.visible = false;
        this.removeComponent(this.popover);
        if (this.contents instanceof PopoverContentComponent) {
            this.contents.hideFromPopover();
        }
        this.cdr.detectChanges();
        this.popoverHidden.emit(this);
    }
    getElement() {
        return this.viewContainerRef.element.nativeElement;
    }
}
TerraPopoverDirective.ɵfac = function TerraPopoverDirective_Factory(t) { return new (t || TerraPopoverDirective)(ɵɵdirectiveInject(ViewContainerRef), ɵɵdirectiveInject(ChangeDetectorRef), ɵɵdirectiveInject(ComponentFactoryResolver), ɵɵdirectiveInject(ApplicationRef), ɵɵdirectiveInject(Injector)); };
TerraPopoverDirective.ɵdir = ɵɵdefineDirective({ type: TerraPopoverDirective, selectors: [["", "terraPopover", ""]], hostBindings: function TerraPopoverDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵɵlistener("click", function TerraPopoverDirective_click_HostBindingHandler($event) { return ctx.showOrHideOnClick($event); })("touchend", function TerraPopoverDirective_touchend_HostBindingHandler($event) { return ctx.showOrHideOnTouch($event); })("focusin", function TerraPopoverDirective_focusin_HostBindingHandler($event) { return ctx.showOnFocus($event); })("mouseenter", function TerraPopoverDirective_mouseenter_HostBindingHandler() { return ctx.showOnHover(); })("focusout", function TerraPopoverDirective_focusout_HostBindingHandler() { return ctx.hideOnFocusOut(); })("keydown.enter", function TerraPopoverDirective_keydown_enter_HostBindingHandler() { return ctx.hideOnEnter(); }, false, ɵɵresolveDocument)("mouseleave", function TerraPopoverDirective_mouseleave_HostBindingHandler() { return ctx.hideOnHover(); });
    } }, inputs: { contents: ["terraPopover", "contents"], popoverSize: "popoverSize", popoverDisabled: "popoverDisabled", popoverAnimation: "popoverAnimation", popoverPlacement: "popoverPlacement", popoverTitle: "popoverTitle", popoverOnHover: "popoverOnHover", inputConfigure: "inputConfigure", popoverCloseOnClickOutside: "popoverCloseOnClickOutside", popoverCloseOnMouseOutside: "popoverCloseOnMouseOutside", popoverDismissTimeout: "popoverDismissTimeout", appendToBody: "appendToBody" }, outputs: { popoverShown: "popoverShown", popoverHidden: "popoverHidden" }, exportAs: ["terraPopover"], features: [ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TerraPopoverDirective, [{
        type: Directive,
        args: [{
                selector: '[terraPopover]',
                exportAs: 'terraPopover',
            }]
    }], function () { return [{ type: ViewContainerRef }, { type: ChangeDetectorRef }, { type: ComponentFactoryResolver }, { type: ApplicationRef }, { type: Injector }]; }, { contents: [{
            type: Input,
            args: ['terraPopover']
        }], popoverSize: [{
            type: Input
        }], popoverDisabled: [{
            type: Input
        }], popoverAnimation: [{
            type: Input
        }], popoverPlacement: [{
            type: Input
        }], popoverTitle: [{
            type: Input
        }], popoverOnHover: [{
            type: Input
        }], inputConfigure: [{
            type: Input
        }], popoverCloseOnClickOutside: [{
            type: Input
        }], popoverCloseOnMouseOutside: [{
            type: Input
        }], popoverDismissTimeout: [{
            type: Input
        }], appendToBody: [{
            type: Input
        }], popoverShown: [{
            type: Output
        }], popoverHidden: [{
            type: Output
        }], showOrHideOnClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], showOrHideOnTouch: [{
            type: HostListener,
            args: ['touchend', ['$event']]
        }], showOnFocus: [{
            type: HostListener,
            args: ['focusin', ['$event']]
        }], showOnHover: [{
            type: HostListener,
            args: ['mouseenter']
        }], hideOnFocusOut: [{
            type: HostListener,
            args: ['focusout']
        }], hideOnEnter: [{
            type: HostListener,
            args: ['document:keydown.enter']
        }], hideOnHover: [{
            type: HostListener,
            args: ['mouseleave']
        }] }); })();

class PopoverModule {
}
PopoverModule.ɵmod = ɵɵdefineNgModule({ type: PopoverModule });
PopoverModule.ɵinj = ɵɵdefineInjector({ factory: function PopoverModule_Factory(t) { return new (t || PopoverModule)(); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(PopoverModule, { declarations: [TerraPopoverDirective, PopoverContentComponent], imports: [CommonModule], exports: [PopoverContentComponent, TerraPopoverDirective] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(PopoverModule, [{
        type: NgModule,
        args: [{
                declarations: [TerraPopoverDirective, PopoverContentComponent],
                imports: [CommonModule],
                exports: [PopoverContentComponent, TerraPopoverDirective],
                entryComponents: [PopoverContentComponent],
            }]
    }], null, null); })();

class AutocompleteLibComponent {
    constructor() { }
    ngOnInit() {
    }
}
AutocompleteLibComponent.ɵfac = function AutocompleteLibComponent_Factory(t) { return new (t || AutocompleteLibComponent)(); };
AutocompleteLibComponent.ɵcmp = ɵɵdefineComponent({ type: AutocompleteLibComponent, selectors: [["ng-autocomplete-lib"]], decls: 2, vars: 0, template: function AutocompleteLibComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "p");
        ɵɵtext(1, " autocomplete-lib works! ");
        ɵɵelementEnd();
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AutocompleteLibComponent, [{
        type: Component,
        args: [{
                selector: 'ng-autocomplete-lib',
                template: `
    <p>
      autocomplete-lib works!
    </p>
  `,
                styles: []
            }]
    }], function () { return []; }, null); })();

class HighlightPipe {
    transform(text, search, searchKeyword) {
        let pattern = search.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
        pattern = pattern.split(' ').filter((t) => {
            return t.length > 0;
        }).join('|');
        const regex = new RegExp(pattern, 'gi');
        if (!search) {
            return text;
        }
        if (searchKeyword) {
            const name = text[searchKeyword].replace(regex, (match) => `<b>${match}</b>`);
            // copy original object
            const text2 = Object.assign({}, text);
            // set bold value into searchKeyword of copied object
            text2[searchKeyword] = name;
            return text2;
        }
        else {
            return search ? text.replace(regex, (match) => `<b>${match}</b>`) : text;
        }
    }
}
HighlightPipe.ɵfac = function HighlightPipe_Factory(t) { return new (t || HighlightPipe)(); };
HighlightPipe.ɵpipe = ɵɵdefinePipe({ name: "highlight", type: HighlightPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(HighlightPipe, [{
        type: Pipe,
        args: [{
                name: 'highlight'
            }]
    }], null, null); })();

const _c0$2 = ["searchInput"];
const _c1$1 = ["filteredListElement"];
const _c2$1 = ["historyListElement"];
function AutocompleteComponent_ion_icon_5_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-icon", 11);
    ɵɵlistener("click", function AutocompleteComponent_ion_icon_5_Template_ion_icon_click_0_listener($event) { ɵɵrestoreView(_r7); const ctx_r6 = ɵɵnextContext(); return ctx_r6.remove($event); });
    ɵɵelementEnd();
} }
function AutocompleteComponent_li_9_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
const _c3 = function (a0) { return { $implicit: a0 }; };
function AutocompleteComponent_li_9_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 14);
    ɵɵlistener("click", function AutocompleteComponent_li_9_div_1_Template_div_click_0_listener() { ɵɵrestoreView(_r15); const item_r8 = ɵɵnextContext().$implicit; const ctx_r13 = ɵɵnextContext(); return ctx_r13.select(item_r8); });
    ɵɵtemplate(1, AutocompleteComponent_li_9_div_1_ng_container_1_Template, 1, 0, "ng-container", 15);
    ɵɵpipe(2, "highlight");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = ɵɵnextContext();
    const idx_r9 = ctx_r16.index;
    const item_r8 = ctx_r16.$implicit;
    const ctx_r10 = ɵɵnextContext();
    ɵɵclassProp("complete-selected", idx_r9 === ctx_r10.selectedIdx);
    ɵɵadvance(1);
    ɵɵproperty("ngTemplateOutlet", ctx_r10.itemTemplate)("ngTemplateOutletContext", ɵɵpureFunction1(7, _c3, ɵɵpipeBind2(2, 4, item_r8, ctx_r10.toHighlight)));
} }
function AutocompleteComponent_li_9_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
function AutocompleteComponent_li_9_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 14);
    ɵɵlistener("click", function AutocompleteComponent_li_9_div_2_Template_div_click_0_listener() { ɵɵrestoreView(_r20); const item_r8 = ɵɵnextContext().$implicit; const ctx_r18 = ɵɵnextContext(); return ctx_r18.select(item_r8); });
    ɵɵtemplate(1, AutocompleteComponent_li_9_div_2_ng_container_1_Template, 1, 0, "ng-container", 15);
    ɵɵpipe(2, "highlight");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = ɵɵnextContext();
    const idx_r9 = ctx_r21.index;
    const item_r8 = ctx_r21.$implicit;
    const ctx_r11 = ɵɵnextContext();
    ɵɵclassProp("complete-selected", idx_r9 === ctx_r11.selectedIdx);
    ɵɵadvance(1);
    ɵɵproperty("ngTemplateOutlet", ctx_r11.itemTemplate)("ngTemplateOutletContext", ɵɵpureFunction1(8, _c3, ɵɵpipeBind3(2, 4, item_r8, ctx_r11.toHighlight, ctx_r11.searchKeyword)));
} }
function AutocompleteComponent_li_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "li", 12);
    ɵɵtemplate(1, AutocompleteComponent_li_9_div_1_Template, 3, 9, "div", 13);
    ɵɵtemplate(2, AutocompleteComponent_li_9_div_2_Template, 3, 10, "div", 13);
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r8 = ctx.$implicit;
    const ctx_r3 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r3.isTypeString(item_r8));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r3.isTypeString(item_r8));
} }
function AutocompleteComponent_div_10_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
function AutocompleteComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 16);
    ɵɵtemplate(1, AutocompleteComponent_div_10_ng_container_1_Template, 1, 0, "ng-container", 15);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngTemplateOutlet", ctx_r4.notFoundTemplate)("ngTemplateOutletContext", ɵɵpureFunction1(2, _c3, ctx_r4.notFoundText));
} }
function AutocompleteComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 17);
    ɵɵlistener("click", function AutocompleteComponent_div_11_Template_div_click_0_listener() { ɵɵrestoreView(_r24); const ctx_r23 = ɵɵnextContext(); return ctx_r23.handleOverlay(); });
    ɵɵelementEnd();
} }
const _c4 = function (a0) { return { active: a0 }; };
const _c5 = function (a0, a1) { return { "is-hidden": a0, "is-visible": a1 }; };
/**
 * Keyboard events
 */
const isArrowUp = keyCode => keyCode === 38;
const isArrowDown = keyCode => keyCode === 40;
const isArrowUpDown = keyCode => isArrowUp(keyCode) || isArrowDown(keyCode);
const isEnter = keyCode => keyCode === 13;
const isBackspace = keyCode => keyCode === 8;
const isDelete = keyCode => keyCode === 46;
const isESC = keyCode => keyCode === 27;
const isTab = keyCode => keyCode === 9;
class AutocompleteComponent {
    constructor(elementRef, renderer) {
        this.renderer = renderer;
        this.query = ''; // search query
        this.filteredList = []; // list of items
        this.historyList = []; // list of history items
        this.isHistoryListVisible = true;
        this.selectedIdx = -1;
        this.toHighlight = '';
        this.notFound = false;
        this.isFocused = false;
        this.isOpen = false;
        this.isScrollToEnd = false;
        this.overlay = false;
        this.manualOpen = undefined;
        this.manualClose = undefined;
        // @Inputs
        /**
         * Data of items list.
         * It can be array of strings or array of objects.
         */
        this.data = [];
        this.placeholder = '';
        this.heading = '';
        /**
         * Heading text of history list.
         * If it is null then history heading is hidden.
         */
        this.historyHeading = 'Recently selected';
        this.historyListMaxNumber = 15; // maximum number of items in the history list.
        this.notFoundText = 'Not found'; // set custom text when filter returns empty result
        /**
         * The minimum number of characters the user must type before a search is performed.
         */
        this.minQueryLength = 1;
        /**
         * Focus first item in the list
         */
        this.focusFirst = false;
        // @Output events
        /** Event that is emitted whenever an item from the list is selected. */
        this.selected = new EventEmitter();
        /** Event that is emitted whenever an input is changed. */
        this.inputChanged = new EventEmitter();
        /** Event that is emitted whenever an input is focused. */
        this.inputFocused = new EventEmitter();
        /** Event that is emitted whenever an input is cleared. */
        this.inputCleared = new EventEmitter();
        /** Event that is emitted when the autocomplete panel is opened. */
        this.opened = new EventEmitter();
        /** Event that is emitted when the autocomplete panel is closed. */
        this.closed = new EventEmitter();
        /** Event that is emitted when scrolled to the end of items. */
        this.scrolledToEnd = new EventEmitter();
        /**
         * Propagates new value when model changes
         */
        this.propagateChange = () => {
        };
        this.onTouched = () => {
        };
        this.elementRef = elementRef;
    }
    /**
     * Writes a new value from the form model into the view,
     * Updates model
     */
    writeValue(value = '') {
        this.query = value && !this.isTypeString(value) ? value[this.searchKeyword] : value;
    }
    /**
     * Registers a handler that is called when something in the view has changed
     */
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    /**
     * Registers a handler specifically for when a control receives a touch event
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * Event that is called when the value of an input element is changed
     */
    onChange(event) {
        this.propagateChange(event.target.value);
    }
    /**
     * Event that is called when the control status changes to or from DISABLED
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        this.initEventStream();
        this.handleScroll();
    }
    /**
     * Set initial value
     * @param value
     */
    setInitialValue(value) {
        if (this.initialValue) {
            this.select(value);
        }
    }
    /**
     * Update search results
     */
    ngOnChanges(changes) {
        this.setInitialValue(this.initialValue);
        if (changes &&
            changes.data &&
            Array.isArray(changes.data.currentValue)) {
            this.filters();
            this.handleItemsChange();
            if (!changes.data.firstChange && this.isFocused) {
                this.handleOpen();
            }
        }
    }
    /**
     * Items change
     */
    handleItemsChange() {
        this.isScrollToEnd = false;
        if (!this.isOpen) {
            return;
        }
        this.filteredList = this.data;
        this.notFound = !this.filteredList || this.filteredList.length === 0;
        // Filter list when updating data and panel is open
        if (this.isOpen) {
            this.filterList();
        }
    }
    filters() {
        let filter = [];
        this.data = this.data.map(val => {
            return Object.assign(Object.assign({}, val), { name: val.name, override: val.name.trim().toLocaleLowerCase() });
        })
            .filter(val => {
            if (filter.indexOf(val.override) === -1) {
                filter.push(val.override);
                return true;
            }
            else {
                return false;
            }
        })
            .map(val => {
            return Object.assign(Object.assign({}, val), { name: val.name, override: val.name });
        });
    }
    trackByFn(index, item) {
        return item.name.trim().toLocaleLowerCase();
    }
    /**
     * Filter data
     */
    filterList() {
        this.selectedIdx = -1;
        this.initSearchHistory();
        if (this.query != null && this.data) {
            this.toHighlight = this.query;
            this.filteredList = this.customFilter !== undefined ? this.customFilter([...this.data], this.query) : this.defaultFilterFunction();
            // If [focusFirst]="true" automatically focus the first match
            if (this.filteredList.length > 0 && this.focusFirst) {
                this.selectedIdx = 0;
            }
        }
        else {
            this.notFound = false;
        }
    }
    /**
     * Default filter function, used unless customFilter is provided
     */
    defaultFilterFunction() {
        return this.data.filter((item) => {
            if (typeof item === 'string') {
                // string logic, check equality of strings
                return item.toLowerCase().indexOf(this.query.toLowerCase()) > -1;
            }
            else if (typeof item === 'object' && item instanceof Object) {
                // object logic, check property equality
                return item[this.searchKeyword].trim().toLowerCase().indexOf(this.query.toLowerCase()) > -1;
            }
        });
    }
    /**
     * Check if item is a string in the list.
     * @param item
     */
    isTypeString(item) {
        return typeof item === 'string';
    }
    /**
     * Select item in the list.
     * @param item
     */
    select(item) {
        this.query = !this.isTypeString(item) ? item[this.searchKeyword] : item;
        this.isOpen = true;
        this.overlay = false;
        this.selected.emit(item);
        this.propagateChange(item);
        if (this.initialValue) {
            // check if history already exists in localStorage and then update
            const history = window.localStorage.getItem(`${this.historyIdentifier}`);
            if (history) {
                let existingHistory = JSON.parse(localStorage[`${this.historyIdentifier}`]);
                if (!(existingHistory instanceof Array))
                    existingHistory = [];
                // check if selected item exists in existingHistory
                if (!existingHistory.some((existingItem) => !this.isTypeString(existingItem)
                    ? existingItem[this.searchKeyword] == item[this.searchKeyword] : existingItem == item)) {
                    existingHistory.unshift(item);
                    localStorage.setItem(`${this.historyIdentifier}`, JSON.stringify(existingHistory));
                    // check if items don't exceed max allowed number
                    if (existingHistory.length >= this.historyListMaxNumber) {
                        existingHistory.splice(existingHistory.length - 1, 1);
                        localStorage.setItem(`${this.historyIdentifier}`, JSON.stringify(existingHistory));
                    }
                }
                else {
                    // if selected item exists in existingHistory swap to top in array
                    if (!this.isTypeString(item)) {
                        // object logic
                        const copiedExistingHistory = existingHistory.slice(); // copy original existingHistory array
                        const selectedIndex = copiedExistingHistory.map((el) => el[this.searchKeyword]).indexOf(item[this.searchKeyword]);
                        copiedExistingHistory.splice(selectedIndex, 1);
                        copiedExistingHistory.splice(0, 0, item);
                        localStorage.setItem(`${this.historyIdentifier}`, JSON.stringify(copiedExistingHistory));
                    }
                    else {
                        // string logic
                        const copiedExistingHistory = existingHistory.slice(); // copy original existingHistory array
                        copiedExistingHistory.splice(copiedExistingHistory.indexOf(item), 1);
                        copiedExistingHistory.splice(0, 0, item);
                        localStorage.setItem(`${this.historyIdentifier}`, JSON.stringify(copiedExistingHistory));
                    }
                }
            }
            else {
                this.saveHistory(item);
            }
        }
        else {
            this.saveHistory(item);
        }
        this.handleClose();
    }
    /**
     * Document click
     * @param e event
     */
    handleClick(e) {
        let clickedComponent = e.target;
        let inside = false;
        do {
            if (clickedComponent === this.elementRef.nativeElement) {
                inside = true;
                if (this.filteredList.length) {
                    this.handleOpen();
                }
            }
            clickedComponent = clickedComponent.parentNode;
        } while (clickedComponent);
        if (!inside) {
            this.handleClose();
        }
    }
    /**
     * Handle body overlay
     */
    handleOverlay() {
        this.overlay = false;
    }
    /**
     * Scroll items
     */
    handleScroll() {
        this.renderer.listen(this.filteredListElement.nativeElement, 'scroll', () => {
            this.scrollToEnd();
        });
    }
    /**
     * Define panel state
     */
    setPanelState(event) {
        if (event) {
            event.stopPropagation();
        }
        // If controls are untouched
        if (typeof this.manualOpen === 'undefined'
            && typeof this.manualClose === 'undefined') {
            this.isOpen = false;
            this.handleOpen();
        }
        // If one of the controls is untouched and other is deactivated
        if (typeof this.manualOpen === 'undefined'
            && this.manualClose === false
            || typeof this.manualClose === 'undefined'
                && this.manualOpen === false) {
            this.isOpen = false;
            this.handleOpen();
        }
        // if controls are touched but both are deactivated
        if (this.manualOpen === false && this.manualClose === false) {
            this.isOpen = false;
            this.handleOpen();
        }
        // if open control is touched and activated
        if (this.manualOpen) {
            this.isOpen = false;
            this.handleOpen();
            this.manualOpen = false;
        }
        // if close control is touched and activated
        if (this.manualClose) {
            this.isOpen = true;
            this.handleClose();
            this.manualClose = false;
        }
    }
    /**
     * Manual controls
     */
    open() {
        this.manualOpen = true;
        this.isOpen = false;
        this.handleOpen();
    }
    close() {
        this.manualClose = true;
        this.isOpen = true;
        this.handleClose();
    }
    focus() {
        this.handleFocus(event);
    }
    clear() {
        this.remove(event);
    }
    /**
     * Remove search query
     */
    remove(e) {
        e.stopPropagation();
        this.query = '';
        this.inputCleared.emit();
        this.propagateChange(this.query);
        this.setPanelState(e);
        if (this.data && !this.data.length) {
            this.notFound = false;
        }
    }
    /**
     * Initialize historyList search
     */
    initSearchHistory() {
        this.isHistoryListVisible = false;
        if (this.historyIdentifier && !this.query) {
            const history = window.localStorage.getItem(`${this.historyIdentifier}`);
            if (history) {
                this.isHistoryListVisible = true;
                this.filteredList = [];
                this.historyList = history ? JSON.parse(history) : [];
            }
            else {
                this.isHistoryListVisible = false;
            }
        }
        else {
            this.isHistoryListVisible = false;
        }
    }
    handleOpen() {
        if (this.isOpen || this.isOpen && !this.isLoading) {
            return;
        }
        // If data exists
        if (this.data && this.data.length) {
            this.isOpen = true;
            this.overlay = true;
            this.filterList();
            this.opened.emit();
        }
    }
    handleClose() {
        if (!this.isOpen) {
            this.isFocused = false;
            return;
        }
        this.isOpen = false;
        this.overlay = false;
        this.filteredList = [];
        this.selectedIdx = -1;
        this.notFound = false;
        this.isHistoryListVisible = false;
        this.isFocused = false;
        this.closed.emit();
    }
    handleFocus(e) {
        this.searchInput.nativeElement.focus();
        if (this.isFocused) {
            return;
        }
        this.inputFocused.emit(e);
        // if data exists then open
        if (this.data && this.data.length) {
            this.setPanelState(event);
        }
        this.isFocused = true;
    }
    scrollToEnd() {
        if (this.isScrollToEnd) {
            return;
        }
        const scrollTop = this.filteredListElement.nativeElement
            .scrollTop;
        const scrollHeight = this.filteredListElement.nativeElement
            .scrollHeight;
        const elementHeight = this.filteredListElement.nativeElement
            .clientHeight;
        const atBottom = scrollHeight === scrollTop + elementHeight;
        if (atBottom) {
            this.scrolledToEnd.emit();
            this.isScrollToEnd = true;
        }
    }
    /**
     * Initialize keyboard events
     */
    initEventStream() {
        this.inputKeyUp$ = fromEvent(this.searchInput.nativeElement, 'keyup').pipe(map((e) => e));
        this.inputKeyDown$ = fromEvent(this.searchInput.nativeElement, 'keydown').pipe(map((e) => e));
        this.listenEventStream();
    }
    /**
     * Listen keyboard events
     */
    listenEventStream() {
        // key up event
        this.inputKeyUp$
            .pipe(filter(e => !isArrowUpDown(e.keyCode) &&
            !isEnter(e.keyCode) &&
            !isESC(e.keyCode) &&
            !isTab(e.keyCode)), debounceTime(this.debounceTime)).subscribe(e => {
            this.onKeyUp(e);
        });
        // cursor up & down
        this.inputKeyDown$.pipe(filter(e => isArrowUpDown(e.keyCode))).subscribe(e => {
            e.preventDefault();
            this.onFocusItem(e);
        });
        // enter keyup
        this.inputKeyUp$.pipe(filter(e => isEnter(e.keyCode))).subscribe(e => {
            //this.onHandleEnter();
        });
        // enter keydown
        this.inputKeyDown$.pipe(filter(e => isEnter(e.keyCode))).subscribe(e => {
            this.onHandleEnter();
        });
        // ESC
        this.inputKeyUp$.pipe(filter(e => isESC(e.keyCode), debounceTime(100))).subscribe(e => {
            this.onEsc();
        });
        // TAB
        this.inputKeyDown$.pipe(filter(e => isTab(e.keyCode))).subscribe(e => {
            this.onTab();
        });
        // delete
        this.inputKeyDown$.pipe(filter(e => isBackspace(e.keyCode) || isDelete(e.keyCode))).subscribe(e => {
            this.onDelete();
        });
    }
    /**
     * on keyup == when input changed
     * @param e event
     */
    onKeyUp(e) {
        this.notFound = false; // search results are unknown while typing
        // if input is empty
        if (!this.query) {
            this.notFound = false;
            this.inputChanged.emit(e.target.value);
            this.inputCleared.emit();
            this.setPanelState(e);
        }
        // note that '' can be a valid query
        if (!this.query && this.query !== '') {
            return;
        }
        // if query >= to minQueryLength
        if (this.query.length >= this.minQueryLength) {
            this.inputChanged.emit(e.target.value);
            this.filterList();
            // If no results found
            if (!this.filteredList.length && !this.isLoading) {
                this.notFoundText ? this.notFound = true : this.notFound = false;
            }
            if (this.data && !this.data.length) {
                this.isOpen = true;
            }
        }
    }
    /**
     * Keyboard arrow top and arrow bottom
     * @param e event
     */
    onFocusItem(e) {
        // filteredList
        const totalNumItem = this.filteredList.length;
        if (e.key === 'ArrowDown') {
            let sum = this.selectedIdx;
            sum = (this.selectedIdx === null) ? -1 : sum + 1;
            this.selectedIdx = (totalNumItem + sum) % totalNumItem;
            if (totalNumItem - 1 !== this.selectedIdx) {
                this.scrollToFocusedItem(this.selectedIdx);
            }
            else {
                this.selectedIdx = -1;
            }
        }
        else if (e.key === 'ArrowUp') {
            // this.selectedIdx = this.selectedIdx - 1;
            if (this.selectedIdx == 0) {
                this.selectedIdx = this.selectedIdx - 1;
            }
            else {
                this.selectedIdx = (totalNumItem + this.selectedIdx - 1) % totalNumItem;
                this.scrollToFocusedItem(this.selectedIdx);
            }
        }
    }
    /**
     * Scroll to focused item
     * * @param index
     */
    scrollToFocusedItem(index) {
        let listElement = null;
        // Define list element
        if (!this.historyList.length || !this.isHistoryListVisible) {
            // filteredList element
            listElement = this.filteredListElement.nativeElement;
        }
        else {
            // historyList element
            listElement = this.historyListElement.nativeElement;
        }
        const items = Array.prototype.slice.call(listElement.childNodes).filter((node) => {
            if (node.nodeType === 1) {
                // if node is element
                return node.className.includes('item');
            }
            else {
                return false;
            }
        });
        if (!items.length) {
            return;
        }
        const listHeight = listElement.offsetHeight;
        const itemHeight = items[index].offsetHeight;
        const visibleTop = listElement.scrollTop;
        const visibleBottom = listElement.scrollTop + listHeight - itemHeight;
        const targetPosition = items[index].offsetTop;
        if (targetPosition < visibleTop) {
            listElement.scrollTop = targetPosition;
        }
        if (targetPosition > visibleBottom) {
            listElement.scrollTop = targetPosition - listHeight + itemHeight;
        }
    }
    /**
     * Select item on enter click
     */
    onHandleEnter() {
        if (this.selectedIdx === -1) {
            this.select(this.query);
        }
        else {
            // filteredList
            this.query = !this.isTypeString(this.filteredList[this.selectedIdx])
                ? this.filteredList[this.selectedIdx][this.searchKeyword]
                : this.filteredList[this.selectedIdx];
            this.saveHistory(this.filteredList[this.selectedIdx]);
            this.select(this.filteredList[this.selectedIdx]);
        }
        this.isHistoryListVisible = false;
        this.handleClose();
    }
    /**
     * Esc click
     */
    onEsc() {
        this.searchInput.nativeElement.blur();
        this.handleClose();
    }
    /**
     * Tab click
     */
    onTab() {
        this.searchInput.nativeElement.blur();
        this.handleClose();
    }
    /**
     * Delete click
     */
    onDelete() {
        this.isOpen = true;
    }
    /**
     * Select item to save in localStorage
     * @param selected
     */
    saveHistory(selected) {
        if (this.historyIdentifier) {
            // check if selected item exists in historyList
            if (!this.historyList.some((item) => !this.isTypeString(item)
                ? item[this.searchKeyword] == selected[this.searchKeyword] : item == selected)) {
                this.saveHistoryToLocalStorage([selected, ...this.historyList]);
                // check if items don't exceed max allowed number
                if (this.historyList.length >= this.historyListMaxNumber) {
                    this.historyList.splice(this.historyList.length - 1, 1);
                    this.saveHistoryToLocalStorage([selected, ...this.historyList]);
                }
            }
            else {
                // if selected item exists in historyList swap to top in array
                if (!this.isTypeString(selected)) {
                    // object logic
                    const copiedHistoryList = this.historyList.slice(); // copy original historyList array
                    const selectedIndex = copiedHistoryList.map((item) => item[this.searchKeyword]).indexOf(selected[this.searchKeyword]);
                    copiedHistoryList.splice(selectedIndex, 1);
                    copiedHistoryList.splice(0, 0, selected);
                    this.saveHistoryToLocalStorage([...copiedHistoryList]);
                }
                else {
                    // string logic
                    const copiedHistoryList = this.historyList.slice(); // copy original historyList array
                    copiedHistoryList.splice(this.historyList.indexOf(selected), 1);
                    copiedHistoryList.splice(0, 0, selected);
                    this.saveHistoryToLocalStorage([...copiedHistoryList]);
                }
            }
        }
    }
    /**
     * Save item in localStorage
     * @param selected
     */
    saveHistoryToLocalStorage(selected) {
        window.localStorage.setItem(`${this.historyIdentifier}`, JSON.stringify(selected));
    }
    /**
     * Remove item from localStorage
     * @param index
     * @param e event
     */
    removeHistoryItem(index, e) {
        e.stopPropagation();
        this.historyList = this.historyList.filter((v, i) => i !== index);
        this.saveHistoryToLocalStorage(this.historyList);
        if (this.historyList.length == 0) {
            window.localStorage.removeItem(`${this.historyIdentifier}`);
            this.filterList();
        }
    }
    /**
     * Reset localStorage
     * @param e event
     */
    resetHistoryList(e) {
        e.stopPropagation();
        this.historyList = [];
        window.localStorage.removeItem(`${this.historyIdentifier}`);
        this.filterList();
    }
}
AutocompleteComponent.ɵfac = function AutocompleteComponent_Factory(t) { return new (t || AutocompleteComponent)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(Renderer2)); };
AutocompleteComponent.ɵcmp = ɵɵdefineComponent({ type: AutocompleteComponent, selectors: [["ng-autocomplete"]], contentQueries: function AutocompleteComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵɵcontentQuery(dirIndex, TemplateRef, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.customTemplate = _t.first);
    } }, viewQuery: function AutocompleteComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$2, true);
        ɵɵviewQuery(_c1$1, true);
        ɵɵviewQuery(_c2$1, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.searchInput = _t.first);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.filteredListElement = _t.first);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.historyListElement = _t.first);
    } }, hostAttrs: [1, "ng-autocomplete"], hostBindings: function AutocompleteComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵɵlistener("click", function AutocompleteComponent_click_HostBindingHandler($event) { return ctx.handleClick($event); }, false, ɵɵresolveDocument);
    } }, inputs: { query: "query", data: "data", searchKeyword: "searchKeyword", placeholder: "placeholder", heading: "heading", initialValue: "initialValue", historyIdentifier: "historyIdentifier", historyHeading: "historyHeading", historyListMaxNumber: "historyListMaxNumber", notFoundText: "notFoundText", isLoading: "isLoading", debounceTime: "debounceTime", disabled: "disabled", minQueryLength: "minQueryLength", focusFirst: "focusFirst", customFilter: "customFilter", itemTemplate: "itemTemplate", notFoundTemplate: "notFoundTemplate" }, outputs: { selected: "selected", inputChanged: "inputChanged", inputFocused: "inputFocused", inputCleared: "inputCleared", opened: "opened", closed: "closed", scrolledToEnd: "scrolledToEnd" }, features: [ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => AutocompleteComponent),
                multi: true
            }
        ]), ɵɵNgOnChangesFeature], decls: 12, vars: 16, consts: [[1, "autocomplete-container", 3, "ngClass"], [1, "input-container"], ["name", "search-outline"], ["type", "text", "autocomplete", "off", 3, "placeholder", "ngModel", "disabled", "ngModelChange", "input", "focus", "blur"], ["searchInput", ""], ["name", "close-sharp", 3, "click", 4, "ngIf"], [1, "suggestions-container", 3, "ngClass"], ["filteredListElement", ""], ["class", "item", 4, "ngFor", "ngForOf"], ["class", "not-found", 4, "ngIf"], ["class", "autocomplete-overlay", 3, "click", 4, "ngIf"], ["name", "close-sharp", 3, "click"], [1, "item"], [3, "complete-selected", "click", 4, "ngIf"], [3, "click"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "not-found"], [1, "autocomplete-overlay", 3, "click"]], template: function AutocompleteComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelement(2, "ion-icon", 2);
        ɵɵelementStart(3, "input", 3, 4);
        ɵɵlistener("ngModelChange", function AutocompleteComponent_Template_input_ngModelChange_3_listener($event) { return ctx.query = $event; })("input", function AutocompleteComponent_Template_input_input_3_listener($event) { return ctx.onChange($event); })("focus", function AutocompleteComponent_Template_input_focus_3_listener($event) { return ctx.handleFocus($event); })("blur", function AutocompleteComponent_Template_input_blur_3_listener($event) { return ctx.onTouched($event); });
        ɵɵelementEnd();
        ɵɵtemplate(5, AutocompleteComponent_ion_icon_5_Template, 1, 0, "ion-icon", 5);
        ɵɵelementEnd();
        ɵɵelementStart(6, "div", 6);
        ɵɵelementStart(7, "ul", null, 7);
        ɵɵtemplate(9, AutocompleteComponent_li_9_Template, 3, 2, "li", 8);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(10, AutocompleteComponent_div_10_Template, 2, 4, "div", 9);
        ɵɵelementEnd();
        ɵɵtemplate(11, AutocompleteComponent_div_11_Template, 1, 0, "div", 10);
    } if (rf & 2) {
        ɵɵproperty("ngClass", ɵɵpureFunction1(11, _c4, ctx.isOpen));
        ɵɵadvance(3);
        ɵɵproperty("placeholder", ctx.placeholder)("ngModel", ctx.query)("disabled", ctx.disabled);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.query);
        ɵɵadvance(1);
        ɵɵproperty("ngClass", ɵɵpureFunction2(13, _c5, ctx.isHistoryListVisible, !ctx.isHistoryListVisible));
        ɵɵadvance(1);
        ɵɵclassProp("li-list", ctx.filteredList.length > 0);
        ɵɵadvance(2);
        ɵɵproperty("ngForOf", ctx.filteredList);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.isLoading ? !ctx.isLoading && ctx.notFound : ctx.notFound);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.overlay);
    } }, directives: [NgClass, IonIcon, DefaultValueAccessor, NgControlStatus, NgModel, NgIf, NgForOf, NgTemplateOutlet], pipes: [HighlightPipe], styles: [".ng-autocomplete{width:600px}.autocomplete-container{background:#fff;border:1px solid #bababa;border-radius:4px;box-sizing:border-box;height:48px;overflow:visible;position:relative}.autocomplete-container .input-container{display:flex;padding:12px 20px}.autocomplete-container .input-container ion-icon{color:#bababa;cursor:pointer;font-size:24px}.autocomplete-container .input-container input{background:#fff;border:none;box-shadow:none;box-sizing:border-box;color:#3b3b3b;font-size:16px;height:24px;line-height:21px;margin:0 10px;outline:none;width:100%}.autocomplete-container .suggestions-container{position:absolute;width:100%;z-index:5}.autocomplete-container .suggestions-container ul{height:auto;margin:0;max-height:200px;overflow-y:auto;padding:0}.autocomplete-container .suggestions-container ul.li-list{background:#fff;border:1px solid #efefef;border-radius:4px;box-shadow:0 0 6px rgba(0,0,0,.1)}.autocomplete-container .suggestions-container ul li{cursor:pointer;list-style:none;margin:0;padding:0;position:relative}.autocomplete-container .suggestions-container ul li a{color:#3b3b3b;cursor:pointer;display:block;font-size:16px;line-height:150%;padding:10px 15px;text-decoration:none}.autocomplete-container .suggestions-container .complete-selected,.autocomplete-container .suggestions-container ul li:hover{background-color:#f0f6ff}.autocomplete-container .suggestions-container .heading{border:1px solid #f1f1f1;padding:10px 15px;position:relative}.autocomplete-container .suggestions-container .heading .text{font-size:.85em}.autocomplete-container .suggestions-container.is-hidden{visibility:hidden}.autocomplete-container .suggestions-container.is-visible{visibility:visible}.autocomplete-container .not-found{background:#fff;border:1px solid #f1f1f1;padding:0 .75em}.autocomplete-container .not-found div{border-bottom:1px solid #f0f6ff;font-size:.95em;line-height:1.4;padding:.4em 0}.autocomplete-container.active{z-index:999}.highlight{font-weight:700}.autocomplete-overlay{background-color:transparent;bottom:0;height:100%;left:0;right:0;top:0;width:100%;z-index:50}"], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AutocompleteComponent, [{
        type: Component,
        args: [{
                selector: 'ng-autocomplete',
                templateUrl: './autocomplete.component.html',
                styleUrls: ['./autocomplete.component.scss'],
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => AutocompleteComponent),
                        multi: true
                    }
                ],
                encapsulation: ViewEncapsulation.None,
                host: {
                    '(document:click)': 'handleClick($event)',
                    'class': 'ng-autocomplete'
                },
            }]
    }], function () { return [{ type: ElementRef }, { type: Renderer2 }]; }, { searchInput: [{
            type: ViewChild,
            args: ['searchInput']
        }], filteredListElement: [{
            type: ViewChild,
            args: ['filteredListElement']
        }], historyListElement: [{
            type: ViewChild,
            args: ['historyListElement']
        }], query: [{
            type: Input
        }], data: [{
            type: Input
        }], searchKeyword: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], heading: [{
            type: Input
        }], initialValue: [{
            type: Input
        }], historyIdentifier: [{
            type: Input
        }], historyHeading: [{
            type: Input
        }], historyListMaxNumber: [{
            type: Input
        }], notFoundText: [{
            type: Input
        }], isLoading: [{
            type: Input
        }], debounceTime: [{
            type: Input
        }], disabled: [{
            type: Input
        }], minQueryLength: [{
            type: Input
        }], focusFirst: [{
            type: Input
        }], customFilter: [{
            type: Input
        }], selected: [{
            type: Output
        }], inputChanged: [{
            type: Output
        }], inputFocused: [{
            type: Output
        }], inputCleared: [{
            type: Output
        }], opened: [{
            type: Output
        }], closed: [{
            type: Output
        }], scrolledToEnd: [{
            type: Output
        }], itemTemplate: [{
            type: Input
        }], notFoundTemplate: [{
            type: Input
        }], customTemplate: [{
            type: ContentChild,
            args: [TemplateRef]
        }] }); })();

class AutocompleteLibModule {
}
AutocompleteLibModule.ɵmod = ɵɵdefineNgModule({ type: AutocompleteLibModule });
AutocompleteLibModule.ɵinj = ɵɵdefineInjector({ factory: function AutocompleteLibModule_Factory(t) { return new (t || AutocompleteLibModule)(); }, imports: [[
            CommonModule,
            FormsModule,
            IonicModule.forRoot(),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(AutocompleteLibModule, { declarations: [AutocompleteLibComponent, AutocompleteComponent, HighlightPipe], imports: [CommonModule,
        FormsModule, IonicModule], exports: [AutocompleteLibComponent, AutocompleteComponent, HighlightPipe] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(AutocompleteLibModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    IonicModule.forRoot(),
                ],
                declarations: [AutocompleteLibComponent, AutocompleteComponent, HighlightPipe],
                exports: [AutocompleteLibComponent, AutocompleteComponent, HighlightPipe]
            }]
    }], null, null); })();

const _c0$3 = ["slideWithNav3"];
function TagSliderComponent_ion_grid_0_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 8);
    ɵɵlistener("click", function TagSliderComponent_ion_grid_0_button_3_Template_button_click_0_listener() { ɵɵrestoreView(_r6); ɵɵnextContext(); const _r2 = ɵɵreference(5); const ctx_r5 = ɵɵnextContext(); return ctx_r5.slidePrev(_r2); });
    ɵɵelement(1, "ion-icon", 9);
    ɵɵelementEnd();
} }
function TagSliderComponent_ion_grid_0_ion_slide_6_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-slide", 10);
    ɵɵlistener("click", function TagSliderComponent_ion_grid_0_ion_slide_6_Template_ion_slide_click_0_listener() { ɵɵrestoreView(_r9); const tag_r7 = ctx.$implicit; const ctx_r8 = ɵɵnextContext(2); return ctx_r8.selectTag.emit(tag_r7); });
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const tag_r7 = ctx.$implicit;
    ɵɵclassProp("active", tag_r7.active);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", tag_r7.name, " ");
} }
function TagSliderComponent_ion_grid_0_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 11);
    ɵɵlistener("click", function TagSliderComponent_ion_grid_0_button_7_Template_button_click_0_listener() { ɵɵrestoreView(_r11); ɵɵnextContext(); const _r2 = ɵɵreference(5); const ctx_r10 = ɵɵnextContext(); return ctx_r10.slideNext(_r2); });
    ɵɵelement(1, "ion-icon", 12);
    ɵɵelementEnd();
} }
function TagSliderComponent_ion_grid_0_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-grid", 1);
    ɵɵelementStart(1, "ion-row");
    ɵɵelementStart(2, "ion-col", 2);
    ɵɵtemplate(3, TagSliderComponent_ion_grid_0_button_3_Template, 2, 0, "button", 3);
    ɵɵelementStart(4, "ion-slides", 4, 5);
    ɵɵlistener("ionSlideDidChange", function TagSliderComponent_ion_grid_0_Template_ion_slides_ionSlideDidChange_4_listener() { ɵɵrestoreView(_r13); const _r2 = ɵɵreference(5); const ctx_r12 = ɵɵnextContext(); return ctx_r12.SlideDidChange(_r2); });
    ɵɵtemplate(6, TagSliderComponent_ion_grid_0_ion_slide_6_Template, 2, 3, "ion-slide", 6);
    ɵɵelementEnd();
    ɵɵtemplate(7, TagSliderComponent_ion_grid_0_button_7_Template, 2, 0, "button", 7);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵproperty("ngIf", !ctx_r0.isBeginningSlide);
    ɵɵadvance(1);
    ɵɵproperty("options", ctx_r0.slideOptsThree);
    ɵɵadvance(2);
    ɵɵproperty("ngForOf", ctx_r0.tags);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r0.isEndSlide);
} }
class TagSliderComponent {
    constructor() {
        this.selectTag = new EventEmitter();
        this.isBeginningSlide = true;
        this.isEndSlide = false;
        this.slideOptsThree = {
            initialSlide: 0,
            autoHeight: false,
            slidesPerView: 'auto',
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                dynamicBullets: true,
                dynamicMainBullets: 15,
            },
        };
        // empty
    }
    ngOnInit() {
        // empty
    }
    // Move to Next slide
    slideNext(slideView) {
        slideView.slideNext(500).then(() => {
            this.checkIfNavDisabled(slideView);
        });
    }
    // Move to previous slide
    slidePrev(slideView) {
        slideView.slidePrev(500).then(() => {
            this.checkIfNavDisabled(slideView);
        });
    }
    // Method called when slide is changed by drag or navigation
    SlideDidChange(slideView) {
        this.checkIfNavDisabled(slideView);
    }
    // Call methods to check if slide is first or last to enable disbale navigation
    checkIfNavDisabled(slideView) {
        this.checkisBeginning(slideView);
        this.checkisEnd(slideView);
    }
    checkisBeginning(slideView) {
        slideView.isBeginning().then(istrue => {
            this.isBeginningSlide = istrue;
        });
    }
    checkisEnd(slideView) {
        slideView.isEnd().then(istrue => {
            this.isEndSlide = istrue;
        });
    }
}
TagSliderComponent.ɵfac = function TagSliderComponent_Factory(t) { return new (t || TagSliderComponent)(); };
TagSliderComponent.ɵcmp = ɵɵdefineComponent({ type: TagSliderComponent, selectors: [["terra-tag-slider"]], viewQuery: function TagSliderComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$3, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.slideWithNav3 = _t.first);
    } }, inputs: { tags: "tags" }, outputs: { selectTag: "selectTag" }, decls: 1, vars: 1, consts: [["class", "pos-relas", 4, "ngIf"], [1, "pos-relas"], ["size", "12"], ["class", "slider-button left", 3, "click", 4, "ngIf"], [1, "scrollbar-hide", 3, "options", "ionSlideDidChange"], ["slideWithNav3", ""], ["class", "sub-tags", 3, "active", "click", 4, "ngFor", "ngForOf"], ["class", "slider-button right", 3, "click", 4, "ngIf"], [1, "slider-button", "left", 3, "click"], ["name", "arrow-back-outline"], [1, "sub-tags", 3, "click"], [1, "slider-button", "right", 3, "click"], ["name", "arrow-forward-outline"]], template: function TagSliderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, TagSliderComponent_ion_grid_0_Template, 8, 4, "ion-grid", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", (ctx.tags == null ? null : ctx.tags.length) != 0);
    } }, directives: [NgIf, NgForOf], styles: [".pos-relas[_ngcontent-%COMP%]{padding:0}.pos-relas[_ngcontent-%COMP%]   ion-col[_ngcontent-%COMP%]{padding:0;position:relative}.pos-relas[_ngcontent-%COMP%]   ion-col[_ngcontent-%COMP%]   .slider-button[_ngcontent-%COMP%]{background:transparent;font-size:24px;outline:none;position:absolute;top:10px;z-index:2}.pos-relas[_ngcontent-%COMP%]   ion-col[_ngcontent-%COMP%]   .slider-button[_ngcontent-%COMP%]   ion-icon[_ngcontent-%COMP%]{background:hsla(0,0%,100%,.82);border:.2px solid #d6d6d6;border-radius:100%;color:#797979}.pos-relas[_ngcontent-%COMP%]   ion-col[_ngcontent-%COMP%]   .slider-button.left[_ngcontent-%COMP%]{left:-20px}.pos-relas[_ngcontent-%COMP%]   ion-col[_ngcontent-%COMP%]   .slider-button.right[_ngcontent-%COMP%]{right:-20px}.pos-relas[_ngcontent-%COMP%]   ion-col[_ngcontent-%COMP%]   .sub-tags[_ngcontent-%COMP%]{background:#fff;border:1px solid #bababa;border-radius:40px;box-sizing:border-box;color:#000;cursor:pointer;font-size:16px;line-height:150%;margin-right:16px;padding:12px 16px;width:auto}.pos-relas[_ngcontent-%COMP%]   ion-col[_ngcontent-%COMP%]   .sub-tags.active[_ngcontent-%COMP%]{background:#3677cb!important;border-color:#3677cb;color:#fff}.pos-relas[_ngcontent-%COMP%]   ion-col[_ngcontent-%COMP%]   .sub-tags[_ngcontent-%COMP%]   .icons[_ngcontent-%COMP%]{vertical-align:middle}ion-slides[_ngcontent-%COMP%]{-ms-overflow-style:none;overflow-x:scroll;scrollbar-width:none}ion-slides[_ngcontent-%COMP%]   ion-slide[_ngcontent-%COMP%]{align-items:flex-start;border-radius:4px;box-sizing:border-box}.scrollbar-hide[_ngcontent-%COMP%]::-webkit-scrollbar{display:none;height:0}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TagSliderComponent, [{
        type: Component,
        args: [{
                selector: 'terra-tag-slider',
                templateUrl: './tag-slider.component.html',
                styleUrls: ['./tag-slider.component.scss'],
            }]
    }], function () { return []; }, { tags: [{
            type: Input
        }], selectTag: [{
            type: Output
        }], slideWithNav3: [{
            type: ViewChild,
            args: ['slideWithNav3', { static: false }]
        }] }); })();

class TagSliderComponentModule {
}
TagSliderComponentModule.ɵmod = ɵɵdefineNgModule({ type: TagSliderComponentModule });
TagSliderComponentModule.ɵinj = ɵɵdefineInjector({ factory: function TagSliderComponentModule_Factory(t) { return new (t || TagSliderComponentModule)(); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(TagSliderComponentModule, { declarations: [TagSliderComponent], imports: [CommonModule], exports: [TagSliderComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(TagSliderComponentModule, [{
        type: NgModule,
        args: [{
                declarations: [TagSliderComponent],
                imports: [CommonModule],
                exports: [TagSliderComponent],
                entryComponents: [TagSliderComponent],
            }]
    }], null, null); })();

class FilterPipe {
    transform(value, input) {
        let rawData = [...value];
        rawData = rawData
            .filter(v => v.values && v.values.length > 0)
            .map(v => {
            return Object.assign(Object.assign({}, v), { values: [
                    ...v.values
                        .filter(values => {
                        if (input) {
                            return (values.name
                                .toLocaleLowerCase()
                                .indexOf(input.toLocaleLowerCase()) !== -1);
                        }
                        else {
                            return true;
                        }
                    })
                        .sort((a, b) => (a.name < b.name ? -1 : 1)),
                ] });
        })
            .filter(v => v.values.length > 0);
        if (rawData.length === 0) {
            rawData.push({
                header: 'No results found. Please search again or select “Others” to continue. You can also <a href="mailto:support@terra.do" target="_blank">request an addition</a> to the list.',
            });
        }
        return rawData;
        // if (input) {
        // 	rawData = rawData.filter(
        // 		val =>
        // 			val.name.toLocaleLowerCase().indexOf(input.toLocaleLowerCase()) !==
        // 			-1,
        // 	);
        // } else {
        // 	const constRowMap = rawData
        // 		.sort((a, b) => (a < b ? 1 : -1))
        // 		.filter((v, i, a) => a.indexOf(v) === i)
        // 		.slice(0, 5);
        // 	rawData = rawData
        // 		.map(val => {
        // 			return {
        // 				...val,
        // 				name:
        // 					(constRowMap &&
        // 						constRowMap.length > 0 &&
        // 						constRowMap.indexOf(val.count) !== -1) ||
        // 						val.isChecked
        // 						? ' ' + val.name
        // 						: val.name,
        // 			};
        // 		})
        // 		.sort((a, b) => (a.name < b.name ? -1 : 1))
        // }
        // const fa = [];
        // rawData.map(r => {
        // 	if (
        // 		fa.length === 0 ||
        // 		fa[fa.length - 1].name[0].toLocaleUpperCase() !==
        // 		r.name[0].toLocaleUpperCase()
        // 	) {
        // 		fa.push({
        // 			id: r.name[0].toLocaleUpperCase(),
        // 			header: r.name[0].toLocaleUpperCase(),
        // 		});
        // 	}
        // 	fa.push(r);
        // });
        // if (fa.length === 0) {
        // 	fa.push({ id: '1', header: 'No results found. Please search again or select “Others” to continue. You can also <a href="mailto:support@terra.do" target="_blank">request an addition</a> to the list.' });
        // } else {
        // }
        // return fa;
    }
}
FilterPipe.ɵfac = function FilterPipe_Factory(t) { return new (t || FilterPipe)(); };
FilterPipe.ɵpipe = ɵɵdefinePipe({ name: "filter", type: FilterPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FilterPipe, [{
        type: Pipe,
        args: [{
                name: 'filter',
            }]
    }], null, null); })();

function SelectionComponent_ion_icon_4_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-icon", 10);
    ɵɵlistener("click", function SelectionComponent_ion_icon_4_Template_ion_icon_click_0_listener() { ɵɵrestoreView(_r4); const ctx_r3 = ɵɵnextContext(); return ctx_r3.searchTxt = ""; });
    ɵɵelementEnd();
} }
function SelectionComponent_ion_icon_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "ion-icon", 11);
} }
function SelectionComponent_ion_row_8_ng_container_1_ion_col_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "ion-col", 15);
} if (rf & 2) {
    const als_r6 = ɵɵnextContext().$implicit;
    ɵɵproperty("innerHtml", als_r6.header, ɵɵsanitizeHtml);
} }
function SelectionComponent_ion_row_8_ng_container_1_ion_col_2_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-col", 16);
    ɵɵlistener("click", function SelectionComponent_ion_row_8_ng_container_1_ion_col_2_Template_ion_col_click_0_listener() { ɵɵrestoreView(_r12); const al_r10 = ctx.$implicit; const ctx_r11 = ɵɵnextContext(3); return ctx_r11.checkBoxClicked(al_r10); });
    ɵɵelement(1, "ion-checkbox", 17);
    ɵɵtext(2);
    ɵɵelementEnd();
} if (rf & 2) {
    const al_r10 = ctx.$implicit;
    ɵɵclassProp("active", al_r10.isChecked);
    ɵɵadvance(1);
    ɵɵproperty("checked", al_r10.isChecked);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", al_r10.name, " ");
} }
function SelectionComponent_ion_row_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, SelectionComponent_ion_row_8_ng_container_1_ion_col_1_Template, 1, 1, "ion-col", 13);
    ɵɵtemplate(2, SelectionComponent_ion_row_8_ng_container_1_ion_col_2_Template, 3, 4, "ion-col", 14);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const als_r6 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", als_r6.header && als_r6.header != " ");
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", als_r6 == null ? null : als_r6.values);
} }
function SelectionComponent_ion_row_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-row");
    ɵɵtemplate(1, SelectionComponent_ion_row_8_ng_container_1_Template, 3, 2, "ng-container", 12);
    ɵɵpipe(2, "filter");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ɵɵpipeBind2(2, 1, ctx_r2.arrayList, ctx_r2.searchTxt));
} }
class SelectionComponent {
    constructor(popoverController) {
        this.popoverController = popoverController;
        this.placeholder = 'Search tags or tag groups';
        this.arrayList = [];
        this.saveClose = new EventEmitter();
        this.searchTxt = '';
        /*empty*/
    }
    ngOnInit() {
        /** empty */
    }
    deselectAll() {
        this.arrayList.filter(als => {
            als === null || als === void 0 ? void 0 : als.values.filter(al => {
                al.isChecked = false;
            });
        });
    }
    trackByFn(index, item) {
        return item.id;
    }
    done() {
        return __awaiter(this, void 0, void 0, function* () {
            this.closePopover('Done');
        });
    }
    closePopover(str) {
        this.saveClose.emit(str);
        if (this.popoverController) {
            this.popoverController.dismiss(str);
        }
    }
    checkBoxClicked(record) {
        record.isChecked = !record.isChecked;
    }
}
SelectionComponent.ɵfac = function SelectionComponent_Factory(t) { return new (t || SelectionComponent)(ɵɵdirectiveInject(PopoverController)); };
SelectionComponent.ɵcmp = ɵɵdefineComponent({ type: SelectionComponent, selectors: [["terra-selection"]], inputs: { name: "name", arrayList: "arrayList" }, outputs: { saveClose: "saveClose" }, decls: 18, vars: 5, consts: [[1, "main-box"], ["size", "12", 1, "main-title", "bottom"], ["value", "custom", 3, "ngModel", "placeholder", "ngModelChange"], ["name", "close-outline", "class", "img-bottom", 3, "click", 4, "ngIf"], ["name", "search-outline", "class", "img-bottom", 4, "ngIf"], ["size", "12", 1, "set-max-height"], [4, "ngIf"], ["size", "12", 1, "p16", "space-between-flex"], [1, "btn-white-small", "text-right", 3, "click"], [1, "btn-yellow-small", 3, "click"], ["name", "close-outline", 1, "img-bottom", 3, "click"], ["name", "search-outline", 1, "img-bottom"], [4, "ngFor", "ngForOf"], ["size", "12", "class", "selector header", 3, "innerHtml", 4, "ngIf"], ["size", "12", "class", "selector cursor", 3, "active", "click", 4, "ngFor", "ngForOf"], ["size", "12", 1, "selector", "header", 3, "innerHtml"], ["size", "12", 1, "selector", "cursor", 3, "click"], [3, "checked"]], template: function SelectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "ion-grid", 0);
        ɵɵelementStart(1, "ion-row");
        ɵɵelementStart(2, "ion-col", 1);
        ɵɵelementStart(3, "ion-input", 2);
        ɵɵlistener("ngModelChange", function SelectionComponent_Template_ion_input_ngModelChange_3_listener($event) { return ctx.searchTxt = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(4, SelectionComponent_ion_icon_4_Template, 1, 0, "ion-icon", 3);
        ɵɵtemplate(5, SelectionComponent_ion_icon_5_Template, 1, 0, "ion-icon", 4);
        ɵɵelementEnd();
        ɵɵelementStart(6, "ion-col", 5);
        ɵɵelementStart(7, "ion-grid");
        ɵɵtemplate(8, SelectionComponent_ion_row_8_Template, 3, 4, "ion-row", 6);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(9, "ion-col", 7);
        ɵɵelementStart(10, "div");
        ɵɵelementStart(11, "ion-button", 8);
        ɵɵlistener("click", function SelectionComponent_Template_ion_button_click_11_listener() { return ctx.deselectAll(); });
        ɵɵelementStart(12, "span");
        ɵɵtext(13, "Clear selection");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(14, "div");
        ɵɵelementStart(15, "ion-button", 9);
        ɵɵlistener("click", function SelectionComponent_Template_ion_button_click_15_listener() { return ctx.done(); });
        ɵɵelementStart(16, "span");
        ɵɵtext(17, "Add selected tags");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(3);
        ɵɵproperty("ngModel", ctx.searchTxt)("placeholder", ctx.placeholder);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !!ctx.searchTxt);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.searchTxt);
        ɵɵadvance(3);
        ɵɵproperty("ngIf", ctx.arrayList.length > 0);
    } }, directives: [IonGrid, IonRow, IonCol, IonInput, TextValueAccessor, NgControlStatus, NgModel, NgIf, IonButton, IonIcon, NgForOf, IonCheckbox, BooleanValueAccessor], pipes: [FilterPipe], styles: ["ion-col[_ngcontent-%COMP%], ion-grid[_ngcontent-%COMP%]{padding:0}ion-checkbox[_ngcontent-%COMP%]{--border-color:#3b3b3b}.cursor[_ngcontent-%COMP%]{cursor:pointer}.main-box[_ngcontent-%COMP%]{background:#fff;border:1px solid #efefef;border-radius:4px;box-shadow:0 0 6px rgba(0,0,0,.1);left:0;max-width:520px;position:absolute;z-index:2}.p16[_ngcontent-%COMP%]{padding:16px}ion-grid[_ngcontent-%COMP%]   .set-max-height[_ngcontent-%COMP%]{border-bottom:1px solid #efefef;border-top:1px solid #efefef;max-height:237px;min-height:237px;overflow-y:scroll}ion-grid[_ngcontent-%COMP%]   .set-max-height[_ngcontent-%COMP%]   .selector[_ngcontent-%COMP%]{color:#000;display:flex;font-size:16px;line-height:150%;padding:10px 16px 10px 56px;position:relative;text-align:left}ion-grid[_ngcontent-%COMP%]   .set-max-height[_ngcontent-%COMP%]   .selector[_ngcontent-%COMP%]   ion-checkbox[_ngcontent-%COMP%]{--border-radius:0;left:20px;position:absolute;top:15px}ion-grid[_ngcontent-%COMP%]   .set-max-height[_ngcontent-%COMP%]   .selector.active[_ngcontent-%COMP%]{background:#ebfaf0}ion-grid[_ngcontent-%COMP%]   .set-max-height[_ngcontent-%COMP%]   .selector.header[_ngcontent-%COMP%]{color:#3b3b3b;display:block;font-size:16px;font-style:italic;letter-spacing:.2px;line-height:150%;padding-bottom:5px;padding-top:12px}ion-grid[_ngcontent-%COMP%]   .main-title[_ngcontent-%COMP%]{color:#000;font-size:16px;line-height:150%;padding:12px 16px;position:relative}ion-grid[_ngcontent-%COMP%]   .main-title[_ngcontent-%COMP%]   .img-bottom[_ngcontent-%COMP%]{color:#bababa;cursor:pointer;font-size:24px;position:absolute;right:16px;top:12px}ion-grid[_ngcontent-%COMP%]   .main-title[_ngcontent-%COMP%]   ion-input[_ngcontent-%COMP%]{--padding-bottom:0;--padding-end:0;--padding-start:0;--padding-top:0;color:#3b3b3b;font-size:16px;line-height:150%;max-width:calc(100% - 34px);text-align:left}ion-grid[_ngcontent-%COMP%]   .main-title[_ngcontent-%COMP%]   .close-outline[_ngcontent-%COMP%]{cursor:pointer;z-index:2}ion-grid[_ngcontent-%COMP%]   .main-title[_ngcontent-%COMP%]   .text-right[_ngcontent-%COMP%]{position:absolute;right:16px}@media (min-width:576px){.isCustom[_ngcontent-%COMP%]{max-width:360px;min-width:360px}}@media (max-width:575.98px){.isCustom[_ngcontent-%COMP%]{left:20px!important;right:20px!important}}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SelectionComponent, [{
        type: Component,
        args: [{
                selector: 'terra-selection',
                templateUrl: './selection.component.html',
                styleUrls: ['./selection.component.scss'],
            }]
    }], function () { return [{ type: PopoverController }]; }, { name: [{
            type: Input
        }], arrayList: [{
            type: Input
        }], saveClose: [{
            type: Output
        }] }); })();

function PeopleTagComponent_ion_row_12_ng_container_1_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 14);
    ɵɵlistener("click", function PeopleTagComponent_ion_row_12_ng_container_1_div_4_Template_div_click_0_listener() { ɵɵrestoreView(_r7); const tag_r5 = ctx.$implicit; const ctx_r6 = ɵɵnextContext(3); return ctx_r6.removeTag(tag_r5); });
    ɵɵtext(1);
    ɵɵelement(2, "ion-icon", 15);
    ɵɵelementEnd();
} if (rf & 2) {
    const tag_r5 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", tag_r5.name, " ");
} }
function PeopleTagComponent_ion_row_12_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "ion-col", 11);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementStart(3, "ion-col", 12);
    ɵɵtemplate(4, PeopleTagComponent_ion_row_12_ng_container_1_div_4_Template, 3, 1, "div", 13);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const tag_r3 = ctx.$implicit;
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", tag_r3.header, " ");
    ɵɵadvance(2);
    ɵɵproperty("ngForOf", tag_r3.values);
} }
function PeopleTagComponent_ion_row_12_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-row", 9);
    ɵɵtemplate(1, PeopleTagComponent_ion_row_12_ng_container_1_Template, 5, 2, "ng-container", 10);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r1.selectedValue);
} }
class PeopleTagComponent {
    constructor() {
        this.tagAddRemove = new EventEmitter();
        this.selectedValue = [];
        this.popoverDisabled = false;
        this.activeTag = true;
        // * empty
    }
    get tagArr() {
        return this._tagArr;
    }
    set tagArr(value) {
        this._tagArr = value;
        this.recheck();
    }
    saveClose(ev) {
        this.tagAddRemove.emit(this._tagArr);
        this.popoverDisabled = true;
        this.recheck();
    }
    removeTag(ev) {
        ev.isChecked = false;
        this.tagAddRemove.emit(this._tagArr);
        this.recheck();
    }
    recheck() {
        this.selectedValue = [...this._tagArr]
            .map(v => {
            return Object.assign(Object.assign({}, v), { values: [
                    ...v.values
                        .filter(values => values.isChecked)
                        .sort((a, b) => (a.name < b.name ? 1 : -1)),
                ] });
        })
            .filter(v => v.values.length > 0);
    }
    ngOnInit() {
        this.recheck();
    }
    enableFilter() {
        this.popoverDisabled = false;
    }
    popoverShown(ev) {
        this.popoverDisabled = false;
    }
}
PeopleTagComponent.ɵfac = function PeopleTagComponent_Factory(t) { return new (t || PeopleTagComponent)(); };
PeopleTagComponent.ɵcmp = ɵɵdefineComponent({ type: PeopleTagComponent, selectors: [["terra-people-tag"]], inputs: { tagArr: "tagArr" }, outputs: { tagAddRemove: "tagAddRemove" }, decls: 13, vars: 10, consts: [[1, "white-box"], [1, "fixed-box"], ["popoverPlacement", "bottom", 1, "space-between-flex", "input-search", 3, "terraPopover", "popoverOnHover", "popoverDisabled", "popoverShown", "click"], ["src", "/assets/fi_chevrons-down.svg", 1, "icons"], ["name", "chevron-down-outline"], [3, "closeOnClickOutside"], ["Sectors", ""], [3, "arrayList", "saveClose"], ["class", "activeTag", 4, "ngIf"], [1, "activeTag"], [4, "ngFor", "ngForOf"], ["size", "12", 1, "main-tags"], ["size", "12", 1, "sub-tags"], [3, "click", 4, "ngFor", "ngForOf"], [3, "click"], ["name", "close-sharp", 1, "close-sharp"]], template: function PeopleTagComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div");
        ɵɵelementStart(1, "ion-grid", 0);
        ɵɵelementStart(2, "ion-row", 1);
        ɵɵelementStart(3, "ion-col", 2);
        ɵɵlistener("popoverShown", function PeopleTagComponent_Template_ion_col_popoverShown_3_listener($event) { return ctx.popoverShown($event); })("click", function PeopleTagComponent_Template_ion_col_click_3_listener() { return ctx.enableFilter(); });
        ɵɵelementStart(4, "div");
        ɵɵtext(5, " + Add a new tag ");
        ɵɵelement(6, "ion-icon", 3);
        ɵɵelementEnd();
        ɵɵelementStart(7, "div");
        ɵɵelement(8, "ion-icon", 4);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(9, "terra-popover-content", 5, 6);
        ɵɵelementStart(11, "terra-selection", 7);
        ɵɵlistener("saveClose", function PeopleTagComponent_Template_terra_selection_saveClose_11_listener($event) { return ctx.saveClose($event); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(12, PeopleTagComponent_ion_row_12_Template, 2, 1, "ion-row", 8);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵɵreference(10);
        ɵɵadvance(1);
        ɵɵclassProp("abs", ctx.activeTag)("rel", !ctx.activeTag);
        ɵɵadvance(2);
        ɵɵproperty("terraPopover", _r0)("popoverOnHover", false)("popoverDisabled", ctx.popoverDisabled);
        ɵɵadvance(6);
        ɵɵproperty("closeOnClickOutside", true);
        ɵɵadvance(2);
        ɵɵproperty("arrayList", ctx._tagArr);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.selectedValue == null ? null : ctx.selectedValue.length) > 0);
    } }, directives: [IonGrid, IonRow, IonCol, TerraPopoverDirective, IonIcon, PopoverContentComponent, SelectionComponent, NgIf, NgForOf], styles: [".height-60[_ngcontent-%COMP%]{height:60px}.white-box[_ngcontent-%COMP%]{padding:0;position:relative;z-index:1}.white-box[_ngcontent-%COMP%]   .fixed-box[_ngcontent-%COMP%]   .input-search[_ngcontent-%COMP%]{border:1px solid #bababa;border-radius:4px;box-sizing:border-box;max-width:520px;padding:20px;text-align:left}.white-box[_ngcontent-%COMP%]   ion-col[_ngcontent-%COMP%], .white-box[_ngcontent-%COMP%]   ion-grid[_ngcontent-%COMP%]{padding:0}.white-box[_ngcontent-%COMP%]   .activeTag[_ngcontent-%COMP%]{padding:0 10px 20px 20px}.white-box[_ngcontent-%COMP%]   .activeTag[_ngcontent-%COMP%] > ion-col[_ngcontent-%COMP%]:first-child{padding-top:10px}.white-box[_ngcontent-%COMP%]   .activeTag[_ngcontent-%COMP%]   .main-tags[_ngcontent-%COMP%]{color:#000;font-size:18px;font-weight:700;line-height:133.33%;padding-bottom:11px;padding-top:25px;text-align:left}.white-box[_ngcontent-%COMP%]   .activeTag[_ngcontent-%COMP%]   .sub-tags[_ngcontent-%COMP%]{display:contents}.white-box[_ngcontent-%COMP%]   .activeTag[_ngcontent-%COMP%]   .sub-tags[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{align-items:center;background:#f0f6ff;border:1px solid #f0f6ff;border-radius:90px;box-sizing:border-box;display:flex;margin-bottom:5px;margin-right:10px;margin-top:5px;padding:8px 12px}.white-box[_ngcontent-%COMP%]   .activeTag[_ngcontent-%COMP%]   .sub-tags[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]   .close-sharp[_ngcontent-%COMP%]{color:#3b3b3b;cursor:pointer;font-size:16px;margin-left:4px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PeopleTagComponent, [{
        type: Component,
        args: [{
                selector: 'terra-people-tag',
                templateUrl: './people-tag.component.html',
                styleUrls: ['./people-tag.component.scss'],
            }]
    }], function () { return []; }, { tagArr: [{
            type: Input
        }], tagAddRemove: [{
            type: Output
        }] }); })();

class SelectionComponentModule {
}
SelectionComponentModule.ɵmod = ɵɵdefineNgModule({ type: SelectionComponentModule });
SelectionComponentModule.ɵinj = ɵɵdefineInjector({ factory: function SelectionComponentModule_Factory(t) { return new (t || SelectionComponentModule)(); }, imports: [[
            CommonModule,
            FormsModule,
            IonicModule,
            ReactiveFormsModule,
            FeatureToggleLibModule,
            UtilLibModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(SelectionComponentModule, { declarations: [SelectionComponent, FilterPipe], imports: [CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        FeatureToggleLibModule,
        UtilLibModule], exports: [SelectionComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(SelectionComponentModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    IonicModule,
                    ReactiveFormsModule,
                    FeatureToggleLibModule,
                    UtilLibModule,
                ],
                declarations: [SelectionComponent, FilterPipe],
                entryComponents: [SelectionComponent],
                exports: [SelectionComponent],
            }]
    }], null, null); })();

class PeopleTagsComponentModule {
}
PeopleTagsComponentModule.ɵmod = ɵɵdefineNgModule({ type: PeopleTagsComponentModule });
PeopleTagsComponentModule.ɵinj = ɵɵdefineInjector({ factory: function PeopleTagsComponentModule_Factory(t) { return new (t || PeopleTagsComponentModule)(); }, imports: [[
            CommonModule,
            FormsModule,
            IonicModule,
            ReactiveFormsModule,
            PopoverModule,
            SelectionComponentModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(PeopleTagsComponentModule, { declarations: [PeopleTagComponent], imports: [CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        PopoverModule,
        SelectionComponentModule], exports: [PeopleTagComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(PeopleTagsComponentModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    IonicModule,
                    ReactiveFormsModule,
                    PopoverModule,
                    SelectionComponentModule,
                ],
                declarations: [PeopleTagComponent],
                entryComponents: [PeopleTagComponent],
                exports: [PeopleTagComponent],
            }]
    }], null, null); })();

class ApplicationUIService {
    constructor(http, authStore) {
        this.http = http;
        this.authStore = authStore;
        this.headers = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        };
        this.application = new BehaviorSubject([]);
        this.application$ = this.application.asObservable();
        this.questions = new BehaviorSubject([]);
        this.questions$ = this.questions.asObservable();
        this.ENDPOINT = '';
    }
    getApplicationDetails(id) {
        combineLatest([
            this.authStore.profileDetail$,
            this.authStore.firebaseToken$,
        ])
            .pipe(filter(([user, token]) => !!user && !!token), first())
            .subscribe(([user, token]) => {
            const headers = {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + token,
            };
            const url = this.ENDPOINT + 'application/details/' + id;
            this.http
                .get(url, { headers: new HttpHeaders(headers) })
                .subscribe(response => {
                this.application.next(Object.assign(Object.assign({}, response.data), { createdAt: format(new Date(response.data.stage_updated_time), 'MMM dd,yyyy'), purchasedAt: format(new Date(response.data.created_at), 'MMM dd,yyyy') }));
            }, error => {
                console.log('Something was wrong');
            });
        });
    }
    getApplicationQuestion(cohortId) {
        combineLatest([
            this.authStore.profileDetail$,
            this.authStore.firebaseToken$,
        ])
            .pipe(filter(([user, token]) => !!user && !!token), first())
            .subscribe(([user, token]) => {
            const headers = {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + token,
            };
            const url = this.ENDPOINT + 'course/questions';
            this.http
                .post(url, { courseId: cohortId, token: token }, { headers: new HttpHeaders(headers) })
                .subscribe(response => {
                this.questions.next(response.data);
            }, error => {
                console.log('Something was wrong');
            });
        });
    }
}
ApplicationUIService.ɵfac = function ApplicationUIService_Factory(t) { return new (t || ApplicationUIService)(ɵɵinject(HttpClient), ɵɵinject(AuthStoreService)); };
ApplicationUIService.ɵprov = ɵɵdefineInjectable({ token: ApplicationUIService, factory: ApplicationUIService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ApplicationUIService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: HttpClient }, { type: AuthStoreService }]; }, null); })();

function ApplicationUiComponent_ion_grid_0_ng_container_1_ion_row_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "ion-row", 5);
} }
function ApplicationUiComponent_ion_grid_0_ng_container_1_ion_row_3_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
function ApplicationUiComponent_ion_grid_0_ng_container_1_ion_row_3_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, ApplicationUiComponent_ion_grid_0_ng_container_1_ion_row_3_ng_container_4_ng_container_1_Template, 1, 0, "ng-container", 10);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵɵnextContext();
    const _r11 = ɵɵreference(7);
    ɵɵadvance(1);
    ɵɵproperty("ngTemplateOutlet", _r11);
} }
function ApplicationUiComponent_ion_grid_0_ng_container_1_ion_row_3_ng_container_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
function ApplicationUiComponent_ion_grid_0_ng_container_1_ion_row_3_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, ApplicationUiComponent_ion_grid_0_ng_container_1_ion_row_3_ng_container_5_ng_container_1_Template, 1, 0, "ng-container", 10);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵɵnextContext();
    const _r13 = ɵɵreference(9);
    ɵɵadvance(1);
    ɵɵproperty("ngTemplateOutlet", _r13);
} }
function ApplicationUiComponent_ion_grid_0_ng_container_1_ion_row_3_ng_template_6_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 12);
    ɵɵlistener("click", function ApplicationUiComponent_ion_grid_0_ng_container_1_ion_row_3_ng_template_6_div_3_Template_div_click_0_listener() { ɵɵrestoreView(_r23); const resume_r21 = ctx.ngIf; const ctx_r22 = ɵɵnextContext(5); return ctx_r22.redirectTo(resume_r21); });
    ɵɵelementStart(1, "p");
    ɵɵtext(2, "Resume");
    ɵɵelementEnd();
    ɵɵelement(3, "img", 13);
    ɵɵelementEnd();
} }
function ApplicationUiComponent_ion_grid_0_ng_container_1_ion_row_3_ng_template_6_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 12);
    ɵɵlistener("click", function ApplicationUiComponent_ion_grid_0_ng_container_1_ion_row_3_ng_template_6_div_4_Template_div_click_0_listener() { ɵɵrestoreView(_r26); const linkedIn_r24 = ctx.ngIf; const ctx_r25 = ɵɵnextContext(5); return ctx_r25.redirectTo(linkedIn_r24); });
    ɵɵelementStart(1, "p");
    ɵɵtext(2, "LinkedIn");
    ɵɵelementEnd();
    ɵɵelement(3, "img", 14);
    ɵɵelementEnd();
} }
function ApplicationUiComponent_ion_grid_0_ng_container_1_ion_row_3_ng_template_6_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r29 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 12);
    ɵɵlistener("click", function ApplicationUiComponent_ion_grid_0_ng_container_1_ion_row_3_ng_template_6_div_5_Template_div_click_0_listener() { ɵɵrestoreView(_r29); const portfolio_r27 = ctx.ngIf; const ctx_r28 = ɵɵnextContext(5); return ctx_r28.redirectTo(portfolio_r27); });
    ɵɵelementStart(1, "p");
    ɵɵtext(2, "Portfolio");
    ɵɵelementEnd();
    ɵɵelement(3, "img", 15);
    ɵɵelementEnd();
} }
function ApplicationUiComponent_ion_grid_0_ng_container_1_ion_row_3_ng_template_6_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r32 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 12);
    ɵɵlistener("click", function ApplicationUiComponent_ion_grid_0_ng_container_1_ion_row_3_ng_template_6_div_6_Template_div_click_0_listener() { ɵɵrestoreView(_r32); const website_r30 = ctx.ngIf; const ctx_r31 = ɵɵnextContext(5); return ctx_r31.redirectTo(website_r30); });
    ɵɵelementStart(1, "p");
    ɵɵtext(2, "Website");
    ɵɵelementEnd();
    ɵɵelement(3, "img", 15);
    ɵɵelementEnd();
} }
function ApplicationUiComponent_ion_grid_0_ng_container_1_ion_row_3_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "h3");
    ɵɵtext(1, "Profile, social, and websites");
    ɵɵelementEnd();
    ɵɵelementStart(2, "ion-row");
    ɵɵtemplate(3, ApplicationUiComponent_ion_grid_0_ng_container_1_ion_row_3_ng_template_6_div_3_Template, 4, 0, "div", 11);
    ɵɵtemplate(4, ApplicationUiComponent_ion_grid_0_ng_container_1_ion_row_3_ng_template_6_div_4_Template, 4, 0, "div", 11);
    ɵɵtemplate(5, ApplicationUiComponent_ion_grid_0_ng_container_1_ion_row_3_ng_template_6_div_5_Template, 4, 0, "div", 11);
    ɵɵtemplate(6, ApplicationUiComponent_ion_grid_0_ng_container_1_ion_row_3_ng_template_6_div_6_Template, 4, 0, "div", 11);
    ɵɵelementEnd();
} if (rf & 2) {
    const foo_r7 = ɵɵnextContext().$implicit;
    ɵɵadvance(3);
    ɵɵproperty("ngIf", foo_r7 == null ? null : foo_r7.resume);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", foo_r7.linkedin);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", foo_r7.portfolio);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", foo_r7.website);
} }
function ApplicationUiComponent_ion_grid_0_ng_container_1_ion_row_3_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "h3");
    ɵɵtext(1);
    ɵɵelementEnd();
    ɵɵelement(2, "p", 16);
} if (rf & 2) {
    const foo_r7 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate(foo_r7.question.title);
    ɵɵadvance(1);
    ɵɵproperty("innerHtml", foo_r7.answer, ɵɵsanitizeHtml);
} }
function ApplicationUiComponent_ion_grid_0_ng_container_1_ion_row_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-row", 6);
    ɵɵelementStart(1, "span", 7);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementStart(3, "ion-col");
    ɵɵtemplate(4, ApplicationUiComponent_ion_grid_0_ng_container_1_ion_row_3_ng_container_4_Template, 2, 1, "ng-container", 2);
    ɵɵtemplate(5, ApplicationUiComponent_ion_grid_0_ng_container_1_ion_row_3_ng_container_5_Template, 2, 1, "ng-container", 2);
    ɵɵelementEnd();
    ɵɵtemplate(6, ApplicationUiComponent_ion_grid_0_ng_container_1_ion_row_3_ng_template_6_Template, 7, 4, "ng-template", null, 8, ɵɵtemplateRefExtractor);
    ɵɵtemplate(8, ApplicationUiComponent_ion_grid_0_ng_container_1_ion_row_3_ng_template_8_Template, 3, 2, "ng-template", null, 9, ɵɵtemplateRefExtractor);
    ɵɵelementEnd();
} if (rf & 2) {
    const foo_r7 = ctx.$implicit;
    const i_r8 = ctx.index;
    ɵɵadvance(2);
    ɵɵtextInterpolate(i_r8 + 1);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", foo_r7.key === "website");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", foo_r7.key !== "website");
} }
function ApplicationUiComponent_ion_grid_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, ApplicationUiComponent_ion_grid_0_ng_container_1_ion_row_1_Template, 1, 0, "ion-row", 3);
    ɵɵpipe(2, "async");
    ɵɵtemplate(3, ApplicationUiComponent_ion_grid_0_ng_container_1_ion_row_3_Template, 10, 3, "ion-row", 4);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const applicationForm_r1 = ɵɵnextContext().ngIf;
    const ctx_r2 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ɵɵpipeBind1(2, 2, ctx_r2.applicationUIService.application$));
    ɵɵadvance(2);
    ɵɵproperty("ngForOf", applicationForm_r1);
} }
function ApplicationUiComponent_ion_grid_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "ion-row");
    ɵɵelementStart(2, "ion-col", 17);
    ɵɵelement(3, "ion-spinner", 18);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} }
function ApplicationUiComponent_ion_grid_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-grid", 1);
    ɵɵtemplate(1, ApplicationUiComponent_ion_grid_0_ng_container_1_Template, 4, 4, "ng-container", 2);
    ɵɵtemplate(2, ApplicationUiComponent_ion_grid_0_ng_container_2_Template, 4, 0, "ng-container", 2);
    ɵɵelementEnd();
} if (rf & 2) {
    const applicationForm_r1 = ctx.ngIf;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", applicationForm_r1.length > 0);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", applicationForm_r1.length == 0);
} }
class ApplicationUiComponent {
    constructor(applicationUIService) {
        this.applicationUIService = applicationUIService;
        this.applicationId = 0;
        this.url = '';
        this.cohortId = 0;
        this.formQuestions = [];
        this.redirectTo = (redirect) => window.open(redirect, '_blank');
        this.applicationForm$ = combineLatest([
            this.applicationUIService.application$,
            this.applicationUIService.questions$,
        ]).pipe(map(([applicationDetails, question]) => {
            const results = [];
            if (question.length > 0) {
                const excludeKeys = ['id', 'name', 'email'];
                for (const key in applicationDetails) {
                    if (!excludeKeys.includes(key)
                    // && applicationDetails[key]
                    ) {
                        if (key === 'website') {
                            results.push({
                                key,
                                resume: applicationDetails['resume'],
                                linkedIn: applicationDetails['linkedIn'],
                                portfolio: applicationDetails['portfolio'],
                                website: applicationDetails['website'],
                            });
                        }
                        else {
                            const macthQuestion = question.filter(q => q.ref === key)[0];
                            if (macthQuestion) {
                                results.push({
                                    key,
                                    question: macthQuestion,
                                    answer: applicationDetails[key] || 'NA',
                                });
                            }
                        }
                    }
                }
            }
            return this.mapQuestionsOrder(results, question);
        }));
    }
    ngOnInit() {
        this.applicationUIService.ENDPOINT = this.url;
        this.applicationUIService.getApplicationDetails(this.applicationId);
        this.applicationUIService.getApplicationQuestion(this.cohortId);
    }
    mapQuestionsOrder(array, order) {
        array.sort(function (a, b) {
            let A = a === null || a === void 0 ? void 0 : a.question;
            let B = b === null || b === void 0 ? void 0 : b.question;
            if (order.indexOf(A) > order.indexOf(B)) {
                return 1;
            }
            else {
                return -1;
            }
        });
        return array;
    }
    ;
}
ApplicationUiComponent.ɵfac = function ApplicationUiComponent_Factory(t) { return new (t || ApplicationUiComponent)(ɵɵdirectiveInject(ApplicationUIService)); };
ApplicationUiComponent.ɵcmp = ɵɵdefineComponent({ type: ApplicationUiComponent, selectors: [["terra-application-ui"]], inputs: { applicationId: "applicationId", url: "url", cohortId: "cohortId" }, decls: 2, vars: 3, consts: [["class", "form-container", 4, "ngIf"], [1, "form-container"], [4, "ngIf"], ["class", "application-detail", 4, "ngIf"], ["class", "section", 4, "ngFor", "ngForOf"], [1, "application-detail"], [1, "section"], [1, "circle"], ["profile", ""], ["questions", ""], [4, "ngTemplateOutlet"], ["class", "links", 3, "click", 4, "ngIf"], [1, "links", 3, "click"], ["src", "./assets/resume.svg"], ["src", "./assets/linkedIn-prev.svg"], ["src", "./assets/other-prev.svg"], [3, "innerHtml"], ["size", "12"], ["name", "dots", 1, "spiner"]], template: function ApplicationUiComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, ApplicationUiComponent_ion_grid_0_Template, 3, 2, "ion-grid", 0);
        ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵɵproperty("ngIf", ɵɵpipeBind1(1, 1, ctx.applicationForm$));
    } }, directives: [NgIf, NgForOf, NgTemplateOutlet], pipes: [AsyncPipe], styles: [".form-container[_ngcontent-%COMP%]{padding:0 5px 30px}.form-container[_ngcontent-%COMP%]   .section[_ngcontent-%COMP%]{align-items:baseline;background:#fff;border:1px solid var(--black100);padding:30px 20px}.form-container[_ngcontent-%COMP%]   .section[_ngcontent-%COMP%]   .circle[_ngcontent-%COMP%]{align-items:center;background-color:var(--action100);border-radius:50%;color:var(--black600);display:flex;height:24px;justify-content:center;width:24px}.form-container[_ngcontent-%COMP%]   .section[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{font-weight:700;margin:0 16px}.form-container[_ngcontent-%COMP%]   .section[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:var(--black600);margin:16px 16px 0}.form-container[_ngcontent-%COMP%]   .section[_ngcontent-%COMP%]   .links[_ngcontent-%COMP%]{align-items:center;display:flex;flex-direction:column;margin:16px}.form-container[_ngcontent-%COMP%]   .section[_ngcontent-%COMP%]   .links[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:var(--sea600);margin:8px}.form-container[_ngcontent-%COMP%]   .section[_ngcontent-%COMP%]   .links[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]:hover{cursor:pointer}.form-container[_ngcontent-%COMP%]   .section[_ngcontent-%COMP%]:first-child{border-radius:4px 4px 0 0}.form-container[_ngcontent-%COMP%]   .section[_ngcontent-%COMP%]:last-child{border-radius:0 0 4px 4px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ApplicationUiComponent, [{
        type: Component,
        args: [{
                selector: 'terra-application-ui',
                templateUrl: './application-ui.component.html',
                styleUrls: ['./application-ui.component.scss'],
            }]
    }], function () { return [{ type: ApplicationUIService }]; }, { applicationId: [{
            type: Input
        }], url: [{
            type: Input
        }], cohortId: [{
            type: Input
        }] }); })();

class ApplicationUiModule {
}
ApplicationUiModule.ɵmod = ɵɵdefineNgModule({ type: ApplicationUiModule });
ApplicationUiModule.ɵinj = ɵɵdefineInjector({ factory: function ApplicationUiModule_Factory(t) { return new (t || ApplicationUiModule)(); }, imports: [[CommonModule, AuthLibModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(ApplicationUiModule, { declarations: [ApplicationUiComponent], imports: [CommonModule, AuthLibModule], exports: [ApplicationUiComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(ApplicationUiModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, AuthLibModule],
                declarations: [ApplicationUiComponent],
                exports: [ApplicationUiComponent],
                entryComponents: [ApplicationUiComponent],
            }]
    }], null, null); })();

const _c0$4 = ["addresstext"];
class GooglePlacesComponent {
    constructor(mapsAPILoader) {
        this.mapsAPILoader = mapsAPILoader;
        this.setAddress = new EventEmitter();
    }
    ngOnInit() {
        this.getPlaceAutocomplete();
    }
    // ngAfterViewInit() {
    //     this.getPlaceAutocomplete();
    // }
    getPlaceAutocomplete() {
        this.mapsAPILoader.load().then(() => {
            const autocomplete = new window.google.maps.places.Autocomplete(this.addresstext.nativeElement, {
                // componentRestrictions: { country: 'US' },
                types: [this.addressType],
            });
            google.maps.event.addListener(autocomplete, 'place_changed', () => {
                // console.log("place_changed ",autocomplete);
                const place = autocomplete.getPlace();
                this.invokeEvent(place);
            });
        });
    }
    invokeEvent(place) {
        this.setAddress.emit(place);
    }
    clear() {
        // console.log("autocompleteInput ",this.autocompleteInput);
        if (!this.autocompleteInput) {
            this.invokeEvent(null);
        }
    }
}
GooglePlacesComponent.ɵfac = function GooglePlacesComponent_Factory(t) { return new (t || GooglePlacesComponent)(ɵɵdirectiveInject(MapsAPILoader)); };
GooglePlacesComponent.ɵcmp = ɵɵdefineComponent({ type: GooglePlacesComponent, selectors: [["terra-google-places"]], viewQuery: function GooglePlacesComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$4, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.addresstext = _t.first);
    } }, inputs: { addressType: "addressType", placeholder: "placeholder", autocompleteInput: "autocompleteInput" }, outputs: { setAddress: "setAddress" }, decls: 2, vars: 2, consts: [["type", "text", "debounce", "2000", 1, "input", 3, "ngModel", "placeholder", "ngModelChange", "change"], ["addresstext", ""]], template: function GooglePlacesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "input", 0, 1);
        ɵɵlistener("ngModelChange", function GooglePlacesComponent_Template_input_ngModelChange_0_listener($event) { return ctx.autocompleteInput = $event; })("change", function GooglePlacesComponent_Template_input_change_0_listener() { return ctx.clear(); });
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵpropertyInterpolate("placeholder", ctx.placeholder ? ctx.placeholder : "Enter a location");
        ɵɵproperty("ngModel", ctx.autocompleteInput);
    } }, directives: [DefaultValueAccessor, NgControlStatus, NgModel], styles: ["input[_ngcontent-%COMP%]{background:#fff;border:1px solid #bababa;border-radius:4px;box-sizing:border-box;color:#000;font-size:16px;height:48px;text-indent:20px;width:100%}input[_ngcontent-%COMP%]:focus-visible{outline:none}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(GooglePlacesComponent, [{
        type: Component,
        args: [{
                selector: 'terra-google-places',
                template: `
		<input
			class="input"
			type="text"
			[(ngModel)]="autocompleteInput"
			#addresstext
			debounce="2000"
			placeholder="{{ placeholder ? placeholder : 'Enter a location' }}"
			(change)="clear()"
		/>
	`,
                styleUrls: ['./google-places.component.scss'],
            }]
    }], function () { return [{ type: MapsAPILoader }]; }, { addressType: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], setAddress: [{
            type: Output
        }], addresstext: [{
            type: ViewChild,
            args: ['addresstext']
        }], autocompleteInput: [{
            type: Input
        }] }); })();

class GooglePlacesComponentModule {
}
GooglePlacesComponentModule.ɵmod = ɵɵdefineNgModule({ type: GooglePlacesComponentModule });
GooglePlacesComponentModule.ɵinj = ɵɵdefineInjector({ factory: function GooglePlacesComponentModule_Factory(t) { return new (t || GooglePlacesComponentModule)(); }, imports: [[
            CommonModule,
            FormsModule,
            IonicModule,
            ReactiveFormsModule,
            FeatureToggleLibModule,
            UtilLibModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(GooglePlacesComponentModule, { declarations: [GooglePlacesComponent], imports: [CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        FeatureToggleLibModule,
        UtilLibModule], exports: [GooglePlacesComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(GooglePlacesComponentModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    IonicModule,
                    ReactiveFormsModule,
                    FeatureToggleLibModule,
                    UtilLibModule,
                ],
                declarations: [GooglePlacesComponent],
                entryComponents: [GooglePlacesComponent],
                exports: [GooglePlacesComponent],
            }]
    }], null, null); })();

const initialProfileState = {
    collections: [],
    rolesLoaded: false,
    roles: [],
    selectedRoleIndex: 0,
    searchText: '',
    searchFilters: [],
    searchLoaded: false,
    selectedProfileId: null,
    profileDetail: { id: null },
    profileDetailLoaded: false,
    userProfile: {},
    userProfileLoaded: false,
    collectionLoader: false,
    fieldsSearchText: '',
    skillsSearchText: '',
    helpNeedSearchText: '',
    helpWithSearchText: '',
    searchObj: {
        id: String(Math.random()),
        name: 'Search profiles v2',
        searchQuery: { 'roles.id': ['1', '2', '3', '4', '7'] },
        searchOpt: {},
    },
    sorting: '',
    searchArr: [],
    lastProfileSearch: {},
    imageUploadObj: {},
};

// import { Collection, Media, Profile, ProfileDetail } from './model/profile';
const loadDefaultTags = createAction('[People Note] Load Profile Note Tags');
const loadDefaultTagsLoaded = createAction('[Profile Note] Loaded Profile Note Tags', props());
const loadProfileObservation = createAction('[People Note] Load Note', props());
const loadedProfileObservation = createAction('[People Note] Loaded Note', props());
const activeProfile = createAction('[People Note] profileActive', props());
const clearNote = createAction('[People Note] clearNote');
const loadSearchFilter = createAction('[People Search Filter Load] Get Search Filter');
const loadProfileCompaniesFilter = createAction('[People Search Filter Load] Get Company Search Filter');
const searchFilterLoaded = createAction('[People Search Filter Loaded] Search Filter Loaded', props());
const loadCompanies = createAction('[OnBoarding] Get Companies List');
const companiesLoaded = createAction('[OnBoarding] Get Companies List Loaded', props());
const overrideSearchFilter = createAction('[People Collection] override search filters', props());
const commonFileUpload = createAction('[Common File Upload] uploadFiles', props());
const commonFileUploadSuccess = createAction('[Common File Upload] uploadFiles success', props());
const resetSearchFilter = createAction('[People Collection] reset search filters', props());
const addSearchFilter = createAction('[People Collection] add search filters', props());
const deleteFileForProfile = createAction('[People Profile File Delete] Profile', props());
const resetSearchFilters = createAction('[People Collection] Reset search filters');
const fieldsSearchChange = createAction('[People Interests Search Effect] Search Change', props());
const searchProfiles = createAction('[People Profile Search] Search Profiles By Filters');
const fieldsSearchChangeGotResults = createAction('[People Interests Search Effect] Search change got results', props());
const resetPeople = createAction('[People Collection Reset People] Reset people');
const lastProfileSearch = createAction('[People Profile Click Details] Profile click got details', props());
const peopleLoaderEnable = createAction('[People Loader Enable] Loader Enable');
const peopleLoaderDisabled = createAction('[People Loader Disabled] Loader Disabled');
const peopleCollectionLoaded = createAction('[Profile Effect] People Collections Loaded', props());
const editProfileMedia = createAction('[People Profile Media Edit] Profile media', props());
const profileClick = createAction('[People Profile Click] Profile click', props());
const deleteProfileMedia = createAction('[People Profile Media Delete] Profile media', props());
const addProfileMedia = createAction('[People Profile Media Add] Profile media', props());
const fileUploadForProfile = createAction('[People Profile File Upload] Profile', props());
const fileUploadForProfileSuccess = createAction('[People Profile File Upload] Profile Success', props());
const deleteNote = createAction('[People Profile File Upload] Delete Note', props());

const selectPeopleNoteState = createFeatureSelector('peopleNote');
const selectAllCollectionsFilters = createSelector(selectPeopleNoteState, state => {
    try {
        return state.searchFilter;
    }
    catch (e) {
        return [];
    }
});
const selectProfileObservations = createSelector(selectPeopleNoteState, state => {
    try {
        return state.peopleData.filter(data => parseInt(data.profileId, 0) === state.activeProfile);
    }
    catch (e) {
        return [];
    }
});
const selectSearchFiltersWithText = createSelector(selectPeopleNoteState, (state, props) => {
    const matchArr = state.searchFilters.filter(sf => sf.name === props.title)[0];
    try {
        return matchArr.values
            .map(val => {
            return Object.assign(Object.assign({}, val), { isChecked: matchArr &&
                    matchArr[props.keyOption] &&
                    matchArr[props.keyOption].indexOf(val.id) !== -1
                    ? true
                    : false });
        })
            .filter(el => ((props === null || props === void 0 ? void 0 : props.isAll) ? el : el.count !== 0))
            .sort((a, b) => {
            return a.name.toLocaleLowerCase() < b.name.toLocaleLowerCase()
                ? -1
                : 1;
        });
    }
    catch (e) {
        return [];
    }
});
const selectSearchFilters = createSelector(selectPeopleNoteState, state => state.searchFilters);
const selectSearchHasFilters = createSelector(selectSearchFilters, searchFilters => searchFilters.length > 0);
const selectCommonImageUploadPath = createSelector(selectPeopleNoteState, (state, props) => {
    return state.imageUploadObj[props.key];
});
const selectPeopleV2FilterSearch = createSelector(selectPeopleNoteState, searchFilters => {
    try {
        return searchFilters.searchObj.searchQuery.search[0];
    }
    catch (e) {
        return '';
    }
});
const selectLastProfileSearch = createSelector(selectPeopleNoteState, state => state.lastProfileSearch);
const selectPeopleV2Filter = createSelector(selectPeopleNoteState, searchFilters => {
    const searchQuery = {};
    let isEditor = {};
    Object.keys(searchFilters.searchObj.searchQuery).filter(keys => {
        if (keys === 'isEditor') {
            isEditor = {
                isEditor: true,
            };
        }
        else if (!!searchFilters.searchObj.searchQuery[keys][0]) {
            if (keys === 'location') {
                searchQuery[keys] = searchFilters.searchObj.searchQuery[keys].map(s => String(`\"${s}\"`));
            }
            else {
                searchQuery[keys] = searchFilters.searchObj.searchQuery[keys];
            }
        }
    });
    const boolQuery = {};
    let tagsArr = [];
    searchFilters.searchFilters.filter((sf) => {
        if (!!sf.search && sf.search.length !== 0) {
            if (sf.name === 'Topic') {
                if (isEditor.isEditor) {
                    sf.search.map(s => tagsArr.push(String(s)));
                }
                else {
                    boolQuery['skills.id'] = sf.search.map(s => String(s));
                    boolQuery['helpWith.id'] = sf.search.map(s => String(s));
                }
            }
            if (sf.name === 'Interest') {
                if (isEditor.isEditor) {
                    sf.search.map(s => tagsArr.push(String(s)));
                }
                else {
                    searchQuery['interests.id'] = sf.search.map(s => String(s));
                }
            }
            if (sf.name === 'Course') {
                searchQuery['courses.courseId'] = sf.search.map(s => String(s));
            }
            if (sf.name === 'Locations') {
                searchQuery.country = sf.search.map(s => String(`\"${s}\"`));
            }
        }
    });
    if (tagsArr.length > 0) {
        boolQuery['tags.id'] = tagsArr;
        boolQuery['skills.is'] = tagsArr;
        boolQuery['notes.skills.id'] = tagsArr;
    }
    let sortBy = {};
    switch (searchFilters.sorting) {
        case 'Default':
            sortBy = null;
            break;
        case 'Recently viewed':
            sortBy = 'viewedBy.date';
            break;
        case 'Alphabetical (A to Z)':
            sortBy = 'firstName';
            break;
        default:
            sortBy = null;
            break;
    }
    let saveSearch = {};
    if (searchQuery.search) {
        saveSearch = {
            saveSearch: {
                profileId: searchFilters.userProfile.id,
                searchText: searchQuery.search[0],
            },
        };
    }
    if (!sortBy) {
        return [
            Object.assign(Object.assign(Object.assign(Object.assign({}, searchFilters.searchObj), { searchQuery: Object.assign({}, searchQuery), boolQuery }), saveSearch), isEditor),
        ];
    }
    else {
        return [
            Object.assign(Object.assign(Object.assign(Object.assign({}, searchFilters.searchObj), { searchQuery: Object.assign({}, searchQuery), boolQuery,
                sortBy }), saveSearch), isEditor),
        ];
    }
});
const selectProfileDetail = createSelector(selectPeopleNoteState, state => {
    return state.profileDetail;
});

class PeopleNoteService {
    constructor(authStore, http, messages, auth, store) {
        this.authStore = authStore;
        this.http = http;
        this.messages = messages;
        this.auth = auth;
        this.store = store;
        this.PROFILE_URL = this.auth.PROFILE_URL;
        this.ENDPOINT = 'https://xoqkt7m9zi.execute-api.us-east-1.amazonaws.com/dev/';
        this.userList = new BehaviorSubject([]);
        this.userList$ = this.userList.asObservable();
        this.selectedProfile = new BehaviorSubject([]);
        this.selectedProfile$ = this.selectedProfile.asObservable();
        this.profileTag = new BehaviorSubject([]);
        this.profileTag$ = this.profileTag.asObservable();
        this.application = new BehaviorSubject([]);
        this.application$ = this.application.asObservable();
    }
    getUserList(name) {
        combineLatest([
            this.authStore.profileDetail$,
            this.authStore.firebaseToken$,
        ])
            .pipe(filter(([user, token]) => !!user && !!token), first())
            .subscribe(([users, token]) => {
            const headers = {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + token,
            };
            const url = `${this.PROFILE_URL}/search/${name}/limit/20`;
            this.http
                .get(url, { headers: new HttpHeaders(headers) })
                .subscribe(userList => {
                this.userList.next([
                    ...userList.map(ud => {
                        return Object.assign(Object.assign({}, ud), { name: ud.firstName + ' ' + ud.lastName });
                    }),
                ]);
            });
        });
    }
    addNewObservation(currentUser) {
        return new Observable(subscriber => {
            combineLatest([
                this.authStore.profileDetail$,
                this.authStore.firebaseToken$,
            ])
                .pipe(filter(([user, token]) => !!user && !!token), first())
                .subscribe(([user, token]) => {
                const headers = {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + token,
                };
                const url = `${this.PROFILE_URL}/observation`;
                this.http
                    .post(url, Object.assign(Object.assign({}, currentUser), { observerEmail: user.email, observerProfileId: user.id }), { headers: new HttpHeaders(headers) })
                    .subscribe(newObservation => {
                    this.messages.showMsg({
                        icon: 'checkmark-circle-outline',
                        title1: 'Success!',
                        title2: 'You have successfully create a note',
                    });
                    subscriber.next(newObservation);
                }, error => {
                    this.messages.showErrors('Something was wrong');
                });
            });
        });
    }
    updateObservation(currentUser) {
        return new Observable(subscriber => {
            combineLatest([
                this.authStore.profileDetail$,
                this.authStore.firebaseToken$,
            ])
                .pipe(filter(([user, token]) => !!user && !!token), first())
                .subscribe(([user, token]) => {
                const headers = {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + token,
                };
                const url = `${this.PROFILE_URL}/observation/${currentUser.id}`;
                this.http
                    .put(url, Object.assign(Object.assign({}, currentUser), { observerEmail: user.email, observerProfileId: user.id }), { headers: new HttpHeaders(headers) })
                    .subscribe(newObservation => {
                    this.messages.showMsg({
                        icon: 'checkmark-circle-outline',
                        title1: 'Success!',
                        title2: 'You have successfully update a note',
                    });
                    subscriber.next(newObservation);
                }, error => {
                    this.messages.showErrors('Something was wrong');
                });
            });
        });
    }
    updateTag(tags, id) {
        return new Observable(subscriber => {
            combineLatest([
                this.authStore.profileDetail$,
                this.authStore.firebaseToken$,
            ])
                .pipe(filter(([user, token]) => !!user && !!token), first())
                .subscribe(([user, token]) => {
                const headers = {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + token,
                };
                const url = `${this.PROFILE_URL}/${id}/observation/tags`;
                this.http
                    .post(url, {
                    tags,
                }, { headers: new HttpHeaders(headers) })
                    .subscribe(newObservation => {
                    this.messages.showMsg({
                        icon: 'checkmark-circle-outline',
                        title1: 'Success!',
                        title2: 'You have successfully update a tag',
                    });
                    subscriber.next(newObservation);
                }, error => {
                    this.messages.showErrors('Something was wrong');
                });
            });
        });
    }
    removeNote(noteId, profileId) {
        combineLatest([
            this.authStore.profileDetail$,
            this.authStore.firebaseToken$,
        ])
            .pipe(filter(([user, token]) => !!user && !!token), first())
            .subscribe(([user, token]) => {
            const headers = {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + token,
            };
            const url = `${this.PROFILE_URL}/observation/${noteId}`;
            this.http
                .delete(url, { headers: new HttpHeaders(headers) })
                .subscribe(newObservation => {
                this.messages.showMsg({
                    icon: 'checkmark-circle-outline',
                    title1: 'Success!',
                    title2: 'You have successfully delete a note',
                });
                this.store.dispatch(deleteNote({ noteId: noteId }));
            }, error => {
                this.messages.showErrors('Something was wrong');
            });
        });
    }
    loadPeopleObservation(profileId, token) {
        const headers = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: 'Bearer ' + token,
        };
        const url = `${this.PROFILE_URL}/${profileId}/observation`;
        return this.http.get(url, { headers: new HttpHeaders(headers) });
    }
    loadPeopleIdDetail(profileId) {
        combineLatest([
            this.authStore.profileDetail$,
            this.authStore.firebaseToken$,
        ])
            .pipe(filter(([user, token]) => !!user && !!token), first())
            .subscribe(([users, token]) => {
            const headers = {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + token,
            };
            const url = `${this.PROFILE_URL}/search/${profileId}`;
            this.http
                .get(url, { headers: new HttpHeaders(headers) })
                .subscribe(observations => {
                let obj = Object.assign(Object.assign({}, observations), { name: observations.firstName + ' ' + observations.lastName });
                this.userList.next([obj]);
                this.selectedProfile.next(obj);
            });
        });
    }
    loadTags(token) {
        const headers = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: 'Bearer ' + token,
        };
        const url = `${this.PROFILE_URL}/onboard/observation/tagGroups`;
        return this.http.get(url, { headers: new HttpHeaders(headers) });
    }
    loadPeopleTags(profileId) {
        combineLatest([
            this.authStore.profileDetail$,
            this.authStore.firebaseToken$,
        ])
            .pipe(filter(([user, token]) => !!user && !!token), first())
            .subscribe(([users, token]) => {
            const headers = {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + token,
            };
            const url = `${this.PROFILE_URL}/${profileId}/observation/tags`;
            this.http
                .get(url, { headers: new HttpHeaders(headers) })
                .subscribe(profileTag => {
                this.profileTag.next(profileTag);
            });
        });
    }
    loadPeopleApplication(email) {
        combineLatest([
            this.authStore.profileDetail$,
            this.authStore.firebaseToken$,
        ])
            .pipe(filter(([user, token]) => !!user && !!token), first())
            .subscribe(([users, token]) => {
            const headers = {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + token,
            };
            const url = `https://xoqkt7m9zi.execute-api.us-east-1.amazonaws.com/dev/applications/search/email`;
            this.http
                .post(url, {
                email,
            }, { headers: new HttpHeaders(headers) })
                .subscribe(applicationTag => {
                this.application.next(applicationTag.filter(a => !!a));
            });
        });
    }
    removeObservationMedia(observationId) {
        combineLatest([
            this.authStore.profileDetail$,
            this.authStore.firebaseToken$,
        ])
            .pipe(filter(([user, token]) => !!user && !!token), first())
            .subscribe(([user, token]) => {
            const headers = {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + token,
            };
            const url = `${this.PROFILE_URL}/observation/media/${observationId}`;
            this.http
                .delete(url, { headers: new HttpHeaders(headers) })
                .subscribe(newObservation => {
                this.messages.showMsg({
                    icon: 'checkmark-circle-outline',
                    title1: 'Success!',
                    title2: 'You have successfully delete a media',
                });
            }, error => {
                this.messages.showErrors('Something was wrong');
            });
        });
    }
}
PeopleNoteService.ɵfac = function PeopleNoteService_Factory(t) { return new (t || PeopleNoteService)(ɵɵinject(AuthStoreService), ɵɵinject(HttpClient), ɵɵinject(MessagesService), ɵɵinject(AuthStoreService), ɵɵinject(Store)); };
PeopleNoteService.ɵprov = ɵɵdefineInjectable({ token: PeopleNoteService, factory: PeopleNoteService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PeopleNoteService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: AuthStoreService }, { type: HttpClient }, { type: MessagesService }, { type: AuthStoreService }, { type: Store }]; }, null); })();

class FilterPipe$1 {
    transform(value, input, inline, error) {
        let rawData = value
            .map(val => {
            return Object.assign(Object.assign({}, val), { name: val.name.trim() });
        })
            .sort((a, b) => (a.name < b.name ? -1 : 1));
        if (input) {
            rawData = rawData.filter(val => val.name.toLocaleLowerCase().indexOf(input.toLocaleLowerCase()) !==
                -1);
        }
        else {
            const constRowMap = rawData
                .filter(val => val.count)
                .map(val => val.count)
                .sort((a, b) => (a < b ? 1 : -1))
                .filter((v, i, a) => a.indexOf(v) === i)
                .slice(0, 5);
            rawData = rawData
                .map(val => {
                return Object.assign(Object.assign({}, val), { name: (constRowMap &&
                        constRowMap.length > 0 &&
                        constRowMap.indexOf(val.count) !== -1) ||
                        (val.isChecked && !inline)
                        ? ' ' + val.name
                        : val.name });
            })
                .sort((a, b) => (a.name < b.name ? -1 : 1));
            if (!inline) {
                rawData = rawData.sort((a, b) => (a === null || a === void 0 ? void 0 : a.isChecked) > (b === null || b === void 0 ? void 0 : b.isChecked) ? -1 : 1);
            }
        }
        const fa = [];
        rawData.map(r => {
            if (fa.length === 0 ||
                fa[fa.length - 1].name[0].toLocaleUpperCase() !==
                    r.name[0].toLocaleUpperCase()) {
                fa.push({
                    id: r.name[0].toLocaleUpperCase(),
                    header: r.name[0].toLocaleUpperCase(),
                });
            }
            fa.push(r);
        });
        if (fa.length === 0) {
            if (error) {
                fa.push({
                    id: '1',
                    header: error
                });
            }
            else {
                fa.push({
                    id: '1',
                    header: 'No results found. Please search again or select “Others” to continue. You can also <a href="mailto:support@terra.do" target="_blank">request an addition</a> to the list.',
                });
            }
        }
        else {
        }
        return fa;
    }
}
FilterPipe$1.ɵfac = function FilterPipe_Factory(t) { return new (t || FilterPipe$1)(); };
FilterPipe$1.ɵpipe = ɵɵdefinePipe({ name: "filter", type: FilterPipe$1, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FilterPipe$1, [{
        type: Pipe,
        args: [{
                name: 'filter',
            }]
    }], null, null); })();

function SelectionComponent_ion_col_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-col", 1);
    ɵɵtext(1);
    ɵɵelementStart(2, "img", 8);
    ɵɵlistener("click", function SelectionComponent_ion_col_2_Template_img_click_2_listener() { ɵɵrestoreView(_r6); const ctx_r5 = ɵɵnextContext(); return ctx_r5.closePopover(""); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r0.name, " ");
} }
function SelectionComponent_ion_icon_5_Template$1(rf, ctx) { if (rf & 1) {
    const _r8 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-icon", 9);
    ɵɵlistener("click", function SelectionComponent_ion_icon_5_Template_ion_icon_click_0_listener() { ɵɵrestoreView(_r8); const ctx_r7 = ɵɵnextContext(); return ctx_r7.searchTxt = ""; });
    ɵɵelementEnd();
} }
function SelectionComponent_ion_icon_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "ion-icon", 10);
} }
function SelectionComponent_ion_row_9_ng_container_1_ng_container_1_ion_col_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "ion-col", 13);
} if (rf & 2) {
    const al_r11 = ɵɵnextContext(2).$implicit;
    ɵɵproperty("innerHtml", al_r11.header, ɵɵsanitizeHtml);
} }
function SelectionComponent_ion_row_9_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, SelectionComponent_ion_row_9_ng_container_1_ng_container_1_ion_col_1_Template, 1, 1, "ion-col", 12);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const al_r11 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", al_r11.header != " ");
} }
function SelectionComponent_ion_row_9_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "ion-col", 14);
    ɵɵlistener("click", function SelectionComponent_ion_row_9_ng_container_1_ng_container_2_Template_ion_col_click_1_listener() { ɵɵrestoreView(_r19); const al_r11 = ɵɵnextContext().$implicit; const ctx_r17 = ɵɵnextContext(2); return ctx_r17.checkBoxClicked(al_r11); });
    ɵɵelement(2, "ion-checkbox", 15);
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const al_r11 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵclassProp("active", al_r11.isChecked);
    ɵɵadvance(1);
    ɵɵproperty("checked", al_r11.isChecked);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", al_r11.name, " ");
} }
function SelectionComponent_ion_row_9_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, SelectionComponent_ion_row_9_ng_container_1_ng_container_1_Template, 2, 1, "ng-container", 6);
    ɵɵtemplate(2, SelectionComponent_ion_row_9_ng_container_1_ng_container_2_Template, 4, 4, "ng-container", 6);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const al_r11 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", al_r11.header);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !al_r11.header);
} }
function SelectionComponent_ion_row_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-row");
    ɵɵtemplate(1, SelectionComponent_ion_row_9_ng_container_1_Template, 3, 2, "ng-container", 11);
    ɵɵpipe(2, "filter");
    ɵɵelementEnd();
} if (rf & 2) {
    const arrayList_r9 = ctx.ngIf;
    const ctx_r3 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ɵɵpipeBind4(2, 2, arrayList_r9, ctx_r3.searchTxt, ctx_r3.inline, ctx_r3.errorMessage))("ngForTrackBy", ctx_r3.trackByFn);
} }
function SelectionComponent_ion_col_11_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-col", 16);
    ɵɵelementStart(1, "ion-button", 17);
    ɵɵlistener("click", function SelectionComponent_ion_col_11_Template_ion_button_click_1_listener() { ɵɵrestoreView(_r22); const ctx_r21 = ɵɵnextContext(); return ctx_r21.done(); });
    ɵɵelementStart(2, "span");
    ɵɵtext(3, "Done");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(4, "ion-button", 18);
    ɵɵlistener("click", function SelectionComponent_ion_col_11_Template_ion_button_click_4_listener() { ɵɵrestoreView(_r22); const ctx_r23 = ɵɵnextContext(); return ctx_r23.deselectAll(); });
    ɵɵelementStart(5, "span");
    ɵɵtext(6, "Deselect all");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
class SelectionComponent$1 {
    constructor(popoverController, store) {
        this.popoverController = popoverController;
        this.store = store;
        this.inline = false;
        this.isCustom = false;
        this.keyOption = 'search';
        this.onlyGoClick = false;
        this.leftPx = 0;
        this.errorMessage = false;
        this.saveClose = new EventEmitter();
        this.searchTxt = '';
        this.tempArr = [];
        /** empty */
    }
    get refresh() {
        return true;
    }
    set refresh(refresh) {
        this.ngOnInit();
    }
    ngOnInit() {
        this.list$ = this.store
            .select(selectSearchFiltersWithText, {
            title: this.filterTitle,
            keyOption: this.keyOption,
            isAll: this.isAll,
        })
            .pipe(filter(arrayList => arrayList.length > 0), first(), tap(arrayList => {
            arrayList.filter(al => {
                if (al.isChecked) {
                    this.tempArr = [...this.tempArr, al.id];
                }
            });
        }));
    }
    deselectAll() {
        if (this.onlyGoClick) {
            this.list$ = this.store
                .select(selectSearchFiltersWithText, {
                title: this.filterTitle,
                keyOption: this.keyOption,
                isAll: this.isAll,
            })
                .pipe(first(), map(arrayList => {
                this.tempArr = [];
                return [
                    ...arrayList.map(al => {
                        return Object.assign(Object.assign({}, al), { isChecked: false });
                    }),
                ];
            }));
        }
        else {
            this.store.dispatch(resetSearchFilter({
                name: this.filterTitle,
                keyOption: this.keyOption,
            }));
            this.ngOnInit();
            this.store.dispatch(resetPeople());
            this.store.dispatch(searchProfiles());
        }
    }
    trackByFn(index, item) {
        return item.id;
    }
    done() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.onlyGoClick) {
                this.store.dispatch(overrideSearchFilter({
                    name: this.filterTitle,
                    ids: this.tempArr,
                    keyOption: this.keyOption,
                }));
                this.store.dispatch(resetPeople());
                this.store.dispatch(searchProfiles());
            }
            this.ngOnInit();
            this.closePopover('Done');
        });
    }
    closePopover(str) {
        this.saveClose.emit(str);
        if (this.popoverController) {
            this.popoverController.dismiss(str);
        }
    }
    checkBoxClicked(record) {
        record.isChecked = !record.isChecked;
        if (!this.onlyGoClick) {
            this.store.dispatch(addSearchFilter({
                name: this.filterTitle,
                id: record.id,
                keyOption: this.keyOption,
            }));
            this.ngOnInit();
        }
        else {
            const match = this.tempArr.indexOf(record.id);
            if (match === -1) {
                this.tempArr = [...this.tempArr, record.id];
            }
            else {
                this.tempArr = [...this.tempArr.filter(a => a !== record.id)];
            }
        }
    }
}
SelectionComponent$1.ɵfac = function SelectionComponent_Factory(t) { return new (t || SelectionComponent$1)(ɵɵdirectiveInject(PopoverController), ɵɵdirectiveInject(Store)); };
SelectionComponent$1.ɵcmp = ɵɵdefineComponent({ type: SelectionComponent$1, selectors: [["terra-selection-people"]], inputs: { name: "name", active: "active", placeholder: "placeholder", arrayList: "arrayList", filterTitle: "filterTitle", inline: "inline", isCustom: "isCustom", keyOption: "keyOption", isAll: "isAll", onlyGoClick: "onlyGoClick", leftPx: "leftPx", errorMessage: "errorMessage", refresh: "refresh" }, outputs: { saveClose: "saveClose" }, decls: 12, vars: 15, consts: [["size", "12", "class", "main-title bottom", 4, "ngIf"], ["size", "12", 1, "main-title", "bottom"], ["value", "custom", 3, "ngModel", "placeholder", "ngModelChange"], ["name", "close-outline", "class", "img-bottom", 3, "click", 4, "ngIf"], ["name", "search-outline", "class", "img-bottom", 4, "ngIf"], ["size", "12", 1, "set-max-height"], [4, "ngIf"], ["size", "12", "class", "main-title top p16", 4, "ngIf"], ["src", "/assets/fi_chevrons-up.svg", 1, "img-bottom", "cursor", 3, "click"], ["name", "close-outline", 1, "img-bottom", 3, "click"], ["name", "search-outline", 1, "img-bottom"], [4, "ngFor", "ngForOf", "ngForTrackBy"], ["size", "12", "class", "selector header", 3, "innerHtml", 4, "ngIf"], ["size", "12", 1, "selector", "header", 3, "innerHtml"], ["size", "12", 1, "selector", "cursor", 3, "click"], [3, "checked"], ["size", "12", 1, "main-title", "top", "p16"], [1, "btn-yellow-small", 3, "click"], [1, "btn-white-small", "text-right", 3, "click"]], template: function SelectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "ion-grid");
        ɵɵelementStart(1, "ion-row");
        ɵɵtemplate(2, SelectionComponent_ion_col_2_Template, 3, 1, "ion-col", 0);
        ɵɵelementStart(3, "ion-col", 1);
        ɵɵelementStart(4, "ion-input", 2);
        ɵɵlistener("ngModelChange", function SelectionComponent_Template_ion_input_ngModelChange_4_listener($event) { return ctx.searchTxt = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(5, SelectionComponent_ion_icon_5_Template$1, 1, 0, "ion-icon", 3);
        ɵɵtemplate(6, SelectionComponent_ion_icon_6_Template, 1, 0, "ion-icon", 4);
        ɵɵelementEnd();
        ɵɵelementStart(7, "ion-col", 5);
        ɵɵelementStart(8, "ion-grid");
        ɵɵtemplate(9, SelectionComponent_ion_row_9_Template, 3, 7, "ion-row", 6);
        ɵɵpipe(10, "async");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(11, SelectionComponent_ion_col_11_Template, 7, 0, "ion-col", 7);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵstyleProp("left", ctx.leftPx, "px");
        ɵɵclassProp("inline", ctx.inline)("isCustom", ctx.isCustom);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", !ctx.inline && ctx.name);
        ɵɵadvance(2);
        ɵɵproperty("ngModel", ctx.searchTxt)("placeholder", ctx.placeholder);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !!ctx.searchTxt);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.searchTxt);
        ɵɵadvance(3);
        ɵɵproperty("ngIf", ɵɵpipeBind1(10, 13, ctx.list$));
        ɵɵadvance(2);
        ɵɵproperty("ngIf", !ctx.inline);
    } }, directives: [IonGrid, IonRow, NgIf, IonCol, IonInput, TextValueAccessor, NgControlStatus, NgModel, IonIcon, NgForOf, IonCheckbox, BooleanValueAccessor, IonButton], pipes: [AsyncPipe, FilterPipe$1], styles: ["ion-col[_ngcontent-%COMP%], ion-grid[_ngcontent-%COMP%]{padding:0}ion-checkbox[_ngcontent-%COMP%]{--border-color:#3b3b3b}.cursor[_ngcontent-%COMP%]{cursor:pointer}ion-grid[_ngcontent-%COMP%]   .set-max-height[_ngcontent-%COMP%]{max-height:237px;min-height:237px;overflow-y:scroll}ion-grid[_ngcontent-%COMP%]   .set-max-height[_ngcontent-%COMP%]   .selector[_ngcontent-%COMP%]{color:#000;display:flex;font-size:16px;line-height:150%;padding:10px 16px 10px 56px;position:relative}ion-grid[_ngcontent-%COMP%]   .set-max-height[_ngcontent-%COMP%]   .selector[_ngcontent-%COMP%]   ion-checkbox[_ngcontent-%COMP%]{--border-radius:0;left:20px;position:absolute;top:15px}ion-grid[_ngcontent-%COMP%]   .set-max-height[_ngcontent-%COMP%]   .selector.active[_ngcontent-%COMP%]{background:#ebfaf0}ion-grid[_ngcontent-%COMP%]   .set-max-height[_ngcontent-%COMP%]   .selector.header[_ngcontent-%COMP%]{border-top:1px solid #efefef;color:#3b3b3b;display:block;font-size:16px;font-style:italic;letter-spacing:.2px;line-height:150%;padding-bottom:5px;padding-top:12px}ion-grid.inline[_ngcontent-%COMP%]{background:#fff;border:var(--border,1px solid #bababa);border-radius:4px;box-sizing:border-box}ion-grid.inline[_ngcontent-%COMP%]   .set-max-height[_ngcontent-%COMP%]{max-height:312px;min-height:312px}ion-grid.isCustom[_ngcontent-%COMP%]{background:#fff;border:1px solid #bababa;border-radius:4px;box-sizing:border-box;left:50%;margin-top:8px;max-height:408px;min-height:408px;position:absolute;top:61px;z-index:5}ion-grid[_ngcontent-%COMP%]   .main-title[_ngcontent-%COMP%]{color:#000;font-size:16px;line-height:150%;padding:12px 16px;position:relative}ion-grid[_ngcontent-%COMP%]   .main-title.top[_ngcontent-%COMP%]{border-top:1px solid #efefef}ion-grid[_ngcontent-%COMP%]   .main-title.bottom[_ngcontent-%COMP%]{border-bottom:1px solid #efefef}ion-grid[_ngcontent-%COMP%]   .main-title.p16[_ngcontent-%COMP%]{padding:16px}ion-grid[_ngcontent-%COMP%]   .main-title[_ngcontent-%COMP%]   .img-bottom[_ngcontent-%COMP%]{color:#bababa;cursor:pointer;font-size:24px;position:absolute;right:16px;top:12px}ion-grid[_ngcontent-%COMP%]   .main-title[_ngcontent-%COMP%]   ion-input[_ngcontent-%COMP%]{--padding-bottom:0;--padding-end:0;--padding-start:0;--padding-top:0;color:#3b3b3b;font-size:16px;line-height:150%;max-width:calc(100% - 34px)}ion-grid[_ngcontent-%COMP%]   .main-title[_ngcontent-%COMP%]   .close-outline[_ngcontent-%COMP%]{cursor:pointer;z-index:2}ion-grid[_ngcontent-%COMP%]   .main-title[_ngcontent-%COMP%]   .text-right[_ngcontent-%COMP%]{position:absolute;right:16px}@media (min-width:576px){.isCustom[_ngcontent-%COMP%]{max-width:360px;min-width:360px}}@media (max-width:575.98px){.isCustom[_ngcontent-%COMP%]{left:20px!important;right:20px!important}}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SelectionComponent$1, [{
        type: Component,
        args: [{
                selector: 'terra-selection-people',
                templateUrl: './selection.component.html',
                styleUrls: ['./selection.component.scss'],
            }]
    }], function () { return [{ type: PopoverController }, { type: Store }]; }, { name: [{
            type: Input
        }], active: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], arrayList: [{
            type: Input
        }], filterTitle: [{
            type: Input
        }], inline: [{
            type: Input
        }], isCustom: [{
            type: Input
        }], keyOption: [{
            type: Input
        }], isAll: [{
            type: Input
        }], onlyGoClick: [{
            type: Input
        }], leftPx: [{
            type: Input
        }], errorMessage: [{
            type: Input
        }], saveClose: [{
            type: Output
        }], refresh: [{
            type: Input
        }] }); })();

class AddMediaService {
    constructor(authStore, http, messages, auth) {
        this.authStore = authStore;
        this.http = http;
        this.messages = messages;
        this.auth = auth;
        this.PROFILE_URL = this.auth.PROFILE_URL;
    }
    fileUploadForProfile(folder, file) {
        return new Observable(subscriber => {
            combineLatest([this.authStore.firebaseToken$])
                .pipe(first())
                .subscribe(([token]) => {
                if (token) {
                    const headers = {
                        Accept: 'application/json',
                        Authorization: 'Bearer ' + token,
                    };
                    const url = `${this.PROFILE_URL}/upload/` + folder;
                    this.http
                        .post(url, file, { headers: new HttpHeaders(headers) })
                        .pipe(shareReplay())
                        .subscribe(filePath => {
                        subscriber.next(filePath);
                    }, error => {
                        this.messages.showErrors('Something was wrong');
                    });
                }
                else {
                    this.messages.showErrors('Something was wrong');
                }
            });
        });
    }
    deleteFileUpload(folder, file) {
        return new Observable(subscriber => {
            combineLatest([this.authStore.firebaseToken$])
                .pipe(first())
                .subscribe(([token]) => {
                if (token) {
                    const headers = {
                        Accept: 'application/json',
                        Authorization: 'Bearer ' + token,
                    };
                    const filename = file.split('/');
                    const filePath = file.split('/')[filename.length - 1];
                    const url = `${this.PROFILE_URL}/remove/` + folder + `/` + filePath;
                    return this.http
                        .delete(url, { headers: new HttpHeaders(headers) })
                        .pipe(shareReplay())
                        .subscribe(filePathURL => {
                        subscriber.next(filePathURL);
                    }, error => {
                        this.messages.showErrors('Something was wrong');
                    });
                }
                else {
                    this.messages.showErrors('Something was wrong');
                }
            });
        });
    }
}
AddMediaService.ɵfac = function AddMediaService_Factory(t) { return new (t || AddMediaService)(ɵɵinject(AuthStoreService), ɵɵinject(HttpClient), ɵɵinject(MessagesService), ɵɵinject(AuthStoreService)); };
AddMediaService.ɵprov = ɵɵdefineInjectable({ token: AddMediaService, factory: AddMediaService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AddMediaService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: AuthStoreService }, { type: HttpClient }, { type: MessagesService }, { type: AuthStoreService }]; }, null); })();

const _c0$5 = ["fileInp"];
function TerraAddMediaComponent_ion_card_1_div_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "iframe", 13);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("src", ctx_r5.safeURL(ctx_r5.media.previewUrl), ɵɵsanitizeResourceUrl);
} }
function TerraAddMediaComponent_ion_card_1_div_3_ng_template_2_img_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 15);
} if (rf & 2) {
    const ctx_r8 = ɵɵnextContext(4);
    ɵɵproperty("src", ctx_r8.media.previewUrl, ɵɵsanitizeUrl);
} }
function TerraAddMediaComponent_ion_card_1_div_3_ng_template_2_img_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 15);
} if (rf & 2) {
    const ctx_r9 = ɵɵnextContext(4);
    ɵɵproperty("src", ctx_r9.defaultPreviewUrl, ɵɵsanitizeUrl);
} }
function TerraAddMediaComponent_ion_card_1_div_3_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵtemplate(0, TerraAddMediaComponent_ion_card_1_div_3_ng_template_2_img_0_Template, 1, 1, "img", 14);
    ɵɵtemplate(1, TerraAddMediaComponent_ion_card_1_div_3_ng_template_2_img_1_Template, 1, 1, "img", 14);
} if (rf & 2) {
    const ctx_r7 = ɵɵnextContext(3);
    ɵɵproperty("ngIf", ctx_r7.checkPreviewUrl("image", ctx_r7.media == null ? null : ctx_r7.media.previewUrl));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r7.checkPreviewUrl("image", ctx_r7.media == null ? null : ctx_r7.media.previewUrl));
} }
function TerraAddMediaComponent_ion_card_1_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 10);
    ɵɵtemplate(1, TerraAddMediaComponent_ion_card_1_div_3_ng_container_1_Template, 2, 1, "ng-container", 11);
    ɵɵtemplate(2, TerraAddMediaComponent_ion_card_1_div_3_ng_template_2_Template, 2, 2, "ng-template", null, 12, ɵɵtemplateRefExtractor);
    ɵɵelementEnd();
} if (rf & 2) {
    const _r6 = ɵɵreference(3);
    const ctx_r2 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r2.checkPreviewUrl("video", ctx_r2.media == null ? null : ctx_r2.media.previewUrl))("ngIfElse", _r6);
} }
function TerraAddMediaComponent_ion_card_1_div_4_img_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 15);
} if (rf & 2) {
    const ctx_r10 = ɵɵnextContext(3);
    ɵɵproperty("src", ctx_r10.media.previewUrl, ɵɵsanitizeUrl);
} }
function TerraAddMediaComponent_ion_card_1_div_4_img_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 15);
} if (rf & 2) {
    const ctx_r11 = ɵɵnextContext(3);
    ɵɵproperty("src", ctx_r11.defaultPreviewUrl, ɵɵsanitizeUrl);
} }
function TerraAddMediaComponent_ion_card_1_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 10);
    ɵɵtemplate(1, TerraAddMediaComponent_ion_card_1_div_4_img_1_Template, 1, 1, "img", 14);
    ɵɵtemplate(2, TerraAddMediaComponent_ion_card_1_div_4_img_2_Template, 1, 1, "img", 14);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r3.checkPreviewUrl("image", ctx_r3.media == null ? null : ctx_r3.media.previewUrl));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r3.checkPreviewUrl("image", ctx_r3.media == null ? null : ctx_r3.media.previewUrl));
} }
function TerraAddMediaComponent_ion_card_1_div_5_img_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 15);
} if (rf & 2) {
    const ctx_r12 = ɵɵnextContext(3);
    ɵɵproperty("src", ctx_r12.media.previewUrl, ɵɵsanitizeUrl);
} }
function TerraAddMediaComponent_ion_card_1_div_5_img_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 15);
} if (rf & 2) {
    const ctx_r13 = ɵɵnextContext(3);
    ɵɵproperty("src", ctx_r13.defaultPreviewUrl, ɵɵsanitizeUrl);
} }
function TerraAddMediaComponent_ion_card_1_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 10);
    ɵɵtemplate(1, TerraAddMediaComponent_ion_card_1_div_5_img_1_Template, 1, 1, "img", 14);
    ɵɵtemplate(2, TerraAddMediaComponent_ion_card_1_div_5_img_2_Template, 1, 1, "img", 14);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r4.checkPreviewUrl("image", ctx_r4.media == null ? null : ctx_r4.media.previewUrl));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r4.checkPreviewUrl("image", ctx_r4.media == null ? null : ctx_r4.media.previewUrl));
} }
function TerraAddMediaComponent_ion_card_1_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-card", 2);
    ɵɵlistener("click", function TerraAddMediaComponent_ion_card_1_Template_ion_card_click_0_listener() { ɵɵrestoreView(_r15); const ctx_r14 = ɵɵnextContext(); return ctx_r14.openMediaLink(ctx_r14.media); });
    ɵɵelementStart(1, "ion-row", 3);
    ɵɵelementStart(2, "ion-col", 4);
    ɵɵtemplate(3, TerraAddMediaComponent_ion_card_1_div_3_Template, 4, 2, "div", 5);
    ɵɵtemplate(4, TerraAddMediaComponent_ion_card_1_div_4_Template, 3, 2, "div", 5);
    ɵɵtemplate(5, TerraAddMediaComponent_ion_card_1_div_5_Template, 3, 2, "div", 5);
    ɵɵelementEnd();
    ɵɵelementStart(6, "ion-col", 6);
    ɵɵelementStart(7, "ion-card-content", 7);
    ɵɵelementStart(8, "ion-row");
    ɵɵelementStart(9, "ion-col", 8);
    ɵɵtext(10);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(11, "ion-row");
    ɵɵelementStart(12, "ion-col", 9);
    ɵɵtext(13);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(14, "ion-row");
    ɵɵelementStart(15, "ion-col");
    ɵɵtext(16);
    ɵɵpipe(17, "dateFormat");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵproperty("ngIf", ctx_r0.media.mediaType == "video");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.media.mediaType == "image");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.media.mediaType == "file");
    ɵɵadvance(5);
    ɵɵtextInterpolate1(" ", ctx_r0.media.title, " ");
    ɵɵadvance(3);
    ɵɵtextInterpolate1(" ", ctx_r0.media.shortDescription, " ");
    ɵɵadvance(3);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind2(17, 6, ctx_r0.media.createdAt, "do MMMM yyyy"), " ");
} }
function TerraAddMediaComponent_ng_container_2_p_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "p", 32);
    ɵɵtext(1, " Enter a link to a file or video cannot exceed 200 characters. ");
    ɵɵelementEnd();
} }
function TerraAddMediaComponent_ng_container_2_p_11_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "p", 32);
    ɵɵtext(1, " Enter a link to a file or video is required ");
    ɵɵelementEnd();
} }
function TerraAddMediaComponent_ng_container_2_p_15_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "p", 32);
    ɵɵtext(1, " Enter a title cannot exceed 200 characters. ");
    ɵɵelementEnd();
} }
function TerraAddMediaComponent_ng_container_2_p_16_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "p", 32);
    ɵɵtext(1, " Enter a title is required ");
    ɵɵelementEnd();
} }
function TerraAddMediaComponent_ng_container_2_p_20_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "p", 32);
    ɵɵtext(1, " Enter a description cannot exceed 500 characters. ");
    ɵɵelementEnd();
} }
function TerraAddMediaComponent_ng_container_2_p_21_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "p", 32);
    ɵɵtext(1, " Enter a description is required ");
    ɵɵelementEnd();
} }
function TerraAddMediaComponent_ng_container_2_span_29_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵtext(1, " Change thumbnail");
    ɵɵelementEnd();
} }
function TerraAddMediaComponent_ng_container_2_span_30_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵtext(1, " Add thumbnail");
    ɵɵelementEnd();
} }
function TerraAddMediaComponent_ng_container_2_img_32_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 15);
} if (rf & 2) {
    const ctx_r25 = ɵɵnextContext(2);
    ɵɵproperty("src", ctx_r25.editMedia.value.previewUrl, ɵɵsanitizeUrl);
} }
function TerraAddMediaComponent_ng_container_2_img_33_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 33);
} }
function TerraAddMediaComponent_ng_container_2_ion_row_34_Template(rf, ctx) { if (rf & 1) {
    const _r30 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-row", 34);
    ɵɵelementStart(1, "ion-col", 35);
    ɵɵelementStart(2, "a", 2);
    ɵɵlistener("click", function TerraAddMediaComponent_ng_container_2_ion_row_34_Template_a_click_2_listener() { ɵɵrestoreView(_r30); const ctx_r29 = ɵɵnextContext(2); return ctx_r29.delete(); });
    ɵɵtext(3, "Delete");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(4, "ion-col", 36);
    ɵɵelementStart(5, "a", 2);
    ɵɵlistener("click", function TerraAddMediaComponent_ng_container_2_ion_row_34_Template_a_click_5_listener() { ɵɵrestoreView(_r30); const ctx_r31 = ɵɵnextContext(2); return ctx_r31.update(ctx_r31.editMedia); });
    ɵɵtext(6, "Update");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function TerraAddMediaComponent_ng_container_2_ion_row_35_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-row", 34);
    ɵɵelementStart(1, "ion-col", 35);
    ɵɵelementStart(2, "a", 2);
    ɵɵlistener("click", function TerraAddMediaComponent_ng_container_2_ion_row_35_Template_a_click_2_listener() { ɵɵrestoreView(_r33); const ctx_r32 = ɵɵnextContext(2); return ctx_r32.cancel(); });
    ɵɵtext(3, "Cancel");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(4, "ion-col", 36);
    ɵɵelementStart(5, "a", 2);
    ɵɵlistener("click", function TerraAddMediaComponent_ng_container_2_ion_row_35_Template_a_click_5_listener() { ɵɵrestoreView(_r33); const ctx_r34 = ɵɵnextContext(2); return ctx_r34.add(ctx_r34.editMedia); });
    ɵɵtext(6, "Add");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function TerraAddMediaComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r36 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "ion-grid", 16);
    ɵɵelementStart(2, "form", 17);
    ɵɵelementStart(3, "ion-row");
    ɵɵelementStart(4, "ion-col", 18);
    ɵɵelementStart(5, "ion-grid");
    ɵɵelementStart(6, "ion-row");
    ɵɵelementStart(7, "ion-col", 19);
    ɵɵelement(8, "ion-input", 20);
    ɵɵelementStart(9, "div", 21);
    ɵɵtemplate(10, TerraAddMediaComponent_ng_container_2_p_10_Template, 2, 0, "p", 22);
    ɵɵtemplate(11, TerraAddMediaComponent_ng_container_2_p_11_Template, 2, 0, "p", 22);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(12, "ion-col", 19);
    ɵɵelement(13, "ion-input", 23);
    ɵɵelementStart(14, "div", 21);
    ɵɵtemplate(15, TerraAddMediaComponent_ng_container_2_p_15_Template, 2, 0, "p", 22);
    ɵɵtemplate(16, TerraAddMediaComponent_ng_container_2_p_16_Template, 2, 0, "p", 22);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(17, "ion-col", 19);
    ɵɵelement(18, "ion-textarea", 24);
    ɵɵelementStart(19, "div", 21);
    ɵɵtemplate(20, TerraAddMediaComponent_ng_container_2_p_20_Template, 2, 0, "p", 22);
    ɵɵtemplate(21, TerraAddMediaComponent_ng_container_2_p_21_Template, 2, 0, "p", 22);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(22, "ion-col", 25);
    ɵɵelementStart(23, "ion-grid");
    ɵɵelementStart(24, "ion-row");
    ɵɵelementStart(25, "ion-col", 19);
    ɵɵelementStart(26, "input", 26, 27);
    ɵɵlistener("change", function TerraAddMediaComponent_ng_container_2_Template_input_change_26_listener($event) { ɵɵrestoreView(_r36); const ctx_r35 = ɵɵnextContext(); return ctx_r35.handleFileInput($event); });
    ɵɵelementEnd();
    ɵɵelementStart(28, "ion-button", 28);
    ɵɵlistener("click", function TerraAddMediaComponent_ng_container_2_Template_ion_button_click_28_listener() { ɵɵrestoreView(_r36); const ctx_r37 = ɵɵnextContext(); return ctx_r37.onClick(); });
    ɵɵtemplate(29, TerraAddMediaComponent_ng_container_2_span_29_Template, 2, 0, "span", 1);
    ɵɵtemplate(30, TerraAddMediaComponent_ng_container_2_span_30_Template, 2, 0, "span", 1);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(31, "ion-col", 29);
    ɵɵtemplate(32, TerraAddMediaComponent_ng_container_2_img_32_Template, 1, 1, "img", 14);
    ɵɵtemplate(33, TerraAddMediaComponent_ng_container_2_img_33_Template, 1, 0, "img", 30);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(34, TerraAddMediaComponent_ng_container_2_ion_row_34_Template, 7, 0, "ion-row", 31);
    ɵɵtemplate(35, TerraAddMediaComponent_ng_container_2_ion_row_35_Template, 7, 0, "ion-row", 31);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵproperty("formGroup", ctx_r1.editMedia);
    ɵɵadvance(8);
    ɵɵproperty("ngIf", ctx_r1.editMedia.controls["mediaUrl"].hasError("maxlength"));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r1.editMedia.controls["mediaUrl"].hasError("required") && ctx_r1.editMedia.controls["mediaUrl"].dirty);
    ɵɵadvance(4);
    ɵɵproperty("ngIf", ctx_r1.editMedia.controls["title"].hasError("maxlength"));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r1.editMedia.controls["title"].hasError("required") && ctx_r1.editMedia.controls["title"].dirty);
    ɵɵadvance(4);
    ɵɵproperty("ngIf", ctx_r1.editMedia.controls["shortDescription"].hasError("maxlength"));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r1.editMedia.controls["shortDescription"].hasError("required") && ctx_r1.editMedia.controls["shortDescription"].dirty);
    ɵɵadvance(8);
    ɵɵproperty("ngIf", ctx_r1.checkPreviewUrl("image", ctx_r1.editMedia == null ? null : ctx_r1.editMedia.value == null ? null : ctx_r1.editMedia.value.previewUrl));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r1.checkPreviewUrl("image", ctx_r1.editMedia == null ? null : ctx_r1.editMedia.value == null ? null : ctx_r1.editMedia.value.previewUrl));
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r1.checkPreviewUrl("image", ctx_r1.editMedia == null ? null : ctx_r1.editMedia.value == null ? null : ctx_r1.editMedia.value.previewUrl));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r1.checkPreviewUrl("image", ctx_r1.editMedia == null ? null : ctx_r1.editMedia.value == null ? null : ctx_r1.editMedia.value.previewUrl));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r1.media == null ? null : ctx_r1.media.id);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !(ctx_r1.media == null ? null : ctx_r1.media.id));
} }
class TerraAddMediaComponent {
    constructor(formBuilder, messageService, sanitizer, addMediaService) {
        this.formBuilder = formBuilder;
        this.messageService = messageService;
        this.sanitizer = sanitizer;
        this.addMediaService = addMediaService;
        this.folderName = '';
        this.view = 'show';
        this.mediaType = 'link';
        this.addMediaFn = new EventEmitter();
        this.updateMediaFn = new EventEmitter();
        this.deleteMediaFn = new EventEmitter();
        this.newObjRefresh = new EventEmitter();
        this.defaultPreviewUrl = 'https://res.cloudinary.com/terra-do/image/upload/v1610974478/user-link_oarrrv.png';
        this.showSkeleton = false;
        this.editMedia = this.formBuilder.group({
            id: [''],
            previewUrl: [''],
            title: ['', [Validators.required, Validators.maxLength(200)]],
            mediaType: [''],
            mediaUrl: ['', [Validators.required, Validators.maxLength(200)]],
            shortDescription: ['', [Validators.required, Validators.maxLength(500)]],
        });
    }
    ngOnInit() {
        if (!!this.media) {
            const obj = {
                id: this.media.id,
                previewUrl: this.media.previewUrl,
                title: this.media.title,
                mediaType: this.media.mediaType,
                mediaUrl: this.media.mediaUrl,
                shortDescription: this.media.shortDescription,
            };
            this.editMedia.patchValue(obj);
        }
    }
    openMediaLink(media) {
        window.open(media.mediaUrl, '_blank');
    }
    update(editMedia) {
        // console.log('update ', editMedia);
        const media = editMedia.value;
        if (this.mediaType === 'link' ||
            this.mediaType === 'image' ||
            this.mediaType === 'video') {
            // if (media?.mediaUrl.match(/\.(jpeg|jpg|gif|png)$/) === null) {
            // 	this.mediaType = 'video';
            // 	if (!media.previewUrl && media.mediaUrl) {
            // 		// if media type is video and there is no preview url then use media url for it
            // 		media.previewUrl = media.mediaUrl;
            // 	}
            // } else {
            // 	this.mediaType = 'image';
            // }
            if (!media.previewUrl &&
                media.mediaUrl &&
                (media === null || media === void 0 ? void 0 : media.mediaUrl.match(/\.(jpeg|jpg|gif|png)$/)) === null) {
                // if media type is video and there is no preview url then use media url for it
                media.previewUrl = media.mediaUrl;
                this.mediaType = 'video';
            }
            else if (media.previewUrl &&
                (media === null || media === void 0 ? void 0 : media.previewUrl.match(/\.(jpeg|jpg|gif|png)$/)) === null) {
                this.mediaType = 'video';
            }
            else {
                this.mediaType = 'image';
            }
        }
        else {
            this.mediaType = 'file';
            // media.mediaUrl = media.previewUrl;
        }
        media.mediaType = this.mediaType;
        const obj = {
            id: media.id,
            title: media.title,
            mediaType: media.mediaType,
            mediaUrl: media.mediaUrl,
            shortDescription: media.shortDescription,
            mediaDuration: media.mediaDuration ? media.mediaDuration : 0,
            previewUrl: media.previewUrl ? media.previewUrl : this.defaultPreviewUrl,
        };
        this.updateMediaFn.emit(obj);
        this.messageService.showSuccessMessages('You have successfully updated this media');
    }
    delete() {
        this.deleteMediaFn.emit(this.media.id);
    }
    add(editMedia) {
        // console.log('add ', editMedia);
        const media = editMedia.value;
        if (this.mediaType === 'link' ||
            this.mediaType === 'image' ||
            this.mediaType === 'video') {
            // if (media?.mediaUrl.match(/\.(jpeg|jpg|gif|png)$/) === null) {
            // 	this.mediaType = 'video';
            // 	if (!media.previewUrl && media.mediaUrl) {
            // 		// if media type is video and there is no preview url then use media url for it
            // 		media.previewUrl = media.mediaUrl;
            // 	}
            // } else {
            // 	this.mediaType = 'image';
            // }
            if (!media.previewUrl &&
                media.mediaUrl &&
                (media === null || media === void 0 ? void 0 : media.mediaUrl.match(/\.(jpeg|jpg|gif|png)$/)) === null) {
                // if media type is video and there is no preview url then use media url for it
                media.previewUrl = media.mediaUrl;
                this.mediaType = 'video';
            }
            else if (media.previewUrl &&
                (media === null || media === void 0 ? void 0 : media.previewUrl.match(/\.(jpeg|jpg|gif|png)$/)) === null) {
                this.mediaType = 'video';
            }
            else {
                this.mediaType = 'image';
            }
        }
        else {
            this.mediaType = 'file';
            // media.mediaUrl = media.previewUrl;
        }
        media.mediaType = this.mediaType;
        if (media.title || media.mediaUrl || media.previewUrl) {
            const obj = {
                title: media.title,
                mediaType: this.mediaType,
                mediaUrl: media.mediaUrl,
                shortDescription: media.shortDescription,
                mediaDuration: media.mediaDuration ? media.mediaDuration : 0,
                previewUrl: media.previewUrl ? media.previewUrl : this.defaultPreviewUrl,
            };
            this.addMediaFn.emit(obj);
        }
        else {
            this.messageService.showSuccessMessages('Please fill media detail');
        }
    }
    handleFileInput(event) {
        // console.log('handle file input ', event);
        var _a, _b;
        const selectedFile = event.target.files[0];
        console.log('file ', selectedFile);
        let extension = '';
        if (!!selectedFile) {
            extension = selectedFile.name.split('.')[selectedFile.name.split('.').length - 1];
            // console.log("extension ", extension, selectedFile.name.split("."));
            if (extension !== 'png' &&
                extension !== 'jpg' &&
                extension !== 'svg' &&
                extension !== 'mp4' &&
                extension !== 'jpeg') {
                this.messageService.showErrors('Only images and videos are allowed');
            }
            else {
                const formData = new FormData();
                formData.append('file', selectedFile);
                this.showSkeleton = true;
                if ((_b = (_a = this.editMedia) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.previewUrl) {
                    this.deleteUrl(this.editMedia.value.previewUrl);
                }
                this.addMediaService
                    .fileUploadForProfile(this.folderName, formData)
                    .subscribe(filePath => {
                    var _a;
                    this.editMedia.controls.previewUrl.setValue(filePath.url);
                    if ((_a = this.media) === null || _a === void 0 ? void 0 : _a.id) {
                        this.update(this.editMedia);
                    }
                    else {
                        this.add(this.editMedia);
                    }
                });
            }
        }
    }
    deleteUrl(url) {
        this.addMediaService
            .deleteFileUpload(this.folderName, url)
            .subscribe(() => { });
    }
    onClick() {
        this.fileInput.nativeElement.click();
    }
    safeURL(videoURL) {
        videoURL = this.createYouTubeEmbedLink(videoURL);
        return this.sanitizer.bypassSecurityTrustResourceUrl(videoURL);
    }
    createYouTubeEmbedLink(link) {
        if (link.indexOf('http://www.youtube.com/watch?v=') > -1) {
            return link.replace('http://www.youtube.com/watch?v=', 'http://www.youtube.com/embed/');
        }
        else if (link.indexOf('https://www.youtube.com/watch?v=') > -1) {
            return link.replace('https://www.youtube.com/watch?v=', 'https://www.youtube.com/embed/');
        }
        else {
            return link;
        }
    }
    cancel() {
        var _a, _b;
        this.newObjRefresh.emit();
        if ((_b = (_a = this.editMedia) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.previewUrl) {
            this.deleteUrl(this.editMedia.value.previewUrl);
        }
        this.editMedia.reset();
    }
    deleteMedia() { }
    checkPreviewUrl(type, url) {
        if (type === 'video') {
            return url && url.indexOf('https://www.youtube.com/watch?v=') > -1;
        }
        else {
            return url && url.match(/\.(jpeg|jpg|gif|png)$/) !== null;
        }
    }
}
TerraAddMediaComponent.ɵfac = function TerraAddMediaComponent_Factory(t) { return new (t || TerraAddMediaComponent)(ɵɵdirectiveInject(FormBuilder), ɵɵdirectiveInject(MessagesService), ɵɵdirectiveInject(DomSanitizer), ɵɵdirectiveInject(AddMediaService)); };
TerraAddMediaComponent.ɵcmp = ɵɵdefineComponent({ type: TerraAddMediaComponent, selectors: [["app-terra-add-media"]], viewQuery: function TerraAddMediaComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$5, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.fileInput = _t.first);
    } }, inputs: { media: "media", folderName: "folderName", view: "view", mediaType: "mediaType" }, outputs: { addMediaFn: "addMediaFn", updateMediaFn: "updateMediaFn", deleteMediaFn: "deleteMediaFn", newObjRefresh: "newObjRefresh" }, decls: 3, vars: 2, consts: [["class", "cursor", 3, "click", 4, "ngIf"], [4, "ngIf"], [1, "cursor", 3, "click"], [1, "view-card"], ["size-sm", "12", "size-xs", "12", "size-md", "4", "size-md", "4", 1, "p20"], ["class", "showMediaLink", 4, "ngIf"], ["size-sm", "12", "size-xs", "12", "size-md", "8", "size-md", "8"], [1, "p-content"], [1, "title"], [1, "shortDescription"], [1, "showMediaLink"], [4, "ngIf", "ngIfElse"], ["article", ""], ["frameborder", "0", "allowfullscreen", "", 1, "videoPlayer", 3, "src"], [3, "src", 4, "ngIf"], [3, "src"], [1, "editable"], [3, "formGroup"], ["size-xs", "12", "size-sm", "12", "size-md", "8", "size-lg", "8"], ["size", "12"], ["type", "text", "formControlName", "mediaUrl", "placeholder", "Enter a link to a file or video", 1, "input-box"], [1, "error-message"], ["class", "alert alert-danger", 4, "ngIf"], ["type", "text", "formControlName", "title", "placeholder", "Enter a title", 1, "input-box", "mt20"], ["type", "text", "formControlName", "shortDescription", "placeholder", "Enter a description", 1, "input-box", "last-desc", "mt20"], ["size-xs", "12", "size-sm", "12", "size-md", "4", "size-lg", "4", 1, "max-width"], ["type", "file", "id", "file-input", "accept", "image/*", 2, "opacity", "0", "width", "0", 3, "change"], ["fileInp", ""], [1, "btn-white-small", 3, "click"], ["size", "12", 1, "center-image"], ["class", "image-size", "src", "./assets/people/media.png", 4, "ngIf"], ["class", "pt20", 4, "ngIf"], [1, "alert", "alert-danger"], ["src", "./assets/people/media.png", 1, "image-size"], [1, "pt20"], ["size", "6", 1, "mb-20"], ["size", "6", 1, "tar", "mb-20"]], template: function TerraAddMediaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelement(0, "util-messages");
        ɵɵtemplate(1, TerraAddMediaComponent_ion_card_1_Template, 18, 9, "ion-card", 0);
        ɵɵtemplate(2, TerraAddMediaComponent_ng_container_2_Template, 36, 13, "ng-container", 1);
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.media && ctx.view == "show");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.view == "edit" || ctx.view == "add");
    } }, directives: [MessagesComponent, NgIf, IonCard, IonRow, IonCol, IonCardContent, IonGrid, ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, IonInput, TextValueAccessor, NgControlStatus, FormControlName, IonTextarea, IonButton], pipes: [DateFormatPipe], styles: ["img[_ngcontent-%COMP%]{-o-object-fit:cover!important;object-fit:cover!important}.error-message[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#ea0028;font-size:14px;line-height:16px;margin:0;padding-top:4px;text-transform:lowercase}.error-message[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]:first-letter{text-transform:uppercase}.error-message[_ngcontent-%COMP%]   .alert-danger[_ngcontent-%COMP%]{color:var(--ion-color-danger)}.showMediaLink[_ngcontent-%COMP%]   .videoPlayer[_ngcontent-%COMP%], .showMediaLink[_ngcontent-%COMP%]   img[_ngcontent-%COMP%], .showMediaLink[_ngcontent-%COMP%]   ion-skeleton-text[_ngcontent-%COMP%]{background:#000;border-radius:4px;height:175px;width:100%}.editMediaLink[_ngcontent-%COMP%]   .videoPlayer[_ngcontent-%COMP%], .editMediaLink[_ngcontent-%COMP%]   img[_ngcontent-%COMP%], .editMediaLink[_ngcontent-%COMP%]   ion-skeleton-text[_ngcontent-%COMP%]{background:#000;border-radius:4px;height:175px;opacity:.25;width:100%}.image-size[_ngcontent-%COMP%]{height:140px}.pt20[_ngcontent-%COMP%]{padding-top:20px}ion-card[_ngcontent-%COMP%]{box-shadow:none}ion-card[_ngcontent-%COMP%]   .p20[_ngcontent-%COMP%], ion-card[_ngcontent-%COMP%]   ion-card-header[_ngcontent-%COMP%]{padding:20px!important}ion-card[_ngcontent-%COMP%]   .p-content[_ngcontent-%COMP%]{padding:20px 20px 20px 15px!important}ion-card[_ngcontent-%COMP%]   ion-col[_ngcontent-%COMP%]{padding:0}ion-card[_ngcontent-%COMP%]   ion-card-content[_ngcontent-%COMP%]{font-size:16px;line-height:150%;padding:0}ion-card[_ngcontent-%COMP%]   ion-card-content[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#000}ion-card[_ngcontent-%COMP%]   ion-card-content[_ngcontent-%COMP%]   .shortDescription[_ngcontent-%COMP%]{color:#797979}.tar[_ngcontent-%COMP%]{text-align:right}.editMedia[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]{color:#000;font-size:14px;line-height:16px;padding-bottom:8px}.editMedia[_ngcontent-%COMP%]   ion-input[_ngcontent-%COMP%]{--padding-start:20px;background:#fff;border:1px solid #bababa;border-radius:4px;box-sizing:border-box;color:#000;font-size:16px}.editMedia[_ngcontent-%COMP%]   .set-to-bottom[_ngcontent-%COMP%]{--background:#fff;border:1px solid #3b3b3b;border-radius:4px;bottom:0;box-sizing:border-box;cursor:pointer;left:50%;position:absolute;text-transform:none;transform:translate(-50%,-150%)}.editMedia[_ngcontent-%COMP%]   .default-media[_ngcontent-%COMP%]{height:175px;width:100%}.editMedia[_ngcontent-%COMP%]   .set-to-bottom[_ngcontent-%COMP%]   #file-input[_ngcontent-%COMP%]{height:100%;left:0;opacity:0;position:absolute;top:0;width:100%;z-index:999}.editMedia[_ngcontent-%COMP%]   .set-to-bottom[_ngcontent-%COMP%]   ion-button[_ngcontent-%COMP%]{--background:#fff;--box-shadow:none;border:none;color:#000}.editable[_ngcontent-%COMP%]{background:#fff;border:1px solid #bababa;border-radius:4px;box-sizing:border-box;padding:20px}.editable[_ngcontent-%COMP%]   ion-col[_ngcontent-%COMP%], .editable[_ngcontent-%COMP%]   ion-grid[_ngcontent-%COMP%]{padding:0}.editable[_ngcontent-%COMP%]   .input-box[_ngcontent-%COMP%]{--padding-bottom:12px;--padding-end:16px;--padding-start:16px;--padding-top:12px;background:#fff;border:1px solid #bababa;border-radius:4px;box-sizing:border-box;color:#3b3b3b;font-size:16px;line-height:150%;margin-top:0}.editable[_ngcontent-%COMP%]   .input-box.last-desc[_ngcontent-%COMP%]{margin-bottom:0}.editable[_ngcontent-%COMP%]   .input-box.mt20[_ngcontent-%COMP%]{margin-top:20px}.editable[_ngcontent-%COMP%]   .max-width[_ngcontent-%COMP%]{max-width:204px;padding-left:20px}.editable[_ngcontent-%COMP%]   .max-width[_ngcontent-%COMP%]   ion-button[_ngcontent-%COMP%]{margin-bottom:20px;width:100%}.editable[_ngcontent-%COMP%]   .max-width[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:140px;width:184px}.view-card[_ngcontent-%COMP%]{padding:10px}.view-card[_ngcontent-%COMP%] > ion-col[_ngcontent-%COMP%]{padding:0!important}.view-card[_ngcontent-%COMP%] > ion-col[_ngcontent-%COMP%]:first-child{max-width:184px!important}.view-card[_ngcontent-%COMP%] > ion-col[_ngcontent-%COMP%]   ion-card-content[_ngcontent-%COMP%]{padding:0 0 0 20px!important}.view-card[_ngcontent-%COMP%] > ion-col[_ngcontent-%COMP%]   ion-card-content[_ngcontent-%COMP%] > ion-row[_ngcontent-%COMP%]{padding-bottom:8px!important}.view-card[_ngcontent-%COMP%] > ion-col[_ngcontent-%COMP%]   ion-card-content[_ngcontent-%COMP%] > ion-row[_ngcontent-%COMP%]:last-child{padding-bottom:0!important}@media (max-width:575.98px){.view-card[_ngcontent-%COMP%] > ion-col[_ngcontent-%COMP%]{padding:0 6px!important}.view-card[_ngcontent-%COMP%] > ion-col[_ngcontent-%COMP%]:first-child{max-width:100%!important;padding-top:6px!important}.view-card[_ngcontent-%COMP%] > ion-col[_ngcontent-%COMP%]:last-child{padding-bottom:6px!important}.view-card[_ngcontent-%COMP%] > ion-col[_ngcontent-%COMP%]:last-child   ion-card-content[_ngcontent-%COMP%]{padding:0!important}.view-card[_ngcontent-%COMP%] > ion-col[_ngcontent-%COMP%]:last-child   ion-card-content[_ngcontent-%COMP%] > ion-row[_ngcontent-%COMP%]{padding-bottom:8px!important}.view-card[_ngcontent-%COMP%] > ion-col[_ngcontent-%COMP%]:last-child   ion-card-content[_ngcontent-%COMP%] > ion-row[_ngcontent-%COMP%]:last-child{padding-bottom:0!important}.max-width[_ngcontent-%COMP%]{padding-left:0!important;padding-top:20px!important}.max-width[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:140px!important;width:100%!important}ion-card[_ngcontent-%COMP%]{margin:0}ion-input[_ngcontent-%COMP%]{margin-top:8px}.mb-20[_ngcontent-%COMP%], ion-input[_ngcontent-%COMP%]{margin-bottom:20px}}@media (max-width:767.98px){.max-width[_ngcontent-%COMP%]{padding-left:0!important;padding-top:20px!important}.max-width[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:140px!important}.center-image[_ngcontent-%COMP%]{text-align:center}}.cursor[_ngcontent-%COMP%]{cursor:pointer}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TerraAddMediaComponent, [{
        type: Component,
        args: [{
                selector: 'app-terra-add-media',
                templateUrl: './terra-add-media.component.html',
                styleUrls: ['./terra-add-media.component.scss'],
            }]
    }], function () { return [{ type: FormBuilder }, { type: MessagesService }, { type: DomSanitizer }, { type: AddMediaService }]; }, { fileInput: [{
            type: ViewChild,
            args: ['fileInp']
        }], media: [{
            type: Input
        }], folderName: [{
            type: Input
        }], view: [{
            type: Input
        }], mediaType: [{
            type: Input
        }], addMediaFn: [{
            type: Output
        }], updateMediaFn: [{
            type: Output
        }], deleteMediaFn: [{
            type: Output
        }], newObjRefresh: [{
            type: Output
        }] }); })();

const _c0$6 = ["Tinterests"];
const _c1$2 = ["Tskills"];
const _c2$2 = ["Tcompanies"];
function PeopleNoteFormComponent_ion_col_4_a_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "a", 31);
    ɵɵtext(1, " / Note");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵɵnextContext(2);
    ɵɵpropertyInterpolate1("href", "/#/people/", ctx_r9.studentID, "/note", ɵɵsanitizeUrl);
} }
function PeopleNoteFormComponent_ion_col_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-col", 27);
    ɵɵelementStart(1, "div");
    ɵɵelementStart(2, "a", 28);
    ɵɵtext(3, "Back to list");
    ɵɵelementEnd();
    ɵɵtemplate(4, PeopleNoteFormComponent_ion_col_4_a_4_Template, 2, 1, "a", 29);
    ɵɵelementEnd();
    ɵɵelementStart(5, "div");
    ɵɵelementStart(6, "ion-button", 30);
    ɵɵelementStart(7, "span");
    ɵɵtext(8, "Submit note");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(4);
    ɵɵproperty("ngIf", ctx_r0.studentID);
} }
function PeopleNoteFormComponent_ion_row_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-row", 32);
    ɵɵelementStart(1, "ion-button", 30);
    ɵɵelementStart(2, "span");
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵtextInterpolate1("", ctx_r1.observationId ? "Update" : "Submit", " note");
} }
function PeopleNoteFormComponent_div_6_ion_row_1_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "a", 42);
} if (rf & 2) {
    const item_r16 = ctx.$implicit;
    ɵɵproperty("innerHTML", item_r16.name, ɵɵsanitizeHtml);
} }
function PeopleNoteFormComponent_div_6_ion_row_1_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 42);
} if (rf & 2) {
    const notFound_r17 = ctx.$implicit;
    ɵɵproperty("innerHTML", notFound_r17, ɵɵsanitizeHtml);
} }
function PeopleNoteFormComponent_div_6_ion_row_1_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-row", 34);
    ɵɵelementStart(1, "ion-col", 35);
    ɵɵelement(2, "img", 36);
    ɵɵelementEnd();
    ɵɵelementStart(3, "ion-col", 37);
    ɵɵtext(4, " Student observation form ");
    ɵɵelementEnd();
    ɵɵelementStart(5, "ion-col", 38);
    ɵɵelementStart(6, "ng-autocomplete", 39);
    ɵɵlistener("inputChanged", function PeopleNoteFormComponent_div_6_ion_row_1_Template_ng_autocomplete_inputChanged_6_listener($event) { ɵɵrestoreView(_r19); const ctx_r18 = ɵɵnextContext(2); return ctx_r18.onChangeSearch($event); })("inputCleared", function PeopleNoteFormComponent_div_6_ion_row_1_Template_ng_autocomplete_inputCleared_6_listener() { ɵɵrestoreView(_r19); const ctx_r20 = ɵɵnextContext(2); return ctx_r20.inputCleared(); })("selected", function PeopleNoteFormComponent_div_6_ion_row_1_Template_ng_autocomplete_selected_6_listener($event) { ɵɵrestoreView(_r19); const ctx_r21 = ɵɵnextContext(2); return ctx_r21.selectedProfile($event); });
    ɵɵpipe(7, "async");
    ɵɵelementEnd();
    ɵɵtemplate(8, PeopleNoteFormComponent_div_6_ion_row_1_ng_template_8_Template, 1, 1, "ng-template", null, 40, ɵɵtemplateRefExtractor);
    ɵɵtemplate(10, PeopleNoteFormComponent_div_6_ion_row_1_ng_template_10_Template, 1, 1, "ng-template", null, 41, ɵɵtemplateRefExtractor);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const _r12 = ɵɵreference(9);
    const _r14 = ɵɵreference(11);
    const ctx_r10 = ɵɵnextContext(2);
    ɵɵadvance(6);
    ɵɵproperty("data", ɵɵpipeBind1(7, 3, ctx_r10.peopleNoteService.userList$))("itemTemplate", _r12)("notFoundTemplate", _r14);
} }
function PeopleNoteFormComponent_div_6_ion_row_2_img_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 47);
} if (rf & 2) {
    const noteBox_r22 = ɵɵnextContext().ngIf;
    ɵɵproperty("src", noteBox_r22.multimedia, ɵɵsanitizeUrl);
} }
function PeopleNoteFormComponent_div_6_ion_row_2_img_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 36);
} }
function PeopleNoteFormComponent_div_6_ion_row_2_ion_col_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-col", 48);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const checkValueR_r27 = ctx.ngIf;
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", checkValueR_r27, " ");
} }
function PeopleNoteFormComponent_div_6_ion_row_2_Template(rf, ctx) { if (rf & 1) {
    const _r29 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-row", 34);
    ɵɵelementStart(1, "ion-col", 35);
    ɵɵtemplate(2, PeopleNoteFormComponent_div_6_ion_row_2_img_2_Template, 1, 1, "img", 43);
    ɵɵtemplate(3, PeopleNoteFormComponent_div_6_ion_row_2_img_3_Template, 1, 0, "img", 44);
    ɵɵelementEnd();
    ɵɵelementStart(4, "ion-col", 37);
    ɵɵtext(5);
    ɵɵelementEnd();
    ɵɵtemplate(6, PeopleNoteFormComponent_div_6_ion_row_2_ion_col_6_Template, 2, 1, "ion-col", 45);
    ɵɵelementStart(7, "ion-col", 46);
    ɵɵlistener("click", function PeopleNoteFormComponent_div_6_ion_row_2_Template_ion_col_click_7_listener() { ɵɵrestoreView(_r29); const ctx_r28 = ɵɵnextContext(2); return ctx_r28.editProfile == null ? null : ctx_r28.editProfile.controls["profile"] == null ? null : ctx_r28.editProfile.controls["profile"].setValue(false); });
    ɵɵtext(8, " Change ");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const noteBox_r22 = ctx.ngIf;
    const ctx_r11 = ɵɵnextContext(2);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", noteBox_r22.multimedia);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !noteBox_r22.multimedia);
    ɵɵadvance(2);
    ɵɵtextInterpolate2(" ", noteBox_r22.firstName, " ", noteBox_r22.lastName, " ");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r11.checkValue(noteBox_r22));
} }
function PeopleNoteFormComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtemplate(1, PeopleNoteFormComponent_div_6_ion_row_1_Template, 12, 5, "ion-row", 33);
    ɵɵtemplate(2, PeopleNoteFormComponent_div_6_ion_row_2_Template, 9, 5, "ion-row", 33);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r2.editProfile.value.profile);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r2.editProfile.value.profile);
} }
function PeopleNoteFormComponent_div_12_p_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "p", 49);
    ɵɵtext(1, " Add a new note cannot exceed 200 characters. ");
    ɵɵelementEnd();
} }
function PeopleNoteFormComponent_div_12_p_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "p", 49);
    ɵɵtext(1, " Add a new note is required ");
    ɵɵelementEnd();
} }
function PeopleNoteFormComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 15);
    ɵɵtemplate(1, PeopleNoteFormComponent_div_12_p_1_Template, 2, 0, "p", 16);
    ɵɵtemplate(2, PeopleNoteFormComponent_div_12_p_2_Template, 2, 0, "p", 16);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r3.editProfile.controls["newNote"].hasError("maxlength"));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r3.editProfile.controls["newNote"].hasError("required"));
} }
function PeopleNoteFormComponent_p_19_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "p", 49);
    ɵɵtext(1, " Type of note is required ");
    ɵɵelementEnd();
} }
function PeopleNoteFormComponent_p_25_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "p", 49);
    ɵɵtext(1, " Channel is required ");
    ɵɵelementEnd();
} }
function PeopleNoteFormComponent_p_31_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "p", 49);
    ɵɵtext(1, " Interaction date is required ");
    ɵɵelementEnd();
} }
function PeopleNoteFormComponent_p_32_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "p", 49);
    ɵɵtext(1, " future dates are not valid ");
    ɵɵelementEnd();
} }
function PeopleNoteFormComponent_ion_row_52_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 54);
    ɵɵtext(1, " Location ");
    ɵɵelementEnd();
} }
function PeopleNoteFormComponent_ion_row_52_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 54);
    ɵɵtext(1, " Climate interests ");
    ɵɵelementEnd();
} }
function PeopleNoteFormComponent_ion_row_52_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 54);
    ɵɵtext(1, " Expertise ");
    ɵɵelementEnd();
} }
function PeopleNoteFormComponent_ion_row_52_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 54);
    ɵɵtext(1, " Work history ");
    ɵɵelementEnd();
} }
function PeopleNoteFormComponent_ion_row_52_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 54);
    ɵɵtext(1, " Media ");
    ɵɵelementEnd();
} }
function PeopleNoteFormComponent_ion_row_52_ng_container_9_p_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "p", 49);
    ɵɵtext(1, " Location Notes maximum length is less than 200 character ");
    ɵɵelementEnd();
} }
function PeopleNoteFormComponent_ion_row_52_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    const _r44 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "ion-col", 55);
    ɵɵtext(2, "Update location / add location-related notes ");
    ɵɵelementEnd();
    ɵɵelementStart(3, "ion-col", 56);
    ɵɵelementStart(4, "terra-google-places", 57);
    ɵɵlistener("setAddress", function PeopleNoteFormComponent_ion_row_52_ng_container_9_Template_terra_google_places_setAddress_4_listener($event) { ɵɵrestoreView(_r44); const ctx_r43 = ɵɵnextContext(2); return ctx_r43.getAddress($event); })("ngModelValue", function PeopleNoteFormComponent_ion_row_52_ng_container_9_Template_terra_google_places_ngModelValue_4_listener($event) { ɵɵrestoreView(_r44); const ctx_r45 = ɵɵnextContext(2); return ctx_r45.getAddress($event); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(5, "ion-col", 8);
    ɵɵelement(6, "ion-input", 58);
    ɵɵelementStart(7, "div", 15);
    ɵɵtemplate(8, PeopleNoteFormComponent_ion_row_52_ng_container_9_p_8_Template, 2, 0, "p", 16);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r37 = ɵɵnextContext(2);
    ɵɵadvance(4);
    ɵɵproperty("autocompleteInput", ctx_r37.cityName.address);
    ɵɵadvance(4);
    ɵɵproperty("ngIf", ctx_r37.editProfile == null ? null : ctx_r37.editProfile.controls["locationNotes"] == null ? null : ctx_r37.editProfile.controls["locationNotes"].hasError("maxlength"));
} }
function PeopleNoteFormComponent_ion_row_52_ng_container_10_ng_container_10_ion_col_1_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r53 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 71);
    ɵɵlistener("click", function PeopleNoteFormComponent_ion_row_52_ng_container_10_ng_container_10_ion_col_1_div_7_Template_div_click_0_listener() { ɵɵrestoreView(_r53); const selection_r51 = ctx.$implicit; ɵɵnextContext(3); const _r46 = ɵɵreference(9); const ctx_r52 = ɵɵnextContext(2); ctx_r52.checkBoxClicked("Interest", selection_r51.id, "interests"); return _r46.ngOnInit(); });
    ɵɵelement(1, "ion-icon", 72);
    ɵɵtext(2);
    ɵɵelementEnd();
} if (rf & 2) {
    const selection_r51 = ctx.$implicit;
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", selection_r51.name, " ");
} }
function PeopleNoteFormComponent_ion_row_52_ng_container_10_ng_container_10_ion_col_1_Template(rf, ctx) { if (rf & 1) {
    const _r55 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-col", 65);
    ɵɵelementStart(1, "div", 66);
    ɵɵelementStart(2, "div", 67);
    ɵɵtext(3, "My selection");
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", 68);
    ɵɵlistener("click", function PeopleNoteFormComponent_ion_row_52_ng_container_10_ng_container_10_ion_col_1_Template_div_click_4_listener() { ɵɵrestoreView(_r55); ɵɵnextContext(2); const _r46 = ɵɵreference(9); const ctx_r54 = ɵɵnextContext(2); ctx_r54.clearSelection("Interest", "interests"); return _r46.ngOnInit(); });
    ɵɵtext(5, " Deselect all ");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(6, "div", 69);
    ɵɵtemplate(7, PeopleNoteFormComponent_ion_row_52_ng_container_10_ng_container_10_ion_col_1_div_7_Template, 3, 1, "div", 70);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const topicinterests_r48 = ɵɵnextContext().ngIf;
    ɵɵadvance(7);
    ɵɵproperty("ngForOf", topicinterests_r48);
} }
function PeopleNoteFormComponent_ion_row_52_ng_container_10_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, PeopleNoteFormComponent_ion_row_52_ng_container_10_ng_container_10_ion_col_1_Template, 8, 1, "ion-col", 64);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const topicinterests_r48 = ctx.ngIf;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", topicinterests_r48.length > 0);
} }
function PeopleNoteFormComponent_ion_row_52_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "ion-col", 59);
    ɵɵelementStart(2, "ion-grid");
    ɵɵelementStart(3, "ion-row");
    ɵɵelementStart(4, "ion-col", 60);
    ɵɵelementStart(5, "ion-label", 61);
    ɵɵtext(6, "Add new climate interests");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(7, "ion-col", 8);
    ɵɵelement(8, "terra-selection-people", 62, 63);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(10, PeopleNoteFormComponent_ion_row_52_ng_container_10_ng_container_10_Template, 2, 1, "ng-container", 5);
    ɵɵpipe(11, "async");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r38 = ɵɵnextContext(2);
    ɵɵadvance(8);
    ɵɵproperty("inline", true)("isAll", true);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ɵɵpipeBind1(11, 3, ctx_r38.topicinterests$));
} }
function PeopleNoteFormComponent_ion_row_52_ng_container_11_ng_container_10_ion_col_1_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r64 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 71);
    ɵɵlistener("click", function PeopleNoteFormComponent_ion_row_52_ng_container_11_ng_container_10_ion_col_1_div_7_Template_div_click_0_listener() { ɵɵrestoreView(_r64); const selection_r62 = ctx.$implicit; ɵɵnextContext(3); const _r57 = ɵɵreference(9); const ctx_r63 = ɵɵnextContext(2); ctx_r63.checkBoxClicked("Topic", selection_r62.id, "skills"); return _r57.ngOnInit(); });
    ɵɵelement(1, "ion-icon", 72);
    ɵɵtext(2);
    ɵɵelementEnd();
} if (rf & 2) {
    const selection_r62 = ctx.$implicit;
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", selection_r62.name, " ");
} }
function PeopleNoteFormComponent_ion_row_52_ng_container_11_ng_container_10_ion_col_1_Template(rf, ctx) { if (rf & 1) {
    const _r66 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-col", 65);
    ɵɵelementStart(1, "div", 66);
    ɵɵelementStart(2, "div", 67);
    ɵɵtext(3, "My selection");
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", 68);
    ɵɵlistener("click", function PeopleNoteFormComponent_ion_row_52_ng_container_11_ng_container_10_ion_col_1_Template_div_click_4_listener() { ɵɵrestoreView(_r66); ɵɵnextContext(2); const _r57 = ɵɵreference(9); const ctx_r65 = ɵɵnextContext(2); ctx_r65.clearSelection("Topic", "skills"); return _r57.ngOnInit(); });
    ɵɵtext(5, " Deselect all ");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(6, "div", 69);
    ɵɵtemplate(7, PeopleNoteFormComponent_ion_row_52_ng_container_11_ng_container_10_ion_col_1_div_7_Template, 3, 1, "div", 70);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const topicskills_r59 = ɵɵnextContext().ngIf;
    ɵɵadvance(7);
    ɵɵproperty("ngForOf", topicskills_r59);
} }
function PeopleNoteFormComponent_ion_row_52_ng_container_11_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, PeopleNoteFormComponent_ion_row_52_ng_container_11_ng_container_10_ion_col_1_Template, 8, 1, "ion-col", 64);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const topicskills_r59 = ctx.ngIf;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", topicskills_r59.length > 0);
} }
function PeopleNoteFormComponent_ion_row_52_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "ion-col", 59);
    ɵɵelementStart(2, "ion-grid");
    ɵɵelementStart(3, "ion-row");
    ɵɵelementStart(4, "ion-col", 60);
    ɵɵelementStart(5, "ion-label", 61);
    ɵɵtext(6, "Add new expertise");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(7, "ion-col", 8);
    ɵɵelement(8, "terra-selection-people", 73, 74);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(10, PeopleNoteFormComponent_ion_row_52_ng_container_11_ng_container_10_Template, 2, 1, "ng-container", 5);
    ɵɵpipe(11, "async");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r39 = ɵɵnextContext(2);
    ɵɵadvance(8);
    ɵɵproperty("inline", true)("isAll", true);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ɵɵpipeBind1(11, 3, ctx_r39.topicskills$));
} }
function PeopleNoteFormComponent_ion_row_52_ng_container_12_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵtext(1, "Upload resume PDF");
    ɵɵelementEnd();
} }
function PeopleNoteFormComponent_ion_row_52_ng_container_12_span_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵtext(1, "Update");
    ɵɵelementEnd();
} }
function PeopleNoteFormComponent_ion_row_52_ng_container_12_ion_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r77 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-button", 88);
    ɵɵlistener("click", function PeopleNoteFormComponent_ion_row_52_ng_container_12_ion_button_11_Template_ion_button_click_0_listener() { ɵɵrestoreView(_r77); const ctx_r76 = ɵɵnextContext(3); return ctx_r76.deleteResume(); });
    ɵɵelementStart(1, "span");
    ɵɵtext(2, "Delete");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function PeopleNoteFormComponent_ion_row_52_ng_container_12_p_26_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "p", 49);
    ɵɵtext(1, " Years of experience between 0 to 100 years ");
    ɵɵelementEnd();
} }
function PeopleNoteFormComponent_ion_row_52_ng_container_12_p_27_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "p", 49);
    ɵɵtext(1, " Months of experience between 0 to 11 months ");
    ɵɵelementEnd();
} }
function PeopleNoteFormComponent_ion_row_52_ng_container_12_ng_container_37_ion_col_1_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r83 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 71);
    ɵɵlistener("click", function PeopleNoteFormComponent_ion_row_52_ng_container_12_ng_container_37_ion_col_1_div_7_Template_div_click_0_listener() { ɵɵrestoreView(_r83); const selection_r81 = ctx.$implicit; ɵɵnextContext(3); const _r74 = ɵɵreference(36); const ctx_r82 = ɵɵnextContext(2); ctx_r82.checkBoxClicked("ProfileCompanies", selection_r81.id, "Companies"); return _r74.ngOnInit(); });
    ɵɵelement(1, "ion-icon", 72);
    ɵɵtext(2);
    ɵɵelementEnd();
} if (rf & 2) {
    const selection_r81 = ctx.$implicit;
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", selection_r81.name, " ");
} }
function PeopleNoteFormComponent_ion_row_52_ng_container_12_ng_container_37_ion_col_1_Template(rf, ctx) { if (rf & 1) {
    const _r85 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-col", 90);
    ɵɵelementStart(1, "div", 66);
    ɵɵelementStart(2, "div", 67);
    ɵɵtext(3, "Selected");
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", 68);
    ɵɵlistener("click", function PeopleNoteFormComponent_ion_row_52_ng_container_12_ng_container_37_ion_col_1_Template_div_click_4_listener() { ɵɵrestoreView(_r85); ɵɵnextContext(2); const _r74 = ɵɵreference(36); const ctx_r84 = ɵɵnextContext(2); ctx_r84.clearSelection("ProfileCompanies", "Companies"); return _r74.ngOnInit(); });
    ɵɵtext(5, " Deselect all ");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(6, "div", 69);
    ɵɵtemplate(7, PeopleNoteFormComponent_ion_row_52_ng_container_12_ng_container_37_ion_col_1_div_7_Template, 3, 1, "div", 70);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const topicscompanies_r78 = ɵɵnextContext().ngIf;
    ɵɵadvance(7);
    ɵɵproperty("ngForOf", topicscompanies_r78);
} }
function PeopleNoteFormComponent_ion_row_52_ng_container_12_ng_container_37_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, PeopleNoteFormComponent_ion_row_52_ng_container_12_ng_container_37_ion_col_1_Template, 8, 1, "ion-col", 89);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const topicscompanies_r78 = ctx.ngIf;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", topicscompanies_r78.length > 0);
} }
function PeopleNoteFormComponent_ion_row_52_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    const _r88 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "ion-col", 75);
    ɵɵelementStart(2, "div");
    ɵɵelementStart(3, "div", 61);
    ɵɵelementStart(4, "ion-label");
    ɵɵtext(5, "Update resume");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(6, "input", 76, 77);
    ɵɵlistener("change", function PeopleNoteFormComponent_ion_row_52_ng_container_12_Template_input_change_6_listener($event) { ɵɵrestoreView(_r88); const ctx_r87 = ɵɵnextContext(2); return ctx_r87.handleFileInput($event, ctx_r87.editProfile == null ? null : ctx_r87.editProfile.value, "resume"); });
    ɵɵelementEnd();
    ɵɵelementStart(8, "ion-button", 78);
    ɵɵlistener("click", function PeopleNoteFormComponent_ion_row_52_ng_container_12_Template_ion_button_click_8_listener() { ɵɵrestoreView(_r88); const _r68 = ɵɵreference(7); return _r68.click(); });
    ɵɵtemplate(9, PeopleNoteFormComponent_ion_row_52_ng_container_12_span_9_Template, 2, 0, "span", 5);
    ɵɵtemplate(10, PeopleNoteFormComponent_ion_row_52_ng_container_12_span_10_Template, 2, 0, "span", 5);
    ɵɵelementEnd();
    ɵɵtemplate(11, PeopleNoteFormComponent_ion_row_52_ng_container_12_ion_button_11_Template, 3, 0, "ion-button", 79);
    ɵɵelementEnd();
    ɵɵelementStart(12, "div");
    ɵɵelementStart(13, "div", 80);
    ɵɵelementStart(14, "ion-label");
    ɵɵtext(15, "Update work experience");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(16, "div", 81);
    ɵɵelementStart(17, "span");
    ɵɵelement(18, "ion-input", 82);
    ɵɵelementEnd();
    ɵɵelementStart(19, "span", 83);
    ɵɵtext(20, "years");
    ɵɵelementEnd();
    ɵɵelementStart(21, "span");
    ɵɵelement(22, "ion-input", 84);
    ɵɵelementEnd();
    ɵɵelementStart(23, "span", 83);
    ɵɵtext(24, "months");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(25, "div", 15);
    ɵɵtemplate(26, PeopleNoteFormComponent_ion_row_52_ng_container_12_p_26_Template, 2, 0, "p", 16);
    ɵɵtemplate(27, PeopleNoteFormComponent_ion_row_52_ng_container_12_p_27_Template, 2, 0, "p", 16);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(28, "ion-col", 85);
    ɵɵelementStart(29, "ion-grid");
    ɵɵelementStart(30, "ion-row");
    ɵɵelementStart(31, "ion-col", 60);
    ɵɵelementStart(32, "ion-label", 61);
    ɵɵtext(33, "Add new organisations");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(34, "ion-col", 8);
    ɵɵelement(35, "terra-selection-people", 86, 87);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(37, PeopleNoteFormComponent_ion_row_52_ng_container_12_ng_container_37_Template, 2, 1, "ng-container", 5);
    ɵɵpipe(38, "async");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r40 = ɵɵnextContext(2);
    ɵɵadvance(9);
    ɵɵproperty("ngIf", !(ctx_r40.editProfile == null ? null : ctx_r40.editProfile.value == null ? null : ctx_r40.editProfile.value.resume));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r40.editProfile == null ? null : ctx_r40.editProfile.value == null ? null : ctx_r40.editProfile.value.resume);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r40.editProfile == null ? null : ctx_r40.editProfile.value == null ? null : ctx_r40.editProfile.value.resume);
    ɵɵadvance(15);
    ɵɵproperty("ngIf", (ctx_r40.editProfile == null ? null : ctx_r40.editProfile.controls["yearEx"] == null ? null : ctx_r40.editProfile.controls["yearEx"].hasError("min")) || (ctx_r40.editProfile == null ? null : ctx_r40.editProfile.controls["yearEx"] == null ? null : ctx_r40.editProfile.controls["yearEx"].hasError("max")));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (ctx_r40.editProfile == null ? null : ctx_r40.editProfile.controls["monthEx"] == null ? null : ctx_r40.editProfile.controls["monthEx"].hasError("min")) || (ctx_r40.editProfile == null ? null : ctx_r40.editProfile.controls["monthEx"] == null ? null : ctx_r40.editProfile.controls["monthEx"].hasError("max")));
    ɵɵadvance(8);
    ɵɵproperty("inline", true)("isAll", true);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ɵɵpipeBind1(38, 8, ctx_r40.topicscompanies$));
} }
function PeopleNoteFormComponent_ion_row_52_ng_container_13_ion_col_9_Template(rf, ctx) { if (rf & 1) {
    const _r95 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-col", 95);
    ɵɵelementStart(1, "app-terra-add-media", 97);
    ɵɵlistener("addMediaFn", function PeopleNoteFormComponent_ion_row_52_ng_container_13_ion_col_9_Template_app_terra_add_media_addMediaFn_1_listener($event) { ɵɵrestoreView(_r95); const i_r93 = ctx.index; const ctx_r94 = ɵɵnextContext(3); return ctx_r94.addMediaFn($event, i_r93); })("updateMediaFn", function PeopleNoteFormComponent_ion_row_52_ng_container_13_ion_col_9_Template_app_terra_add_media_updateMediaFn_1_listener($event) { ɵɵrestoreView(_r95); const i_r93 = ctx.index; const ctx_r96 = ɵɵnextContext(3); return ctx_r96.updateMediaFn($event, i_r93); })("deleteMediaFn", function PeopleNoteFormComponent_ion_row_52_ng_container_13_ion_col_9_Template_app_terra_add_media_deleteMediaFn_1_listener() { ɵɵrestoreView(_r95); const i_r93 = ctx.index; const m_r92 = ctx.$implicit; const ctx_r97 = ɵɵnextContext(3); return ctx_r97.deleteMediaFn(i_r93, m_r92.id); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const m_r92 = ctx.$implicit;
    const ctx_r90 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("mediaType", ctx_r90.mediaType)("media", m_r92);
} }
function PeopleNoteFormComponent_ion_row_52_ng_container_13_ion_col_10_Template(rf, ctx) { if (rf & 1) {
    const _r99 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-col", 95);
    ɵɵelementStart(1, "app-terra-add-media", 98);
    ɵɵlistener("addMediaFn", function PeopleNoteFormComponent_ion_row_52_ng_container_13_ion_col_10_Template_app_terra_add_media_addMediaFn_1_listener($event) { ɵɵrestoreView(_r99); const ctx_r98 = ɵɵnextContext(3); return ctx_r98.addMediaFn($event, ctx_r98.medias.length + 1); })("updateMediaFn", function PeopleNoteFormComponent_ion_row_52_ng_container_13_ion_col_10_Template_app_terra_add_media_updateMediaFn_1_listener($event) { ɵɵrestoreView(_r99); const ctx_r100 = ɵɵnextContext(3); return ctx_r100.updateMediaFn($event, ctx_r100.medias.length + 1); })("newObjRefresh", function PeopleNoteFormComponent_ion_row_52_ng_container_13_ion_col_10_Template_app_terra_add_media_newObjRefresh_1_listener() { ɵɵrestoreView(_r99); const ctx_r101 = ɵɵnextContext(3); return ctx_r101.newObjRefresh(); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r91 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("mediaType", ctx_r91.mediaType)("media", ctx_r91.newM);
} }
function PeopleNoteFormComponent_ion_row_52_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    const _r103 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "ion-col", 91);
    ɵɵelementStart(2, "ion-grid");
    ɵɵelementStart(3, "ion-row");
    ɵɵelementStart(4, "ion-col", 8);
    ɵɵelementStart(5, "div", 61);
    ɵɵtext(6, "Share media");
    ɵɵelementEnd();
    ɵɵelementStart(7, "div", 92);
    ɵɵtext(8, " Eg. any talks, articles, research publications, or documents ");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(9, PeopleNoteFormComponent_ion_row_52_ng_container_13_ion_col_9_Template, 2, 2, "ion-col", 93);
    ɵɵtemplate(10, PeopleNoteFormComponent_ion_row_52_ng_container_13_ion_col_10_Template, 2, 2, "ion-col", 94);
    ɵɵelementStart(11, "ion-col", 95);
    ɵɵelementStart(12, "ion-button", 96);
    ɵɵlistener("click", function PeopleNoteFormComponent_ion_row_52_ng_container_13_Template_ion_button_click_12_listener() { ɵɵrestoreView(_r103); const ctx_r102 = ɵɵnextContext(2); return ctx_r102.addMediaLinkOrFile("file"); });
    ɵɵtext(13, " + \u00A0 ");
    ɵɵelementStart(14, "span");
    ɵɵtext(15, "Add another media");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r41 = ɵɵnextContext(2);
    ɵɵadvance(9);
    ɵɵproperty("ngForOf", ctx_r41.medias);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r41.addMedia);
} }
function PeopleNoteFormComponent_ion_row_52_Template(rf, ctx) { if (rf & 1) {
    const _r105 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-row", 50);
    ɵɵelementStart(1, "ion-col", 51);
    ɵɵtemplate(2, PeopleNoteFormComponent_ion_row_52_div_2_Template, 2, 0, "div", 52);
    ɵɵtemplate(3, PeopleNoteFormComponent_ion_row_52_div_3_Template, 2, 0, "div", 52);
    ɵɵtemplate(4, PeopleNoteFormComponent_ion_row_52_div_4_Template, 2, 0, "div", 52);
    ɵɵtemplate(5, PeopleNoteFormComponent_ion_row_52_div_5_Template, 2, 0, "div", 52);
    ɵɵtemplate(6, PeopleNoteFormComponent_ion_row_52_div_6_Template, 2, 0, "div", 52);
    ɵɵelementStart(7, "div");
    ɵɵelementStart(8, "ion-icon", 53);
    ɵɵlistener("click", function PeopleNoteFormComponent_ion_row_52_Template_ion_icon_click_8_listener() { ɵɵrestoreView(_r105); const ctx_r104 = ɵɵnextContext(); return ctx_r104.activeFormName = ""; });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(9, PeopleNoteFormComponent_ion_row_52_ng_container_9_Template, 9, 2, "ng-container", 5);
    ɵɵtemplate(10, PeopleNoteFormComponent_ion_row_52_ng_container_10_Template, 12, 5, "ng-container", 5);
    ɵɵtemplate(11, PeopleNoteFormComponent_ion_row_52_ng_container_11_Template, 12, 5, "ng-container", 5);
    ɵɵtemplate(12, PeopleNoteFormComponent_ion_row_52_ng_container_12_Template, 39, 10, "ng-container", 5);
    ɵɵtemplate(13, PeopleNoteFormComponent_ion_row_52_ng_container_13_Template, 16, 2, "ng-container", 5);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r8.activeFormName == "location");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r8.activeFormName == "interests");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r8.activeFormName == "expertise");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r8.activeFormName == "history");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r8.activeFormName == "media");
    ɵɵadvance(3);
    ɵɵproperty("ngIf", ctx_r8.activeFormName == "location");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r8.activeFormName == "interests");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r8.activeFormName == "expertise");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r8.activeFormName == "history");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r8.activeFormName == "media");
} }
const _c3$1 = function (a0) { return { "padding-top": a0 }; };
const _c4$1 = function () { return { standalone: true }; };
const _c5$1 = function () { return ["calendar"]; };
class PeopleNoteFormComponent {
    constructor(menuController, formBuilder, peopleNoteService, store, activatedRoute, authStore, messages, router, modalController, navParams) {
        this.menuController = menuController;
        this.formBuilder = formBuilder;
        this.peopleNoteService = peopleNoteService;
        this.store = store;
        this.activatedRoute = activatedRoute;
        this.authStore = authStore;
        this.messages = messages;
        this.router = router;
        this.modalController = modalController;
        this.navParams = navParams;
        this.noteValue = this.navParams.get('noteData');
        this.menuId = 'student-observation-form';
        this.newM = {};
        this.userList = [
            {
                id: 0,
                name: 'Nathan Flanagan-Tordjman',
            },
            {
                id: 1,
                name: 'Nathan Kiner',
            },
        ];
        this.editorConfig = {
            enterMode: 3,
            shiftEnterMode: 2,
            extraPlugins: 'emoji',
            toolbar: [
                {
                    name: 'basicstyles',
                    items: [
                        'Bold',
                        'Italic',
                        'Underline',
                        'BulletedList',
                        'Link',
                        'EmojiPanel',
                    ],
                },
            ],
            removeButtons: 'Subscript,Superscript',
            contentsCss: '/assets/ckedtor.css',
            fontFamily: {
                options: ['Lato, sans-serif'],
            },
        };
        this.typesOfNote = [
            'Feedback for Terra',
            'New job',
            'Hiring alert',
            'Interests',
            'Mentorship feedback',
            'Other',
        ].map(val => {
            return {
                id: val,
                name: val,
            };
        });
        this.channels = ['Email', 'Slack', 'Zoom call', 'Linkedin', 'Other'].map(val => {
            return {
                id: val,
                name: val,
            };
        });
        this.medias = null;
        this.profileId = 0;
        this.activeFormName = '';
        this.cityName = {};
        this.mediaType = 'image';
        this.addMedia = false;
        this.from = '';
        this.activeNote = null;
        this.activeChannel = null;
        this.observationId = false;
        // studentID: any = false;
        this.profileError = 'Please select one Profile';
        this.maxDate = format(new Date(), 'yyyy-MM-dd');
        this.store.dispatch(loadDefaultTags());
        this.editProfile = this.formBuilder.group({
            id: [''],
            newNote: ['', [Validators.required]],
            typeOfNote: ['', Validators.required],
            channel: ['', Validators.required],
            interactionDate: format(new Date(), 'yyyy-MM-dd'),
            locationNotes: ['', Validators.maxLength(200)],
            profile: '',
            resume: [''],
            yearEx: ['', [Validators.min(0), Validators.max(100)]],
            monthEx: ['', [Validators.min(0), Validators.max(11)]],
        });
        this.store.dispatch(loadSearchFilter());
        // this.studentID = this.activatedRoute.snapshot.paramMap.get('id');
        this.store
            .select(selectSearchHasFilters)
            .pipe(filter((it) => !!it), first())
            .subscribe(ev => {
            this.store.dispatch(loadCompanies());
        });
    }
    inputCleared() {
        this.peopleNoteService.getUserList('');
    }
    onChangeSearch(ev) {
        this.peopleNoteService.getUserList(ev);
    }
    addMediaFn(ev, i) {
        this.from = 'media';
        // this.addMedia=false
        if (!ev.mediaUrl) {
            this.messages.showErrors('please enter media url');
            return;
        }
        else {
            if (!this.isValidURL(ev.mediaUrl)) {
                this.messages.showErrors('please enter valid url');
                return;
            }
        }
        this.medias[i - 1] = ev;
        // this.medias.push(ev)
        if (this.editProfile.value.profile.id) {
            if (this.addMedia === true) {
                this.addMedia = false;
            }
            // this.formSubmit(this.editProfile);
        }
        else {
            this.messages.showErrors(this.profileError);
        }
    }
    updateMediaFn(ev, i) {
        this.from = 'media';
        this.medias[i] = ev;
        if (this.editProfile.value.profile.id) {
            // this.formSubmit(this.editProfile);
        }
        else {
            this.messages.showErrors(this.profileError);
        }
    }
    newObjRefresh() {
        if (this.newObjRefresh.length === 2) {
            this.addMedia = false;
            this.addMedia = true;
        }
        else {
            this.addMedia = false;
        }
    }
    deleteMediaFn(i, uId = false) {
        this.medias.splice(i, 1);
        if (i === this.medias.length + 1) {
            this.addMedia = false;
        }
        else {
            if (this.editProfile.value.profile.id) {
                this.peopleNoteService.removeObservationMedia(uId);
            }
            else {
                this.messages.showErrors(this.profileError);
            }
        }
    }
    recheck() {
        // this.studentID = this.activatedRoute.snapshot.paramMap.get('id');
        // this.studentID = this.studentID;
        if (this.studentID) {
            this.peopleNoteService.userList$
                .pipe(filter(obj => obj.length > 0), map(obj => obj.filter(ud => ud.id === Number(this.studentID))), filter(obj => obj.length > 0), first())
                .subscribe(profileData => {
                var _a, _b, _c;
                this.editProfile.controls.profile.setValue(profileData[0]);
                if (this.observationId) {
                    this.store
                        .pipe(select(selectProfileObservations))
                        .pipe(filter(obj => obj.length > 0), map(obj => obj.filter(ud => ud.id === Number(this.observationId))), filter(obj => obj.length > 0), first())
                        .subscribe(dataArr => {
                        var _a, _b, _c;
                        const data = dataArr[0];
                        this.editProfile.controls.id.setValue(data.id);
                        this.editProfile.controls.newNote.setValue(data.details);
                        this.editProfile.controls.typeOfNote.setValue({
                            id: data.observationType,
                            name: data.observationType,
                        });
                        this.activeNote = data.observationType;
                        this.editProfile.controls.channel.setValue({
                            id: data.channel,
                            name: data.channel,
                        });
                        this.activeChannel = data.channel;
                        this.editProfile.controls.interactionDate.setValue(format(new Date(data.interactionTime), 'yyyy-MM-dd'));
                        this.editProfile.controls.resume.setValue(data.resume);
                        this.cityName = {
                            address: data.address,
                            city: data.city,
                            country: data.country,
                            state: data.state,
                        };
                        this.editProfile.controls.locationNotes.setValue(data.locationNotes);
                        this.store.dispatch(overrideSearchFilter({
                            name: 'Interest',
                            ids: [],
                            keyOption: 'interests',
                        }));
                        (_a = this.Tinterests) === null || _a === void 0 ? void 0 : _a.ngOnInit();
                        this.store.dispatch(overrideSearchFilter({
                            name: 'Topic',
                            ids: [],
                            keyOption: 'skills',
                        }));
                        (_b = this.Tskills) === null || _b === void 0 ? void 0 : _b.ngOnInit();
                        this.store.dispatch(overrideSearchFilter({
                            name: 'Companies',
                            ids: [],
                            keyOption: 'ProfileCompanies',
                        }));
                        (_c = this.Tcompanies) === null || _c === void 0 ? void 0 : _c.ngOnInit();
                        this.selectionAll('Interest', 'interests', true)
                            .pipe(filter(datas => datas.length > 0), first())
                            .subscribe(res => {
                            var _a, _b;
                            if (((_a = data.interests) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                                this.store.dispatch(overrideSearchFilter({
                                    name: 'Interest',
                                    ids: data.interests.map(id => id.id),
                                    keyOption: 'interests',
                                }));
                                (_b = this.Tinterests) === null || _b === void 0 ? void 0 : _b.ngOnInit();
                            }
                        });
                        this.selectionAll('Topic', 'skills', true)
                            .pipe(filter(datas => datas.length > 0), first())
                            .subscribe(res => {
                            var _a, _b;
                            if (((_a = data.skills) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                                this.store.dispatch(overrideSearchFilter({
                                    name: 'Topic',
                                    ids: data.skills.map(id => id.id),
                                    keyOption: 'skills',
                                }));
                                (_b = this.Tskills) === null || _b === void 0 ? void 0 : _b.ngOnInit();
                            }
                        });
                        this.selectionAll('Companies', 'ProfileCompanies', true)
                            .pipe(filter(datas => datas.length > 0), first())
                            .subscribe(res => {
                            var _a, _b;
                            if (((_a = data.pastCompanies) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                                this.store.dispatch(overrideSearchFilter({
                                    name: 'Companies',
                                    ids: data.pastCompanies.map(id => id.companyId),
                                    keyOption: 'ProfileCompanies',
                                }));
                                (_b = this.Tcompanies) === null || _b === void 0 ? void 0 : _b.ngOnInit();
                            }
                        });
                        if (!!data.noOfMonthExperience) {
                            const no = parseInt(data.noOfMonthExperience, 0) / 12;
                            const yearEx = parseInt(no, 0);
                            const mo = yearEx * 12 - data.noOfMonthExperience;
                            const monthEx = mo >= 0 ? mo : mo * -1;
                            this.editProfile.controls.yearEx.setValue(yearEx);
                            this.editProfile.controls.monthEx.setValue(monthEx);
                        }
                        this.medias = data.medias;
                    });
                }
                else {
                    this.medias = [{}];
                    this.newM = {};
                    this.addMedia = false;
                    this.store.dispatch(overrideSearchFilter({
                        name: 'Interest',
                        ids: [],
                        keyOption: 'interests',
                    }));
                    (_a = this.Tinterests) === null || _a === void 0 ? void 0 : _a.ngOnInit();
                    this.store.dispatch(overrideSearchFilter({
                        name: 'Topic',
                        ids: [],
                        keyOption: 'skills',
                    }));
                    (_b = this.Tskills) === null || _b === void 0 ? void 0 : _b.ngOnInit();
                    this.store.dispatch(overrideSearchFilter({
                        name: 'Companies',
                        ids: [],
                        keyOption: 'ProfileCompanies',
                    }));
                    (_c = this.Tcompanies) === null || _c === void 0 ? void 0 : _c.ngOnInit();
                }
            });
        }
    }
    toWebsiteText(s) {
        if (!s || s.length === 0) {
            return null;
        }
        const str = String(s)
            .replace('https://', '')
            .replace('http://', '')
            .split('/');
        return str[str.length - 1];
    }
    handleFileInput(event, profile, key) {
        // console.log('handle file input ', event);
        const selectedFile = event.target.files[0];
        // console.log('file ', selectedFile);
        let extension = '';
        if (!!selectedFile) {
            extension = selectedFile.name.split('.')[selectedFile.name.split('.').length - 1];
            // console.log("extension ", extension, selectedFile.name.split("."));
            const formData = new FormData();
            formData.append('file', selectedFile);
            this.store.dispatch(commonFileUpload({
                folder: 'resumes',
                file: formData,
                dynamicKeyName: 'work_history',
            }));
            this.store
                .select(selectCommonImageUploadPath, { key: 'work_history' })
                .pipe(filter((it) => !!it), first())
                .subscribe(filePath => {
                this.editProfile.controls.resume.setValue(filePath);
            });
        }
    }
    ngOnInit() {
        this.topicinterests$ = this.selection('Interest', 'interests', true);
        this.topicskills$ = this.selection('Topic', 'skills', true);
        this.topicscompanies$ = this.selection('Companies', 'ProfileCompanies', true);
        if (this.noteValue) {
            this.observationId = this.noteValue.id;
            this.editProfile.controls.id.setValue(this.noteValue.id);
            this.editProfile.controls.newNote.setValue(this.noteValue.details);
            this.editProfile.controls.typeOfNote.setValue({
                id: this.noteValue.observationType,
                name: this.noteValue.observationType,
            });
            this.activeNote = this.noteValue.observationType;
            this.editProfile.controls.channel.setValue({
                id: this.noteValue.channel,
                name: this.noteValue.channel,
            });
            this.activeChannel = this.noteValue.channel;
            // this.editProfile.controls.profile = this.studentID;
            this.editProfile.controls.interactionDate.setValue(format(new Date(this.noteValue.interactionTime), 'yyyy-MM-dd'));
            this.editProfile.controls.resume.setValue(this.noteValue.resume);
            this.cityName = {
                address: this.noteValue.address,
                city: this.noteValue.city,
                country: this.noteValue.country,
                state: this.noteValue.state,
            };
            this.editProfile.controls.locationNotes.setValue(this.noteValue.locationNotes);
            this.medias = this.noteValue.medias;
            if (!!this.noteValue.noOfMonthExperience) {
                const no = parseInt(this.noteValue.noOfMonthExperience, 0) / 12;
                const yearEx = parseInt(no, 0);
                const mo = yearEx * 12 - this.noteValue.noOfMonthExperience;
                const monthEx = mo >= 0 ? mo : mo * -1;
                this.editProfile.controls.yearEx.setValue(yearEx);
                this.editProfile.controls.monthEx.setValue(monthEx);
            }
        }
        if (this.studentID) {
            this.peopleNoteService.loadPeopleIdDetail(this.studentID);
        }
        else {
            this.peopleNoteService.getUserList('');
        }
        this.recheck();
    }
    initializeApp() {
        // this.menuUIService.mobileMenu$.subscribe(mobileMenu => {
        // 	if (!!mobileMenu) {
        // 		this.menuController.enable(false, 'mainMenu');
        // 		this.menuController.enable(true, this.menuId);
        // 		this.menuController.open(this.menuId);
        // 	}
        // });
    }
    menuClose() {
        this.menuController.close(this.menuId);
        this.menuController.enable(false, this.menuId);
        this.menuController.enable(true, 'mainMenu');
    }
    goToWebsite() {
        window.open('https://www.terra.do', '_blank');
    }
    clearForm() {
        var _a, _b, _c;
        this.editProfile.controls.id.setValue(null);
        this.editProfile.controls.newNote.setValue('<p></p>');
        this.editProfile.controls.typeOfNote.setValue(null);
        this.activeNote = null;
        this.editProfile.controls.channel.setValue(null);
        this.activeChannel = null;
        this.editProfile.controls.interactionDate.setValue(format(new Date(), 'yyyy-MM-dd'));
        this.editProfile.controls.locationNotes.setValue(null);
        this.editProfile.controls.resume.setValue(null);
        this.editProfile.controls.yearEx.setValue(null);
        this.editProfile.controls.monthEx.setValue(null);
        this.clearSelection('Interest', 'interests');
        (_a = this.Tinterests) === null || _a === void 0 ? void 0 : _a.ngOnInit();
        this.clearSelection('Topic', 'skills');
        (_b = this.Tskills) === null || _b === void 0 ? void 0 : _b.ngOnInit();
        this.clearSelection('Companies', 'ProfileCompanies');
        (_c = this.Tcompanies) === null || _c === void 0 ? void 0 : _c.ngOnInit();
        this.medias = [{}];
        this.newM = {};
        this.editProfile.markAsPristine();
        this.editProfile.markAsUntouched();
    }
    formSubmit(editProfile) {
        // if (this.pageName === 'BOB') {
        // 	this.editProfile.controls.profile = this.studentID;
        // }
        if (editProfile.controls.profile.status !== 'VALID') {
            this.messages.showErrors('Please select one profile');
        }
        else if (editProfile.controls.newNote.status !== 'VALID') {
            this.messages.showErrors('Please fill add new note');
        }
        else if (editProfile.controls.typeOfNote.status !== 'VALID') {
            this.messages.showErrors('Please select one type of note');
        }
        else if (editProfile.controls.channel.status !== 'VALID') {
            this.messages.showErrors('Please select one channel');
        }
        else if (editProfile.controls.interactionDate.status !== 'VALID') {
            this.messages.showErrors('Please select Interaction date');
        }
        else if (editProfile.controls.interactionDate.status !== 'VALID') {
            this.messages.showErrors('Please select Interaction date');
        }
        else if (editProfile.controls.yearEx.status !== 'VALID') {
            this.messages.showErrors('Please enter years of experience between 0 to 100 years');
        }
        else if (editProfile.controls.monthEx.status !== 'VALID') {
            this.messages.showErrors('Please months of experience between 0 to 11 months');
        }
        else if (editProfile.status === 'INVALID') {
            this.messages.showErrors('Please fill valid details');
        }
        else {
            // console.log(editProfile.value)
            this.onSubmit(editProfile.value);
        }
    }
    onSubmit(value) {
        if (value.profile.id) {
            combineLatest([
                this.topicinterests$,
                this.topicskills$,
                this.topicscompanies$,
                this.authStore.profileDetail$,
            ])
                .pipe(first())
                .subscribe(allRecords => {
                var _a;
                const interest = allRecords[0];
                const skill = allRecords[1];
                const compaines = allRecords[2];
                const user = allRecords[3];
                let noOfMonthExperience = 0;
                if (!!value.yearEx || !!value.monthEx) {
                    noOfMonthExperience = parseInt(value.yearEx * 12 + value.monthEx, 0);
                }
                else {
                    if (value.yearEx === 0 && value.monthEx === 0) {
                        noOfMonthExperience = 0;
                    }
                }
                const medias = [];
                if (((_a = this.medias) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    this.medias.filter((md) => {
                        if (md.title || md.mediaUrl || md.shortDescription) {
                            medias.push({
                                id: md.id,
                                studentObservationId: user.id,
                                previewUrl: md.previewUrl,
                                title: md.title || ' ',
                                mediaType: md.mediaType,
                                mediaUrl: md.mediaUrl ? md.mediaUrl : '',
                                shortDescription: md.shortDescription || ' ',
                                mediaDuration: md.mediaDuration,
                            });
                        }
                    });
                }
                const obj = Object.assign(Object.assign({ profileId: value.profile.id, observationType: value.typeOfNote.name, details: value.newNote, channel: value.channel.name, interactionTime: new Date(value.interactionDate).getTime(), interests: interest.map(i => i.id), skills: skill.map(i => i.id), pastCompanies: compaines.map(res => {
                        return {
                            companyId: res.id,
                            name: res.name,
                            studentObservationId: user.id,
                        };
                    }), locationNotes: value.locationNotes, noOfMonthExperience, resume: value.resume }, this.cityName), { medias });
                if (value.id) {
                    this.peopleNoteService
                        .updateObservation(Object.assign({ id: value.id }, obj))
                        .subscribe(data => {
                        this.store.dispatch(clearNote());
                        this.store.dispatch(loadProfileObservation({
                            peopleId: this.studentID,
                        }));
                        this.recheck();
                    });
                }
                else {
                    this.peopleNoteService
                        .addNewObservation(Object.assign({}, obj))
                        .subscribe(data => {
                        this.store.dispatch(clearNote());
                        this.store.dispatch(loadProfileObservation({
                            peopleId: this.studentID,
                        }));
                        this.recheck();
                        this.clearForm();
                    });
                }
            });
        }
        else {
            this.messages.showErrors(this.profileError);
        }
    }
    clearSelection(name, keyOption) {
        this.store.dispatch(resetSearchFilter({ name, keyOption }));
    }
    selection(title, keyOption, isAll) {
        return this.selectionAll(title, keyOption, isAll).pipe(map((it) => it.filter(ti => ti.isChecked)));
    }
    selectionAll(title, keyOption, isAll) {
        return this.store.select(selectSearchFiltersWithText, {
            title,
            keyOption,
            isAll,
        });
    }
    checkBoxClicked(name, id, keyOption) {
        this.store.dispatch(addSearchFilter({ name, id, keyOption }));
    }
    getAddress(place) {
        if (place) {
            const city = this.getCity(place);
            const state = this.getState(place);
            const country = this.getCountry(place);
            this.cityName = {
                address: place.formatted_address,
                city,
                state,
                country,
            };
        }
        else {
            this.cityName = {
                address: '',
                city: '',
                state: '',
                country: '',
            };
        }
    }
    getAddrComponent(place, componentTemplate) {
        let result;
        for (const placeAddr of place.address_components) {
            const addressType = placeAddr.types[0];
            if (componentTemplate[addressType]) {
                result = placeAddr[componentTemplate[addressType]];
                return result;
            }
        }
        return;
    }
    getCity(place) {
        const COMPONENT_TEMPLATE = { locality: 'long_name' };
        const city = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return city;
    }
    getState(place) {
        const COMPONENT_TEMPLATE = { administrative_area_level_1: 'long_name' };
        const state = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return state;
    }
    getCountry(place) {
        const COMPONENT_TEMPLATE = { country: 'long_name' };
        const country = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return country;
    }
    addMediaLinkOrFile(mediaType) {
        this.mediaType = mediaType;
        if (this.addMedia) {
            this.messages.showErrors('Please fill the form and add it first');
        }
        this.addMedia = true;
    }
    selectedProfile(ev) {
        if (ev.id) {
            this.editProfile.controls.profile.setValue(ev);
        }
        // if (this.pageName === 'BOB') {
        // 	this.editProfile.controls.profile.setValue(this.studentID);
        // }
    }
    checkValue(noteBox) {
        const arr = [];
        if (noteBox.email) {
            arr.push(noteBox.email);
        }
        if (noteBox.conatct) {
            arr.push(noteBox.conatct);
        }
        if (noteBox.group) {
            arr.push(noteBox.group);
        }
        return arr.join(' | ');
    }
    deleteResume() {
        const file = this.editProfile.get('resume').value;
        if (file) {
            const fileArr = file.split('/');
            if (fileArr.length > 0) {
                const fileName = file.split('/')[fileArr.length - 1];
                this.store.dispatch(deleteFileForProfile({
                    folder: 'resumes',
                    fileName,
                }));
            }
        }
        this.editProfile.get('resume').setValue('');
    }
    isValidURL(strings) {
        const res = strings.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
        return res !== null;
    }
    checkDate() {
        if (this.editProfile.value.interactionDate > this.maxDate) {
            this.maxDateError = true;
        }
        else {
            this.maxDateError = false;
        }
    }
    closeModal() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.modalController.dismiss({ closeModal: true });
        });
    }
}
PeopleNoteFormComponent.ɵfac = function PeopleNoteFormComponent_Factory(t) { return new (t || PeopleNoteFormComponent)(ɵɵdirectiveInject(MenuController), ɵɵdirectiveInject(FormBuilder), ɵɵdirectiveInject(PeopleNoteService), ɵɵdirectiveInject(Store), ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(AuthStoreService), ɵɵdirectiveInject(MessagesService), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(ModalController), ɵɵdirectiveInject(NavParams)); };
PeopleNoteFormComponent.ɵcmp = ɵɵdefineComponent({ type: PeopleNoteFormComponent, selectors: [["terra-people-note-form"]], viewQuery: function PeopleNoteFormComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$6, true);
        ɵɵviewQuery(_c1$2, true);
        ɵɵviewQuery(_c2$2, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.Tinterests = _t.first);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.Tskills = _t.first);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.Tcompanies = _t.first);
    } }, inputs: { studentID: "studentID", pageName: "pageName", noteValue: "noteValue" }, features: [ɵɵProvidersFeature([NavParams])], decls: 53, vars: 25, consts: [[1, "main-form"], [3, "formGroup", "keydown.enter", "ngSubmit"], [1, "main-box"], ["size", "12", "class", "space-between-flex back-to-lists", 4, "ngIf"], ["class", "submit-bob", 4, "ngIf"], [4, "ngIf"], [1, "new-note", 3, "ngStyle"], ["size", "12", 1, "add"], ["size", "12"], ["name", "descriptionTA input-box", "formControlName", "newNote", "skin", "moono-lisa", "language", "en", 3, "config", "configChange"], ["class", "error-message", 4, "ngIf"], [1, "selection-box"], [1, "pr20"], [1, "text"], ["placeholder", "Select type", "bindLabel", "name", "bindValue", "id", 3, "ngModel", "ngModelOptions", "items", "ngModelChange", "change"], [1, "error-message"], ["class", "alert alert-danger", 4, "ngIf"], ["placeholder", "Select channel", "bindLabel", "name", "bindValue", "id", 3, "ngModel", "ngModelOptions", "items", "ngModelChange", "change"], ["mbsc-datepicker", "", "dateFormat", "DD/MM/YYYY", "formControlName", "interactionDate", 1, "mt8", "p7", "width100", 3, "controls", "max", "change"], [1, "green-box"], [1, "first-image"], ["src", "./assets/student_form.png"], [1, "secound-image"], ["size", "12", 1, "specific"], ["size", "12", 1, "options"], [1, "white-box", 3, "click"], ["class", "form-details white-box", 4, "ngIf"], ["size", "12", 1, "space-between-flex", "back-to-lists"], ["href", "/#/people", 1, "back"], ["class", "back", 3, "href", 4, "ngIf"], ["type", "submit", 1, "btn-yellow-small"], [1, "back", 3, "href"], [1, "submit-bob"], ["class", "primary-box", 4, "ngIf"], [1, "primary-box"], ["size", "12", 1, "form-image", "cl-image-100p"], ["src", "./assets/student_observation_form.jpg"], ["size", "12", 1, "form-name", "montserrat"], ["size", "12", 1, "form-selection", "text-left"], ["searchKeyword", "name", "placeholder", "Type student\u2019s name...", 3, "data", "itemTemplate", "notFoundTemplate", "inputChanged", "inputCleared", "selected"], ["itemTemplate", ""], ["notFoundTemplate", ""], [3, "innerHTML"], [3, "src", 4, "ngIf"], ["src", "./assets/student_observation_form.jpg", 4, "ngIf"], ["size", "12", "class", "sub-detail", 4, "ngIf"], ["size", "12", 1, "change", 3, "click"], [3, "src"], ["size", "12", 1, "sub-detail"], [1, "alert", "alert-danger"], [1, "form-details", "white-box"], ["size", "12", 1, "space-between-flex", "main-form-title"], ["class", "form-text montserrat", 4, "ngIf"], ["name", "close-outline", 1, "close-outline", "f24", 3, "click"], [1, "form-text", "montserrat"], ["size", "12", 1, "main-title"], ["size", "12", 1, "google-input"], ["addressType", "geocode", "placeholder", "\uD83D\uDCCD Select city or country", 3, "autocompleteInput", "setAddress", "ngModelValue"], ["type", "text", "formControlName", "locationNotes", "placeholder", "\uD83D\uDCDD Add notes about their location", 1, "input-box"], [1, "formInput"], ["size", "12", 1, "main-heading"], [1, "heading"], ["placeholder", "Search climate sectors", "filterTitle", "Interest", "keyOption", "interests", 3, "inline", "isAll"], ["Tinterests", ""], ["class", "my_selection", 4, "ngIf"], [1, "my_selection"], [1, "space-between-flex"], [1, "my"], [1, "all", 3, "click"], [1, "selection"], [3, "click", 4, "ngFor", "ngForOf"], [3, "click"], ["name", "close-outline", 1, "se-ion-icon"], ["placeholder", "Search areas of expertise", "filterTitle", "Topic", "keyOption", "skills", 3, "inline", "isAll"], ["Tskills", ""], ["size", "12", 1, "work-history"], ["type", "file", "accept", ".pdf, .doc, .docx", 1, "display_none", 3, "change"], ["fileInps", ""], [1, "btn-yellow-large", "pr10", 3, "click"], ["class", "btn-red-large", 3, "click", 4, "ngIf"], [1, "heading", "m-mt20"], [1, "input-box", "ym"], ["formControlName", "yearEx", "type", "number", "placeholder", "____", 1, "input-0"], [1, "years"], ["formControlName", "monthEx", "type", "number", "placeholder", "____", 1, "input-0"], [1, "formInput", "pt40"], ["placeholder", "Search organisations", "filterTitle", "Companies", "keyOption", "ProfileCompanies", 3, "inline", "isAll"], ["Tcompanies", ""], [1, "btn-red-large", 3, "click"], ["class", "my_selection pt40", 4, "ngIf"], [1, "my_selection", "pt40"], ["size", "12", 1, "add-media"], [1, "sub-title"], ["size", "12", "class", "pb20", 4, "ngFor", "ngForOf"], ["size", "12", "class", "pb20", 4, "ngIf"], ["size", "12", 1, "pb20"], [1, "btn-yellow-small", 3, "click"], ["view", "edit", "folderName", "temp", 3, "mediaType", "media", "addMediaFn", "updateMediaFn", "deleteMediaFn"], ["view", "edit", "folderName", "temp", 3, "mediaType", "media", "addMediaFn", "updateMediaFn", "newObjRefresh"]], template: function PeopleNoteFormComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "ion-content", 0);
        ɵɵelementStart(1, "form", 1);
        ɵɵlistener("keydown.enter", function PeopleNoteFormComponent_Template_form_keydown_enter_1_listener($event) { return $event.preventDefault(); })("ngSubmit", function PeopleNoteFormComponent_Template_form_ngSubmit_1_listener() { return ctx.formSubmit(ctx.editProfile); });
        ɵɵelementStart(2, "ion-grid", 2);
        ɵɵelementStart(3, "ion-row");
        ɵɵtemplate(4, PeopleNoteFormComponent_ion_col_4_Template, 9, 1, "ion-col", 3);
        ɵɵelementEnd();
        ɵɵtemplate(5, PeopleNoteFormComponent_ion_row_5_Template, 4, 1, "ion-row", 4);
        ɵɵtemplate(6, PeopleNoteFormComponent_div_6_Template, 3, 2, "div", 5);
        ɵɵelementStart(7, "ion-row", 6);
        ɵɵelementStart(8, "ion-col", 7);
        ɵɵtext(9, " Add a new note ");
        ɵɵelementEnd();
        ɵɵelementStart(10, "ion-col", 8);
        ɵɵelementStart(11, "ckeditor", 9);
        ɵɵlistener("configChange", function PeopleNoteFormComponent_Template_ckeditor_configChange_11_listener($event) { return ctx.editorConfig = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(12, PeopleNoteFormComponent_div_12_Template, 3, 2, "div", 10);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(13, "ion-row", 11);
        ɵɵelementStart(14, "ion-col", 12);
        ɵɵelementStart(15, "div", 13);
        ɵɵtext(16, "Type of note");
        ɵɵelementEnd();
        ɵɵelementStart(17, "ng-select", 14);
        ɵɵlistener("ngModelChange", function PeopleNoteFormComponent_Template_ng_select_ngModelChange_17_listener($event) { return ctx.activeNote = $event; })("change", function PeopleNoteFormComponent_Template_ng_select_change_17_listener($event) { return ctx.editProfile == null ? null : ctx.editProfile.controls["typeOfNote"] == null ? null : ctx.editProfile.controls["typeOfNote"].setValue($event); });
        ɵɵelementEnd();
        ɵɵelementStart(18, "div", 15);
        ɵɵtemplate(19, PeopleNoteFormComponent_p_19_Template, 2, 0, "p", 16);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(20, "ion-col", 12);
        ɵɵelementStart(21, "div", 13);
        ɵɵtext(22, "Channel");
        ɵɵelementEnd();
        ɵɵelementStart(23, "ng-select", 17);
        ɵɵlistener("ngModelChange", function PeopleNoteFormComponent_Template_ng_select_ngModelChange_23_listener($event) { return ctx.activeChannel = $event; })("change", function PeopleNoteFormComponent_Template_ng_select_change_23_listener($event) { return ctx.editProfile == null ? null : ctx.editProfile.controls["channel"] == null ? null : ctx.editProfile.controls["channel"].setValue($event); });
        ɵɵelementEnd();
        ɵɵelementStart(24, "div", 15);
        ɵɵtemplate(25, PeopleNoteFormComponent_p_25_Template, 2, 0, "p", 16);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(26, "ion-col");
        ɵɵelementStart(27, "div", 13);
        ɵɵtext(28, "Interaction date");
        ɵɵelementEnd();
        ɵɵelementStart(29, "input", 18);
        ɵɵlistener("change", function PeopleNoteFormComponent_Template_input_change_29_listener() { return ctx.checkDate(); });
        ɵɵelementEnd();
        ɵɵelementStart(30, "div", 15);
        ɵɵtemplate(31, PeopleNoteFormComponent_p_31_Template, 2, 0, "p", 16);
        ɵɵtemplate(32, PeopleNoteFormComponent_p_32_Template, 2, 0, "p", 16);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(33, "ion-row", 19);
        ɵɵelementStart(34, "ion-col", 20);
        ɵɵelement(35, "img", 21);
        ɵɵelementEnd();
        ɵɵelementStart(36, "ion-col", 22);
        ɵɵelementStart(37, "ion-grid");
        ɵɵelementStart(38, "ion-row");
        ɵɵelementStart(39, "ion-col", 23);
        ɵɵtext(40, " Did you find out any specific details about any of these? ");
        ɵɵelementEnd();
        ɵɵelementStart(41, "ion-col", 24);
        ɵɵelementStart(42, "div", 25);
        ɵɵlistener("click", function PeopleNoteFormComponent_Template_div_click_42_listener() { return ctx.activeFormName = "location"; });
        ɵɵtext(43, " Location ");
        ɵɵelementEnd();
        ɵɵelementStart(44, "div", 25);
        ɵɵlistener("click", function PeopleNoteFormComponent_Template_div_click_44_listener() { return ctx.activeFormName = "interests"; });
        ɵɵtext(45, " Climate interests ");
        ɵɵelementEnd();
        ɵɵelementStart(46, "div", 25);
        ɵɵlistener("click", function PeopleNoteFormComponent_Template_div_click_46_listener() { return ctx.activeFormName = "expertise"; });
        ɵɵtext(47, " Expertise ");
        ɵɵelementEnd();
        ɵɵelementStart(48, "div", 25);
        ɵɵlistener("click", function PeopleNoteFormComponent_Template_div_click_48_listener() { return ctx.activeFormName = "history"; });
        ɵɵtext(49, " Work history ");
        ɵɵelementEnd();
        ɵɵelementStart(50, "div", 25);
        ɵɵlistener("click", function PeopleNoteFormComponent_Template_div_click_50_listener() { return ctx.activeFormName = "media"; });
        ɵɵtext(51, " Media ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(52, PeopleNoteFormComponent_ion_row_52_Template, 14, 10, "ion-row", 26);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("formGroup", ctx.editProfile);
        ɵɵadvance(3);
        ɵɵproperty("ngIf", ctx.pageName !== "BOB");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.pageName === "BOB");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.pageName !== "BOB");
        ɵɵadvance(1);
        ɵɵproperty("ngStyle", ɵɵpureFunction1(20, _c3$1, ctx.pageName === "BOB" ? "0px" : "50px"));
        ɵɵadvance(4);
        ɵɵproperty("config", ctx.editorConfig);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.editProfile.controls["newNote"].dirty && ctx.editProfile.controls["newNote"].touched);
        ɵɵadvance(5);
        ɵɵproperty("ngModel", ctx.activeNote)("ngModelOptions", ɵɵpureFunction0(22, _c4$1))("items", ctx.typesOfNote);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", !ctx.activeNote && ctx.editProfile.controls["typeOfNote"].dirty);
        ɵɵadvance(4);
        ɵɵproperty("ngModel", ctx.activeChannel)("ngModelOptions", ɵɵpureFunction0(23, _c4$1))("items", ctx.channels);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", !ctx.activeChannel && ctx.editProfile.controls["channel"].dirty);
        ɵɵadvance(4);
        ɵɵproperty("controls", ɵɵpureFunction0(24, _c5$1))("max", ctx.maxDate);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.editProfile.controls["interactionDate"].hasError("required") && ctx.editProfile.controls["interactionDate"].dirty);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.maxDateError);
        ɵɵadvance(20);
        ɵɵproperty("ngIf", ctx.activeFormName);
    } }, directives: [IonContent, ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, IonGrid, IonRow, NgIf, NgStyle, IonCol, CKEditorComponent, NgControlStatus, FormControlName, NgSelectComponent, NgModel, DefaultValueAccessor, ɵc, IonButton, AutocompleteComponent, IonIcon, GooglePlacesComponent, IonInput, TextValueAccessor, IonLabel, SelectionComponent$1, NgForOf, NumericValueAccessor, TerraAddMediaComponent], pipes: [AsyncPipe], styles: [".main-box[_ngcontent-%COMP%]{overflow:auto;padding:15px}.main-box[_ngcontent-%COMP%]   .ym[_ngcontent-%COMP%]{display:flex;padding:12px 16px}.main-box[_ngcontent-%COMP%]   .ym[_ngcontent-%COMP%]   ion-input[_ngcontent-%COMP%]{max-width:35px}.main-box[_ngcontent-%COMP%]   .ym[_ngcontent-%COMP%]   .years[_ngcontent-%COMP%]{padding-left:8px;padding-right:8px}.main-box[_ngcontent-%COMP%]   .ym[_ngcontent-%COMP%]   .input-0[_ngcontent-%COMP%]{--padding-bottom:0;--padding-end:0;--padding-start:0;--padding-top:0}.main-box[_ngcontent-%COMP%]   .back-to-lists[_ngcontent-%COMP%]{padding-bottom:12px}.main-box[_ngcontent-%COMP%]   .back-to-lists[_ngcontent-%COMP%]   .back[_ngcontent-%COMP%]{color:#0455bf;cursor:pointer;font-size:16px;line-height:125%}.main-box[_ngcontent-%COMP%]   .primary-box[_ngcontent-%COMP%]{padding:20px;text-align:center}.main-box[_ngcontent-%COMP%]   .primary-box[_ngcontent-%COMP%]   .form-image[_ngcontent-%COMP%]{padding-bottom:20px;padding-top:10px}.main-box[_ngcontent-%COMP%]   .primary-box[_ngcontent-%COMP%]   .form-image[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:90px;width:90px}.main-box[_ngcontent-%COMP%]   .primary-box[_ngcontent-%COMP%]   .form-name[_ngcontent-%COMP%]{font-size:32px;font-weight:700;letter-spacing:-1px;line-height:120%;padding-bottom:20px}.main-box[_ngcontent-%COMP%]   .primary-box[_ngcontent-%COMP%]   .form-selection[_ngcontent-%COMP%]{margin:auto;max-width:429px!important}.main-box[_ngcontent-%COMP%]   .primary-box[_ngcontent-%COMP%]   .form-selection.text-left[_ngcontent-%COMP%]{text-align:left}.main-box[_ngcontent-%COMP%]   .primary-box[_ngcontent-%COMP%]   .sub-detail[_ngcontent-%COMP%]{color:#000;font-size:16px;line-height:12px;text-align:center}.main-box[_ngcontent-%COMP%]   .primary-box[_ngcontent-%COMP%]   .change[_ngcontent-%COMP%]{-webkit-text-decoration-line:underline;color:#0455bf;cursor:pointer;font-size:16px;line-height:12px;padding-top:20px;text-align:center;text-decoration-line:underline}.main-box[_ngcontent-%COMP%]   .new-note[_ngcontent-%COMP%]   .add[_ngcontent-%COMP%]{color:#000;font-size:18px;font-weight:700;line-height:133.33%;padding-bottom:8px}.main-box[_ngcontent-%COMP%]   .selection-box[_ngcontent-%COMP%]{padding-bottom:20px}.main-box[_ngcontent-%COMP%]   .selection-box[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{height:39px}.main-box[_ngcontent-%COMP%]   .selection-box[_ngcontent-%COMP%]   .pr20[_ngcontent-%COMP%]{padding-right:20px}.main-box[_ngcontent-%COMP%]   .selection-box[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{color:#000;font-size:18px;font-weight:700;line-height:133.33%;padding-bottom:8px;padding-top:20px}.main-box[_ngcontent-%COMP%]   .green-box[_ngcontent-%COMP%]{padding:20px}.main-box[_ngcontent-%COMP%]   .green-box[_ngcontent-%COMP%]   .specific[_ngcontent-%COMP%]{color:#000;font-size:18px;font-weight:700;line-height:133.33%;padding-bottom:12px}.main-box[_ngcontent-%COMP%]   .green-box[_ngcontent-%COMP%]   .options[_ngcontent-%COMP%]{display:flex;justify-content:flex-start}.main-box[_ngcontent-%COMP%]   .green-box[_ngcontent-%COMP%]   .options[_ngcontent-%COMP%]   .white-box[_ngcontent-%COMP%]{border:1px solid #b3efcb;color:#3b3b3b;cursor:pointer;font-size:16px;font-weight:500;line-height:150%;margin-right:10px;padding:8px 16px}.main-box[_ngcontent-%COMP%]   .green-box[_ngcontent-%COMP%]   .options[_ngcontent-%COMP%]   .white-box[_ngcontent-%COMP%]:last-child{margin-right:0}.main-box[_ngcontent-%COMP%]   .green-box[_ngcontent-%COMP%]   .first-image[_ngcontent-%COMP%]{margin:auto;max-width:71px!important;vertical-align:middle}.main-box[_ngcontent-%COMP%]   .green-box[_ngcontent-%COMP%]   .secound-image[_ngcontent-%COMP%]{max-width:calc(100% - 71px)!important}.main-box[_ngcontent-%COMP%]   .form-details[_ngcontent-%COMP%]{margin-top:20px;padding:20px}.main-box[_ngcontent-%COMP%]   .form-details[_ngcontent-%COMP%]   .form-text[_ngcontent-%COMP%]{color:#000;font-size:20px;font-weight:500;line-height:130%;padding-bottom:20px}.main-box[_ngcontent-%COMP%]   .form-details[_ngcontent-%COMP%]   .close-outline[_ngcontent-%COMP%]{color:#3b3b3b;cursor:pointer}.main-box[_ngcontent-%COMP%]   .form-details[_ngcontent-%COMP%]   .main-title[_ngcontent-%COMP%]{color:#000;font-size:18px;font-weight:700;line-height:133.33%;margin-bottom:20px}.main-box[_ngcontent-%COMP%]   .form-details[_ngcontent-%COMP%]   .google-input[_ngcontent-%COMP%]{padding-bottom:20px}.main-box[_ngcontent-%COMP%]   .form-details[_ngcontent-%COMP%]   .input-box[_ngcontent-%COMP%]{--padding-bottom:12px;--padding-end:16px;--padding-start:16px;--padding-top:12px;background:#fff;border:1px solid #bababa;border-radius:4px;box-sizing:border-box;color:#797979;font-size:16px;line-height:150%}.main-box[_ngcontent-%COMP%]   .form-details[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]{color:#000;font-size:18px;font-weight:700;line-height:133.33%}.main-box[_ngcontent-%COMP%]   .form-details[_ngcontent-%COMP%]   .formInput[_ngcontent-%COMP%]{margin-right:auto;max-width:408px}.main-box[_ngcontent-%COMP%]   .form-details[_ngcontent-%COMP%]   .formInput[_ngcontent-%COMP%]   .main-heading[_ngcontent-%COMP%]{padding-bottom:8px}.main-box[_ngcontent-%COMP%]   .form-details[_ngcontent-%COMP%]   .my_selection[_ngcontent-%COMP%]{max-width:316px}.main-box[_ngcontent-%COMP%]   .form-details[_ngcontent-%COMP%]   .my_selection[_ngcontent-%COMP%]   .my[_ngcontent-%COMP%]{color:#000;font-size:16px;font-style:italic;font-weight:400;line-height:150%}.main-box[_ngcontent-%COMP%]   .form-details[_ngcontent-%COMP%]   .my_selection[_ngcontent-%COMP%]   .all[_ngcontent-%COMP%]{color:#0455bf;cursor:pointer;font-size:16px;font-weight:500;line-height:150%;text-align:right}.main-box[_ngcontent-%COMP%]   .form-details[_ngcontent-%COMP%]   .my_selection[_ngcontent-%COMP%]   .selection[_ngcontent-%COMP%]{background:#ebfaf0;border:1px solid #b3efcb;border-radius:4px;box-sizing:border-box;margin-top:8px;max-height:360px;overflow:auto;padding:10px 0;position:relative}.main-box[_ngcontent-%COMP%]   .form-details[_ngcontent-%COMP%]   .my_selection[_ngcontent-%COMP%]   .selection[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{color:#000;cursor:pointer;font-size:16px;line-height:150%;padding:10px 20px 10px 64px}.main-box[_ngcontent-%COMP%]   .form-details[_ngcontent-%COMP%]   .my_selection[_ngcontent-%COMP%]   .selection[_ngcontent-%COMP%]   .se-ion-icon[_ngcontent-%COMP%]{color:#3b3b3b;font-size:24px;left:20px;position:absolute}.main-box[_ngcontent-%COMP%]   .form-details[_ngcontent-%COMP%]   .add-media[_ngcontent-%COMP%]   .sub-title[_ngcontent-%COMP%]{color:#797979;font-size:16px;line-height:150%;padding-bottom:20px}.main-box[_ngcontent-%COMP%]   .form-details[_ngcontent-%COMP%]   .add-media[_ngcontent-%COMP%]   .pb20[_ngcontent-%COMP%]{padding-bottom:20px}.display_none[_ngcontent-%COMP%]{display:none}.pr10[_ngcontent-%COMP%]{padding-right:10px}.pt40[_ngcontent-%COMP%]{padding-top:40px!important}.error-message[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#ea0028;font-size:14px;line-height:16px;margin:0;padding-bottom:8px;text-transform:lowercase}.error-message[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]:first-letter{text-transform:uppercase}.work-history[_ngcontent-%COMP%]{display:flex}.work-history[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]{padding-bottom:10px}.work-history[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:first-child{padding-right:40px}.submit-bob[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:flex-end}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PeopleNoteFormComponent, [{
        type: Component,
        args: [{
                selector: 'terra-people-note-form',
                templateUrl: './people-note-form.component.html',
                styleUrls: ['./people-note-form.component.scss'],
                providers: [NavParams],
            }]
    }], function () { return [{ type: MenuController }, { type: FormBuilder }, { type: PeopleNoteService }, { type: Store }, { type: ActivatedRoute }, { type: AuthStoreService }, { type: MessagesService }, { type: Router }, { type: ModalController }, { type: NavParams }]; }, { Tinterests: [{
            type: ViewChild,
            args: ['Tinterests']
        }], Tskills: [{
            type: ViewChild,
            args: ['Tskills']
        }], Tcompanies: [{
            type: ViewChild,
            args: ['Tcompanies']
        }], studentID: [{
            type: Input
        }], pageName: [{
            type: Input
        }], noteValue: [{
            type: Input
        }] }); })();

class PeopleService {
    constructor(http, auth, terraCohortsService) {
        this.http = http;
        this.auth = auth;
        this.terraCohortsService = terraCohortsService;
        this.PROFILE_URL = this.auth.PROFILE_URL;
        this.COHORT_URL = this.terraCohortsService.COHORT_URL;
        this.headers = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: 'bearer ',
        };
        this.hideAddMediaFormSource = new BehaviorSubject(false);
        this.hideAddMediaForm$ = this.hideAddMediaFormSource.asObservable();
    }
    getAllRoles(token) {
        console.log('getAllRoles ', this.headers);
        this.headers.Authorization = 'Bearer ' + token;
        return this.http
            .get(`${this.PROFILE_URL}/roles`, {
            headers: new HttpHeaders(this.headers),
        })
            .pipe(map(res => {
            console.log('getAllRoles res ', res, !res);
            if (!res) {
                return [];
            }
            else {
                return res;
            }
        }), shareReplay());
    }
    getAllSearchFilters(token) {
        this.headers.Authorization = 'Bearer ' + token;
        return this.http
            .post(`${this.PROFILE_URL}/tagGroups`, {
            roles: [1, 2, 3, 4, 7],
        }, {
            headers: new HttpHeaders(this.headers),
        })
            .pipe(map(res => {
            if (!res) {
                return [];
            }
            else {
                return res;
            }
        }), shareReplay());
    }
    getProfileSearchFilters(token) {
        this.headers.Authorization = 'Bearer ' + token;
        return this.http
            .get(`${this.PROFILE_URL}/company/list`, {
            headers: new HttpHeaders(this.headers),
        })
            .pipe(map(res => {
            if (!res) {
                return [];
            }
            else {
                return res;
            }
        }), shareReplay());
    }
    loadOnboardingSearchFilter(token) {
        this.headers.Authorization = 'Bearer ' + token;
        return this.http
            .get(`${this.PROFILE_URL}/onboard/tagGroups`, {
            headers: new HttpHeaders(this.headers),
        })
            .pipe(map(res => {
            if (!res) {
                return [];
            }
            else {
                return res;
            }
        }), shareReplay());
    }
    getAllProfilesByRolesAndFilters(token, role, jsonObj, pageNumber, offset) {
        console.log('getAllProfilesByRolesAndFilters ', this.headers, jsonObj);
        this.headers.Authorization = 'Bearer ' + token;
        return this.http
            .post(`${this.PROFILE_URL}/search/role/` + role, jsonObj, {
            headers: new HttpHeaders(this.headers),
        })
            .pipe(map(res => {
            console.log('getAllProfilesByRolesAndFilters res ', res, !res);
            if (!res) {
                return [];
            }
            else {
                return res;
            }
        }), shareReplay());
    }
    // public getAllCollectionProfiles(
    // 	token,
    // 	collectionAndQueryArray: CollectionAndQuery[],
    // 	role: number,
    // 	filters,
    // ): Observable<Collection[]> {
    // 	console.log('collectionAndQueryArray = ', collectionAndQueryArray);
    // 	let allCollections: Observable<any>;
    // 	for (let i = 0; i < collectionAndQueryArray.length; i++) {
    // 		if (i === 0) {
    // 			const jsonObj = {
    // 				searchFilters: filters,
    // 				collectionFilters: [collectionAndQueryArray[i].query],
    // 			};
    // 			allCollections = this.getAllProfilesByRolesAndFilters(
    // 				token,
    // 				role,
    // 				jsonObj,
    // 				0,
    // 				10,
    // 			).pipe(catchError(err => of({ isError: true, error: err })));
    // 		} else {
    // 			const jsonObj = {
    // 				searchFilters: '',
    // 				collectionFilters: [collectionAndQueryArray[i].query],
    // 			};
    // 			allCollections = concat(
    // 				this.getAllProfilesByRolesAndFilters(
    // 					token,
    // 					role,
    // 					jsonObj,
    // 					0,
    // 					10,
    // 				).pipe(catchError(err => of({ isError: true, error: err }))),
    // 				allCollections,
    // 			);
    // 		}
    // 	}
    // 	allCollections = allCollections.pipe(shareReplay());
    // 	// forkJoin(allCollections).pipe(catchError(err => of({isError: true, error: err})),shareReplay());
    // 	return allCollections;
    // }
    loadProfile(profile, token) {
        this.headers.Authorization = 'Bearer ' + token;
        let url = `${this.PROFILE_URL}/`;
        if (Number.isInteger(profile)) {
            url += `id/${profile}`;
        }
        else {
            url += `email/${profile}`;
        }
        return this.http
            .get(url, { headers: new HttpHeaders(this.headers) })
            .pipe(shareReplay());
    }
    loadCollectionProfiles(query, token, limit = 20) {
        let i = 0;
        const subQuery = [];
        query.filter(q => {
            const obj = Object.assign(Object.assign({}, q), { id: i < 1 ? q.id : String(++i) });
            subQuery.push(obj);
        });
        this.headers.Authorization = 'Bearer ' + token;
        let url = `${this.PROFILE_URL}/`;
        url += `search/limit/${limit}`;
        return this.http
            .post(url, subQuery, {
            headers: new HttpHeaders(this.headers),
        })
            .pipe(shareReplay());
    }
    loadRecentlySearchProfiles(user, token) {
        this.headers.Authorization = 'Bearer ' + token;
        return this.http
            .get(`${this.PROFILE_URL}/${user.id}/search/history/3`, {
            headers: new HttpHeaders(this.headers),
        })
            .pipe(shareReplay());
    }
    loadCompaniesList(token) {
        this.headers.Authorization = 'Bearer ' + token;
        return this.http
            .get(`https://terra-api.terra.do/dev/portfoliodev/company/page/0/limit/100`, {
            headers: new HttpHeaders(this.headers),
        })
            .pipe(shareReplay());
    }
    saveProfile(profileId, viewProfileId, token) {
        this.headers.Authorization = 'Bearer ' + token;
        const url = `${this.PROFILE_URL}/save`;
        return this.http
            .post(url, {
            profileId,
            saveProfileId: viewProfileId,
        }, { headers: new HttpHeaders(this.headers) })
            .pipe(shareReplay());
    }
    peopleNotFOund(name, text, token) {
        this.headers.Authorization = 'Bearer ' + token;
        const url = `${this.PROFILE_URL}/feedback`;
        return this.http
            .post(url, { name, text }, { headers: new HttpHeaders(this.headers) })
            .pipe(shareReplay());
    }
    editProfile(profileId, profileDetail, token) {
        this.headers.Authorization = 'Bearer ' + token;
        const url = `${this.PROFILE_URL}/` + profileId;
        return this.http
            .put(url, profileDetail, {
            headers: new HttpHeaders(this.headers),
        })
            .pipe(shareReplay());
    }
    publishProfile(profileId, visibility, token) {
        this.headers.Authorization = 'Bearer ' + token;
        const url = `${this.PROFILE_URL}/` + profileId + `/visibility/` + visibility;
        return this.http
            .put(url, {}, { headers: new HttpHeaders(this.headers) })
            .pipe(shareReplay());
    }
    editProfileMedia(mediaId, media, token) {
        this.headers.Authorization = 'Bearer ' + token;
        const url = `${this.PROFILE_URL}/media/` + mediaId;
        return this.http
            .put(url, media, { headers: new HttpHeaders(this.headers) })
            .pipe(shareReplay());
    }
    deleteProfileMedia(mediaId, token) {
        this.headers.Authorization = 'Bearer ' + token;
        const url = `${this.PROFILE_URL}/media/` + mediaId;
        return this.http
            .delete(url, { headers: new HttpHeaders(this.headers) })
            .pipe(shareReplay());
    }
    addProfileMedia(media, token) {
        this.headers.Authorization = 'Bearer ' + token;
        const url = `${this.PROFILE_URL}/media`;
        return this.http
            .post(url, media, { headers: new HttpHeaders(this.headers) })
            .pipe(shareReplay());
    }
    fileUploadForProfile(folder, file, token) {
        const headers = {
            Authorization: 'Bearer ' + token,
            Accept: 'application/json',
        };
        const url = `${this.PROFILE_URL}/upload/` + folder;
        return this.http
            .post(url, file, { headers: new HttpHeaders(headers) })
            .pipe(shareReplay());
    }
    deleteFileForProfile(folder, fileName, token) {
        const headers = {
            Authorization: 'Bearer ' + token,
            Accept: 'application/json',
        };
        const url = `${this.PROFILE_URL}/remove/` + folder + `/` + fileName;
        return this.http
            .delete(url, { headers: new HttpHeaders(headers) })
            .pipe(shareReplay());
    }
    hideAddMedia() {
        this.hideAddMediaFormSource.next(true);
    }
    viewProfileLogEvent(viewProfileId, profileId, token) {
        const headers = {
            Authorization: 'Bearer ' + token,
            Accept: 'application/json',
        };
        const url = `${this.PROFILE_URL}/view`;
        return this.http
            .post(url, {
            viewProfileId,
            profileId,
        }, { headers: new HttpHeaders(headers) })
            .pipe(shareReplay());
    }
    nudgeHiddenProfile(nudgeProfileId, profileId, token) {
        const headers = {
            Authorization: 'Bearer ' + token,
            Accept: 'application/json',
        };
        const url = `${this.PROFILE_URL}/nudge`;
        return this.http
            .post(url, {
            nudgeProfileId,
            profileId,
        }, { headers: new HttpHeaders(headers) })
            .pipe(shareReplay());
    }
}
PeopleService.ɵfac = function PeopleService_Factory(t) { return new (t || PeopleService)(ɵɵinject(HttpClient), ɵɵinject(AuthStoreService), ɵɵinject(TerraCohortsService)); };
PeopleService.ɵprov = ɵɵdefineInjectable({ token: PeopleService, factory: PeopleService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PeopleService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }, { type: AuthStoreService }, { type: TerraCohortsService }]; }, null); })();

class PeopleNoteEffects {
    constructor(actions, authStore, store, PeopleNoteService, messages, peopleService) {
        this.actions = actions;
        this.authStore = authStore;
        this.store = store;
        this.PeopleNoteService = PeopleNoteService;
        this.messages = messages;
        this.peopleService = peopleService;
        this.loadDefaultTags = createEffect(() => this.actions.pipe(ofType(loadDefaultTags), withLatestFrom(this.authStore.firebaseToken$, this.store.pipe(select(selectAllCollectionsFilters))), filter(([action, token, filter]) => filter.length === 0), concatMap(([action, token, filter]) => {
            return this.PeopleNoteService.loadTags(token).pipe(catchError(error => {
                if (error.status === 401) {
                    this.authStore.logout();
                }
                this.messages.showErrors(error.error);
                return of(false);
            }));
        }), map(searchFilter => loadDefaultTagsLoaded({
            searchFilter: searchFilter,
        }))));
        this.loadProfileObservation = createEffect(() => this.actions.pipe(ofType(loadProfileObservation), withLatestFrom(this.authStore.firebaseToken$, this.store.pipe(select(selectProfileObservations))), filter(([action, token, filter]) => filter.length === 0), concatMap(([action, token, filter]) => {
            return this.PeopleNoteService.loadPeopleObservation(action.peopleId, token).pipe(catchError(error => {
                if (error.status === 401) {
                    this.authStore.logout();
                }
                this.messages.showErrors(error.error);
                return of(false);
            }));
        }), map(searchFilter => loadedProfileObservation({ searchFilter }))));
        this.getAllSearchFilters = createEffect(() => this.actions.pipe(ofType(loadSearchFilter), withLatestFrom(this.authStore.firebaseToken$, this.store.select(selectSearchFiltersWithText, {
            title: 'Locations',
            keyOption: 'location',
            isAll: true,
        })), filter(([action, token, filters]) => filters.length === 0), concatMap(([action, token, filters]) => {
            return this.peopleService.getAllSearchFilters(token).pipe(catchError(error => {
                if (error.status === 401) {
                    this.authStore.logout();
                }
                this.messages.showErrors(error.error);
                return of(false);
            }));
        }), filter(data => !!data), map((searchFilters) => {
            return [
                ...searchFilters.map(res => {
                    if (res.name === 'Locations') {
                        return Object.assign(Object.assign({}, res), { values: res.values.map(ress => {
                                return {
                                    id: ress,
                                    name: ress,
                                };
                            }) });
                    }
                    else if (res.name === 'Course') {
                        return Object.assign(Object.assign({}, res), { values: res.values.filter(ress => ress.name !== 'test-course') });
                    }
                    else {
                        return res;
                    }
                }),
            ];
        }), tap(() => this.store.dispatch(loadProfileCompaniesFilter())), map((searchFilters) => searchFilterLoaded({ searchFilters }))));
        this.loadCompanies = createEffect(() => this.actions.pipe(ofType(loadCompanies), withLatestFrom(this.authStore.firebaseToken$), concatMap(([action, token]) => this.peopleService.loadCompaniesList(token)), map((companiesArr) => companiesLoaded({ companiesArr: companiesArr.data }))));
        this.commonFileUpload = createEffect(() => this.actions.pipe(ofType(commonFileUpload), withLatestFrom(this.authStore.user$, this.authStore.firebaseToken$), concatMap(([action, user, token]) => {
            return this.peopleService
                .fileUploadForProfile(action.folder, action.file, token)
                .pipe(map(fileRes => {
                return {
                    fileUrl: fileRes.url,
                    dynamicKeyName: action.dynamicKeyName,
                };
            }), catchError(error => {
                if (error.status === 401) {
                    this.authStore.logout();
                }
                this.messages.showErrors(error.error);
                return of(false);
            }));
        }), filter(data => !!data), map((profile) => commonFileUploadSuccess({
            fileUrl: profile.fileUrl,
            dynamicKeyName: profile.dynamicKeyName,
        }))));
        this.deleteFileForProfile = createEffect(() => this.actions.pipe(ofType(deleteFileForProfile), withLatestFrom(this.authStore.user$, this.authStore.firebaseToken$), concatMap(([action, user, token]) => {
            return this.peopleService
                .deleteFileForProfile(action.folder, action.fileName, token)
                .pipe(catchError(error => {
                if (error.status === 401) {
                    this.authStore.logout();
                }
                this.messages.showErrors(error.error);
                return of(false);
            }));
        })), { dispatch: false });
        this.fieldsSearchChange = createEffect(() => this.actions.pipe(ofType(fieldsSearchChange), withLatestFrom(this.store.pipe(select(selectPeopleV2FilterSearch))), filter(([results, oldValue]) => {
            return results.searchText !== oldValue;
        }), tap(([results, oldValue]) => {
            this.store.dispatch(fieldsSearchChangeGotResults(results));
            this.store.dispatch(resetPeople());
        }), map(() => searchProfiles())));
        this.searchProfiles = createEffect(() => this.actions.pipe(ofType(searchProfiles), withLatestFrom(this.authStore.user$, this.authStore.profileDetail$, this.authStore.firebaseToken$, this.store.pipe(select(selectPeopleV2Filter)), this.store.pipe(select(selectLastProfileSearch))), filter(([action, user, profileDetail, token, filters, lastFilter]) => {
            var _a, _b;
            this.store.dispatch(lastProfileSearch({ search: filters }));
            if (!!lastFilter && Object.keys(lastFilter).length > 0) {
                if (((_a = filters[0]) === null || _a === void 0 ? void 0 : _a.sortBy) !== ((_b = lastFilter[0]) === null || _b === void 0 ? void 0 : _b.sortBy)) {
                    if (lastFilter.total === 0) {
                        return false;
                    }
                    else {
                        return true;
                    }
                    // 	} else if( filters[0].searchOpt !== lastFilter[0].searchOpt) {
                    // 		return true;
                    // 	}else {
                    // 		let match = 0, submatch = 0, rt = false;
                    // 		if (!!filters[0].saveSearch || !!lastFilter[0].saveSearch) {
                    // 			if (Object.keys(filters[0].saveSearch).length === 0) {
                    // 				rt = true;
                    // 			} else if (Object.keys(lastFilter[0].saveSearch).length === 0) {
                    // 				rt = true;
                    // 			} else {
                    // 				Object.keys(filters[0].saveSearch).filter(key => {
                    // 					if (!!filters[0].saveSearch[key] && !!lastFilter[0].saveSearch[key]) {
                    // 						if (filters[0].saveSearch[key] === lastFilter[0].saveSearch[key]) {
                    // 							match++;
                    // 						}
                    // 					}
                    // 					submatch++;
                    // 				});
                    // 			}
                    // 		}
                    // 		if (!!filters[0].searchQuery && !!lastFilter[0].searchQuery) {
                    // 			if (Object.keys(filters[0].searchQuery).length === 0) {
                    // 				rt = true;
                    // 			} else if (Object.keys(lastFilter[0].searchQuery).length === 0) {
                    // 				rt = true;
                    // 			} else {
                    // 				Object.keys(filters[0].searchQuery).filter(key => {
                    // 					if (!!filters[0].searchQuery[key][0] && !!lastFilter[0].searchQuery[key][0]) {
                    // 						if (filters[0].searchQuery[key][0] === lastFilter[0].searchQuery[key][0]) {
                    // 							match++;
                    // 						}
                    // 					}
                    // 					submatch++;
                    // 				});
                    // 			}
                    // 		}
                    // 		if (rt === false) {
                    // 			if (match === submatch) {
                    // 				return false;
                    // 			} else {
                    // 				return true;
                    // 			}
                }
                else {
                    return true;
                }
                // 	}
            }
            else {
                return true;
            }
        }), concatMap(([action, user, profileDetail, token, filters, lastFilter]) => {
            this.store.dispatch(peopleLoaderEnable());
            if (filters[0].sortBy === 'viewedBy.date') {
                filters[0].profileId = profileDetail.id;
            }
            return this.peopleService
                .loadCollectionProfiles(filters, token, 20)
                .pipe(tap(collectios => {
                this.store.dispatch(peopleLoaderDisabled());
            }), catchError(error => {
                if (error.status === 401) {
                    this.authStore.logout();
                }
                return throwError(error.error);
            }));
        }), map(collections => peopleCollectionLoaded({ collections }))));
        this.editProfileMedia = createEffect(() => this.actions.pipe(ofType(editProfileMedia), withLatestFrom(this.authStore.user$, this.authStore.firebaseToken$), concatMap(([action, user, token]) => {
            return this.peopleService
                .editProfileMedia(action.mediaId, action.media, token)
                .pipe(map(profileDetail => {
                return {
                    profileId: action.profileId,
                };
            }), catchError(error => {
                if (error.status === 401) {
                    this.authStore.logout();
                }
                this.messages.showErrors(error.error);
                return of(false);
            }));
        }), filter(data => !!data), map((profile) => {
            return profileClick({
                profileId: profile.profileId,
            });
        })));
        this.deleteProfileMedia = createEffect(() => this.actions.pipe(ofType(deleteProfileMedia), withLatestFrom(this.authStore.user$, this.authStore.firebaseToken$), concatMap(([action, user, token]) => {
            return this.peopleService
                .deleteProfileMedia(action.mediaId, token)
                .pipe(map(profileDetail => {
                return {
                    profileId: action.profileId,
                };
            }), catchError(error => {
                if (error.status === 401) {
                    this.authStore.logout();
                }
                this.messages.showErrors(error.error);
                return of(false);
            }));
        }), filter(data => !!data), map((profile) => {
            return profileClick({
                profileId: profile.profileId,
            });
        })));
        this.addProfileMedia = createEffect(() => this.actions.pipe(ofType(addProfileMedia), withLatestFrom(this.authStore.user$, this.authStore.firebaseToken$), concatMap(([action, user, token]) => {
            return this.peopleService.addProfileMedia(action.media, token).pipe(map(profileDetail => {
                this.peopleService.hideAddMedia();
                return {
                    profileId: action.profileId,
                };
            }), catchError(error => {
                if (error.status === 401) {
                    this.authStore.logout();
                }
                this.messages.showErrors(error.error);
                return of(false);
            }));
        }), filter(data => !!data), map((profile) => {
            return profileClick({
                profileId: profile.profileId,
            });
        })));
        this.fileUploadForProfile = createEffect(() => this.actions.pipe(ofType(fileUploadForProfile), withLatestFrom(this.authStore.user$, this.authStore.firebaseToken$), concatMap(([action, user, token]) => {
            return this.peopleService
                .fileUploadForProfile(action.folder, action.file, token)
                .pipe(map(fileRes => {
                return {
                    profileId: action.profileId,
                    fileUrl: fileRes.url,
                    key: action.key,
                };
            }), catchError(error => {
                if (error.status === 401) {
                    this.authStore.logout();
                }
                this.messages.showErrors(error.error);
                return of(false);
            }));
        }), filter(data => !!data), map((profile) => fileUploadForProfileSuccess({
            profileId: profile.profileId,
            fileUrl: profile.fileUrl,
            key: profile.key,
        }))));
    }
}
PeopleNoteEffects.ɵfac = function PeopleNoteEffects_Factory(t) { return new (t || PeopleNoteEffects)(ɵɵinject(Actions), ɵɵinject(AuthStoreService), ɵɵinject(Store), ɵɵinject(PeopleNoteService), ɵɵinject(MessagesService), ɵɵinject(PeopleService)); };
PeopleNoteEffects.ɵprov = ɵɵdefineInjectable({ token: PeopleNoteEffects, factory: PeopleNoteEffects.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PeopleNoteEffects, [{
        type: Injectable
    }], function () { return [{ type: Actions }, { type: AuthStoreService }, { type: Store }, { type: PeopleNoteService }, { type: MessagesService }, { type: PeopleService }]; }, null); })();

const initialProfileNoteState = {
    profileDetail: { id: null },
    searchFilter: [],
    peopleData: [],
    activeProfile: 0,
    collections: [],
    searchText: '',
    searchFilters: [],
    searchLoaded: false,
    collectionLoader: false,
    searchObj: {
        id: String(Math.random()),
        name: 'Search profiles v2',
        searchQuery: { 'roles.id': ['1', '2', '3', '4', '7'] },
        searchOpt: {},
    },
    searchArr: [],
    lastProfileSearch: {},
    imageUploadObj: {},
    sorting: '',
    userProfile: {},
};
const peopleNoteReducer = createReducer(initialProfileNoteState, on(loadDefaultTagsLoaded, (state, action) => {
    return Object.assign(Object.assign({}, state), { searchFilter: action.searchFilter });
}), on(activeProfile, (state, action) => {
    return Object.assign(Object.assign({}, state), { activeProfile: action.peopleId });
}), on(loadedProfileObservation, (state, action) => {
    return Object.assign(Object.assign({}, state), { peopleData: [...state.peopleData, ...action.searchFilter] });
}), on(clearNote, (state, action) => {
    return Object.assign(Object.assign({}, state), { peopleData: [...state.peopleData].filter(data => parseInt(data.profileId, 0) !== state.activeProfile) });
}), on(searchFilterLoaded, (state, action) => {
    const newSearchFilters = JSON.parse(JSON.stringify(action.searchFilters));
    newSearchFilters.filter(f => {
        return f.values.sort((a, b) => (a.name < b.name ? -1 : 1));
    });
    return Object.assign(Object.assign({}, state), { searchText: '', searchFilters: [
            ...newSearchFilters.map(filters => {
                var _a;
                if (((_a = state === null || state === void 0 ? void 0 : state.searchFilters) === null || _a === void 0 ? void 0 : _a.filter(od => od.id === filters.id).length) > 0) {
                    return Object.assign(Object.assign({}, state.searchFilters.filter(od => od.id === filters.id)[0]), filters);
                }
                else {
                    return Object.assign({}, filters);
                }
            }),
        ], searchLoaded: true });
}), on(companiesLoaded, (state, action) => {
    return Object.assign(Object.assign({}, state), { searchFilters: [
            ...state.searchFilters,
            {
                id: 0,
                name: 'Companies',
                values: action.companiesArr,
            },
        ] });
}), on(overrideSearchFilter, (state, action) => {
    return Object.assign(Object.assign({}, state), { searchFilters: [
            ...state.searchFilters.map(sf => {
                if (sf.name === action.name) {
                    const keyOption = {};
                    keyOption[action.keyOption] = action.ids;
                    return Object.assign(Object.assign({}, sf), keyOption);
                }
                else {
                    return sf;
                }
            }),
        ] });
}), on(commonFileUploadSuccess, (state, action) => {
    const newKey = {};
    newKey[action.dynamicKeyName] = action.fileUrl;
    return Object.assign(Object.assign({}, state), { imageUploadObj: Object.assign(Object.assign({}, state.imageUploadObj), newKey) });
}), on(resetSearchFilter, (state, action) => {
    return Object.assign(Object.assign({}, state), { searchFilters: [
            ...state.searchFilters.map(sf => {
                if (sf.name === action.name) {
                    const keyOption = {};
                    keyOption[action.keyOption] = [];
                    return Object.assign(Object.assign({}, sf), keyOption);
                }
                else {
                    return sf;
                }
            }),
        ] });
}), on(addSearchFilter, (state, action) => {
    return Object.assign(Object.assign({}, state), { searchFilters: [
            ...state.searchFilters.map(sf => {
                if (sf.name === action.name) {
                    let search = [action.id];
                    if (sf[action.keyOption]) {
                        const match = sf[action.keyOption].indexOf(action.id);
                        if (match === -1 || action.force) {
                            search = [...sf[action.keyOption], action.id];
                        }
                        else {
                            search = [...sf[action.keyOption]];
                            search.splice(match, 1);
                        }
                    }
                    const keyOption = {};
                    keyOption[action.keyOption] = [...new Set(search)];
                    return Object.assign(Object.assign({}, sf), keyOption);
                }
                else {
                    return sf;
                }
            }),
        ] });
}), on(resetSearchFilters, (state, action) => {
    const newSearchFilters = JSON.parse(JSON.stringify(state.searchFilters));
    newSearchFilters.map(f => {
        if (f.selected) {
            f.values.filter(v => {
                if (v.selected) {
                    v.selected = false;
                }
            });
            f.selected = false;
        }
    });
    return Object.assign(Object.assign({}, state), { searchFilters: newSearchFilters });
}), on(fieldsSearchChangeGotResults, (state, action) => {
    return Object.assign(Object.assign({}, state), { searchObj: Object.assign(Object.assign({}, state.searchObj), { searchQuery: Object.assign(Object.assign({}, state.searchObj.searchQuery), { search: [action.searchText] }) }), searchArr: [action.searchText.trim(), ...state.searchArr]
            .filter(v => !!v)
            .filter((v, i, a) => a.indexOf(v) === i) });
}), on(fieldsSearchChangeGotResults, (state, action) => {
    return Object.assign(Object.assign({}, state), { searchObj: Object.assign(Object.assign({}, state.searchObj), { searchQuery: Object.assign(Object.assign({}, state.searchObj.searchQuery), { search: [action.searchText] }) }), searchArr: [action.searchText.trim(), ...state.searchArr]
            .filter(v => !!v)
            .filter((v, i, a) => a.indexOf(v) === i) });
}), on(resetPeople, (state, action) => {
    return Object.assign(Object.assign({}, state), { collections: [], collectionLoader: false });
}), on(resetPeople, (state, action) => {
    return Object.assign(Object.assign({}, state), { collections: [], collectionLoader: false });
}), on(peopleLoaderEnable, (state, action) => {
    return Object.assign(Object.assign({}, state), { collectionLoader: true });
}), on(peopleLoaderDisabled, (state, action) => {
    return Object.assign(Object.assign({}, state), { collectionLoader: false });
}), on(peopleCollectionLoaded, (state, action) => {
    const collections = action.collections;
    return Object.assign(Object.assign({}, state), { collections: [
            ...collections.map(collection => {
                const cl = Object.assign({}, collection);
                cl.extraMember = collection.total - collection.result.length;
                cl.hasExtra = cl.extraMember > 0;
                // cl.showMore = cl.showMore;
                return Object.assign({}, cl);
            }),
        ], lastProfileSearch: Object.assign(Object.assign({}, state.lastProfileSearch), { total: action.collections[0].total }) });
}), on(fileUploadForProfileSuccess, (state, action) => {
    const updatedProfileDetail = Object.assign({}, state.profileDetail);
    updatedProfileDetail[action.key] = action.fileUrl;
    return Object.assign(Object.assign({}, state), { profileDetail: updatedProfileDetail });
}), on(deleteNote, (state, action) => {
    return Object.assign(Object.assign({}, state), { peopleData: [...state.peopleData].filter(data => parseInt(data.id, 0) !== parseInt(action.noteId, 0)) });
}));

class TerraAddMediaPageModule {
}
TerraAddMediaPageModule.ɵmod = ɵɵdefineNgModule({ type: TerraAddMediaPageModule });
TerraAddMediaPageModule.ɵinj = ɵɵdefineInjector({ factory: function TerraAddMediaPageModule_Factory(t) { return new (t || TerraAddMediaPageModule)(); }, providers: [AddMediaService], imports: [[
            CommonModule,
            FormsModule,
            IonicModule,
            CloudinaryModule.forRoot({ Cloudinary }, {
                cloud_name: 'terra-do',
            }),
            ReactiveFormsModule,
            UtilLibModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(TerraAddMediaPageModule, { declarations: [TerraAddMediaComponent], imports: [CommonModule,
        FormsModule,
        IonicModule, CloudinaryModule, ReactiveFormsModule,
        UtilLibModule], exports: [TerraAddMediaComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(TerraAddMediaPageModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    IonicModule,
                    CloudinaryModule.forRoot({ Cloudinary }, {
                        cloud_name: 'terra-do',
                    }),
                    ReactiveFormsModule,
                    UtilLibModule,
                ],
                declarations: [TerraAddMediaComponent],
                providers: [AddMediaService],
                exports: [TerraAddMediaComponent],
            }]
    }], null, null); })();

class SelectionComponentModule$1 {
}
SelectionComponentModule$1.ɵmod = ɵɵdefineNgModule({ type: SelectionComponentModule$1 });
SelectionComponentModule$1.ɵinj = ɵɵdefineInjector({ factory: function SelectionComponentModule_Factory(t) { return new (t || SelectionComponentModule$1)(); }, imports: [[
            CommonModule,
            FormsModule,
            IonicModule,
            ReactiveFormsModule,
            FeatureToggleLibModule,
            UtilLibModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(SelectionComponentModule$1, { declarations: [SelectionComponent$1, FilterPipe$1], imports: [CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        FeatureToggleLibModule,
        UtilLibModule], exports: [SelectionComponent$1] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(SelectionComponentModule$1, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    IonicModule,
                    ReactiveFormsModule,
                    FeatureToggleLibModule,
                    UtilLibModule,
                ],
                declarations: [SelectionComponent$1, FilterPipe$1],
                entryComponents: [SelectionComponent$1],
                exports: [SelectionComponent$1],
            }]
    }], null, null); })();

// import { PeopleMediaComponentModule } from '../people-media/people-media.component.module';
// import { dashboardReducer } from 'projects/apps/bob/src/app/home/redux/dashboard-reducer';
class PeopleNoteFormModule {
}
PeopleNoteFormModule.ɵmod = ɵɵdefineNgModule({ type: PeopleNoteFormModule });
PeopleNoteFormModule.ɵinj = ɵɵdefineInjector({ factory: function PeopleNoteFormModule_Factory(t) { return new (t || PeopleNoteFormModule)(); }, providers: [PeopleService, PeopleNoteService], imports: [[
            CommonModule,
            FormsModule,
            IonicModule,
            CloudinaryModule.forRoot({ Cloudinary }, {
                cloud_name: 'terra-do',
            }),
            // StoreModule.forFeature('dashboard', dashboardReducer),
            StoreModule.forFeature('peopleNote', peopleNoteReducer),
            EffectsModule.forFeature([PeopleNoteEffects]),
            AutocompleteLibModule,
            ReactiveFormsModule,
            CKEditorModule,
            NgSelectModule,
            GooglePlacesComponentModule,
            UtilLibModule,
            TerraAddMediaPageModule,
            MbscModule,
            SelectionComponentModule$1,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(PeopleNoteFormModule, { declarations: [PeopleNoteFormComponent], imports: [CommonModule,
        FormsModule,
        IonicModule, CloudinaryModule, StoreFeatureModule, EffectsFeatureModule, AutocompleteLibModule,
        ReactiveFormsModule,
        CKEditorModule,
        NgSelectModule,
        GooglePlacesComponentModule,
        UtilLibModule,
        TerraAddMediaPageModule,
        MbscModule,
        SelectionComponentModule$1], exports: [PeopleNoteFormComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(PeopleNoteFormModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    IonicModule,
                    CloudinaryModule.forRoot({ Cloudinary }, {
                        cloud_name: 'terra-do',
                    }),
                    // StoreModule.forFeature('dashboard', dashboardReducer),
                    StoreModule.forFeature('peopleNote', peopleNoteReducer),
                    EffectsModule.forFeature([PeopleNoteEffects]),
                    AutocompleteLibModule,
                    ReactiveFormsModule,
                    CKEditorModule,
                    NgSelectModule,
                    GooglePlacesComponentModule,
                    UtilLibModule,
                    TerraAddMediaPageModule,
                    MbscModule,
                    SelectionComponentModule$1,
                ],
                declarations: [PeopleNoteFormComponent],
                providers: [PeopleService, PeopleNoteService],
                exports: [PeopleNoteFormComponent],
            }]
    }], null, null); })();

class ExternalLinkDirective {
    constructor(el) {
        this.el = el;
    }
    ngAfterViewChecked() {
        Array.from(this.el.nativeElement.querySelectorAll('a')).forEach((el) => {
            el.setAttribute('target', '_blank');
        });
    }
}
ExternalLinkDirective.ɵfac = function ExternalLinkDirective_Factory(t) { return new (t || ExternalLinkDirective)(ɵɵdirectiveInject(ElementRef)); };
ExternalLinkDirective.ɵdir = ɵɵdefineDirective({ type: ExternalLinkDirective, selectors: [["", "terraExternalLink", ""]] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ExternalLinkDirective, [{
        type: Directive,
        args: [{
                selector: '[terraExternalLink]',
            }]
    }], function () { return [{ type: ElementRef }]; }, null); })();

function PeopleNoteViewComponent_ion_row_1_div_1_img_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 11);
} if (rf & 2) {
    const profileDetail_r2 = ɵɵnextContext(2).ngIf;
    ɵɵproperty("src", profileDetail_r2.multimedia, ɵɵsanitizeUrl);
} }
function PeopleNoteViewComponent_ion_row_1_div_1_img_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 12);
} }
function PeopleNoteViewComponent_ion_row_1_div_1_ion_col_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-col", 13);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const checkValueR_r10 = ctx.ngIf;
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", checkValueR_r10, " ");
} }
function PeopleNoteViewComponent_ion_row_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "ion-col", 6);
    ɵɵtemplate(2, PeopleNoteViewComponent_ion_row_1_div_1_img_2_Template, 1, 1, "img", 7);
    ɵɵtemplate(3, PeopleNoteViewComponent_ion_row_1_div_1_img_3_Template, 1, 0, "img", 8);
    ɵɵelementEnd();
    ɵɵelementStart(4, "ion-col", 9);
    ɵɵtext(5);
    ɵɵelementEnd();
    ɵɵtemplate(6, PeopleNoteViewComponent_ion_row_1_div_1_ion_col_6_Template, 2, 1, "ion-col", 10);
    ɵɵelementEnd();
} if (rf & 2) {
    const profileDetail_r2 = ɵɵnextContext().ngIf;
    const ctx_r3 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵproperty("ngIf", profileDetail_r2.multimedia);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !profileDetail_r2.multimedia);
    ɵɵadvance(2);
    ɵɵtextInterpolate2(" ", profileDetail_r2.firstName, " ", profileDetail_r2.lastName, " ");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r3.checkValue(profileDetail_r2));
} }
function PeopleNoteViewComponent_ion_row_1_ion_col_2_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-col", 14);
    ɵɵelementStart(1, "ion-button", 15);
    ɵɵlistener("click", function PeopleNoteViewComponent_ion_row_1_ion_col_2_Template_ion_button_click_1_listener() { ɵɵrestoreView(_r13); const ctx_r12 = ɵɵnextContext(2); return ctx_r12.createAnNote(); });
    ɵɵelementStart(2, "span");
    ɵɵtext(3, "Create new note");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function PeopleNoteViewComponent_ion_row_1_ion_col_3_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-col", 16);
    ɵɵelementStart(1, "terra-people-tag", 17);
    ɵɵlistener("tagAddRemove", function PeopleNoteViewComponent_ion_row_1_ion_col_3_Template_terra_people_tag_tagAddRemove_1_listener($event) { ɵɵrestoreView(_r16); const ctx_r15 = ɵɵnextContext(2); return ctx_r15.tagRemove($event); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const tagArr_r14 = ctx.ngIf;
    ɵɵadvance(1);
    ɵɵproperty("tagArr", tagArr_r14);
} }
function PeopleNoteViewComponent_ion_row_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-row", 2);
    ɵɵtemplate(1, PeopleNoteViewComponent_ion_row_1_div_1_Template, 7, 5, "div", 3);
    ɵɵtemplate(2, PeopleNoteViewComponent_ion_row_1_ion_col_2_Template, 4, 0, "ion-col", 4);
    ɵɵtemplate(3, PeopleNoteViewComponent_ion_row_1_ion_col_3_Template, 2, 1, "ion-col", 5);
    ɵɵpipe(4, "async");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.pageName !== "BOB");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.pageName !== "BOB");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ɵɵpipeBind1(4, 3, ctx_r0.tagArr$));
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtext(1, "\u2B50\uFE0F");
    ɵɵelementContainerEnd();
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtext(1, "\uD83D\uDCBC");
    ɵɵelementContainerEnd();
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtext(1, "\u270F\uFE0F");
    ɵɵelementContainerEnd();
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtext(1, "\uD83D\uDCDA");
    ɵɵelementContainerEnd();
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtext(1, "\u2B50\uFE0F");
    ɵɵelementContainerEnd();
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtext(1, "\u2B50\uFE0F");
    ɵɵelementContainerEnd();
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtext(1, "\uD83D\uDEAA");
    ɵɵelementContainerEnd();
} }
function PeopleNoteViewComponent_ng_container_3_ion_icon_14_Template(rf, ctx) { if (rf & 1) {
    const _r31 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-icon", 20);
    ɵɵlistener("click", function PeopleNoteViewComponent_ng_container_3_ion_icon_14_Template_ion_icon_click_0_listener() { ɵɵrestoreView(_r31); const info_r17 = ɵɵnextContext().$implicit; const ctx_r29 = ɵɵnextContext(); return ctx_r29.copyLink(info_r17); });
    ɵɵelementEnd();
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_span_15_Template(rf, ctx) { if (rf & 1) {
    const _r37 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "span", 25);
    ɵɵlistener("click", function PeopleNoteViewComponent_ng_container_3_ng_container_15_span_15_Template_span_click_0_listener() { ɵɵrestoreView(_r37); const info_r17 = ɵɵnextContext(2).$implicit; const ctx_r35 = ɵɵnextContext(); return ctx_r35.onDelete(info_r17.id); });
    ɵɵelement(1, "ion-icon", 26);
    ɵɵelementEnd();
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_16_ng_container_2_p_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "p");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r39 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", item_r39.answer, " ");
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_16_ng_container_2_ng_container_5_p_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "p");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const answer_r46 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate1("- ", answer_r46, "");
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_16_ng_container_2_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_16_ng_container_2_ng_container_5_p_1_Template, 2, 1, "p", 1);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r39 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", item_r39.answers);
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_16_ng_container_2_p_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "p");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r39 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", item_r39.answer, " ");
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_16_ng_container_2_p_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtext(1, " \u2B50 ");
    ɵɵelementContainerEnd();
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_16_ng_container_2_p_7_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtext(1, " \u2B50 \u2B50 ");
    ɵɵelementContainerEnd();
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_16_ng_container_2_p_7_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtext(1, " \u2B50 \u2B50 \u2B50 ");
    ɵɵelementContainerEnd();
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_16_ng_container_2_p_7_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtext(1, " \u2B50 \u2B50 \u2B50 \u2B50 ");
    ɵɵelementContainerEnd();
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_16_ng_container_2_p_7_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtext(1, " \u2B50 \u2B50 \u2B50 \u2B50 \u2B50 ");
    ɵɵelementContainerEnd();
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_16_ng_container_2_p_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "p");
    ɵɵtemplate(1, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_16_ng_container_2_p_7_ng_container_1_Template, 2, 0, "ng-container", 3);
    ɵɵtemplate(2, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_16_ng_container_2_p_7_ng_container_2_Template, 2, 0, "ng-container", 3);
    ɵɵtemplate(3, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_16_ng_container_2_p_7_ng_container_3_Template, 2, 0, "ng-container", 3);
    ɵɵtemplate(4, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_16_ng_container_2_p_7_ng_container_4_Template, 2, 0, "ng-container", 3);
    ɵɵtemplate(5, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_16_ng_container_2_p_7_ng_container_5_Template, 2, 0, "ng-container", 3);
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r39 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", item_r39.answer == "1");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", item_r39.answer == "2");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", item_r39.answer == "3");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", item_r39.answer == "4");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", item_r39.answer == "5");
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_16_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "p");
    ɵɵelementStart(2, "b");
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(4, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_16_ng_container_2_p_4_Template, 2, 1, "p", 3);
    ɵɵtemplate(5, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_16_ng_container_2_ng_container_5_Template, 2, 1, "ng-container", 3);
    ɵɵtemplate(6, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_16_ng_container_2_p_6_Template, 2, 1, "p", 3);
    ɵɵtemplate(7, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_16_ng_container_2_p_7_Template, 6, 5, "p", 3);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r39 = ctx.$implicit;
    ɵɵadvance(3);
    ɵɵtextInterpolate(item_r39.title);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", item_r39.type == "short_text");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", item_r39.type == "multiple_choice");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", item_r39.type == "long_text");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", item_r39.type == "rating");
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "ion-col", 27);
    ɵɵtemplate(2, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_16_ng_container_2_Template, 8, 5, "ng-container", 1);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const info_r17 = ɵɵnextContext(2).$implicit;
    ɵɵadvance(2);
    ɵɵproperty("ngForOf", info_r17.questions);
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ion_col_2_ion_col_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-col", 31);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const info_r17 = ɵɵnextContext(4).$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" \uD83D\uDCCD ", info_r17.address, " ");
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ion_col_2_ion_col_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-col", 31);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const info_r17 = ɵɵnextContext(4).$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", info_r17.locationNotes, " ");
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ion_col_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-col", 30);
    ɵɵelementStart(1, "ion-grid");
    ɵɵelementStart(2, "ion-row");
    ɵɵelementStart(3, "ion-col", 31);
    ɵɵelementStart(4, "b");
    ɵɵtext(5, "Location:");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(6, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ion_col_2_ion_col_6_Template, 2, 1, "ion-col", 32);
    ɵɵtemplate(7, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ion_col_2_ion_col_7_Template, 2, 1, "ion-col", 32);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const info_r17 = ɵɵnextContext(3).$implicit;
    ɵɵadvance(6);
    ɵɵproperty("ngIf", info_r17.address);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", info_r17.locationNotes);
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_3_ion_col_1_ng_container_7_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtext(1, " , ");
    ɵɵelementContainerEnd();
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_3_ion_col_1_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r73 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "a", 33);
    ɵɵlistener("click", function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_3_ion_col_1_ng_container_7_Template_a_click_1_listener() { ɵɵrestoreView(_r73); const interest_r69 = ctx.$implicit; const ctx_r72 = ɵɵnextContext(6); return ctx_r72.peopleSearchFn(interest_r69); });
    ɵɵtext(2);
    ɵɵtemplate(3, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_3_ion_col_1_ng_container_7_ng_container_3_Template, 2, 0, "ng-container", 3);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const interest_r69 = ctx.$implicit;
    const last_r70 = ctx.last;
    ɵɵadvance(2);
    ɵɵtextInterpolate1("", interest_r69, " ");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !last_r70);
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_3_ion_col_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-col", 30);
    ɵɵelementStart(1, "ion-grid");
    ɵɵelementStart(2, "ion-row");
    ɵɵelementStart(3, "ion-col", 31);
    ɵɵelementStart(4, "b");
    ɵɵtext(5, "Climate interests:");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(6, "ion-col", 31);
    ɵɵtemplate(7, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_3_ion_col_1_ng_container_7_Template, 4, 2, "ng-container", 1);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const interests_r66 = ɵɵnextContext().ngIf;
    ɵɵadvance(7);
    ɵɵproperty("ngForOf", interests_r66);
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_3_ion_col_1_Template, 8, 1, "ion-col", 29);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const interests_r66 = ctx.ngIf;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", interests_r66.length > 0);
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_4_ion_col_1_ng_container_7_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtext(1, " , ");
    ɵɵelementContainerEnd();
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_4_ion_col_1_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r82 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "a", 33);
    ɵɵlistener("click", function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_4_ion_col_1_ng_container_7_Template_a_click_1_listener() { ɵɵrestoreView(_r82); const skill_r78 = ctx.$implicit; const ctx_r81 = ɵɵnextContext(6); return ctx_r81.peopleSearchFn(skill_r78); });
    ɵɵtext(2);
    ɵɵtemplate(3, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_4_ion_col_1_ng_container_7_ng_container_3_Template, 2, 0, "ng-container", 3);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const skill_r78 = ctx.$implicit;
    const last_r79 = ctx.last;
    ɵɵadvance(2);
    ɵɵtextInterpolate1("", skill_r78, " ");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !last_r79);
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_4_ion_col_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-col", 30);
    ɵɵelementStart(1, "ion-grid");
    ɵɵelementStart(2, "ion-row");
    ɵɵelementStart(3, "ion-col", 31);
    ɵɵelementStart(4, "b");
    ɵɵtext(5, "Expertise:");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(6, "ion-col", 31);
    ɵɵtemplate(7, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_4_ion_col_1_ng_container_7_Template, 4, 2, "ng-container", 1);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const skills_r75 = ɵɵnextContext().ngIf;
    ɵɵadvance(7);
    ɵɵproperty("ngForOf", skills_r75);
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_4_ion_col_1_Template, 8, 1, "ion-col", 29);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const skills_r75 = ctx.ngIf;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", skills_r75.length > 0);
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_5_ion_col_1_ng_container_6_ion_col_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-col", 31);
    ɵɵelementStart(1, "b");
    ɵɵtext(2, "Experience: ");
    ɵɵelementEnd();
    ɵɵtext(3);
    ɵɵelementEnd();
} if (rf & 2) {
    const noOfMonthExperience_r90 = ctx.ngIf;
    ɵɵadvance(3);
    ɵɵtextInterpolate1(" ", noOfMonthExperience_r90, " ");
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_5_ion_col_1_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_5_ion_col_1_ng_container_6_ion_col_1_Template, 4, 1, "ion-col", 32);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const info_r17 = ɵɵnextContext(5).$implicit;
    const ctx_r86 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r86.calculateYearsOfExperience(info_r17.noOfMonthExperience));
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_5_ion_col_1_ion_col_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-col", 31);
    ɵɵelementStart(1, "b");
    ɵɵtext(2, "Resume: ");
    ɵɵelementEnd();
    ɵɵelementStart(3, "a", 34);
    ɵɵtext(4);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const info_r17 = ɵɵnextContext(5).$implicit;
    const ctx_r87 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵproperty("href", info_r17.resume, ɵɵsanitizeUrl);
    ɵɵadvance(1);
    ɵɵtextInterpolate(ctx_r87.getFileName(info_r17.resume));
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_5_ion_col_1_ion_col_8_ng_container_3_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtext(1, " , ");
    ɵɵelementContainerEnd();
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_5_ion_col_1_ion_col_8_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r98 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "a", 33);
    ɵɵlistener("click", function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_5_ion_col_1_ion_col_8_ng_container_3_Template_a_click_1_listener() { ɵɵrestoreView(_r98); const pastCompanie_r94 = ctx.$implicit; const ctx_r97 = ɵɵnextContext(7); return ctx_r97.peopleSearchFn(pastCompanie_r94); });
    ɵɵtext(2);
    ɵɵtemplate(3, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_5_ion_col_1_ion_col_8_ng_container_3_ng_container_3_Template, 2, 0, "ng-container", 3);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const pastCompanie_r94 = ctx.$implicit;
    const last_r95 = ctx.last;
    ɵɵadvance(2);
    ɵɵtextInterpolate1("", pastCompanie_r94, " ");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !last_r95);
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_5_ion_col_1_ion_col_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-col", 31);
    ɵɵelementStart(1, "b");
    ɵɵtext(2, "Organisations: ");
    ɵɵelementEnd();
    ɵɵtemplate(3, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_5_ion_col_1_ion_col_8_ng_container_3_Template, 4, 2, "ng-container", 1);
    ɵɵelementEnd();
} if (rf & 2) {
    const pastCompanies_r84 = ɵɵnextContext(2).ngIf;
    ɵɵadvance(3);
    ɵɵproperty("ngForOf", pastCompanies_r84);
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_5_ion_col_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-col", 30);
    ɵɵelementStart(1, "ion-grid");
    ɵɵelementStart(2, "ion-row");
    ɵɵelementStart(3, "ion-col", 31);
    ɵɵelementStart(4, "b");
    ɵɵtext(5, "Work history:");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(6, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_5_ion_col_1_ng_container_6_Template, 2, 1, "ng-container", 3);
    ɵɵtemplate(7, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_5_ion_col_1_ion_col_7_Template, 5, 2, "ion-col", 32);
    ɵɵtemplate(8, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_5_ion_col_1_ion_col_8_Template, 4, 1, "ion-col", 32);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const pastCompanies_r84 = ɵɵnextContext().ngIf;
    const info_r17 = ɵɵnextContext(3).$implicit;
    ɵɵadvance(6);
    ɵɵproperty("ngIf", info_r17.noOfMonthExperience > 0);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", info_r17.resume);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", pastCompanies_r84.length > 0);
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_5_ion_col_1_Template, 9, 3, "ion-col", 29);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const pastCompanies_r84 = ctx.ngIf;
    const info_r17 = ɵɵnextContext(3).$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", info_r17.resume || pastCompanies_r84.length > 0 || info_r17.noOfMonthExperience > 0);
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ion_col_6_ion_col_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-col", 36);
    ɵɵelementStart(1, "div");
    ɵɵelementStart(2, "a", 34);
    ɵɵelement(3, "img", 11);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(4, "div");
    ɵɵelementStart(5, "div", 37);
    ɵɵtext(6);
    ɵɵelementEnd();
    ɵɵelementStart(7, "div", 38);
    ɵɵtext(8);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const medias_r104 = ctx.$implicit;
    ɵɵadvance(2);
    ɵɵproperty("href", medias_r104.mediaUrl, ɵɵsanitizeUrl);
    ɵɵadvance(1);
    ɵɵproperty("src", medias_r104.previewUrl, ɵɵsanitizeUrl);
    ɵɵadvance(3);
    ɵɵtextInterpolate1(" ", medias_r104.title, " ");
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", medias_r104.shortDescription, " ");
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ion_col_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-col", 30);
    ɵɵelementStart(1, "ion-grid");
    ɵɵelementStart(2, "ion-row");
    ɵɵelementStart(3, "ion-col", 31);
    ɵɵelementStart(4, "b");
    ɵɵtext(5, "Media:");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(6, "ion-col", 31);
    ɵɵelementStart(7, "ion-grid");
    ɵɵelementStart(8, "ion-row");
    ɵɵtemplate(9, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ion_col_6_ion_col_9_Template, 9, 4, "ion-col", 35);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const info_r17 = ɵɵnextContext(3).$implicit;
    ɵɵadvance(9);
    ɵɵproperty("ngForOf", info_r17.medias);
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "ion-col", 28);
    ɵɵtemplate(2, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ion_col_2_Template, 8, 2, "ion-col", 29);
    ɵɵtemplate(3, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_3_Template, 2, 1, "ng-container", 3);
    ɵɵtemplate(4, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_4_Template, 2, 1, "ng-container", 3);
    ɵɵtemplate(5, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ng_container_5_Template, 2, 1, "ng-container", 3);
    ɵɵtemplate(6, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_ion_col_6_Template, 10, 1, "ion-col", 29);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const info_r17 = ɵɵnextContext(2).$implicit;
    const ctx_r34 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("innerHtml", info_r17.details, ɵɵsanitizeHtml);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", info_r17.address || info_r17.locationNotes);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (info_r17 == null ? null : info_r17.interests) && ctx_r34.getList(info_r17.interests));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (info_r17 == null ? null : info_r17.skills) && ctx_r34.getList(info_r17.skills));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r34.getList(info_r17.pastCompanies));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", info_r17.medias.length > 0);
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "ion-row", 21);
    ɵɵelementStart(2, "ion-col", 22);
    ɵɵelementStart(3, "div", 23);
    ɵɵtext(4, " Added by ");
    ɵɵelementStart(5, "b");
    ɵɵtext(6);
    ɵɵelementEnd();
    ɵɵtext(7, " from interaction on ");
    ɵɵelementStart(8, "b");
    ɵɵtext(9);
    ɵɵpipe(10, "date");
    ɵɵelementEnd();
    ɵɵtext(11, " via ");
    ɵɵelementStart(12, "b");
    ɵɵtext(13);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(14, "div");
    ɵɵtemplate(15, PeopleNoteViewComponent_ng_container_3_ng_container_15_span_15_Template, 2, 0, "span", 24);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(16, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_16_Template, 3, 1, "ng-container", 3);
    ɵɵtemplate(17, PeopleNoteViewComponent_ng_container_3_ng_container_15_ng_container_17_Template, 7, 6, "ng-container", 3);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const info_r17 = ɵɵnextContext().$implicit;
    const ctx_r27 = ɵɵnextContext();
    ɵɵadvance(6);
    ɵɵtextInterpolate(info_r17.observerFirstName);
    ɵɵadvance(3);
    ɵɵtextInterpolate(ɵɵpipeBind2(10, 6, info_r17.interactionTime, "MMM dd,yyyy"));
    ɵɵadvance(4);
    ɵɵtextInterpolate(info_r17.channel);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", info_r17.observationType !== "Mentorship feedback - BOB" && ctx_r27.isEditable);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", info_r17.observationType == "Mentorship feedback - BOB");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", info_r17.observationType != "Mentorship feedback - BOB");
} }
function PeopleNoteViewComponent_ng_container_3_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "ion-row", 39);
    ɵɵelementStart(2, "ion-col", 31);
    ɵɵelement(3, "terra-application-ui", 40);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const info_r17 = ɵɵnextContext().$implicit;
    const ctx_r28 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵproperty("applicationId", info_r17.id)("url", ctx_r28.ENDPOINT)("cohortId", info_r17.course_id);
} }
function PeopleNoteViewComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "ion-row");
    ɵɵelementStart(2, "ion-col", 18);
    ɵɵelementStart(3, "div");
    ɵɵtemplate(4, PeopleNoteViewComponent_ng_container_3_ng_container_4_Template, 2, 0, "ng-container", 3);
    ɵɵtemplate(5, PeopleNoteViewComponent_ng_container_3_ng_container_5_Template, 2, 0, "ng-container", 3);
    ɵɵtemplate(6, PeopleNoteViewComponent_ng_container_3_ng_container_6_Template, 2, 0, "ng-container", 3);
    ɵɵtemplate(7, PeopleNoteViewComponent_ng_container_3_ng_container_7_Template, 2, 0, "ng-container", 3);
    ɵɵtemplate(8, PeopleNoteViewComponent_ng_container_3_ng_container_8_Template, 2, 0, "ng-container", 3);
    ɵɵtemplate(9, PeopleNoteViewComponent_ng_container_3_ng_container_9_Template, 2, 0, "ng-container", 3);
    ɵɵtemplate(10, PeopleNoteViewComponent_ng_container_3_ng_container_10_Template, 1, 0, "ng-container", 3);
    ɵɵtemplate(11, PeopleNoteViewComponent_ng_container_3_ng_container_11_Template, 2, 0, "ng-container", 3);
    ɵɵtext(12);
    ɵɵelementEnd();
    ɵɵelementStart(13, "div");
    ɵɵtemplate(14, PeopleNoteViewComponent_ng_container_3_ion_icon_14_Template, 1, 0, "ion-icon", 19);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(15, PeopleNoteViewComponent_ng_container_3_ng_container_15_Template, 18, 9, "ng-container", 3);
    ɵɵtemplate(16, PeopleNoteViewComponent_ng_container_3_ng_container_16_Template, 4, 3, "ng-container", 3);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const info_r17 = ctx.$implicit;
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(4);
    ɵɵproperty("ngIf", info_r17.observationType == "Feedback for Terra");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", info_r17.observationType == "New job");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", info_r17.observationType == "Hiring alert");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", info_r17.observationType == "Interests");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", info_r17.observationType == "Mentorship feedback");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", info_r17.observationType == "Mentorship feedback - BOB");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", info_r17.observationType == "Other");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", info_r17.observationType == "Application");
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", info_r17.observationType, " ");
    ɵɵadvance(2);
    ɵɵproperty("ngIf", info_r17.observationType != "Application" && info_r17.observationType != "Mentorship feedback - BOB" && ctx_r1.isEditable);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", info_r17.observationType != "Application");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", info_r17.observationType == "Application");
} }
class PeopleNoteViewComponent {
    constructor(alertController, peopleNoteService, messages, activatedRoute, store, router, auth, modalController) {
        this.alertController = alertController;
        this.peopleNoteService = peopleNoteService;
        this.messages = messages;
        this.activatedRoute = activatedRoute;
        this.store = store;
        this.router = router;
        this.auth = auth;
        this.modalController = modalController;
        this.isEditable = false;
        this.dataToEdit = new EventEmitter();
        this.peopleSearch = new EventEmitter();
        this.studentObservationFormLink = 2;
        this.studentObservationForm = false;
        this.cohortId = false;
        this.profileObservations$ = this.store.pipe(select(selectProfileObservations));
        this.notes$ = combineLatest([
            this.profileObservations$,
            this.peopleNoteService.application$,
            this.peopleNoteService.selectedProfile$,
        ]).pipe(map(([notes, application, couseDetails]) => {
            console.log('notes', notes);
            const arr = [];
            notes.filter(n => {
                if (n.observationType === 'Mentorship feedback - BOB') {
                    let matchQ = [];
                    let questions = [];
                    n.questions.filter(q => {
                        if (q.type === 'multiple_choice') {
                            if (matchQ.indexOf(q.title) === -1) {
                                questions.push(Object.assign(Object.assign({}, q), { answers: n.questions
                                        .filter(nq => nq.title === q.title && q.type === 'multiple_choice')
                                        .map(nq => nq.answer) }));
                                matchQ.push(q.title);
                            }
                        }
                        else {
                            questions.push(q);
                        }
                    });
                    arr.push(Object.assign(Object.assign({}, n), { questions }));
                }
                else {
                    arr.push(n);
                }
            });
            if (!!couseDetails.courses &&
                couseDetails.courses.length > 0 &&
                application.length > 0) {
                application.filter(a => {
                    const match = couseDetails.courses.filter(c => c.cohortId === a.cohort_id);
                    if (match.length > 0) {
                        arr.push(Object.assign({ observationType: 'Application', interactionTime: new Date(a.created_at).getTime(), course_id: match[0].courseId }, a));
                    }
                });
            }
            return arr.sort((anxPrevious, anxNext) => {
                const a = new Date(anxNext.interactionTime);
                const b = new Date(anxPrevious.interactionTime);
                return a - b;
            });
        }));
        this.ENDPOINT = this.peopleNoteService.ENDPOINT;
        this.store.dispatch(loadDefaultTags());
    }
    ngOnInit() {
        this.recheck();
        console.log('page', this.pageName);
        console.log('id', this.profileID);
    }
    ionViewWillEnter() {
        // this.loadPeople();
        // const id = this.activatedRoute.snapshot.paramMap.get('id');
        const id = this.profileID;
        this.checkStudentObservationForm(id);
    }
    checkStudentObservationForm(id) {
        if (id !== 'me') {
            this.auth.profileDetail$.subscribe((res) => {
                if (!!res) {
                    const studentObservationFormLink = res.roles.filter(r => r.id === 8).length > 0;
                    if (studentObservationFormLink) {
                        if (!!id) {
                            this.studentObservationForm = false;
                            this.peopleNoteService.loadPeopleIdDetail(Number(id));
                            this.peopleNoteService.selectedProfile$.subscribe(profileDetail => {
                                if (profileDetail.id) {
                                    this.studentObservationFormLink = 1;
                                    this.peopleNoteService.loadPeopleApplication(profileDetail.email);
                                }
                                else {
                                    this.studentObservationFormLink = 0;
                                }
                            });
                        }
                        else {
                            this.studentObservationForm = true;
                        }
                    }
                    else {
                        this.studentObservationForm = false;
                        this.studentObservationFormLink = 0;
                    }
                }
            });
        }
        else {
            this.studentObservationForm = false;
            this.studentObservationFormLink = 0;
        }
    }
    recheck() {
        // const id = this.activatedRoute.snapshot.paramMap.get('id');
        const id = this.profileID;
        this.store.dispatch(activeProfile({ peopleId: parseInt(id, 0) }));
        this.store.dispatch(clearNote());
        this.store.dispatch(loadProfileObservation({ peopleId: id }));
        this.peopleNoteService.loadPeopleTags(id);
        this.tagArr$ = combineLatest([
            this.store.pipe(select(selectAllCollectionsFilters)),
            this.peopleNoteService.profileTag$,
        ]).pipe(filter(([tag, profileTag]) => tag.length), tap(([tag, profileTag]) => {
            console.log('tag', tag);
            console.log('profiletag', profileTag);
        }), map(([tag, profileTag]) => {
            let Interest = [], Topic = [];
            try {
                Interest = tag.filter(i => i.name == 'Interest')[0].values;
            }
            catch (e) { }
            try {
                Topic = tag.filter(i => i.name == 'Topic')[0].values;
            }
            catch (e) { }
            let arr = [];
            if (profileTag.length > 0) {
                arr = profileTag.map(pt => pt.tagId);
            }
            return [
                {
                    header: 'Interest',
                    values: Interest.map(v => {
                        return Object.assign(Object.assign({}, v), { isChecked: arr.indexOf(v.id) !== -1 });
                    }),
                },
                {
                    header: 'Topic',
                    values: Topic.map(v => {
                        return Object.assign(Object.assign({}, v), { isChecked: arr.indexOf(v.id) !== -1 });
                    }),
                },
            ];
        }));
    }
    selection(title, keyOption, isAll) {
        return this.store.select(selectSearchFiltersWithText, {
            title,
            keyOption,
            isAll,
        });
    }
    tagRemove(ev) {
        const arr = [];
        ev.filter(e => {
            e.values.filter(v => {
                if (v.isChecked) {
                    arr.push(v.id);
                }
            });
        });
        // const id = this.activatedRoute.snapshot.paramMap.get('id');
        const id = this.profileID;
        this.peopleNoteService.updateTag(arr, id).subscribe(() => { });
    }
    onDelete(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const alert = yield this.alertController.create({
                cssClass: 'delete-card',
                header: 'Delete note?',
                message: `You’ll lose the information you’ve filled here and this action can’t be undone.`,
                buttons: [
                    {
                        text: 'Cancel',
                        role: 'cancel',
                        cssClass: 'cancel-btn',
                    },
                    {
                        text: 'Delete',
                        cssClass: 'delete-btn',
                        handler: _ => {
                            this.onClear(id);
                        },
                    },
                ],
            });
            alert.present();
        });
    }
    onClear(id) {
        // const profileId = this.activatedRoute.snapshot.paramMap.get('id');
        const profileId = this.profileID;
        this.peopleNoteService.removeNote(id, profileId);
    }
    checkValue(noteBox) {
        var _a;
        const arr = [];
        if (noteBox.email) {
            arr.push(noteBox.email);
        }
        if (noteBox.contactNo) {
            arr.push(noteBox.contactNo);
        }
        if (((_a = noteBox === null || noteBox === void 0 ? void 0 : noteBox.courses) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            if (noteBox.courses[0].groupName) {
                this.cohortId = noteBox.courses[0].cohortId;
                arr.push(noteBox.courses[0].groupName);
            }
        }
        return arr.join(' | ');
    }
    createAnNote() {
        // const id = this.activatedRoute.snapshot.paramMap.get('id');
        const id = this.profileID;
        console.log('id', id);
        this.router.navigate(['/student_observation_form/' + id]);
    }
    copyLink(noteBox) {
        // const id = this.activatedRoute.snapshot.paramMap.get('id');
        const id = this.profileID;
        // this.router.navigate([
        // 	'/student_observation_form/' + id + '/' + noteBox.id,
        // ]);
        this.dataToEdit.emit(noteBox);
        // this.openObservation(noteBox);
        // clipboard.writeText(
        // 	`${window.location.origin}/#/student_observation_form/${id}/${noteBox.id}`,
        // );
        // this.messages.showSuccessMessages('Note URL copied');
    }
    getList(array) {
        if (array.length > 0) {
            return array.map(a => a.name);
        }
        else {
            return [];
        }
    }
    yearsToMonth(no) {
        if (no === 0) {
            return '';
        }
        else {
            const int = parseInt(no, 0);
            let years = int / 12;
            years = parseInt(years, 0);
            const count = int - years * 12;
            let str = '';
            if (count === 0) {
                str = `${years} Years`;
            }
            else if (years === 0) {
                str = `${count}  months`;
            }
            else {
                if (years === 1) {
                    str = `${years} Year ${count} months`;
                }
                else {
                    str = `${years} Years ${count} months`;
                }
            }
            return str;
        }
    }
    getFileName(file) {
        if (file) {
            const fileArr = file.split('/');
            if (fileArr.length > 0) {
                const fileName = file.split('/')[fileArr.length - 1];
                return fileName;
            }
            else {
                return file;
            }
        }
        else {
            return '';
        }
    }
    peopleSearchFn(searchText) {
        this.peopleSearch.emit(searchText);
    }
    calculateYearsOfExperience(value) {
        const totalmonths = parseInt(value, 0);
        let temp = totalmonths / 12;
        temp = temp.toString();
        if (temp.includes('.')) {
            temp = temp.split('.');
            const x = value % 12;
            return `${temp[0]} Years ${Math.round(x)} Months`;
        }
        else {
            if (totalmonths < 12) {
                return `${totalmonths} months`;
            }
            else {
                return `${temp} Years`;
            }
        }
    }
}
PeopleNoteViewComponent.ɵfac = function PeopleNoteViewComponent_Factory(t) { return new (t || PeopleNoteViewComponent)(ɵɵdirectiveInject(AlertController), ɵɵdirectiveInject(PeopleNoteService), ɵɵdirectiveInject(MessagesService), ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(Store), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(AuthStoreService), ɵɵdirectiveInject(ModalController)); };
PeopleNoteViewComponent.ɵcmp = ɵɵdefineComponent({ type: PeopleNoteViewComponent, selectors: [["terra-people-note-view"]], inputs: { profileID: "profileID", pageName: "pageName", isEditable: "isEditable" }, outputs: { dataToEdit: "dataToEdit", peopleSearch: "peopleSearch" }, decls: 5, vars: 6, consts: [["class", "primary-box", 4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "primary-box"], [4, "ngIf"], ["size", "12", "class", "buttons", 4, "ngIf"], ["size", "12", "class", "tags", 4, "ngIf"], ["size", "12", 1, "top-image", "cl-image-100p"], [3, "src", 4, "ngIf"], ["src", "/assets/people/d_profile_photo.svg", 4, "ngIf"], ["size", "12", 1, "profile-name", "montserrat"], ["size", "12", "class", "prodile-small-desc", 4, "ngIf"], [3, "src"], ["src", "/assets/people/d_profile_photo.svg"], ["size", "12", 1, "prodile-small-desc"], ["size", "12", 1, "buttons"], [1, "btn-yellow-small", 3, "click"], ["size", "12", 1, "tags"], [3, "tagArr", "tagAddRemove"], ["size", "12", 1, "space-between-flex", "info-title"], ["tooltip", "Edit note", "placement", "bottom", "show-delay", "500", "name", "link-outline", "class", "link-outline f24", 3, "click", 4, "ngIf"], ["tooltip", "Edit note", "placement", "bottom", "show-delay", "500", "name", "link-outline", 1, "link-outline", "f24", 3, "click"], [1, "white-box", "top-box"], ["size", "12", 1, "space-between-flex", "log-date"], [1, "ellipsis-1"], ["title", "delete", "class", "trash-outline", 3, "click", 4, "ngIf"], ["title", "delete", 1, "trash-outline", 3, "click"], ["name", "trash-outline", "placement", "bottom", "show-delay", "500", 1, "trash-outline", "f24"], ["size", "12", 1, "descriptions", "custom-ckeditor"], ["size", "12", "terraExternalLink", "", 1, "descriptions", "custom-ckeditor", 3, "innerHtml"], ["class", "sub-box", "size", "12", 4, "ngIf"], ["size", "12", 1, "sub-box"], ["size", "12"], ["size", "12", 4, "ngIf"], [3, "click"], ["target", "_blank", 3, "href"], ["size", "12", "class", "media-class", 4, "ngFor", "ngForOf"], ["size", "12", 1, "media-class"], [1, "media-title"], [1, "media-desc"], [1, "white-box", "pi"], ["paymentInfo", "true", 3, "applicationId", "url", "cohortId"]], template: function PeopleNoteViewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "ion-grid");
        ɵɵtemplate(1, PeopleNoteViewComponent_ion_row_1_Template, 5, 5, "ion-row", 0);
        ɵɵpipe(2, "async");
        ɵɵtemplate(3, PeopleNoteViewComponent_ng_container_3_Template, 17, 12, "ng-container", 1);
        ɵɵpipe(4, "async");
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ɵɵpipeBind1(2, 2, ctx.peopleNoteService.selectedProfile$));
        ɵɵadvance(2);
        ɵɵproperty("ngForOf", ɵɵpipeBind1(4, 4, ctx.notes$));
    } }, directives: [IonGrid, NgIf, NgForOf, IonRow, IonCol, IonButton, PeopleTagComponent, IonIcon, ExternalLinkDirective], pipes: [AsyncPipe, DatePipe], styles: ["ion-col[_ngcontent-%COMP%], ion-grid[_ngcontent-%COMP%]{padding:0}.pi[_ngcontent-%COMP%], .pi[_ngcontent-%COMP%]   ion-col[_ngcontent-%COMP%]{padding:0!important}.primary-box[_ngcontent-%COMP%]{padding:20px;text-align:center;width:300px}.primary-box[_ngcontent-%COMP%]   .top-image[_ngcontent-%COMP%]{padding-bottom:20px}.primary-box[_ngcontent-%COMP%]   .top-image[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:90px;width:90px}.primary-box[_ngcontent-%COMP%]   .profile-name[_ngcontent-%COMP%]{color:#000;font-size:32px;font-style:normal;font-weight:700;letter-spacing:-1px;line-height:120%;padding-bottom:14px}.primary-box[_ngcontent-%COMP%]   .prodile-small-desc[_ngcontent-%COMP%]{color:#000;font-size:16px;line-height:12px;padding-bottom:24px}.primary-box[_ngcontent-%COMP%]   .buttons[_ngcontent-%COMP%]{padding-bottom:20px}.info-title[_ngcontent-%COMP%]{color:#000;font-size:18px;font-weight:700;line-height:133.33%;margin:40px 0 8px;text-transform:capitalize}.info-title[_ngcontent-%COMP%]   .link-outline[_ngcontent-%COMP%]{color:#3b3b3b;cursor:pointer}.white-box[_ngcontent-%COMP%]{padding:16px 0 0}.white-box.top-box[_ngcontent-%COMP%]   .sub-box[_ngcontent-%COMP%]{border-top:1px solid #efefef}.white-box.top-box[_ngcontent-%COMP%]   .sub-box[_ngcontent-%COMP%]   ion-row[_ngcontent-%COMP%]{padding-bottom:16px;padding-top:16px;row-gap:8px}.white-box.top-box[_ngcontent-%COMP%]   .sub-box[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{cursor:pointer}.white-box[_ngcontent-%COMP%] > ion-col[_ngcontent-%COMP%]{padding-left:16px;padding-right:16px}.white-box[_ngcontent-%COMP%]   .descriptions[_ngcontent-%COMP%]{color:#000;font-size:16px;line-height:150%;padding-bottom:16px;padding-top:8px}.white-box[_ngcontent-%COMP%]   .pb8[_ngcontent-%COMP%]{padding-bottom:8px}.white-box[_ngcontent-%COMP%]   .log-date[_ngcontent-%COMP%]{border-top:1px solid #efefef;color:#797979;font-size:16px;line-height:150%;margin-top:16px;padding-top:16px}.white-box[_ngcontent-%COMP%]   .log-date[_ngcontent-%COMP%]:first-child{border-top:none;margin-top:0;padding-top:0}.white-box[_ngcontent-%COMP%]   .log-date[_ngcontent-%COMP%]   .trash-outline[_ngcontent-%COMP%]{color:#3b3b3b;cursor:pointer}.white-box[_ngcontent-%COMP%]   .log-date[_ngcontent-%COMP%]   .trash-outline[_ngcontent-%COMP%]   ion-icon[_ngcontent-%COMP%]{pointer-events:none}.white-box[_ngcontent-%COMP%]   .media-class[_ngcontent-%COMP%]{background:#fff;border-radius:4px;box-shadow:0 0 2px rgba(0,0,0,.25);display:flex;margin-bottom:20px;padding:20px}.white-box[_ngcontent-%COMP%]   .media-class[_ngcontent-%COMP%]:first-child{margin-bottom:0}.white-box[_ngcontent-%COMP%]   .media-class[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:first-child{padding-right:15px}.white-box[_ngcontent-%COMP%]   .media-class[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{border-radius:4px;height:104px;width:189px}.white-box[_ngcontent-%COMP%]   .media-class[_ngcontent-%COMP%]   .media-title[_ngcontent-%COMP%]{color:#000;font-size:16px;line-height:150%;padding-bottom:8px}.white-box[_ngcontent-%COMP%]   .media-class[_ngcontent-%COMP%]   .media-desc[_ngcontent-%COMP%]{color:#3b3b3b;font-size:16px;height:72px;line-height:150%}terra-application-ui[_ngcontent-%COMP%]{--padding-bottom:0}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PeopleNoteViewComponent, [{
        type: Component,
        args: [{
                selector: 'terra-people-note-view',
                templateUrl: './people-note-view.component.html',
                styleUrls: ['./people-note-view.component.scss'],
            }]
    }], function () { return [{ type: AlertController }, { type: PeopleNoteService }, { type: MessagesService }, { type: ActivatedRoute }, { type: Store }, { type: Router }, { type: AuthStoreService }, { type: ModalController }]; }, { profileID: [{
            type: Input
        }], pageName: [{
            type: Input
        }], isEditable: [{
            type: Input
        }], dataToEdit: [{
            type: Output
        }], peopleSearch: [{
            type: Output
        }] }); })();

// import { PeopleMediaComponentModule } from '../people-media/people-media.component.module';
// import { dashboardReducer } from 'projects/apps/bob/src/app/home/redux/dashboard-reducer';
class PeopleNoteViewModule {
}
PeopleNoteViewModule.ɵmod = ɵɵdefineNgModule({ type: PeopleNoteViewModule });
PeopleNoteViewModule.ɵinj = ɵɵdefineInjector({ factory: function PeopleNoteViewModule_Factory(t) { return new (t || PeopleNoteViewModule)(); }, providers: [PeopleService, PeopleNoteService], imports: [[
            CommonModule,
            FormsModule,
            IonicModule,
            CloudinaryModule.forRoot({ Cloudinary }, {
                cloud_name: 'terra-do',
            }),
            // StoreModule.forFeature('dashboard', dashboardReducer),
            StoreModule.forFeature('peopleNote', peopleNoteReducer),
            EffectsModule.forFeature([PeopleNoteEffects]),
            AutocompleteLibModule,
            ReactiveFormsModule,
            CKEditorModule,
            NgSelectModule,
            GooglePlacesComponentModule,
            SelectionComponentModule$1,
            UtilLibModule,
            TerraAddMediaPageModule,
            MbscModule,
            PeopleTagsComponentModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(PeopleNoteViewModule, { declarations: [PeopleNoteViewComponent, ExternalLinkDirective], imports: [CommonModule,
        FormsModule,
        IonicModule, CloudinaryModule, StoreFeatureModule, EffectsFeatureModule, AutocompleteLibModule,
        ReactiveFormsModule,
        CKEditorModule,
        NgSelectModule,
        GooglePlacesComponentModule,
        SelectionComponentModule$1,
        UtilLibModule,
        TerraAddMediaPageModule,
        MbscModule,
        PeopleTagsComponentModule], exports: [PeopleNoteViewComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(PeopleNoteViewModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    IonicModule,
                    CloudinaryModule.forRoot({ Cloudinary }, {
                        cloud_name: 'terra-do',
                    }),
                    // StoreModule.forFeature('dashboard', dashboardReducer),
                    StoreModule.forFeature('peopleNote', peopleNoteReducer),
                    EffectsModule.forFeature([PeopleNoteEffects]),
                    AutocompleteLibModule,
                    ReactiveFormsModule,
                    CKEditorModule,
                    NgSelectModule,
                    GooglePlacesComponentModule,
                    SelectionComponentModule$1,
                    UtilLibModule,
                    TerraAddMediaPageModule,
                    MbscModule,
                    PeopleTagsComponentModule,
                ],
                declarations: [PeopleNoteViewComponent, ExternalLinkDirective],
                providers: [PeopleService, PeopleNoteService],
                exports: [PeopleNoteViewComponent],
            }]
    }], null, null); })();

// Course Page Segment Click
const calendarSegmentClick = createAction('[Calendar Segment Click] Calendar Click', props());
const calendarSegmentSelected = createAction('[Calendar Segment Effect] Calendar Segment Click Effect', props());
const filterClick = createAction('[Calendar filter Click] Calendar filter Click', props());
const filteredCriteriaClick = createAction('[Calendar filter Effect] Calendar filter data Click Effect', props());
const publishEvent = createAction('[Calendar Event Publish] = Click', props());
const updateEvent = createAction('[Calendar Event Update] = Click', props());
const storePublishedEvent = createAction('[Calendar Event Publish Reducer] called', props());
const updatePublishedEvent = createAction('[Calendar Event update Reducer] called', props());
const zoomAttendace = createAction('[Calendar Event zoom attendance] Click', props());
const attendanceAdded = createAction('[Calendar Event zoom attendance] added', props());
const recordingAttendace = createAction('[Calendar Event recording attendance] Click', props());
const deleteEventClick = createAction('[Delete Calendar Event ] Click', props());
const deleteEventClickEffect = createAction('[Delete Calendar Event] Click Effect', props());
const loadDashboard = createAction('[Home Resolver] calendar', props());
const allAssignmentLoaded = createAction('[Calendar Effect] All assignments Loaded', props());
const dashboardLoaded = createAction('[Calendar Effect] Dashboard Loaded', props());
const allCohortsLoaded = createAction('[Calendar Effect] All Cohorts Loaded', props());
const allEventsLoaded = createAction('[Dashboard Effect] All events Loaded', props());

const selectDashboardState = createFeatureSelector('terraCalendar');
const selectEvents = createSelector(selectDashboardState, state => state.events);
const selectUpcomingAllEvents = createSelector(selectDashboardState, ev => {
    var _a, _b;
    if (ev === null || ev === void 0 ? void 0 : ev.events) {
        let upcomingEvents = [];
        ev.events.forEach(el => {
            if (!!el.events) {
                for (const key in el.events) {
                    if (el.events[key]) {
                        upcomingEvents = upcomingEvents.concat(el.events[key]);
                    }
                }
            }
        });
        upcomingEvents = upcomingEvents.filter(item => {
            var _a, _b;
            const cohortDetail = ev === null || ev === void 0 ? void 0 : ev.cohorts.find(x => x.cohortId === item.cohortId);
            if (!!cohortDetail &&
                !!(cohortDetail === null || cohortDetail === void 0 ? void 0 : cohortDetail.properties) &&
                ((_b = (_a = cohortDetail === null || cohortDetail === void 0 ? void 0 : cohortDetail.properties) === null || _a === void 0 ? void 0 : _a.CohortType) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                if (cohortDetail.properties.CohortType[0] === 'terralite') {
                    if (item.type !== 'assignment' &&
                        item.type !== 'class' &&
                        item.type !== 'announcement') {
                        return item;
                    }
                }
            }
            else {
                return item;
            }
        });
        if (ev === null || ev === void 0 ? void 0 : ev.calendarFilterCriteria) {
            if (((_a = ev.calendarFilterCriteria) === null || _a === void 0 ? void 0 : _a.courses.length) > 0) {
                upcomingEvents = upcomingEvents.filter((x) => ev.calendarFilterCriteria.courses.filter(a => Number(a.keyValue) === x.cohortId).length !== 0);
            }
            if (((_b = ev.calendarFilterCriteria) === null || _b === void 0 ? void 0 : _b.specific.length) > 0) {
                upcomingEvents = upcomingEvents.filter((x) => ev.calendarFilterCriteria.specific.filter(a => a.keyValue === x.type).length !== 0);
            }
        }
        return upcomingEvents
            .filter(anx => {
            return !!anx && isBefore(new Date(), new Date(anx.endDateTime));
        })
            .map(item => {
            const itemData = Object.assign({}, item);
            if (isWithinInterval(new Date(), {
                start: subMinutes(new Date(itemData.startDateTime), 30),
                end: addMinutes(new Date(itemData.endDateTime), 30),
            })) {
                itemData.displayZoomButton = true;
            }
            if (isWithinInterval(new Date(), {
                start: new Date(itemData.startDateTime),
                end: new Date(itemData.endDateTime),
            })) {
                if (itemData.type === 'webinar' || itemData.type === 'class') {
                    itemData.isliveEvent = true;
                }
            }
            return itemData;
        })
            .sort((anxPrevious, anxNext) => {
            const a = new Date(anxPrevious.startDateTime);
            const b = new Date(anxNext.startDateTime);
            return a - b;
        });
    }
});
const selectPreviousEvents = createSelector(selectDashboardState, ev => {
    var _a, _b, _c;
    let previousEvents = [];
    (_a = ev === null || ev === void 0 ? void 0 : ev.events) === null || _a === void 0 ? void 0 : _a.forEach(el => {
        if (!!el.events) {
            for (const key in el.events) {
                if (el.events[key]) {
                    previousEvents = previousEvents.concat(el.events[key]);
                }
            }
        }
    });
    previousEvents = previousEvents.filter(item => {
        var _a, _b;
        const cohortDetail = ev === null || ev === void 0 ? void 0 : ev.cohorts.find(x => x.cohortId === item.cohortId);
        if (!!cohortDetail &&
            !!(cohortDetail === null || cohortDetail === void 0 ? void 0 : cohortDetail.properties) &&
            ((_b = (_a = cohortDetail === null || cohortDetail === void 0 ? void 0 : cohortDetail.properties) === null || _a === void 0 ? void 0 : _a.CohortType) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            if (cohortDetail.properties.CohortType[0] === 'terralite') {
                if (item.type !== 'assignment' &&
                    item.type !== 'class' &&
                    item.type !== 'announcement') {
                    return item;
                }
            }
        }
        else {
            return item;
        }
    });
    if (ev === null || ev === void 0 ? void 0 : ev.calendarFilterCriteria) {
        if (((_b = ev.calendarFilterCriteria) === null || _b === void 0 ? void 0 : _b.courses.length) > 0) {
            previousEvents = previousEvents.filter((x) => ev.calendarFilterCriteria.courses.filter(a => Number(a.keyValue) === x.cohortId).length !== 0);
        }
        if (((_c = ev.calendarFilterCriteria) === null || _c === void 0 ? void 0 : _c.specific.length) > 0) {
            previousEvents = previousEvents.filter((x) => ev.calendarFilterCriteria.specific.filter(a => a.keyValue === x.type)
                .length !== 0);
        }
    }
    return previousEvents
        .filter(anx => {
        return !!anx && isAfter(new Date(), new Date(anx.startDateTime));
    })
        .map(item => {
        const itemData = Object.assign({}, item);
        if (isWithinInterval(new Date(), {
            start: subMinutes(new Date(itemData.startDateTime), 30),
            end: addMinutes(new Date(itemData.endDateTime), 30),
        })) {
            itemData.displayZoomButton = true;
        }
        if (isWithinInterval(new Date(), {
            start: new Date(itemData.startDateTime),
            end: new Date(itemData.endDateTime),
        })) {
            if (itemData.type === 'webinar' || itemData.type === 'class') {
                itemData.isliveEvent = true;
            }
        }
        return itemData;
    })
        .sort((anxPrevious, anxNext) => {
        const a = new Date(anxNext.startDateTime);
        const b = new Date(anxPrevious.startDateTime);
        return a - b;
    });
});
const selectAllEvents = createSelector(selectDashboardState, ev => {
    var _a, _b, _c;
    let allEvents = [];
    if (!ev) {
        return null;
    }
    (_a = ev === null || ev === void 0 ? void 0 : ev.events) === null || _a === void 0 ? void 0 : _a.forEach(el => {
        if (!!el.events) {
            for (const key in el.events) {
                if (!!el.events[key] && key !== 'announcements') {
                    allEvents = allEvents.concat(el.events[key]);
                }
            }
        }
    });
    let newData = [];
    allEvents = allEvents.filter(item => {
        var _a, _b;
        const cohortDetail = ev === null || ev === void 0 ? void 0 : ev.cohorts.find(x => x.cohortId === item.cohortId);
        if (!!cohortDetail &&
            !!(cohortDetail === null || cohortDetail === void 0 ? void 0 : cohortDetail.properties) &&
            ((_b = (_a = cohortDetail === null || cohortDetail === void 0 ? void 0 : cohortDetail.properties) === null || _a === void 0 ? void 0 : _a.CohortType) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            if (cohortDetail.properties.CohortType[0] === 'terralite') {
                if (item.type !== 'assignment' &&
                    item.type !== 'class' &&
                    item.type !== 'announcement') {
                    return item;
                }
            }
        }
        else {
            return item;
        }
    });
    allEvents = allEvents.map(item => {
        const itemData = Object.assign({}, item);
        const diffDays = dateDiffIndays(new Date(itemData.startDateTime), new Date(itemData.endDateTime));
        if (diffDays === 0) {
            itemData.text =
                format(new Date(itemData.startDateTime), 'hh:mm a') +
                    ' ' +
                    itemData.summary;
            itemData.start = new Date(itemData.startDateTime);
            itemData.end = new Date(itemData.endDateTime);
            if (isWithinInterval(new Date(), {
                start: subMinutes(new Date(itemData.startDateTime), 30),
                end: addMinutes(new Date(itemData.endDateTime), 30),
            })) {
                itemData.displayZoomButton = true;
            }
            if (itemData.type === 'announcement') {
                itemData.color = '#A42277';
            }
            if (itemData.type === 'officeHour') {
                itemData.color = '#0984E3';
            }
            if (itemData.type === 'class') {
                itemData.color = '#A42277';
            }
            if (itemData.type === 'assignment') {
                itemData.color = '#D54141';
            }
            if (itemData.type === 'webinar' || itemData.type === 'module') {
                itemData.color = '#00AAA6';
            }
            item = Object.assign({}, itemData);
            return item;
        }
        else {
            itemData.text =
                format(new Date(itemData.startDateTime), 'hh:mm a') +
                    ' ' +
                    itemData.summary;
            itemData.start = new Date(itemData.startDateTime);
            itemData.end = new Date(itemData.startDateTime);
            if (isWithinInterval(new Date(), {
                start: subMinutes(new Date(itemData.startDateTime), 30),
                end: addMinutes(new Date(itemData.endDateTime), 30),
            })) {
                itemData.displayZoomButton = true;
            }
            if (itemData.type === 'announcement') {
                itemData.color = '#A42277';
            }
            if (itemData.type === 'officeHour') {
                itemData.color = '#0984E3';
            }
            if (itemData.type === 'class') {
                itemData.color = '#A42277';
            }
            if (itemData.type === 'assignment') {
                itemData.color = '#D54141';
            }
            if (itemData.type === 'webinar' || itemData.type === 'module') {
                itemData.color = '#00AAA6';
            }
            item = Object.assign({}, itemData);
            newData.push(item);
            return item;
        }
    });
    newData = newData.map(item => {
        const endItemData = Object.assign({}, item);
        endItemData.text =
            format(new Date(item.endDateTime), 'hh:mm a') +
                ' ' +
                item.summary +
                ': Ends';
        endItemData.start = new Date(endItemData.endDateTime);
        endItemData.end = new Date(endItemData.endDateTime);
        if (endItemData.type === 'announcement') {
            endItemData.color = '#A42277';
        }
        if (endItemData.type === 'officeHour') {
            endItemData.color = '#0984E3';
        }
        if (endItemData.type === 'class') {
            endItemData.color = '#A42277';
        }
        if (endItemData.type === 'assignment') {
            endItemData.color = '#D54141';
        }
        if (endItemData.type === 'webinar' || endItemData.type === 'module') {
            endItemData.color = '#00AAA6';
        }
        item = Object.assign({}, endItemData);
        return endItemData;
    });
    if (newData.length > 0) {
        allEvents = allEvents.concat(newData);
    }
    if (ev === null || ev === void 0 ? void 0 : ev.calendarFilterCriteria) {
        if (((_b = ev.calendarFilterCriteria) === null || _b === void 0 ? void 0 : _b.courses.length) > 0) {
            allEvents = allEvents.filter((x) => ev.calendarFilterCriteria.courses.filter(a => Number(a.keyValue) === x.cohortId).length !== 0);
        }
        if (((_c = ev.calendarFilterCriteria) === null || _c === void 0 ? void 0 : _c.specific.length) > 0) {
            allEvents = allEvents.filter((x) => ev.calendarFilterCriteria.specific.filter(a => a.keyValue === x.type)
                .length !== 0);
        }
    }
    return allEvents;
});
const selectSearchCohortTerraLite = createSelector(selectDashboardState, (state, props) => {
    try {
        return state.cohorts.filter(co => co.cohortId === props)[0].properties
            .CohortType[0] === 'terralite'
            ? 'true'
            : 'false';
    }
    catch (e) {
        return 'false';
    }
});
const selectActiveSegmentOnCalendar = createSelector(selectEvents, state => {
    var _a;
    return (!!state && ((_a = state[0]) === null || _a === void 0 ? void 0 : _a.activeSegment)) || 'upcoming';
});
const selectEventLoaded = createSelector(selectDashboardState, state => {
    return (state && state.eventsLoaded) || false;
});
const selectAllCourses = createSelector(selectDashboardState, state => {
    return state.cohorts;
});
const getAllEventsType = createSelector(selectDashboardState, state => {
    return state && state.eventsType ? state.eventsType : [];
});
const selectCalendarFilterCriteria = createSelector(selectDashboardState, state => {
    return state.calendarFilterCriteria;
});
const dateDiffIndays = (date1, date2) => {
    const dt1 = new Date(date1);
    const dt2 = new Date(date2);
    const parsedDate2 = Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate());
    const parsedDate1 = Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate());
    return Math.floor((parsedDate2 - parsedDate1) / (1000 * 60 * 60 * 24));
};

function FilterComponent_ng_container_0_ng_container_1_ion_row_7_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "ion-item", 21);
    ɵɵelementStart(2, "ion-checkbox", 22);
    ɵɵlistener("ngModelChange", function FilterComponent_ng_container_0_ng_container_1_ion_row_7_ng_container_4_Template_ion_checkbox_ngModelChange_2_listener($event) { ɵɵrestoreView(_r14); const filter_r12 = ctx.$implicit; return filter_r12.isChecked = $event; })("ionChange", function FilterComponent_ng_container_0_ng_container_1_ion_row_7_ng_container_4_Template_ion_checkbox_ionChange_2_listener($event) { ɵɵrestoreView(_r14); const ctx_r15 = ɵɵnextContext(4); return ctx_r15.onSelect($event, "courses"); });
    ɵɵelementEnd();
    ɵɵelementStart(3, "span", 23);
    ɵɵtext(4);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const filter_r12 = ctx.$implicit;
    ɵɵadvance(2);
    ɵɵproperty("ngModel", filter_r12.isChecked)("value", filter_r12.cohortId);
    ɵɵadvance(2);
    ɵɵtextInterpolate(filter_r12.name);
} }
function FilterComponent_ng_container_0_ng_container_1_ion_row_7_ion_col_16_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-col", 24);
    ɵɵlistener("click", function FilterComponent_ng_container_0_ng_container_1_ion_row_7_ion_col_16_Template_ion_col_click_0_listener() { const al_r16 = ctx.$implicit; return al_r16.isChecked = !al_r16.isChecked; });
    ɵɵelementStart(1, "ion-checkbox", 25);
    ɵɵlistener("ngModelChange", function FilterComponent_ng_container_0_ng_container_1_ion_row_7_ion_col_16_Template_ion_checkbox_ngModelChange_1_listener($event) { ɵɵrestoreView(_r19); const al_r16 = ctx.$implicit; return al_r16.isChecked = $event; })("ionChange", function FilterComponent_ng_container_0_ng_container_1_ion_row_7_ion_col_16_Template_ion_checkbox_ionChange_1_listener($event) { ɵɵrestoreView(_r19); const ctx_r20 = ɵɵnextContext(4); return ctx_r20.onSelect($event, "courses"); })("click", function FilterComponent_ng_container_0_ng_container_1_ion_row_7_ion_col_16_Template_ion_checkbox_click_1_listener($event) { ɵɵrestoreView(_r19); return $event.stopPropagation(); });
    ɵɵelementEnd();
    ɵɵelementStart(2, "div");
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const al_r16 = ctx.$implicit;
    ɵɵclassProp("active", al_r16.isChecked);
    ɵɵadvance(1);
    ɵɵproperty("ngModel", al_r16.isChecked)("value", al_r16.cohortId);
    ɵɵadvance(2);
    ɵɵtextInterpolate(al_r16.name);
} }
function FilterComponent_ng_container_0_ng_container_1_ion_row_7_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-row");
    ɵɵelementStart(1, "span", 19);
    ɵɵtext(2, " Your courses: ");
    ɵɵelementEnd();
    ɵɵelementStart(3, "ion-col", 6);
    ɵɵtemplate(4, FilterComponent_ng_container_0_ng_container_1_ion_row_7_ng_container_4_Template, 5, 3, "ng-container", 7);
    ɵɵelementEnd();
    ɵɵelementStart(5, "ion-col", 8);
    ɵɵelementStart(6, "div", 9);
    ɵɵlistener("popoverShown", function FilterComponent_ng_container_0_ng_container_1_ion_row_7_Template_div_popoverShown_6_listener($event) { ɵɵrestoreView(_r23); const ctx_r22 = ɵɵnextContext(3); return ctx_r22.popoverShown($event); })("click", function FilterComponent_ng_container_0_ng_container_1_ion_row_7_Template_div_click_6_listener() { ɵɵrestoreView(_r23); const ctx_r24 = ɵɵnextContext(3); return ctx_r24.enableFilter(); });
    ɵɵelementStart(7, "span", 10);
    ɵɵtext(8, "Your courses");
    ɵɵelementEnd();
    ɵɵelementStart(9, "span", 11);
    ɵɵtext(10);
    ɵɵelement(11, "ion-icon", 12);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(12, "terra-popover-content", 13, 20);
    ɵɵelementStart(14, "ion-grid", 15);
    ɵɵelementStart(15, "ion-row");
    ɵɵtemplate(16, FilterComponent_ng_container_0_ng_container_1_ion_row_7_ion_col_16_Template, 4, 5, "ion-col", 16);
    ɵɵelementStart(17, "ion-col", 17);
    ɵɵelementStart(18, "ion-button", 18);
    ɵɵlistener("click", function FilterComponent_ng_container_0_ng_container_1_ion_row_7_Template_ion_button_click_18_listener() { ɵɵrestoreView(_r23); const ctx_r25 = ɵɵnextContext(3); return ctx_r25.popoverDisabled = true; });
    ɵɵelementStart(19, "span");
    ɵɵtext(20, "Done");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const _r10 = ɵɵreference(13);
    const allFilters_r1 = ɵɵnextContext(2).ngIf;
    const ctx_r4 = ɵɵnextContext();
    ɵɵadvance(4);
    ɵɵproperty("ngForOf", allFilters_r1.courses)("ngForTrackBy", ctx_r4.trackByFn);
    ɵɵadvance(2);
    ɵɵproperty("terraPopover", _r10)("popoverOnHover", false)("popoverDisabled", ctx_r4.popoverDisabled);
    ɵɵadvance(4);
    ɵɵtextInterpolate2(" ", allFilters_r1.courseSelect, " of ", allFilters_r1.courseTotal, " ");
    ɵɵadvance(2);
    ɵɵproperty("closeOnClickOutside", true);
    ɵɵadvance(4);
    ɵɵproperty("ngForOf", allFilters_r1.courses)("ngForTrackBy", ctx_r4.trackByFn);
} }
function FilterComponent_ng_container_0_ng_container_1_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 19);
    ɵɵtext(1, " Event types: ");
    ɵɵelementEnd();
} }
function FilterComponent_ng_container_0_ng_container_1_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    const _r29 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "ion-item", 21);
    ɵɵelementStart(2, "ion-checkbox", 22);
    ɵɵlistener("ngModelChange", function FilterComponent_ng_container_0_ng_container_1_ng_container_11_Template_ion_checkbox_ngModelChange_2_listener($event) { ɵɵrestoreView(_r29); const filter_r27 = ctx.$implicit; return filter_r27.isChecked = $event; })("ionChange", function FilterComponent_ng_container_0_ng_container_1_ng_container_11_Template_ion_checkbox_ionChange_2_listener($event) { ɵɵrestoreView(_r29); const ctx_r30 = ɵɵnextContext(3); return ctx_r30.onSelect($event, "specific"); });
    ɵɵelementEnd();
    ɵɵelementStart(3, "span", 23);
    ɵɵtext(4);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const filter_r27 = ctx.$implicit;
    ɵɵadvance(2);
    ɵɵproperty("ngModel", filter_r27.isChecked)("value", filter_r27.name);
    ɵɵadvance(2);
    ɵɵtextInterpolate(filter_r27.title);
} }
function FilterComponent_ng_container_0_ng_container_1_ion_col_23_Template(rf, ctx) { if (rf & 1) {
    const _r34 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-col", 24);
    ɵɵlistener("click", function FilterComponent_ng_container_0_ng_container_1_ion_col_23_Template_ion_col_click_0_listener() { const al_r31 = ctx.$implicit; return al_r31.isChecked = !al_r31.isChecked; });
    ɵɵelementStart(1, "ion-checkbox", 25);
    ɵɵlistener("ngModelChange", function FilterComponent_ng_container_0_ng_container_1_ion_col_23_Template_ion_checkbox_ngModelChange_1_listener($event) { ɵɵrestoreView(_r34); const al_r31 = ctx.$implicit; return al_r31.isChecked = $event; })("ionChange", function FilterComponent_ng_container_0_ng_container_1_ion_col_23_Template_ion_checkbox_ionChange_1_listener($event) { ɵɵrestoreView(_r34); const ctx_r35 = ɵɵnextContext(3); return ctx_r35.onSelect($event, "specific"); })("click", function FilterComponent_ng_container_0_ng_container_1_ion_col_23_Template_ion_checkbox_click_1_listener($event) { ɵɵrestoreView(_r34); return $event.stopPropagation(); });
    ɵɵelementEnd();
    ɵɵelementStart(2, "div");
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const al_r31 = ctx.$implicit;
    ɵɵclassProp("active", al_r31.isChecked);
    ɵɵadvance(1);
    ɵɵproperty("ngModel", al_r31.isChecked)("value", al_r31.name);
    ɵɵadvance(2);
    ɵɵtextInterpolate(al_r31.title);
} }
function FilterComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r38 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "ion-grid");
    ɵɵelementStart(2, "ion-row", 1);
    ɵɵelementStart(3, "ion-col", 2);
    ɵɵtext(4, " Save the dates for your Terra.do events \uD83D\uDCCC ");
    ɵɵelementEnd();
    ɵɵelementStart(5, "ion-col", 3);
    ɵɵelementStart(6, "ion-grid", 4);
    ɵɵtemplate(7, FilterComponent_ng_container_0_ng_container_1_ion_row_7_Template, 21, 10, "ion-row", 0);
    ɵɵelementStart(8, "ion-row");
    ɵɵtemplate(9, FilterComponent_ng_container_0_ng_container_1_span_9_Template, 2, 0, "span", 5);
    ɵɵelementStart(10, "ion-col", 6);
    ɵɵtemplate(11, FilterComponent_ng_container_0_ng_container_1_ng_container_11_Template, 5, 3, "ng-container", 7);
    ɵɵelementEnd();
    ɵɵelementStart(12, "ion-col", 8);
    ɵɵelementStart(13, "div", 9);
    ɵɵlistener("popoverShown", function FilterComponent_ng_container_0_ng_container_1_Template_div_popoverShown_13_listener($event) { ɵɵrestoreView(_r38); const ctx_r37 = ɵɵnextContext(2); return ctx_r37.popoverShown($event); })("click", function FilterComponent_ng_container_0_ng_container_1_Template_div_click_13_listener() { ɵɵrestoreView(_r38); const ctx_r39 = ɵɵnextContext(2); return ctx_r39.enableFilter(); });
    ɵɵelementStart(14, "span", 10);
    ɵɵtext(15, "Event types");
    ɵɵelementEnd();
    ɵɵelementStart(16, "span", 11);
    ɵɵtext(17);
    ɵɵelement(18, "ion-icon", 12);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(19, "terra-popover-content", 13, 14);
    ɵɵelementStart(21, "ion-grid", 15);
    ɵɵelementStart(22, "ion-row");
    ɵɵtemplate(23, FilterComponent_ng_container_0_ng_container_1_ion_col_23_Template, 4, 5, "ion-col", 16);
    ɵɵelementStart(24, "ion-col", 17);
    ɵɵelementStart(25, "ion-button", 18);
    ɵɵlistener("click", function FilterComponent_ng_container_0_ng_container_1_Template_ion_button_click_25_listener() { ɵɵrestoreView(_r38); const ctx_r40 = ɵɵnextContext(2); return ctx_r40.popoverDisabled = true; });
    ɵɵelementStart(26, "span");
    ɵɵtext(27, "Done");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r7 = ɵɵreference(20);
    const allFilters_r1 = ɵɵnextContext().ngIf;
    const ctx_r2 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵclassProp("filter-calendar", !ctx_r2.popup);
    ɵɵadvance(6);
    ɵɵproperty("ngIf", allFilters_r1.courses.length > 1);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", allFilters_r1.courses.length > 1);
    ɵɵadvance(2);
    ɵɵproperty("ngForOf", allFilters_r1.eventsType)("ngForTrackBy", ctx_r2.trackByFn);
    ɵɵadvance(2);
    ɵɵproperty("terraPopover", _r7)("popoverOnHover", false)("popoverDisabled", ctx_r2.popoverDisabled);
    ɵɵadvance(4);
    ɵɵtextInterpolate2(" ", allFilters_r1.eventSelect, " of ", allFilters_r1.eventTotal, " ");
    ɵɵadvance(2);
    ɵɵproperty("closeOnClickOutside", true);
    ɵɵadvance(4);
    ɵɵproperty("ngForOf", allFilters_r1.eventsType)("ngForTrackBy", ctx_r2.trackByFn);
} }
function FilterComponent_ng_container_0_ng_container_2_ng_container_9_ion_col_3_Template(rf, ctx) { if (rf & 1) {
    const _r48 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-col", 24);
    ɵɵlistener("click", function FilterComponent_ng_container_0_ng_container_2_ng_container_9_ion_col_3_Template_ion_col_click_0_listener() { const al_r45 = ctx.$implicit; return al_r45.isChecked = !al_r45.isChecked; });
    ɵɵelementStart(1, "ion-checkbox", 25);
    ɵɵlistener("ngModelChange", function FilterComponent_ng_container_0_ng_container_2_ng_container_9_ion_col_3_Template_ion_checkbox_ngModelChange_1_listener($event) { ɵɵrestoreView(_r48); const al_r45 = ctx.$implicit; return al_r45.isChecked = $event; })("ionChange", function FilterComponent_ng_container_0_ng_container_2_ng_container_9_ion_col_3_Template_ion_checkbox_ionChange_1_listener($event) { ɵɵrestoreView(_r48); const ctx_r49 = ɵɵnextContext(4); return ctx_r49.onSelect($event, "courses"); })("click", function FilterComponent_ng_container_0_ng_container_2_ng_container_9_ion_col_3_Template_ion_checkbox_click_1_listener($event) { ɵɵrestoreView(_r48); return $event.stopPropagation(); });
    ɵɵelementEnd();
    ɵɵelementStart(2, "div");
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const al_r45 = ctx.$implicit;
    ɵɵclassProp("active", al_r45.isChecked);
    ɵɵadvance(1);
    ɵɵproperty("ngModel", al_r45.isChecked)("value", al_r45.cohortId);
    ɵɵadvance(2);
    ɵɵtextInterpolate(al_r45.name);
} }
function FilterComponent_ng_container_0_ng_container_2_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "ion-col", 30);
    ɵɵtext(2, " Your courses ");
    ɵɵelementEnd();
    ɵɵtemplate(3, FilterComponent_ng_container_0_ng_container_2_ng_container_9_ion_col_3_Template, 4, 5, "ion-col", 16);
    ɵɵelementStart(4, "ion-col", 30);
    ɵɵtext(5, " Event types ");
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const allFilters_r1 = ɵɵnextContext(2).ngIf;
    const ctx_r42 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵproperty("ngForOf", allFilters_r1.courses)("ngForTrackBy", ctx_r42.trackByFn);
} }
function FilterComponent_ng_container_0_ng_container_2_ion_col_10_Template(rf, ctx) { if (rf & 1) {
    const _r55 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-col", 24);
    ɵɵlistener("click", function FilterComponent_ng_container_0_ng_container_2_ion_col_10_Template_ion_col_click_0_listener() { const al_r52 = ctx.$implicit; return al_r52.isChecked = !al_r52.isChecked; });
    ɵɵelementStart(1, "ion-checkbox", 25);
    ɵɵlistener("ngModelChange", function FilterComponent_ng_container_0_ng_container_2_ion_col_10_Template_ion_checkbox_ngModelChange_1_listener($event) { ɵɵrestoreView(_r55); const al_r52 = ctx.$implicit; return al_r52.isChecked = $event; })("ionChange", function FilterComponent_ng_container_0_ng_container_2_ion_col_10_Template_ion_checkbox_ionChange_1_listener($event) { ɵɵrestoreView(_r55); const ctx_r56 = ɵɵnextContext(3); return ctx_r56.onSelect($event, "specific"); })("click", function FilterComponent_ng_container_0_ng_container_2_ion_col_10_Template_ion_checkbox_click_1_listener($event) { ɵɵrestoreView(_r55); return $event.stopPropagation(); });
    ɵɵelementEnd();
    ɵɵelementStart(2, "div");
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const al_r52 = ctx.$implicit;
    ɵɵclassProp("active", al_r52.isChecked);
    ɵɵadvance(1);
    ɵɵproperty("ngModel", al_r52.isChecked)("value", al_r52.name);
    ɵɵadvance(2);
    ɵɵtextInterpolate(al_r52.title);
} }
function FilterComponent_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r59 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 26);
    ɵɵelementStart(2, "span");
    ɵɵtext(3, "Filter events");
    ɵɵelementEnd();
    ɵɵelementStart(4, "span");
    ɵɵelementStart(5, "ion-icon", 27);
    ɵɵlistener("click", function FilterComponent_ng_container_0_ng_container_2_Template_ion_icon_click_5_listener() { ɵɵrestoreView(_r59); const ctx_r58 = ɵɵnextContext(2); return ctx_r58.dismiss("close"); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(6, "ion-content");
    ɵɵelementStart(7, "ion-grid", 28);
    ɵɵelementStart(8, "ion-row");
    ɵɵtemplate(9, FilterComponent_ng_container_0_ng_container_2_ng_container_9_Template, 6, 2, "ng-container", 0);
    ɵɵtemplate(10, FilterComponent_ng_container_0_ng_container_2_ion_col_10_Template, 4, 5, "ion-col", 16);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(11, "ion-row");
    ɵɵelementStart(12, "ion-col", 29);
    ɵɵelementStart(13, "ion-button", 18);
    ɵɵlistener("click", function FilterComponent_ng_container_0_ng_container_2_Template_ion_button_click_13_listener() { ɵɵrestoreView(_r59); const ctx_r60 = ɵɵnextContext(2); return ctx_r60.dismiss("apply"); });
    ɵɵelementStart(14, "span");
    ɵɵtext(15, "Done");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const allFilters_r1 = ɵɵnextContext().ngIf;
    const ctx_r3 = ɵɵnextContext();
    ɵɵadvance(9);
    ɵɵproperty("ngIf", allFilters_r1.courses.length > 1);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", allFilters_r1.eventsType)("ngForTrackBy", ctx_r3.trackByFn);
} }
function FilterComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, FilterComponent_ng_container_0_ng_container_1_Template, 28, 14, "ng-container", 0);
    ɵɵtemplate(2, FilterComponent_ng_container_0_ng_container_2_Template, 16, 3, "ng-container", 0);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r0.popup);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.popup);
} }
class FilterComponent {
    constructor(modalController, store) {
        this.modalController = modalController;
        this.store = store;
        this.popup = false;
        this.filterCriteria = {
            courses: [],
            specific: [],
            isRemote: true,
        };
        this.openCourse = false;
        this.popoverDisabled = false;
    }
    ngOnInit() {
        const course = this.store.pipe(select(selectAllCourses), filter(data => !!data), map(data => {
            return data.map(item => {
                return {
                    name: item.course.name,
                    cohortId: item.cohortId,
                    isChecked: false,
                };
            });
        }));
        const eventType = of([
            // { title: 'Announcements', name: 'announcement', isChecked: false },
            { title: 'Discussion Labs', name: 'office-hours', isChecked: false },
            { title: 'Classes', name: 'class', isChecked: false },
            { title: 'Live Events', name: 'webinar', isChecked: false },
            { title: 'Assignments', name: 'assignment', isChecked: false },
        ]);
        const filterCri = this.store.pipe(select(selectCalendarFilterCriteria), map(data => {
            if (!!data) {
                return data;
            }
            else {
                return {
                    courses: [],
                    specific: [],
                    isRemote: false,
                };
            }
        }));
        this.allFilters$ = combineLatest([course, eventType, filterCri]).pipe(map(([courses, eventsType, filterCriteria]) => {
            if (!!filterCriteria) {
                if ((filterCriteria === null || filterCriteria === void 0 ? void 0 : filterCriteria.courses.length) > 0) {
                    courses = courses.map((x) => {
                        const index = filterCriteria.courses.findIndex(a => String(a.keyValue) === String(x.cohortId));
                        if (index > -1) {
                            x.isChecked = true;
                            return x;
                        }
                        else {
                            return x;
                        }
                    });
                }
                if ((filterCriteria === null || filterCriteria === void 0 ? void 0 : filterCriteria.specific.length) > 0) {
                    eventsType = eventsType.map((x) => {
                        const index = filterCriteria.specific.findIndex(a => a.keyValue === x.name);
                        if (index > -1) {
                            x.isChecked = true;
                            return x;
                        }
                        else {
                            return x;
                        }
                    });
                }
            }
            return {
                courses,
                courseTotal: courses.length,
                courseSelect: courses.filter(al => al.isChecked).length,
                eventsType,
                eventTotal: eventsType.length,
                eventSelect: eventsType.filter(al => al.isChecked).length,
            };
        }));
        // this.allFilters$.subscribe(data=>console.log("this is all filters",data))
    }
    popoverShown(ev) {
        this.popoverDisabled = false;
    }
    enableFilter() {
        this.popoverDisabled = false;
    }
    dismiss(data) {
        if (data === 'apply') {
            this.store.dispatch(filterClick({
                calendarFilterCriteria: this.filterCriteria,
            }));
        }
        if (this.modalController) {
            try {
                this.modalController.dismiss(this.filterCriteria);
            }
            catch (x) {
                // on non-modal (desktop)
            }
        }
    }
    onSelect(ev, item) {
        if (ev.detail.checked) {
            const filterCriteria = Object.assign({}, this.filterCriteria);
            if (filterCriteria[item].filter(el => el.keyValue === ev.detail.value)
                .length === 0) {
                filterCriteria[item] = [
                    ...filterCriteria[item],
                    { keyValue: ev.detail.value, isChecked: true },
                ];
                this.filterCriteria = Object.assign({}, filterCriteria);
            }
        }
        else {
            const filterCriteria = Object.assign({}, this.filterCriteria);
            filterCriteria[item] = filterCriteria[item].filter(el => el.keyValue !== ev.detail.value);
            this.filterCriteria = Object.assign({}, filterCriteria);
        }
        if (!this.popup) {
            this.store.dispatch(filterClick({
                calendarFilterCriteria: this.filterCriteria,
            }));
        }
    }
    trackByFn(index, item) {
        return item.id;
    }
}
FilterComponent.ɵfac = function FilterComponent_Factory(t) { return new (t || FilterComponent)(ɵɵdirectiveInject(ModalController), ɵɵdirectiveInject(Store)); };
FilterComponent.ɵcmp = ɵɵdefineComponent({ type: FilterComponent, selectors: [["terra-calendar-filter-component"]], inputs: { popup: "popup", filter: "filter" }, decls: 2, vars: 3, consts: [[4, "ngIf"], [1, "filter-option"], ["size", "12", 1, "option-title", "montserrat"], ["size", "12"], [1, "mobile-screen"], ["class", "sub-title", 4, "ngIf"], ["size", "12", 1, "checkBox", "filter-up"], [4, "ngFor", "ngForOf", "ngForTrackBy"], ["size", "12", 1, "checkBox", "filter-down"], ["popoverPlacement", "bottom", 1, "event-types", 3, "terraPopover", "popoverOnHover", "popoverDisabled", "popoverShown", "click"], [1, "filter-main-title"], [1, "filter-sub-title"], ["src", "/assets/fi_chevrons-down.svg"], [3, "closeOnClickOutside"], ["eventTypes", ""], [1, "eventTypes"], ["size", "12", "class", "selector cursor", 3, "active", "click", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["size", "12", 1, "main-title", "top", "p16"], [1, "btn-yellow-small", 3, "click"], [1, "sub-title"], ["yourCourses", ""], ["lines", "none", 1, "filter-items"], ["color", "primary", 3, "ngModel", "value", "ngModelChange", "ionChange"], [1, "chekbox-text"], ["size", "12", 1, "selector", "cursor", 3, "click"], [3, "ngModel", "value", "ngModelChange", "ionChange", "click"], [1, "mobile-first-title"], ["name", "close-outline", 1, "close-outline", 3, "click"], [1, "eventTypes", "popups"], ["size", "12", 1, "last-done"], ["size", "12", 1, "popup-title"]], template: function FilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, FilterComponent_ng_container_0_Template, 3, 2, "ng-container", 0);
        ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵɵproperty("ngIf", ɵɵpipeBind1(1, 1, ctx.allFilters$));
    } }, directives: [NgIf, NgForOf], pipes: [AsyncPipe], styles: [".filter-calendar[_ngcontent-%COMP%], .filter-calendar[_ngcontent-%COMP%]   ion-col[_ngcontent-%COMP%], .filter-calendar[_ngcontent-%COMP%]   ion-grid[_ngcontent-%COMP%]{padding:0}.filter-calendar[_ngcontent-%COMP%]   .filter-option[_ngcontent-%COMP%]{background:#f0f6ff;border:1px solid #adc8ec;border-radius:4px;box-sizing:border-box;padding:20px 20px 10px}.filter-calendar[_ngcontent-%COMP%]   .filter-option[_ngcontent-%COMP%]   .option-title[_ngcontent-%COMP%]{color:#000;font-size:20px;font-weight:500;line-height:130%;padding-bottom:10px}.filter-calendar[_ngcontent-%COMP%]   .filter-option[_ngcontent-%COMP%]   .checkBox[_ngcontent-%COMP%]{display:contents}.filter-calendar[_ngcontent-%COMP%]   .filter-option[_ngcontent-%COMP%]   .filter-items[_ngcontent-%COMP%]{--background:#fff;--border-color:#bababa;--border-radius:4px;--border-style:solid;--border-width:1px;--color:#000;--detail-icon-color:#3b3b3b;--inner-padding-end:0;--ion-color-primary:#000;--min-height:0;--padding-bottom:0;--padding-end:0;--padding-start:0;--padding-top:0;font-size:16px;line-height:150%;margin-bottom:10px;margin-right:20px;margin-top:10px}.filter-calendar[_ngcontent-%COMP%]   .filter-option[_ngcontent-%COMP%]   .filter-items[_ngcontent-%COMP%]:last-child{padding-right:0}.filter-calendar[_ngcontent-%COMP%]   .filter-option[_ngcontent-%COMP%]   .filter-items[_ngcontent-%COMP%]   ion-checkbox[_ngcontent-%COMP%]{margin:12px 0 12px 12px}.filter-calendar[_ngcontent-%COMP%]   .filter-option[_ngcontent-%COMP%]   .filter-items[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{margin-right:12px}.filter-calendar[_ngcontent-%COMP%]   .main-title[_ngcontent-%COMP%]{color:#000;font-size:20px;font-weight:500;line-height:130%;padding-bottom:30px}.filter-calendar[_ngcontent-%COMP%]   .mb15[_ngcontent-%COMP%]{display:contents}.filter-calendar[_ngcontent-%COMP%]   .divider[_ngcontent-%COMP%]{margin-bottom:15px;margin-top:15px}.filter-calendar[_ngcontent-%COMP%]   ion-item[_ngcontent-%COMP%]{--background:#f2f2f2;padding:0}.filter-calendar[_ngcontent-%COMP%]   ion-checkbox[_ngcontent-%COMP%]{margin:0}.filter-calendar[_ngcontent-%COMP%]   .pad0[_ngcontent-%COMP%]{padding:0}.filter-calendar[_ngcontent-%COMP%]   .chekbox-text[_ngcontent-%COMP%]{color:var(--ion-color-primary);padding-left:9px}.filter-calendar[_ngcontent-%COMP%]   .checkBox[_ngcontent-%COMP%]{color:#0455bf;font-size:16px;line-height:150%}.btn-white-small[_ngcontent-%COMP%]{text-transform:none!important}.mobile-first-title[_ngcontent-%COMP%]{color:#000;display:flex;font-size:16px;font-weight:700;justify-content:space-between;line-height:140%;padding:20px 20px 16px 30px!important}.filter-popup-calendar[_ngcontent-%COMP%]{padding:0}.filter-popup-calendar[_ngcontent-%COMP%]   .scroll[_ngcontent-%COMP%]{overflow-y:auto}.filter-popup-calendar[_ngcontent-%COMP%]   .main-title[_ngcontent-%COMP%]{color:#1f1f1f;font-size:16px;font-weight:700;line-height:140%}.filter-popup-calendar[_ngcontent-%COMP%]   .padding-top-30[_ngcontent-%COMP%]{padding-top:30px}.filter-popup-calendar[_ngcontent-%COMP%]   .close-outline[_ngcontent-%COMP%]{color:#1f1f1f;font-size:25px}.filter-popup-calendar[_ngcontent-%COMP%]   .mobile-first-option[_ngcontent-%COMP%]{padding-left:25px}.filter-popup-calendar[_ngcontent-%COMP%]   .mobile-first-option.pb0[_ngcontent-%COMP%]{padding-bottom:0}.filter-popup-calendar[_ngcontent-%COMP%]   .pl30[_ngcontent-%COMP%]{padding-left:30px}.filter-popup-calendar[_ngcontent-%COMP%]   .pb20[_ngcontent-%COMP%]{padding-bottom:20px}.filter-popup-calendar[_ngcontent-%COMP%]   ion-item[_ngcontent-%COMP%]{padding:0}.filter-popup-calendar[_ngcontent-%COMP%]   ion-checkbox[_ngcontent-%COMP%]{margin:0}.filter-popup-calendar[_ngcontent-%COMP%]   .pad0[_ngcontent-%COMP%]{padding:0}.filter-popup-calendar[_ngcontent-%COMP%]   .chekbox-text[_ngcontent-%COMP%]{color:var(--ion-color-primary);padding-left:9px}.filter-popup-calendar[_ngcontent-%COMP%]   .checkBox[_ngcontent-%COMP%]{color:#0455bf;font-size:16px;line-height:150%}.filter-popup-calendar[_ngcontent-%COMP%]   .btn-white-small[_ngcontent-%COMP%]{--background:transparent;margin:0 0 0 30px;width:calc(100% - 60px)}.overflow-scroll[_ngcontent-%COMP%]{overflow:scroll}.center[_ngcontent-%COMP%]{text-align:center}@media (max-width:575.98px){ion-header[_ngcontent-%COMP%]{height:58px!important}.mobile-first-title[_ngcontent-%COMP%]{border-bottom:1px solid #efefef;font-weight:700}}.filter-up[_ngcontent-%COMP%]{display:contents!important}.filter-down[_ngcontent-%COMP%]{display:none!important}@media (max-width:768px) and (min-width:576px){.filter-up[_ngcontent-%COMP%]{display:none!important}.filter-down[_ngcontent-%COMP%]{display:block!important}.event-types[_ngcontent-%COMP%]{background:#fff;border:1px solid #bababa;border-radius:4px;box-sizing:border-box;display:flex;justify-content:space-between;padding:12px!important}.event-types[_ngcontent-%COMP%]   .filter-main-title[_ngcontent-%COMP%]{color:#000;font-size:16px;line-height:150%}.event-types[_ngcontent-%COMP%]   .filter-sub-title[_ngcontent-%COMP%]{color:#797979;font-size:16px;font-style:italic;font-weight:400;line-height:150%;padding-right:4px}.event-types[_ngcontent-%COMP%]   .filter-sub-title[_ngcontent-%COMP%]   ion-icon[_ngcontent-%COMP%]{font-size:24px;vertical-align:bottom}}.sub-title[_ngcontent-%COMP%]{color:#000;font-size:16px;line-height:150%;margin-bottom:20px;margin-right:20px;margin-top:21px}@media (max-width:768px){.eventTypes[_ngcontent-%COMP%]{background:#fff;left:0;position:absolute;top:48px;z-index:5}.eventTypes[_ngcontent-%COMP%]   ion-row[_ngcontent-%COMP%]   ion-col[_ngcontent-%COMP%]{color:#000;font-size:16px;line-height:150%;padding:10px 20px}.eventTypes[_ngcontent-%COMP%]   ion-row[_ngcontent-%COMP%]   ion-col.active[_ngcontent-%COMP%]{background:#ebfaf0}.eventTypes[_ngcontent-%COMP%]   ion-row[_ngcontent-%COMP%]   ion-col[_ngcontent-%COMP%]   ion-checkbox[_ngcontent-%COMP%]{--color:#000;--detail-icon-color:#3b3b3b;--ion-color-primary:#000;margin-right:20px;vertical-align:text-bottom}.sub-title[_ngcontent-%COMP%]{display:none}.mobile-screen[_ngcontent-%COMP%]{display:flex;justify-content:space-between}.mobile-screen[_ngcontent-%COMP%] > ion-row[_ngcontent-%COMP%]{padding-right:20px;width:100%}.mobile-screen[_ngcontent-%COMP%] > ion-row[_ngcontent-%COMP%]:last-child{padding-right:0}.selector[_ngcontent-%COMP%]{position:relative}.selector[_ngcontent-%COMP%]   ion-checkbox[_ngcontent-%COMP%]{position:absolute;top:15px}.selector[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{margin-left:38px}}@media (max-width:768px) and (min-width:576px){.eventTypes[_ngcontent-%COMP%]{border:1px solid #bababa;border-top-color:#efefef}.eventTypes[_ngcontent-%COMP%]   ion-row[_ngcontent-%COMP%]   ion-col[_ngcontent-%COMP%]:last-child{border-top:1px solid #efefef}}@media (max-width:575.98px){.eventTypes[_ngcontent-%COMP%]{padding:0;top:0}.last-done[_ngcontent-%COMP%]{padding:20px}.last-done[_ngcontent-%COMP%]   ion-button[_ngcontent-%COMP%]{width:100%}.popups[_ngcontent-%COMP%]   ion-row[_ngcontent-%COMP%]   ion-col[_ngcontent-%COMP%]{padding-left:30px}.popups[_ngcontent-%COMP%]   ion-row[_ngcontent-%COMP%]   .popup-title[_ngcontent-%COMP%]{color:#000;font-size:16px;font-style:italic;font-weight:400;line-height:140%}}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FilterComponent, [{
        type: Component,
        args: [{
                selector: 'terra-calendar-filter-component',
                templateUrl: './filter-component.component.html',
                styleUrls: ['./filter-component.component.scss']
            }]
    }], function () { return [{ type: ModalController }, { type: Store }]; }, { popup: [{
            type: Input
        }], filter: [{
            type: Input
        }] }); })();

class TerraVyasService {
    // cohortUrl = 'https://cohort.terra.do/cohort';
    constructor(auth, http, router, 
    // public terraCohortsService: TerraCohortsService,
    // public featureToggleLibService: FeatureToggleLibService,
    messagesService) {
        this.auth = auth;
        this.http = http;
        this.router = router;
        this.messagesService = messagesService;
        this.cohortUrl = 'https://terra-api.terra.do/dev/cohortdev';
    }
    loadClassesForCohort(token, cohortId) {
        return this.http
            .get(this.cohortUrl + `/${cohortId}/module/classes`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .pipe(shareReplay());
    }
    openZoomLinkLog(ev, redirectTo = '_blank') {
        this.logCalEventClick(ev.eventId, ev.summary, 'calendar_event_zoom_click', 'calendar');
        window.open(ev.zoomLink, redirectTo);
    }
    logCalEventClick(eventId, eventName, eventType, from) {
        const pageViewEvent = {};
        pageViewEvent.type = eventType;
        pageViewEvent.event = -1;
        pageViewEvent.eventId = eventId;
        pageViewEvent.name = eventName;
        pageViewEvent.from = from;
        combineLatest([this.auth.profileDetail$, this.auth.user$])
            .pipe(first(), map(([profileDetail, userFire]) => {
            if (profileDetail != null && userFire != null) {
                pageViewEvent.profileId = profileDetail === null || profileDetail === void 0 ? void 0 : profileDetail.id;
                this.logUserAction(pageViewEvent);
            }
            else {
            }
        }))
            .subscribe();
    }
    logUserAction(pageViewEvent) {
        pageViewEvent.app = 'Learn';
        //console.log(pageViewEvent);
        this.auth.logAuthUserAction(pageViewEvent);
    }
    openRecordingLink(ev, redirectTo = '_blank') {
        if (ev.recordingLink) {
            this.logCalEventClick(ev.eventId, ev.summary, 'calendar_event_recording_click', 'calendar');
            window.open(ev.recordingLink, redirectTo);
        }
    }
    replaceHtml(eventData) {
        if (eventData === null || eventData === void 0 ? void 0 : eventData.description) {
            let index = eventData.description.indexOf('Live');
            let str = eventData.description;
            if (index) {
                var b = str.replace(/(?:https?|ftp):\/\/[\n\S]+/g, '');
                b = b.replace('Live:', '');
                str = b;
            }
            let indexrec = eventData.description.indexOf('Recording');
            if (indexrec) {
                var b = str.replace(/(?:https?|ftp):\/\/[\n\S]+/g, '');
                b = b.replace('Recording:', '');
                str = b;
            }
            const zoomLink = `https://${window.location.hostname}/#/join/course-event/${eventData.eventId}`;
            const eventdesc = str
                .replace(/(?:\r\n|\r|\n)/g, '<br>')
                .replace(/(?:\\r\\n|\\r|\\n)/g, '<br>')
                .replace(/\\\"/g, '"')
                .replace(/\\"/g, '"')
                .replace(/\"/g, '"')
                .replace(/\\\'/g, "'")
                .replace(/\\'/g, "'")
                .replace(/(<br>)+/g, '<br>')
                .replace('\nLive: ' + zoomLink, '')
                .replace('\n' + zoomLink, '')
                .replace('<br>Live: ' + zoomLink, '')
                .replace('<br>' + zoomLink, '');
            return eventdesc;
        }
        else {
            return eventData === null || eventData === void 0 ? void 0 : eventData.description;
        }
    }
    openZoomLink(ev) {
        console.log('i am in terra vyas service', ev);
        if (isAfter$1(new Date(), new Date(ev.endDateTime))) {
            this.messagesService.showMsg({
                icon: 'checkmark-circle-outline',
                title1: 'Error!',
                title2: 'Event completed',
            });
            this.openRecordingLink(ev);
        }
        else if (!ev.zoomLink) {
            if (ev === null || ev === void 0 ? void 0 : ev.classId.includes('https://')) {
                window.open(ev.classId, '_blank');
            }
            else {
                window.open(`https://my.terra.do/class/${ev.classId}`, '_blank');
            }
        }
        else if (ev) {
            // // this.router.navigateByUrl(`/join/course-event/${ev.eventId}`)
            // const url = this.router.serializeUrl(
            // 	this.router.createUrlTree([`/join/course-event/${ev.eventId}`]),
            // );
            // // url = '/#' + url;
            // this.router.navigate([url]);
            window.open('/#/join/course-event/' + ev.eventId, '_blank');
        }
    }
    getFullCohortsDetailsByEmail(id, email, accessToken) {
        if (id) {
            console.log(' i am here', this.cohortUrl);
            let testurl = this.cohortUrl + `/${id}/events`;
            return this.http
                .get(testurl, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + accessToken,
                }),
            })
                .pipe(shareReplay());
        }
        else {
            let url = this.cohortUrl + `/student/${email}/allCohorts`;
            return this.http
                .get(url, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + accessToken,
                }),
            })
                .pipe(shareReplay());
        }
    }
}
TerraVyasService.ɵfac = function TerraVyasService_Factory(t) { return new (t || TerraVyasService)(ɵɵinject(AuthStoreService), ɵɵinject(HttpClient), ɵɵinject(Router), ɵɵinject(MessagesService)); };
TerraVyasService.ɵprov = ɵɵdefineInjectable({ token: TerraVyasService, factory: TerraVyasService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TerraVyasService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: AuthStoreService }, { type: HttpClient }, { type: Router }, { type: MessagesService }]; }, null); })();

const _c0$7 = ["fileInp"];
function ManageCalendarEventComponent_ion_button_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-button", 51);
    ɵɵelementStart(1, "span", 52);
    ɵɵtext(2, " Publish ");
    ɵɵelementEnd();
    ɵɵelementStart(3, "span", 53);
    ɵɵtext(4, " Publish event");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵproperty("disabled", !ctx_r0.createEvent.valid);
} }
function ManageCalendarEventComponent_ion_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-button", 54);
    ɵɵlistener("click", function ManageCalendarEventComponent_ion_button_10_Template_ion_button_click_0_listener() { ɵɵrestoreView(_r23); const ctx_r22 = ɵɵnextContext(); return ctx_r22.confirmDelete(); });
    ɵɵelementStart(1, "span");
    ɵɵtext(2, " Delete ");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function ManageCalendarEventComponent_ion_button_11_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-button", 55);
    ɵɵelementStart(1, "span", 52);
    ɵɵtext(2, " Update ");
    ɵɵelementEnd();
    ɵɵelementStart(3, "span", 53);
    ɵɵtext(4, " Update event ");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵproperty("disabled", !ctx_r2.createEvent.valid);
} }
function ManageCalendarEventComponent_ng_container_21_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 57);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r25 = ɵɵnextContext(2);
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", ctx_r25.courseName, " ");
} }
function ManageCalendarEventComponent_ng_container_21_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "ng-select", 56);
    ɵɵlistener("change", function ManageCalendarEventComponent_ng_container_21_Template_ng_select_change_1_listener($event) { ɵɵrestoreView(_r27); const ctx_r26 = ɵɵnextContext(); return ctx_r26.changeCohort($event); });
    ɵɵelementEnd();
    ɵɵtemplate(2, ManageCalendarEventComponent_ng_container_21_ng_container_2_Template, 3, 1, "ng-container", 14);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngClass", ctx_r3.isCreate == "update" ? "hide" : "ww")("items", ctx_r3.tempCohortList);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r3.isCreate == "update");
} }
function ManageCalendarEventComponent_div_51_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 58);
    ɵɵtext(1, " Please enter valid date. ");
    ɵɵelementEnd();
} }
function ManageCalendarEventComponent_ion_row_57_Template(rf, ctx) { if (rf & 1) {
    const _r29 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-row");
    ɵɵelementStart(1, "ion-col", 15);
    ɵɵelementStart(2, "ion-label", 12);
    ɵɵtext(3, "Event link");
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", 59);
    ɵɵlistener("click", function ManageCalendarEventComponent_ion_row_57_Template_div_click_4_listener() { ɵɵrestoreView(_r29); const ctx_r28 = ɵɵnextContext(); return ctx_r28.copyToClipboard(ctx_r28.createEvent.value.eventLink); });
    ɵɵtext(5);
    ɵɵelement(6, "ion-icon", 60);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵɵnextContext();
    ɵɵadvance(5);
    ɵɵtextInterpolate1(" ", ctx_r5.createEvent.value.eventLink, " ");
} }
function ManageCalendarEventComponent_cl_image_70_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "cl-image", 61);
} if (rf & 2) {
    const ctx_r6 = ɵɵnextContext();
    ɵɵproperty("public-id", ctx_r6.createEvent.value.image);
} }
function ManageCalendarEventComponent_img_71_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 62);
} }
function ManageCalendarEventComponent_cl_image_79_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "cl-image", 63);
} if (rf & 2) {
    const ctx_r9 = ɵɵnextContext();
    ɵɵproperty("public-id", ctx_r9.createEvent.value.image);
} }
function ManageCalendarEventComponent_img_80_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 62);
} }
function ManageCalendarEventComponent_ion_col_94_Template(rf, ctx) { if (rf & 1) {
    const _r31 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-col", 64);
    ɵɵelementStart(1, "div", 65);
    ɵɵlistener("click", function ManageCalendarEventComponent_ion_col_94_Template_div_click_1_listener() { ɵɵrestoreView(_r31); const ctx_r30 = ɵɵnextContext(); return ctx_r30.changeRadioValue("cohortCal"); });
    ɵɵelementStart(2, "div", 66);
    ɵɵtext(3, "Your cohort");
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", 67);
    ɵɵelement(5, "img", 68);
    ɵɵtext(6, " All members ");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵclassProp("active", ctx_r12.createEvent.getRawValue().calendarType == "cohortCal");
} }
function ManageCalendarEventComponent_ion_col_95_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-col", 64);
    ɵɵelementStart(1, "div", 65);
    ɵɵlistener("click", function ManageCalendarEventComponent_ion_col_95_Template_div_click_1_listener() { ɵɵrestoreView(_r33); const ctx_r32 = ɵɵnextContext(); return ctx_r32.changeRadioValue("groupCal"); });
    ɵɵelementStart(2, "div", 66);
    ɵɵtext(3, "Group");
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", 67);
    ɵɵelement(5, "img", 69);
    ɵɵtext(6, " A close-knit setting ");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵclassProp("active", ctx_r13.createEvent.getRawValue().calendarType == "groupCal");
} }
function ManageCalendarEventComponent_ion_col_97_Template(rf, ctx) { if (rf & 1) {
    const _r35 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-col", 70);
    ɵɵelementStart(1, "div", 65);
    ɵɵlistener("click", function ManageCalendarEventComponent_ion_col_97_Template_div_click_1_listener() { ɵɵrestoreView(_r35); const ctx_r34 = ɵɵnextContext(); return ctx_r34.changeRadioValue("cohortCal"); });
    ɵɵelementStart(2, "div", 67);
    ɵɵelementStart(3, "div");
    ɵɵelement(4, "img", 71);
    ɵɵelementStart(5, "div", 66);
    ɵɵtext(6, "Your cohort");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(7, "div");
    ɵɵtext(8, "All members");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵclassProp("active", ctx_r14.createEvent.getRawValue().calendarType == "cohortCal");
} }
function ManageCalendarEventComponent_ion_col_98_Template(rf, ctx) { if (rf & 1) {
    const _r37 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-col", 70);
    ɵɵelementStart(1, "div", 65);
    ɵɵlistener("click", function ManageCalendarEventComponent_ion_col_98_Template_div_click_1_listener() { ɵɵrestoreView(_r37); const ctx_r36 = ɵɵnextContext(); return ctx_r36.changeRadioValue("groupCal"); });
    ɵɵelementStart(2, "div", 67);
    ɵɵelementStart(3, "div");
    ɵɵelement(4, "img", 72);
    ɵɵelementStart(5, "div", 66);
    ɵɵtext(6, "Group");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(7, "div");
    ɵɵtext(8);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵclassProp("active", ctx_r15.createEvent.getRawValue().calendarType == "groupCal");
    ɵɵadvance(7);
    ɵɵtextInterpolate1("A close-knit setting ", ctx_r15.calendarGroups.length, "");
} }
function ManageCalendarEventComponent_ion_row_99_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 57);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r38 = ɵɵnextContext(2);
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", ctx_r38.groupName, " ");
} }
function ManageCalendarEventComponent_ion_row_99_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-row");
    ɵɵelementStart(1, "ion-col", 73);
    ɵɵelementStart(2, "ion-label", 12);
    ɵɵtext(3, "Groups");
    ɵɵelementEnd();
    ɵɵelementStart(4, "span", 13);
    ɵɵtext(5, "*");
    ɵɵelementEnd();
    ɵɵelement(6, "ng-select", 74);
    ɵɵtemplate(7, ManageCalendarEventComponent_ion_row_99_ng_container_7_Template, 3, 1, "ng-container", 14);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = ɵɵnextContext();
    ɵɵadvance(6);
    ɵɵproperty("ngClass", ctx_r16.isCreate == "update" ? "hide" : "ww")("items", ctx_r16.calendarGroups);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r16.isCreate == "update");
} }
function ManageCalendarEventComponent_ng_container_107_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 57);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r17 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", ctx_r17.createEvent.getRawValue().type, " ");
} }
function ManageCalendarEventComponent_ng_container_113_ion_col_5_Template(rf, ctx) { if (rf & 1) {
    const _r41 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-col", 78);
    ɵɵelementStart(1, "ion-label", 12);
    ɵɵtext(2, "Module Id");
    ɵɵelementEnd();
    ɵɵelementStart(3, "ng-select", 79);
    ɵɵlistener("change", function ManageCalendarEventComponent_ng_container_113_ion_col_5_Template_ng_select_change_3_listener($event) { ɵɵrestoreView(_r41); const ctx_r40 = ɵɵnextContext(2); return ctx_r40.changeWeekType($event); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r39 = ɵɵnextContext(2);
    ɵɵadvance(3);
    ɵɵproperty("items", ctx_r39.classList);
} }
function ManageCalendarEventComponent_ng_container_113_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "ion-col", 75);
    ɵɵelementStart(2, "ion-label", 12);
    ɵɵtext(3, "Class");
    ɵɵelementEnd();
    ɵɵelement(4, "ion-input", 76);
    ɵɵelementEnd();
    ɵɵtemplate(5, ManageCalendarEventComponent_ng_container_113_ion_col_5_Template, 4, 1, "ion-col", 77);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r18 = ɵɵnextContext();
    ɵɵadvance(5);
    ɵɵproperty("ngIf", ctx_r18.isCreate != "update");
} }
function ManageCalendarEventComponent_ion_col_114_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-col", 73);
    ɵɵelementStart(1, "ion-label", 12);
    ɵɵtext(2, "Announcement type ");
    ɵɵelementEnd();
    ɵɵelementStart(3, "span", 13);
    ɵɵtext(4, "*");
    ɵɵelementEnd();
    ɵɵelement(5, "ng-select", 80);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = ɵɵnextContext();
    ɵɵadvance(5);
    ɵɵproperty("items", ctx_r19.announcementType);
} }
function ManageCalendarEventComponent_ion_row_115_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-row");
    ɵɵelementStart(1, "ion-col", 81);
    ɵɵelementStart(2, "ion-label", 12);
    ɵɵtext(3, "Announcement action ");
    ɵɵelementEnd();
    ɵɵelementStart(4, "span", 13);
    ɵɵtext(5, "*");
    ɵɵelementEnd();
    ɵɵelement(6, "ion-input", 82);
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function ManageCalendarEventComponent_ion_row_116_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-row");
    ɵɵelementStart(1, "ion-col", 81);
    ɵɵelementStart(2, "ion-label", 12);
    ɵɵtext(3, "Assignment link ");
    ɵɵelementEnd();
    ɵɵelement(4, "ion-input", 83);
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
const _c1$3 = function () { return ["calendar", "time"]; };
class ManageCalendarEventComponent {
    constructor(modalController, formBuilder, store, cloudinary, zone, alertCtrl, terraCohortsService, message) {
        this.modalController = modalController;
        this.formBuilder = formBuilder;
        this.store = store;
        this.cloudinary = cloudinary;
        this.zone = zone;
        this.alertCtrl = alertCtrl;
        this.terraCohortsService = terraCohortsService;
        this.message = message;
        this.isCreate = '';
        this.cohortCal = '';
        this.hasBaseDropZoneOver = false;
        this.userEmail = '';
        this.calendarGroups = [];
        this.groupName = '';
        this.classList = [];
        this.selectCohorts$ = this.store.pipe(select(selectAllCourses));
        //url = "https://app-dev.terra.do/join/course-event/"
        this.url = 'https://app.terra.do/join/course-event/';
        this.eventList = [
            // { id: 1, title: 'Class', name: 'class' },
            // { id: 2, title: 'Assignment', name: 'assignment' },
            { id: 3, title: 'Live events', name: 'webinar' },
            { id: 4, title: 'Announcement', name: 'announcement' },
            { id: 5, title: 'Discussion labs', name: 'office-hours' },
        ].sort((a, b) => {
            if (a.title < b.title) {
                return -1;
            }
            if (a.title > b.title) {
                return 1;
            }
            return 0;
        });
        this.announcementType = [
            { id: 1, name: 's1_1' },
            { id: 2, name: 'feedback' },
            { id: 3, name: 'fireside_chats' },
            { id: 4, name: 'mentorship' },
            { id: 5, name: 'special_events' },
            { id: 6, name: 'survey' },
            { id: 7, name: 'testimonial' },
            { id: 8, name: 'guide' },
            { id: 9, name: 'slack_invite' },
            { id: 10, name: 'calendar' },
            { id: 11, name: 'general' },
        ].sort((a, b) => {
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
            return 0;
        });
        this.responses = [];
        this.createEvent = this.formBuilder.group({
            summary: ['', Validators.required],
            cohortId: [null, Validators.required],
            description: [''],
            type: [null, Validators.required],
            image: [''],
            website: [null],
            zoomLink: [null],
            slackHandle: [''],
            startDateTime: [null, Validators.required],
            endDateTime: [null, Validators.required],
            announcementType: [null],
            announcementAction: [null],
            recordingLink: [null],
            id: [null],
            calendarType: ['', Validators.required],
            eventId: [''],
            eventLink: [''],
            groupCalId: [null],
            cohortCalId: [null],
            calendarId: [null],
            isLocked: [true],
            moduleId: [null],
            mandatory: [false]
        });
    }
    onChange(ev) {
        if (ev) {
            this.maxDate = this.toDatetimeLocal(new Date(ev.value));
            if (isAfter$1(new Date(ev.value), new Date(this.createEvent.get('endDateTime').value))) {
                this.createEvent
                    .get('endDateTime')
                    .setValue(addHours(new Date(ev.value), 1));
            }
        }
    }
    ngOnInit() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        console.log('event data', this.eventData);
        this.selectCohorts$.subscribe(data => {
            console.log('###############', data);
            if (data) {
                this.cohortsFromInput = data;
            }
        });
        this.setEventTypeValidators();
        this.setCalTypeValidators();
        console.log('this is cohort list', this.cohortsFromInput);
        this.cohorts$ = this.manageCohorts(this.cohortsFromInput, this.userFromInput);
        const uploaderOptions = {
            url: `https://api.cloudinary.com/v1_1/${this.cloudinary.config().cloud_name}/upload`,
            autoUpload: true,
            isHTML5: true,
            removeAfterUpload: true,
            headers: [
                {
                    name: 'X-Requested-With',
                    value: 'XMLHttpRequest',
                },
            ],
        };
        this.uploader = new FileUploader(uploaderOptions);
        this.uploader.onBuildItemForm = (fileItem, form) => {
            form.append('upload_preset', 'koitppzh');
            form.append('folder', 'Events');
            form.append('file', fileItem);
            fileItem.withCredentials = false;
            return { fileItem, form };
        };
        this.uploader.onCompleteItem = (item, response, status, headers) => {
            if (status === 200) {
                const res = JSON.parse(response);
                this.createEvent.get('image').setValue(res.public_id);
            }
        };
        if (this.isCreate === 'update') {
            this.createEvent.get('summary').setValue((_a = this.eventData) === null || _a === void 0 ? void 0 : _a.summary);
            this.createEvent.get('description').setValue((_b = this.eventData) === null || _b === void 0 ? void 0 : _b.description);
            this.createEvent.get('type').setValue((_c = this.eventData) === null || _c === void 0 ? void 0 : _c.type);
            this.createEvent.get('zoomLink').setValue((_d = this.eventData) === null || _d === void 0 ? void 0 : _d.zoomLink);
            this.createEvent.get('mandatory').setValue(!((_e = this.eventData) === null || _e === void 0 ? void 0 : _e.mandatory));
            if ((_f = this.eventData) === null || _f === void 0 ? void 0 : _f.zoomLink) {
                this.createEvent
                    .get('eventLink')
                    .setValue(this.url + this.eventData.eventId);
            }
            if (((_g = this.eventData) === null || _g === void 0 ? void 0 : _g.description) && ((_h = this.eventData) === null || _h === void 0 ? void 0 : _h.zoomLink)) {
                const isEventLink = this.eventData.description.includes(this.createEvent.get('eventLink').value);
                if (isEventLink) {
                    this.createEvent.get('description').setValue(this.createEvent
                        .get('description')
                        .value.replace('\nLive: ' + this.createEvent.get('eventLink').value, '')
                        .replace(this.createEvent.get('eventLink').value, ''));
                }
            }
            this.createEvent
                .get('recordingLink')
                .setValue((_j = this.eventData) === null || _j === void 0 ? void 0 : _j.recordingLink);
            this.createEvent.get('website').setValue((_k = this.eventData) === null || _k === void 0 ? void 0 : _k.website);
            this.createEvent.get('id').setValue((_l = this.eventData) === null || _l === void 0 ? void 0 : _l.id);
            this.createEvent
                .get('announcementType')
                .setValue((_m = this.eventData) === null || _m === void 0 ? void 0 : _m.announcementType);
            this.createEvent
                .get('announcementAction')
                .setValue((_o = this.eventData) === null || _o === void 0 ? void 0 : _o.announcementAction);
            this.createEvent.get('slackHandle').setValue((_p = this.eventData) === null || _p === void 0 ? void 0 : _p.slackHandle);
            this.createEvent.get('isLocked').setValue((_q = this.eventData) === null || _q === void 0 ? void 0 : _q.isLocked);
            this.createEvent.get('cohortId').setValue((_r = this.eventData) === null || _r === void 0 ? void 0 : _r.cohortId);
            this.createEvent.get('image').setValue((_s = this.eventData) === null || _s === void 0 ? void 0 : _s.image);
            this.createEvent
                .get('startDateTime')
                .setValue(this.toDatetimeLocal(new Date((_t = this.eventData) === null || _t === void 0 ? void 0 : _t.startDateTime)));
            this.createEvent
                .get('endDateTime')
                .setValue(this.toDatetimeLocal(new Date((_u = this.eventData) === null || _u === void 0 ? void 0 : _u.endDateTime)));
            this.createEvent.get('eventId').setValue((_v = this.eventData) === null || _v === void 0 ? void 0 : _v.eventId);
            this.cohorts$.subscribe(data => {
                let userEmail = this.userFromInput.email
                    ? this.userFromInput.email
                    : '';
                console.log('i am data terra ui', data, this.isAdmin);
                data = data
                    .map(el => {
                    const elData = Object.assign({}, el);
                    const startDate = format$1(new Date(elData.startTime), 'MMM yyyy');
                    elData.name = `[${elData.cohortId}] ${startDate} ${elData.course.name} `;
                    return elData;
                })
                    .filter(item => {
                    if ((!!item.editors && item.editors.split(',').includes(userEmail)) ||
                        this.isAdmin) {
                        return true;
                    }
                    if (!!item.groups && item.groups.length > 0) {
                        for (const el of item.groups) {
                            if ((!!el.editors && el.editors.split(',').includes(userEmail)) ||
                                this.isAdmin) {
                                return true;
                            }
                        }
                    }
                });
                data.filter(ch => {
                    var _a;
                    this.calendarId = ch;
                    if (ch.cohortId === this.createEvent.get('cohortId').value) {
                        this.courseName = ch.name;
                        this.cohortCal = ch.cohortCalendar;
                        this.createEvent
                            .get('calendarId')
                            .setValue(this.eventData.calendarId);
                        if (!!ch.groups && ch.groups.length > 0) {
                            for (const el of ch.groups) {
                                if ((el.editors &&
                                    el.editors.split(',').includes(this.userEmail)) ||
                                    this.isAdmin) {
                                    this.calendarGroups.push(el);
                                }
                            }
                        }
                        if (ch.cohortCalendar === ((_a = this.eventData) === null || _a === void 0 ? void 0 : _a.calendarId)) {
                            console.log('hello from 301');
                            this.createEvent.get('calendarType').setValue('cohortCal');
                            this.createEvent
                                .get('cohortCalId')
                                .setValue(this.eventData.calendarId);
                            this.createEvent.get('groupCalId').setValue(null);
                        }
                        else {
                            console.log('hello from 308');
                            if (!!ch.groups && ch.groups.length > 0) {
                                this.calendarGroups = [];
                                for (const el of ch.groups) {
                                    console.log('hello from 312', el, this.eventData.calendarId);
                                    if (this.eventData.calendarId === el.calendarId) {
                                        this.groupName = el.name;
                                        this.createEvent.get('calendarType').setValue('groupCal');
                                        this.createEvent
                                            .get('groupCalId')
                                            .setValue(this.eventData.calendarId);
                                        this.createEvent.get('cohortCalId').setValue(null);
                                    }
                                    if ((el.editors &&
                                        el.editors.split(',').includes(this.userEmail)) ||
                                        this.isAdmin) {
                                        this.calendarGroups.push(el);
                                    }
                                }
                            }
                        }
                    }
                });
            });
            this.createEvent.controls.type.disable();
            this.createEvent.controls.cohortId.disable();
            this.createEvent.controls.groupCalId.disable();
        }
    }
    manageCohorts(cohorts, user) {
        this.userEmail = user === null || user === void 0 ? void 0 : user.email;
        const cohortList = cohorts
            .map(el => {
            const elData = Object.assign({}, el);
            const startDate = format$1(new Date(elData.startTime), 'MMM yyyy');
            elData.name = `[${elData.cohortId}] ${startDate} ${elData.course.name} `;
            return elData;
        })
            .filter(item => {
            console.log(item, 'jii');
            if ((!!item.editors && (user === null || user === void 0 ? void 0 : user.email)) || this.isAdmin) {
                if ((!!item.editors && item.editors.split(',').includes(user.email)) ||
                    this.isAdmin) {
                    return true;
                }
            }
            if (!!item.groups && item.groups.length > 0) {
                for (const el of item.groups) {
                    if ((!!el.editors && el.editors.split(',').includes(user.email)) ||
                        this.isAdmin) {
                        return true;
                    }
                }
            }
        });
        if (this.isCreate === 'create') {
            if (!!cohortList && cohortList.length === 1) {
                this.createEvent.get('cohortId').setValue(cohortList[0].cohortId);
                if (!!cohortList[0].editors &&
                    cohortList[0].editors.split(',').includes(user.email)) {
                    this.cohortCal = cohortList[0].cohortCalendar;
                    if (this.cohortCal) {
                        this.createEvent.get('calendarType').setValue('cohortCal');
                        this.createEvent.get('cohortCalId').setValue(this.cohortCal);
                    }
                }
                cohortList.forEach(item => {
                    this.calendarGroups = [];
                    if (!!item.groups && item.groups.length > 0) {
                        for (const el of item.groups) {
                            if ((item.cohortId === el.cohortId &&
                                el.editors &&
                                el.editors.split(',').includes(user.email)) ||
                                this.isAdmin) {
                                this.calendarGroups.push(el);
                            }
                        }
                    }
                    else {
                        this.calendarGroups = [];
                    }
                });
            }
            else {
                cohortList.forEach(item => {
                    if (!!item.groups && item.groups.length > 0) {
                        for (const el of item.groups) {
                            if ((item.editors &&
                                item.editors.split(',').includes(user.email)) ||
                                this.isAdmin) {
                                this.calendarGroups.push(el);
                            }
                        }
                    }
                    else {
                        this.calendarGroups = [];
                    }
                });
            }
            this.minDate = this.toDatetimeLocal(new Date());
            this.maxDate = this.toDatetimeLocal(new Date());
        }
        this.tempCohortList = cohortList;
        console.log('i am manage cohortList', cohortList);
        return of(cohortList);
    }
    setEventTypeValidators() {
        const announcementType = this.createEvent.get('announcementType');
        const announcementAction = this.createEvent.get('announcementAction');
        this.createEvent.get('type').valueChanges.subscribe(eventType => {
            if (eventType === 'announcement') {
                announcementType.setValidators([Validators.required]);
                announcementAction.setValidators([Validators.required]);
            }
            if (eventType !== 'announcement') {
                announcementType.setValidators(null);
                announcementAction.setValidators(null);
                this.createEvent.get('announcementType').setValue(null);
                this.createEvent.get('announcementAction').setValue(null);
            }
            announcementType.updateValueAndValidity();
            announcementAction.updateValueAndValidity();
        });
    }
    setCalTypeValidators() {
        const groupCalId = this.createEvent.get('groupCalId');
        this.createEvent.get('calendarType').valueChanges.subscribe(calType => {
            if (calType === 'groupCal') {
                groupCalId.setValidators([Validators.required]);
                this.createEvent.get('cohortCalId').setValue(null);
            }
            if (calType !== 'groupCal') {
                groupCalId.setValidators(null);
                this.createEvent.get('cohortCalId').setValue(this.cohortCal);
                this.createEvent.get('groupCalId').setValue(null);
            }
            groupCalId.updateValueAndValidity();
        });
    }
    toDatetimeLocal(date) {
        const ten = i => {
            return (i < 10 ? '0' : '') + i;
        };
        const YYYY = date.getFullYear();
        const MM = ten(date.getMonth() + 1);
        const DD = ten(date.getDate());
        const HH = ten(date.getHours());
        const II = ten(date.getMinutes());
        return YYYY + '-' + MM + '-' + DD + 'T' + HH + ':' + II;
    }
    fileOverBase(e) {
        this.hasBaseDropZoneOver = e;
    }
    onClick() {
        this.fileInput.nativeElement.click();
    }
    close() {
        this.modalController.dismiss();
    }
    changeEventType(ev) {
        if (!!ev && ev.name === 'class') {
            let cohortid = this.createEvent.get('cohortId').value;
            this.createEvent.get('id').setValue(null);
            //console.log('cohort',this.token)
            this.terraCohortsService
                .loadClassesForCohort(this.token, cohortid)
                .subscribe(data => {
                this.classList = data;
            });
        }
        else if (!!ev && ev.name !== 'class') {
            this.createEvent.get('id').setValue(null);
        }
    }
    changeWeekType(ev) {
        console.log(ev);
        //this.createEvent.get('moduleId').setValue(ev);
    }
    changeRadioValue(value) {
        this.createEvent.get('calendarType').setValue(value);
    }
    changeCohort(ev) {
        if (!!ev && this.createEvent.get('cohortId').value) {
            if (!!ev.editors && ev.editors.split(',').includes(this.userEmail)) {
                this.cohortCal = ev.cohortCalendar;
                if (this.cohortCal) {
                    this.createEvent.get('calendarType').setValue('cohortCal');
                    this.createEvent.get('cohortCalId').setValue(this.cohortCal);
                }
            }
            this.calendarGroups = [];
            this.cohortCal = ev.cohortCalendar;
            if (!!ev.groups && ev.groups.length > 0) {
                for (const el of ev.groups) {
                    if ((el.editors && el.editors.split(',').includes(this.userEmail)) ||
                        this.isAdmin) {
                        this.calendarGroups.push(el);
                    }
                }
            }
            else {
                this.calendarGroups = [];
            }
        }
        else {
            this.createEvent.get('calendarType').setValue('');
            this.createEvent.get('cohortCalId').setValue(null);
            this.createEvent.get('groupCalId').setValue(null);
            this.calendarGroups = [];
        }
    }
    onSubmit(evData) {
        var _a;
        console.log('hello', this.createEvent);
        let typeCal = this.createEvent.get('calendarType').value;
        this.createEvent
            .get('startDateTime')
            .setValue(new Date(this.createEvent.get('startDateTime').value).toISOString());
        this.createEvent
            .get('mandatory')
            .setValue(!this.createEvent.get('mandatory').value);
        this.createEvent
            .get('endDateTime')
            .setValue(new Date(this.createEvent.get('endDateTime').value).toISOString());
        if (!this.createEvent.get('id').value) {
            if (evData.getRawValue().type === 'class' && !evData.getRawValue().id) {
                this.createEvent.get('id').setValue('');
            }
            else {
                this.createEvent.get('id').setValue(v4());
            }
        }
        this.createEvent
            .get('eventLink')
            .setValue(this.url);
        let zoomLink = this.createEvent.get('zoomLink').value;
        if (zoomLink) {
            if (!this.isURL(zoomLink)) {
                this.message.showMsg({
                    icon: 'close-circle-outline',
                    title1: 'Event error!',
                    title2: 'please enter a valid link',
                    type: 'error',
                });
                return;
            }
        }
        if (!((zoomLink === null || zoomLink === void 0 ? void 0 : zoomLink.includes('https://')) || (zoomLink === null || zoomLink === void 0 ? void 0 : zoomLink.includes('http://'))) &&
            (zoomLink === null || zoomLink === void 0 ? void 0 : zoomLink.length) > 0) {
            this.createEvent.get('zoomLink').setValue('https://' + zoomLink);
        }
        let recordingLink = this.createEvent.get('recordingLink').value;
        if (recordingLink) {
            if (!this.isURL(recordingLink)) {
                this.message.showMsg({
                    icon: 'close-circle-outline',
                    title1: 'Event error!',
                    title2: 'please enter a valid link',
                    type: 'error',
                });
                return;
            }
        }
        if (!((recordingLink === null || recordingLink === void 0 ? void 0 : recordingLink.includes('https://')) || (recordingLink === null || recordingLink === void 0 ? void 0 : recordingLink.includes('http://'))) &&
            (recordingLink === null || recordingLink === void 0 ? void 0 : recordingLink.length) > 0) {
            this.createEvent
                .get('recordingLink')
                .setValue('https://' + recordingLink);
        }
        if (isAfter$1(new Date(this.createEvent.get('startDateTime').value), new Date(this.createEvent.get('endDateTime').value))) {
            this.createEvent.get('endDateTime').setValue(null);
            return;
        }
        if (this.isCreate === 'create') {
            if (!!this.createEvent.get('cohortCalId').value) {
                this.createEvent
                    .get('calendarId')
                    .setValue(this.createEvent.get('cohortCalId').value);
            }
            else {
                this.createEvent
                    .get('calendarId')
                    .setValue(this.createEvent.get('groupCalId').value);
            }
            let temp = Object.assign({}, this.createEvent.value);
            if (((_a = this.tempCohortList) === null || _a === void 0 ? void 0 : _a.length) === 1 && typeCal === 'cohortCal') {
                temp = Object.assign(Object.assign({}, this.createEvent.value), { cohortCalId: this.tempCohortList[0].cohortCalendar, calendarType: 'cohortCal', calendarId: this.tempCohortList[0].cohortCalendar });
                console.log('i am event data', temp, this.calendarId, this.cohortCal);
            }
            this.store.dispatch(publishEvent({ createEvent: temp }));
        }
        else {
            if (!!this.createEvent.get('zoomLink').value &&
                !this.createEvent.get('description').value.includes('terra.do/#/join')) {
                this.createEvent
                    .get('description')
                    .setValue(this.createEvent.get('description').value +
                    '\nLive: ' +
                    this.createEvent.get('eventLink').value +
                    this.createEvent.get('eventId').value);
            }
            const updateEventData = evData.getRawValue();
            this.store.dispatch(updateEvent({
                updateEvent: updateEventData,
                eventId: this.eventData.eventId,
            }));
        }
        this.modalController.dismiss();
    }
    confirmDelete() {
        return __awaiter(this, void 0, void 0, function* () {
            const alert = yield this.alertCtrl.create({
                header: 'Confirm!',
                message: 'Do you want to delete this event?',
                buttons: [
                    {
                        text: 'Cancel',
                        role: 'cancel',
                    },
                    {
                        text: 'Confirm',
                        handler: () => {
                            this.store.dispatch(deleteEventClick({
                                eventData: this.createEvent.getRawValue(),
                            }));
                            this.modalController.dismiss();
                        },
                    },
                ],
            });
            yield alert.present();
        });
    }
    copyToClipboard(s) {
        const clistener = (e) => {
            e.clipboardData.setData('text/plain', s);
            e.preventDefault();
        };
        document.addEventListener('copy', clistener);
        document.execCommand('copy');
        document.removeEventListener('copy', clistener);
        navigator.clipboard.writeText(s);
        this.message.showSuccessMessages('Event link copied');
    }
    isURL(str) {
        var res = str.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
        return res !== null;
    }
}
ManageCalendarEventComponent.ɵfac = function ManageCalendarEventComponent_Factory(t) { return new (t || ManageCalendarEventComponent)(ɵɵdirectiveInject(ModalController), ɵɵdirectiveInject(FormBuilder), ɵɵdirectiveInject(Store), ɵɵdirectiveInject(Cloudinary$1), ɵɵdirectiveInject(NgZone), ɵɵdirectiveInject(AlertController), ɵɵdirectiveInject(TerraVyasService), ɵɵdirectiveInject(MessagesService)); };
ManageCalendarEventComponent.ɵcmp = ɵɵdefineComponent({ type: ManageCalendarEventComponent, selectors: [["terra-manage-calendar-event"]], viewQuery: function ManageCalendarEventComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$7, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.fileInput = _t.first);
    } }, inputs: { isCreate: "isCreate", eventData: "eventData", cohortsFromInput: "cohortsFromInput", userFromInput: "userFromInput", token: "token", cohortUrlFromInput: "cohortUrlFromInput", isAdmin: "isAdmin" }, decls: 117, vars: 43, consts: [[1, "manage-calendar-event"], [1, "form-detail", 3, "formGroup", "ngSubmit"], [1, "grid-wp"], [1, "pt16", "pb34", "first-row"], ["size-md", "4", "size-lg", "6", 1, "header-text", "montserrat", "tal"], ["size-md", "8", "size-lg", "6", 1, "tar", "saving-buttons"], [1, "cursor", "pr20", "cancel-text", 2, "cursor", "pointer", 3, "click"], ["class", "btn-yellow-small mt16", "type", "submit", 3, "disabled", 4, "ngIf"], ["class", "btn-black-small pr20 mb16 mt16", 3, "click", 4, "ngIf"], ["class", "btn-yellow-small", "type", "submit", 3, "disabled", 4, "ngIf"], ["size", "12", 1, "tal", "basic-text", "montserrat"], ["size-md", "6", "size-lg", "4", "size-sm", "12", "size-xs", "12", 1, "field-pad-bottom"], [1, "heading"], [1, "val-required-sign"], [4, "ngIf"], ["size", "12", 1, "field-pad-bottom"], ["type", "text", "formControlName", "summary", "placeholder", "Enter an event title", 1, "input-border", "mt8"], ["cols", "10", "rows", "8", "formControlName", "description", "placeholder", "Enter description", 1, "input-border", "mt8"], ["size-md", "6", "size-lg", "6", "size-sm", "12", "size-xs", "12", 1, "tal", "field-pad-bottom"], ["mbsc-datepicker", "", "dateFormat", "DD/MM/YYYY", "placeholder", "Please select start date", "formControlName", "startDateTime", 1, "mt8", "p7", "width100", 3, "controls", "min", "touchUi", "stepMinute", "onChange"], ["mbsc-datepicker", "", "dateFormat", "DD/MM/YYYY", "placeholder", "Please select end date", "formControlName", "endDateTime", 1, "mt8", "p7", "width100", 3, "controls", "min", "touchUi", "stepMinute"], [1, "alert-danger"], ["class", "error-message", 4, "ngIf"], ["type", "text", "formControlName", "zoomLink", "placeholder", "Enter a Zoom link, Google Meet link, or wherever you want people to join in", 1, "input-border", "mt8"], ["size", "12", 1, "pb40"], ["type", "text", "formControlName", "recordingLink", "placeholder", "Enter Recording link", 1, "input-border", "mt8"], [1, "tal", "more-text", "montserrat", "pb20"], ["size-md", "4", "size-lg", "4", "size-sm", "12", "size-xs", "12", 1, "tac", "mb16", "mobile-up"], ["class", "logo cursor cl-image-4", "height", "166", "width", "184", "radius", "4", "crop", "fill", "format", "png", 3, "public-id", 4, "ngIf"], ["class", "default-image", "src", "/assets/event-default-image.png", 4, "ngIf"], ["type", "file", "ng2FileSelect", "", "accept", "image/*", 2, "opacity", "0", 3, "uploader"], ["fileInp", ""], [1, "btn-black-small", "mt20", 3, "click"], ["size-md", "4", "size-lg", "4", "size-sm", "12", "size-xs", "12", 1, "tac", "mb16", "mobile-down", "add-to-thumbnai"], ["class", "logo cursor cl-image-4", "height", "128", "width", "116", "radius", "4", "crop", "fill", "format", "png", 3, "public-id", 4, "ngIf"], ["type", "file", "ng2FileSelect", "", "accept", "image/*", 1, "fileInp", 2, "opacity", "0", 3, "uploader"], [1, "btn-white-small", 3, "click"], ["size-md", "8", "size-lg", "8", "size-sm", "12", "size-xs", "12", 1, "mlr0"], ["size", "12"], [1, "pb40", "mobile-pb30", "mobile-up"], ["size-md", "6", "size-lg", "6", "size-sm", "12", "size-xs", "12", "class", "tac share-block", 4, "ngIf"], [1, "pb40", "mobile-pb30", "mobile-down"], ["size", "12", "class", "tac share-block", 4, "ngIf"], [1, "ion-align-items-center"], ["size-md", "6", "size-lg", "6", "size-sm", "12", "size-xs", "12", 1, ""], ["formControlName", "type", "placeholder", "Type", "bindLabel", "title", "bindValue", "name", 1, "input-box", "cursor", 3, "ngClass", "items", "change"], ["size-md", "6", "size-lg", "6", "size-sm", "12", "size-xs", "12"], ["lines", "none", "text-wrap", ""], ["formControlName", "mandatory", 2, "height", "18px", "width", "18px", 3, "checked"], [2, "font-size", "15px", "padding-left", "8px"], ["size-md", "6", "size-lg", "6", "size-sm", "12", "size-xs", "12", "class", "field-pad-bottom no-pb", 4, "ngIf"], ["type", "submit", 1, "btn-yellow-small", "mt16", 3, "disabled"], [1, "mobile-down"], [1, "mobile-up"], [1, "btn-black-small", "pr20", "mb16", "mt16", 3, "click"], ["type", "submit", 1, "btn-yellow-small", 3, "disabled"], ["formControlName", "cohortId", "placeholder", "Cohorts", "bindLabel", "name", "bindValue", "cohortId", 1, "input-box", "mb0", "cursor", 3, "ngClass", "items", "change"], [1, "text-cap", "disable-color"], [1, "error-message"], [1, "background-white", "cursor", "mt8", 3, "click"], ["name", "copy-outline", 1, "copy", "cursor"], ["height", "166", "width", "184", "radius", "4", "crop", "fill", "format", "png", 1, "logo", "cursor", "cl-image-4", 3, "public-id"], ["src", "/assets/event-default-image.png", 1, "default-image"], ["height", "128", "width", "116", "radius", "4", "crop", "fill", "format", "png", 1, "logo", "cursor", "cl-image-4", 3, "public-id"], ["size-md", "6", "size-lg", "6", "size-sm", "12", "size-xs", "12", 1, "tac", "share-block"], [3, "click"], [1, "first-block"], [1, "secound-block"], ["src", "./assets/three.svg"], ["src", "./assets/two.svg"], ["size", "12", 1, "tac", "share-block"], ["src", "./assets/member/three.svg"], ["src", "./assets/member/two.svg"], ["size-md", "6", "size-lg", "6", "size-sm", "12", "size-xs", "12", 1, "field-pad-bottom", "no-pb"], ["formControlName", "groupCalId", "placeholder", "group name", "bindLabel", "name", "bindValue", "calendarId", 1, "input-box", "cursor", 3, "ngClass", "items"], ["size-md", "6", "size-lg", "6", "size-sm", "12", "size-xs", "12", 1, "field-pad-bottom", "no-pb", "mb30"], ["type", "text", "formControlName", "id", "placeholder", "Enter class id", 1, "input-border", "mt8"], ["size-md", "12", "size-lg", "12", "size-sm", "12", "size-xs", "12", "class", "field-pad-bottom no-pb mb30", 4, "ngIf"], ["size-md", "12", "size-lg", "12", "size-sm", "12", "size-xs", "12", 1, "field-pad-bottom", "no-pb", "mb30"], ["formControlName", "moduleId", "placeholder", "Week no", "bindLabel", "name", "bindValue", "id", 1, "input-box", "cursor", "ww", 3, "items", "change"], ["formControlName", "announcementType", "placeholder", "Type", "bindLabel", "name", "bindValue", "name", 1, "input-box", "cursor", 3, "items"], ["size", "12", 1, "field-pad-bottom", "no-pb", "mb30"], ["type", "text", "formControlName", "announcementAction", "placeholder", "Announcement action", 1, "input-border", "mt8"], ["type", "text", "formControlName", "website", "placeholder", "link", 1, "input-border", "mt8"]], template: function ManageCalendarEventComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "ion-content", 0);
        ɵɵelementStart(1, "form", 1);
        ɵɵlistener("ngSubmit", function ManageCalendarEventComponent_Template_form_ngSubmit_1_listener() { return ctx.onSubmit(ctx.createEvent); });
        ɵɵelementStart(2, "ion-grid", 2);
        ɵɵelementStart(3, "ion-row", 3);
        ɵɵelementStart(4, "ion-col", 4);
        ɵɵtext(5);
        ɵɵelementEnd();
        ɵɵelementStart(6, "ion-col", 5);
        ɵɵelementStart(7, "span", 6);
        ɵɵlistener("click", function ManageCalendarEventComponent_Template_span_click_7_listener() { return ctx.close(); });
        ɵɵtext(8, " Cancel");
        ɵɵelementEnd();
        ɵɵtemplate(9, ManageCalendarEventComponent_ion_button_9_Template, 5, 1, "ion-button", 7);
        ɵɵtemplate(10, ManageCalendarEventComponent_ion_button_10_Template, 3, 0, "ion-button", 8);
        ɵɵtemplate(11, ManageCalendarEventComponent_ion_button_11_Template, 5, 1, "ion-button", 9);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(12, "ion-row");
        ɵɵelementStart(13, "ion-col", 10);
        ɵɵtext(14, " Let\u2019s get started! The basics: ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(15, "ion-row");
        ɵɵelementStart(16, "ion-col", 11);
        ɵɵelementStart(17, "ion-label", 12);
        ɵɵtext(18, "Cohorts ");
        ɵɵelementEnd();
        ɵɵelementStart(19, "span", 13);
        ɵɵtext(20, "*");
        ɵɵelementEnd();
        ɵɵtemplate(21, ManageCalendarEventComponent_ng_container_21_Template, 3, 3, "ng-container", 14);
        ɵɵpipe(22, "async");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(23, "ion-row");
        ɵɵelementStart(24, "ion-col", 15);
        ɵɵelementStart(25, "ion-label", 12);
        ɵɵtext(26, "What is this about? ");
        ɵɵelementEnd();
        ɵɵelementStart(27, "span", 13);
        ɵɵtext(28, "*");
        ɵɵelementEnd();
        ɵɵelement(29, "ion-input", 16);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(30, "ion-row");
        ɵɵelementStart(31, "ion-col", 15);
        ɵɵelementStart(32, "ion-label", 12);
        ɵɵtext(33, "Description ");
        ɵɵelementEnd();
        ɵɵelement(34, "ion-textarea", 17);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(35, "ion-row");
        ɵɵelementStart(36, "ion-col", 18);
        ɵɵelementStart(37, "div");
        ɵɵelementStart(38, "ion-label", 12);
        ɵɵtext(39, "Start Date ");
        ɵɵelementEnd();
        ɵɵelementStart(40, "span", 13);
        ɵɵtext(41, "*");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(42, "input", 19);
        ɵɵlistener("onChange", function ManageCalendarEventComponent_Template_input_onChange_42_listener($event) { return ctx.onChange($event); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(43, "ion-col", 18);
        ɵɵelementStart(44, "div");
        ɵɵelementStart(45, "ion-label", 12);
        ɵɵtext(46, "End Date ");
        ɵɵelementEnd();
        ɵɵelementStart(47, "span", 13);
        ɵɵtext(48, "*");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(49, "input", 20);
        ɵɵelementStart(50, "div", 21);
        ɵɵtemplate(51, ManageCalendarEventComponent_div_51_Template, 2, 0, "div", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(52, "ion-row");
        ɵɵelementStart(53, "ion-col", 15);
        ɵɵelementStart(54, "ion-label", 12);
        ɵɵtext(55, "Where");
        ɵɵelementEnd();
        ɵɵelement(56, "ion-input", 23);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(57, ManageCalendarEventComponent_ion_row_57_Template, 7, 1, "ion-row", 14);
        ɵɵelementStart(58, "ion-row");
        ɵɵelementStart(59, "ion-col", 24);
        ɵɵelementStart(60, "ion-label", 12);
        ɵɵtext(61, "Recording link");
        ɵɵelementEnd();
        ɵɵelement(62, "ion-input", 25);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(63, "ion-row");
        ɵɵelementStart(64, "ion-col", 26);
        ɵɵtext(65, " Help people discover your event. Add more detail: ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(66, "ion-col");
        ɵɵelementStart(67, "ion-row");
        ɵɵelementStart(68, "ion-col", 27);
        ɵɵelementStart(69, "div");
        ɵɵtemplate(70, ManageCalendarEventComponent_cl_image_70_Template, 1, 1, "cl-image", 28);
        ɵɵtemplate(71, ManageCalendarEventComponent_img_71_Template, 1, 0, "img", 29);
        ɵɵelementEnd();
        ɵɵelement(72, "input", 30, 31);
        ɵɵelementStart(74, "ion-button", 32);
        ɵɵlistener("click", function ManageCalendarEventComponent_Template_ion_button_click_74_listener() { return ctx.onClick(); });
        ɵɵelementStart(75, "span");
        ɵɵtext(76);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(77, "ion-col", 33);
        ɵɵelementStart(78, "div");
        ɵɵtemplate(79, ManageCalendarEventComponent_cl_image_79_Template, 1, 1, "cl-image", 34);
        ɵɵtemplate(80, ManageCalendarEventComponent_img_80_Template, 1, 0, "img", 29);
        ɵɵelementEnd();
        ɵɵelement(81, "input", 35, 31);
        ɵɵelementStart(83, "ion-button", 36);
        ɵɵlistener("click", function ManageCalendarEventComponent_Template_ion_button_click_83_listener() { return ctx.onClick(); });
        ɵɵelementStart(84, "span");
        ɵɵtext(85);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(86, "ion-col", 37);
        ɵɵelementStart(87, "ion-row");
        ɵɵelementStart(88, "ion-col", 38);
        ɵɵelementStart(89, "ion-label", 12);
        ɵɵtext(90, "Share event with ");
        ɵɵelementEnd();
        ɵɵelementStart(91, "span", 13);
        ɵɵtext(92, "*");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(93, "ion-row", 39);
        ɵɵtemplate(94, ManageCalendarEventComponent_ion_col_94_Template, 7, 2, "ion-col", 40);
        ɵɵtemplate(95, ManageCalendarEventComponent_ion_col_95_Template, 7, 2, "ion-col", 40);
        ɵɵelementEnd();
        ɵɵelementStart(96, "ion-row", 41);
        ɵɵtemplate(97, ManageCalendarEventComponent_ion_col_97_Template, 9, 2, "ion-col", 42);
        ɵɵtemplate(98, ManageCalendarEventComponent_ion_col_98_Template, 9, 3, "ion-col", 42);
        ɵɵelementEnd();
        ɵɵtemplate(99, ManageCalendarEventComponent_ion_row_99_Template, 8, 3, "ion-row", 14);
        ɵɵelementStart(100, "ion-row", 43);
        ɵɵelementStart(101, "ion-col", 44);
        ɵɵelementStart(102, "ion-label", 12);
        ɵɵtext(103, "Event Type");
        ɵɵelementEnd();
        ɵɵelementStart(104, "span", 13);
        ɵɵtext(105, "*");
        ɵɵelementEnd();
        ɵɵelementStart(106, "ng-select", 45);
        ɵɵlistener("change", function ManageCalendarEventComponent_Template_ng_select_change_106_listener($event) { return ctx.changeEventType($event); });
        ɵɵelementEnd();
        ɵɵtemplate(107, ManageCalendarEventComponent_ng_container_107_Template, 3, 1, "ng-container", 14);
        ɵɵelementEnd();
        ɵɵelementStart(108, "ion-col", 46);
        ɵɵelementStart(109, "ion-item", 47);
        ɵɵelement(110, "ion-checkbox", 48);
        ɵɵelementStart(111, "ion-label", 49);
        ɵɵtext(112, "Optional Event ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(113, ManageCalendarEventComponent_ng_container_113_Template, 6, 1, "ng-container", 14);
        ɵɵtemplate(114, ManageCalendarEventComponent_ion_col_114_Template, 6, 1, "ion-col", 50);
        ɵɵelementEnd();
        ɵɵtemplate(115, ManageCalendarEventComponent_ion_row_115_Template, 7, 0, "ion-row", 14);
        ɵɵtemplate(116, ManageCalendarEventComponent_ion_row_116_Template, 5, 0, "ion-row", 14);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("formGroup", ctx.createEvent);
        ɵɵadvance(4);
        ɵɵtextInterpolate1(" ", ctx.isCreate == "update" ? "Update" : "Create", " an event ");
        ɵɵadvance(1);
        ɵɵclassProp("isUpdate", !ctx.isCreate);
        ɵɵadvance(3);
        ɵɵproperty("ngIf", ctx.isCreate == "create");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.isCreate == "update");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.isCreate == "update");
        ɵɵadvance(10);
        ɵɵproperty("ngIf", ɵɵpipeBind1(22, 39, ctx.cohorts$));
        ɵɵadvance(21);
        ɵɵpropertyInterpolate("min", ctx.minDate);
        ɵɵproperty("controls", ɵɵpureFunction0(41, _c1$3))("touchUi", true)("stepMinute", 15);
        ɵɵadvance(7);
        ɵɵpropertyInterpolate("min", ctx.maxDate);
        ɵɵproperty("controls", ɵɵpureFunction0(42, _c1$3))("touchUi", true)("stepMinute", 15);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.createEvent.get("endDateTime").invalid && (ctx.createEvent.get("endDateTime").dirty || ctx.createEvent.get("endDateTime").touched));
        ɵɵadvance(6);
        ɵɵproperty("ngIf", ctx.isCreate == "update" && ctx.createEvent.value.zoomLink && ctx.createEvent.value.eventLink);
        ɵɵadvance(13);
        ɵɵproperty("ngIf", !!ctx.createEvent.value.image && ctx.createEvent.value.image != "none");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.createEvent.value.image || ctx.createEvent.value.image == "none");
        ɵɵadvance(1);
        ɵɵproperty("uploader", ctx.uploader);
        ɵɵadvance(4);
        ɵɵtextInterpolate1(" ", !ctx.createEvent.value.image ? "Upload a thumbnail" : "Upload new thumbnail", " ");
        ɵɵadvance(3);
        ɵɵproperty("ngIf", !!ctx.createEvent.value.image && ctx.createEvent.value.image != "none");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.createEvent.value.image || ctx.createEvent.value.image == "none");
        ɵɵadvance(1);
        ɵɵproperty("uploader", ctx.uploader);
        ɵɵadvance(4);
        ɵɵtextInterpolate1(" ", !ctx.createEvent.value.image ? "Upload a thumbnail" : "Upload new thumbnail", " ");
        ɵɵadvance(9);
        ɵɵproperty("ngIf", ctx.cohortCal || ctx.isAdmin);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.calendarGroups.length > 0 && ctx.isAdmin);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.cohortCal);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.calendarGroups.length > 0);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.createEvent.getRawValue().calendarType == "groupCal" && ctx.calendarGroups.length > 0);
        ɵɵadvance(7);
        ɵɵproperty("ngClass", ctx.isCreate == "update" ? "hide" : "ww")("items", ctx.eventList);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.isCreate == "update");
        ɵɵadvance(3);
        ɵɵproperty("checked", ctx.createEvent.getRawValue().mandatory);
        ɵɵadvance(3);
        ɵɵproperty("ngIf", ctx.createEvent.getRawValue().type == "class");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.createEvent.getRawValue().type == "announcement");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.createEvent.getRawValue().type == "announcement");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.createEvent.getRawValue().type == "assignment");
    } }, directives: [IonContent, ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, IonGrid, IonRow, IonCol, NgIf, IonLabel, IonInput, TextValueAccessor, NgControlStatus, FormControlName, IonTextarea, DefaultValueAccessor, ɵc, FileSelectDirective, IonButton, NgSelectComponent, NgClass, IonItem, IonCheckbox, BooleanValueAccessor, IonIcon, CloudinaryImage], pipes: [AsyncPipe], styles: [".disable-color[_ngcontent-%COMP%]{opacity:.5}.text-cap[_ngcontent-%COMP%]{font-size:16px;padding-top:5px;text-transform:capitalize}.alert-danger[_ngcontent-%COMP%]{color:var(--ion-color-danger)}.manage-calendar-event[_ngcontent-%COMP%]   ion-col[_ngcontent-%COMP%]{padding:0}.manage-calendar-event[_ngcontent-%COMP%]   .grid-wp[_ngcontent-%COMP%]{padding:0 12px 41px 20px;width:100%}.manage-calendar-event[_ngcontent-%COMP%]   .header-text[_ngcontent-%COMP%]{color:#000;font-size:32px;font-weight:700;letter-spacing:-1px;line-height:120%}.manage-calendar-event[_ngcontent-%COMP%]   .basic-text[_ngcontent-%COMP%]{font-size:20px;font-style:normal;font-weight:500;line-height:130%;padding-bottom:20px}.manage-calendar-event[_ngcontent-%COMP%]   .pr20[_ngcontent-%COMP%]{padding-right:20px}.manage-calendar-event[_ngcontent-%COMP%]   .pt16[_ngcontent-%COMP%]{padding-top:16px}.manage-calendar-event[_ngcontent-%COMP%]   .pb34[_ngcontent-%COMP%]{padding-bottom:34px}.manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   .field-pad-bottom[_ngcontent-%COMP%], .manage-calendar-event[_ngcontent-%COMP%]   .pb20[_ngcontent-%COMP%]{padding-bottom:20px}.manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   .radio-icon[_ngcontent-%COMP%], .manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   ion-radio[_ngcontent-%COMP%]   .radio-icon[_ngcontent-%COMP%]{display:none}.manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   .val-required-sign[_ngcontent-%COMP%]{color:var(--ion-color-delayed)}.manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]{font-size:18px;font-weight:700;line-height:25px}.manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   .input-border[_ngcontent-%COMP%]{border:1px solid #3b3b3b;border-radius:4px;box-sizing:border-box}.manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   .more-text[_ngcontent-%COMP%]{font-size:20px;font-style:normal;font-weight:500;line-height:26px}.manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   .default-image[_ngcontent-%COMP%]{height:166px;width:184px}.manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   .default-image[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{padding-left:0!important}.manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   .mobile-pb30[_ngcontent-%COMP%]{padding-bottom:20px!important}.manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   .share-block[_ngcontent-%COMP%]{cursor:pointer;padding-right:20px;padding-top:9px}.manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   .share-block[_ngcontent-%COMP%]:last-child{padding-right:0}.manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   .share-block[_ngcontent-%COMP%]   .active[_ngcontent-%COMP%]{background:#f0f6ff;border:1px solid #adc8ec;border-radius:4px;box-sizing:border-box}.manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   .share-block[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{border:1px solid #bababa;border-radius:4px;padding:12px;text-align:left}.manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   .share-block[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]   .first-block[_ngcontent-%COMP%]{color:#000;font-size:16px;line-height:20px;overflow:hidden;padding-bottom:4px;text-overflow:ellipsis;white-space:nowrap}.manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   .share-block[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]   .secound-block[_ngcontent-%COMP%]{color:#3b3b3b;font-size:14px;line-height:160%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   .share-block[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]   .secound-block[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{margin-right:8px;vertical-align:sub}.manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   .input-box[_ngcontent-%COMP%]{background:#fff;border:1px solid #bababa;border-radius:4px;box-sizing:border-box;margin-bottom:30px!important;margin-right:20px;margin-top:8px}.manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   .mb0[_ngcontent-%COMP%]{margin-bottom:0!important}.manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   .pb40[_ngcontent-%COMP%]{padding-bottom:40px}.manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   .mt8[_ngcontent-%COMP%]{margin-top:8px}.manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   .p7[_ngcontent-%COMP%]{padding:7px}.manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   .p15[_ngcontent-%COMP%]{padding:15px}.manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   .mt20[_ngcontent-%COMP%]{margin-top:20px}.first-row[_ngcontent-%COMP%], .first-row[_ngcontent-%COMP%]   .saving-buttons[_ngcontent-%COMP%]{align-items:center;display:flex}.first-row[_ngcontent-%COMP%]   .saving-buttons[_ngcontent-%COMP%]{justify-content:flex-end}@media (min-width:576px) and (max-width:1365.98px){.manage-calendar-event[_ngcontent-%COMP%]   .header-text[_ngcontent-%COMP%]{font-size:20px;font-weight:700;line-height:26px}}@media (min-width:576px) and (max-width:768px){.manage-calendar-event[_ngcontent-%COMP%]   .grid-wp[_ngcontent-%COMP%]{padding:0}.manage-calendar-event[_ngcontent-%COMP%]   .grid-wp[_ngcontent-%COMP%]   ion-row[_ngcontent-%COMP%]{padding-left:20px;padding-right:20px}.manage-calendar-event[_ngcontent-%COMP%]   .grid-wp[_ngcontent-%COMP%]   .first-row[_ngcontent-%COMP%]{background:#f0f6ff;padding:16px 20px}.manage-calendar-event[_ngcontent-%COMP%]   .grid-wp[_ngcontent-%COMP%]   .first-row[_ngcontent-%COMP%]   .header-text[_ngcontent-%COMP%]{color:#000;font-size:20px;font-weight:700;line-height:130%}.manage-calendar-event[_ngcontent-%COMP%]   .grid-wp[_ngcontent-%COMP%]   .basic-text[_ngcontent-%COMP%]{padding-top:20px}}.cancel-text[_ngcontent-%COMP%]{color:#0455bf}.mobile-up[_ngcontent-%COMP%]{display:block}.mobile-down[_ngcontent-%COMP%]{display:none}@media (max-width:575.98px){.mobile-up[_ngcontent-%COMP%]{display:none}.mobile-down[_ngcontent-%COMP%]{display:block}.mlr0[_ngcontent-%COMP%] > ion-row[_ngcontent-%COMP%]{padding-left:0!important;padding-right:0!important}.mb30[_ngcontent-%COMP%]{margin-bottom:30px}.secound-block[_ngcontent-%COMP%]{display:flex;justify-content:space-between}.secound-block[_ngcontent-%COMP%]   .first-block[_ngcontent-%COMP%]{margin-top:2px;padding-bottom:0!important}.secound-block[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:first-child{display:flex;justify-content:flex-start}.secound-block[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:last-child{font-style:italic;font-weight:400;line-height:16px;margin-top:6px}.secound-block[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{margin-right:4px;width:24px}.default-image[_ngcontent-%COMP%]{height:116px;width:128px}.fileInp[_ngcontent-%COMP%]{height:0;width:0}.add-to-thumbnai[_ngcontent-%COMP%]{align-items:center;display:flex}.manage-calendar-event[_ngcontent-%COMP%]   .mb16[_ngcontent-%COMP%]{margin-bottom:16px}.manage-calendar-event[_ngcontent-%COMP%]   .header-text[_ngcontent-%COMP%]{font-size:18px;font-weight:600;line-height:27px}.manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   ion-col[_ngcontent-%COMP%]{padding:0}.manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   .mb16[_ngcontent-%COMP%]{margin-bottom:16px}.manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   .input-box[_ngcontent-%COMP%]{margin-right:0}.manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   .width100[_ngcontent-%COMP%]{width:100%}.manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   .no-pb[_ngcontent-%COMP%]{padding-bottom:0}.manage-calendar-event[_ngcontent-%COMP%]   .form-detail[_ngcontent-%COMP%]   .mobile-pb30[_ngcontent-%COMP%]{padding-bottom:30px}.manage-calendar-event[_ngcontent-%COMP%]   .pr20[_ngcontent-%COMP%]{padding-right:5px}.manage-calendar-event[_ngcontent-%COMP%]   .grid-wp[_ngcontent-%COMP%]{padding:0}.manage-calendar-event[_ngcontent-%COMP%]   .grid-wp[_ngcontent-%COMP%]   ion-row[_ngcontent-%COMP%]{padding-left:20px;padding-right:20px}.manage-calendar-event[_ngcontent-%COMP%]   .grid-wp[_ngcontent-%COMP%]   .basic-text[_ngcontent-%COMP%]{padding-top:20px}.manage-calendar-event[_ngcontent-%COMP%]   .grid-wp[_ngcontent-%COMP%]   .first-row[_ngcontent-%COMP%]{background:#f0f6ff;padding:20px}.manage-calendar-event[_ngcontent-%COMP%]   .grid-wp[_ngcontent-%COMP%]   .first-row[_ngcontent-%COMP%]   .header-text[_ngcontent-%COMP%]{font-size:18px;font-weight:600;line-height:150%}.manage-calendar-event[_ngcontent-%COMP%]   .grid-wp[_ngcontent-%COMP%]   .first-row[_ngcontent-%COMP%]   .saving-buttons[_ngcontent-%COMP%]{align-items:center;display:flex;justify-content:space-between;padding-top:10px}.manage-calendar-event[_ngcontent-%COMP%]   .grid-wp[_ngcontent-%COMP%]   .first-row[_ngcontent-%COMP%]   .saving-buttons[_ngcontent-%COMP%] > ion-button[_ngcontent-%COMP%]{margin:0;padding:0}}.hide[_ngcontent-%COMP%]{display:none}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ManageCalendarEventComponent, [{
        type: Component,
        args: [{
                selector: 'terra-manage-calendar-event',
                templateUrl: './manage-calendar-event.component.html',
                styleUrls: ['./manage-calendar-event.component.scss'],
            }]
    }], function () { return [{ type: ModalController }, { type: FormBuilder }, { type: Store }, { type: Cloudinary$1 }, { type: NgZone }, { type: AlertController }, { type: TerraVyasService }, { type: MessagesService }]; }, { fileInput: [{
            type: ViewChild,
            args: ['fileInp']
        }], isCreate: [{
            type: Input
        }], eventData: [{
            type: Input
        }], cohortsFromInput: [{
            type: Input
        }], userFromInput: [{
            type: Input
        }], token: [{
            type: Input
        }], cohortUrlFromInput: [{
            type: Input
        }], isAdmin: [{
            type: Input
        }] }); })();

function CalendarEventDetailComponent_ion_col_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-col", 7);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" Authored by ", ctx_r0.eventDetail.creator, " ");
} }
function CalendarEventDetailComponent_ion_row_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtext(1);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r6.displayDate, " ");
} }
function CalendarEventDetailComponent_ion_row_5_ng_container_2_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1);
    ɵɵpipe(2, "dateFormat");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind2(2, 1, ctx_r8.eventDetail.startDateTime, "do MMMM yyyy hh:mm a"), " ");
} }
function CalendarEventDetailComponent_ion_row_5_ng_container_2_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1);
    ɵɵpipe(2, "dateFormat");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind2(2, 1, ctx_r9.eventDetail.endDateTime, "do MMMM yyyy hh:mm a"), " ");
} }
function CalendarEventDetailComponent_ion_row_5_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "ion-col", 10);
    ɵɵelementStart(2, "ion-label", 11);
    ɵɵtext(3, "Starts");
    ɵɵelementEnd();
    ɵɵtemplate(4, CalendarEventDetailComponent_ion_row_5_ng_container_2_div_4_Template, 3, 4, "div", 9);
    ɵɵelementEnd();
    ɵɵelementStart(5, "ion-col", 10);
    ɵɵelementStart(6, "ion-label", 11);
    ɵɵtext(7, "Ends");
    ɵɵelementEnd();
    ɵɵtemplate(8, CalendarEventDetailComponent_ion_row_5_ng_container_2_div_8_Template, 3, 4, "div", 9);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = ɵɵnextContext(2);
    ɵɵadvance(4);
    ɵɵproperty("ngIf", ctx_r7.eventDetail.startDateTime);
    ɵɵadvance(4);
    ɵɵproperty("ngIf", ctx_r7.eventDetail.endDateTime);
} }
function CalendarEventDetailComponent_ion_row_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-row", 8);
    ɵɵtemplate(1, CalendarEventDetailComponent_ion_row_5_ng_container_1_Template, 2, 1, "ng-container", 9);
    ɵɵtemplate(2, CalendarEventDetailComponent_ion_row_5_ng_container_2_Template, 9, 2, "ng-container", 9);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !!ctx_r1.displayDate);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r1.displayDate);
} }
function CalendarEventDetailComponent_ion_row_6_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1);
    ɵɵpipe(2, "dateFormat");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind2(2, 1, ctx_r10.eventDetail.startDateTime, "do MMMM yyyy hh:mm a"), " ");
} }
function CalendarEventDetailComponent_ion_row_6_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1);
    ɵɵpipe(2, "dateFormat");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind2(2, 1, ctx_r11.eventDetail.endDateTime, "do MMMM yyyy hh:mm a"), " ");
} }
function CalendarEventDetailComponent_ion_row_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-row", 8);
    ɵɵelementStart(1, "ion-col", 10);
    ɵɵelementStart(2, "ion-label", 11);
    ɵɵtext(3, "Unlocks");
    ɵɵelementEnd();
    ɵɵtemplate(4, CalendarEventDetailComponent_ion_row_6_div_4_Template, 3, 4, "div", 9);
    ɵɵelementEnd();
    ɵɵelementStart(5, "ion-col", 10);
    ɵɵelementStart(6, "ion-label", 11);
    ɵɵtext(7, "Due by");
    ɵɵelementEnd();
    ɵɵtemplate(8, CalendarEventDetailComponent_ion_row_6_div_8_Template, 3, 4, "div", 9);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵadvance(4);
    ɵɵproperty("ngIf", ctx_r2.eventDetail.startDateTime);
    ɵɵadvance(4);
    ɵɵproperty("ngIf", ctx_r2.eventDetail.endDateTime);
} }
function CalendarEventDetailComponent_ion_row_7_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1);
    ɵɵpipe(2, "dateFormat");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind2(2, 1, ctx_r12.eventDetail.startDateTime, "do MMMM yyyy hh:mm a"), " ");
} }
function CalendarEventDetailComponent_ion_row_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-row", 8);
    ɵɵelementStart(1, "ion-col", 10);
    ɵɵelementStart(2, "ion-label", 11);
    ɵɵtext(3, "Unlocks");
    ɵɵelementEnd();
    ɵɵtemplate(4, CalendarEventDetailComponent_ion_row_7_div_4_Template, 3, 4, "div", 9);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext();
    ɵɵadvance(4);
    ɵɵproperty("ngIf", ctx_r3.eventDetail.startDateTime);
} }
function CalendarEventDetailComponent_ion_col_12_ion_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-button", 17);
    ɵɵlistener("click", function CalendarEventDetailComponent_ion_col_12_ion_button_1_Template_ion_button_click_0_listener() { ɵɵrestoreView(_r17); const ctx_r16 = ɵɵnextContext(2); return ctx_r16.vyasService.openZoomLink(ctx_r16.eventDetail); });
    ɵɵelementStart(1, "span");
    ɵɵtext(2, " Join event ");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function CalendarEventDetailComponent_ion_col_12_ion_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-button", 16);
    ɵɵlistener("click", function CalendarEventDetailComponent_ion_col_12_ion_button_2_Template_ion_button_click_0_listener($event) { ɵɵrestoreView(_r19); const ctx_r18 = ɵɵnextContext(2); return ctx_r18.addToCalendarService.addToCalendar($event, ctx_r18.eventDetail); });
    ɵɵelementStart(1, "span");
    ɵɵtext(2, "Add to Calendar");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function CalendarEventDetailComponent_ion_col_12_ion_button_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-button", 18);
    ɵɵelementStart(1, "span");
    ɵɵtext(2, " View recording");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = ɵɵnextContext(2);
    ɵɵproperty("href", ctx_r15.eventDetail.recordingLink);
} }
function CalendarEventDetailComponent_ion_col_12_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-col", 12);
    ɵɵtemplate(1, CalendarEventDetailComponent_ion_col_12_ion_button_1_Template, 3, 0, "ion-button", 13);
    ɵɵtemplate(2, CalendarEventDetailComponent_ion_col_12_ion_button_2_Template, 3, 0, "ion-button", 14);
    ɵɵtemplate(3, CalendarEventDetailComponent_ion_col_12_ion_button_3_Template, 3, 1, "ion-button", 15);
    ɵɵelementStart(4, "ion-button", 16);
    ɵɵlistener("click", function CalendarEventDetailComponent_ion_col_12_Template_ion_button_click_4_listener() { ɵɵrestoreView(_r21); const ctx_r20 = ɵɵnextContext(); return ctx_r20.close(); });
    ɵɵelementStart(5, "span");
    ɵɵtext(6, "Close");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (ctx_r4.eventDetail == null ? null : ctx_r4.eventDetail.zoomLink) && !!ctx_r4.eventDetail.displayZoomButton);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r4.isHide);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r4.eventDetail == null ? null : ctx_r4.eventDetail.recordingLink);
} }
function CalendarEventDetailComponent_ion_col_13_ion_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-button", 17);
    ɵɵlistener("click", function CalendarEventDetailComponent_ion_col_13_ion_button_1_Template_ion_button_click_0_listener() { ɵɵrestoreView(_r24); const ctx_r23 = ɵɵnextContext(2); return ctx_r23.vyasService.openRecordingLink(ctx_r23.eventDetail); });
    ɵɵelementStart(1, "span");
    ɵɵtext(2, " View recording");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function CalendarEventDetailComponent_ion_col_13_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-col", 12);
    ɵɵtemplate(1, CalendarEventDetailComponent_ion_col_13_ion_button_1_Template, 3, 0, "ion-button", 13);
    ɵɵelementStart(2, "ion-button", 16);
    ɵɵlistener("click", function CalendarEventDetailComponent_ion_col_13_Template_ion_button_click_2_listener() { ɵɵrestoreView(_r26); const ctx_r25 = ɵɵnextContext(); return ctx_r25.close(); });
    ɵɵelementStart(3, "span");
    ɵɵtext(4, "Close");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r5.eventDetail == null ? null : ctx_r5.eventDetail.recordingLink);
} }
class CalendarEventDetailComponent {
    constructor(addToCalendarService, router, modalController, vyasService, messagesService) {
        this.addToCalendarService = addToCalendarService;
        this.router = router;
        this.modalController = modalController;
        this.vyasService = vyasService;
        this.messagesService = messagesService;
        this.isHide = false;
        this.displayDate = '';
    }
    ngOnInit() {
        this.isHide = isBefore$1(new Date(), new Date(this.eventDetail.endDateTime));
        console.log('this is event detail', this.eventDetail);
        if (isSameDay(new Date(this.eventDetail.startDateTime), new Date(this.eventDetail.endDateTime))) {
            this.displayDate =
                format(new Date(this.eventDetail.startDateTime), 'd MMMM yyyy • h:mm a') +
                    ' - ' +
                    format(new Date(this.eventDetail.endDateTime), 'h:mm a');
        }
    }
    close() {
        this.modalController.dismiss();
    }
    manageCUEvent(isCreate, ev) {
        return __awaiter(this, void 0, void 0, function* () {
            const modal = yield this.modalController.create({
                component: ManageCalendarEventComponent,
                cssClass: 'manage-calendar-event',
                componentProps: {
                    isCreate,
                    eventData: ev,
                },
            });
            modal.onDidDismiss().then(f => {
                if (f.data) {
                    // this.filter(f.data);
                }
            });
            return yield modal.present();
        });
    }
}
CalendarEventDetailComponent.ɵfac = function CalendarEventDetailComponent_Factory(t) { return new (t || CalendarEventDetailComponent)(ɵɵdirectiveInject(AddToCalendarService), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(ModalController), ɵɵdirectiveInject(TerraVyasService), ɵɵdirectiveInject(MessagesService)); };
CalendarEventDetailComponent.ɵcmp = ɵɵdefineComponent({ type: CalendarEventDetailComponent, selectors: [["terra-calendar-event-detail"]], inputs: { eventDetail: "eventDetail", eventStatus: "eventStatus" }, decls: 14, vars: 8, consts: [[1, "event-data"], ["size", "12", 1, "event-summary"], ["size", "12", "class", "event-creator", 4, "ngIf"], ["class", "pt16", 4, "ngIf"], ["size", "12", 1, "pt16", "mx-height", "scrollbar-hide"], [1, "event-description", 3, "innerHtml"], ["size", "12", "class", "fixedToBottom tar", 4, "ngIf"], ["size", "12", 1, "event-creator"], [1, "pt16"], [4, "ngIf"], ["size", "6", 1, "event-date"], [1, "heading"], ["size", "12", 1, "fixedToBottom", "tar"], ["class", "btn-yellow-small mb10 mr10", 3, "click", 4, "ngIf"], ["class", "btn-white-small mb10 mr10", 3, "click", 4, "ngIf"], ["target", "_blank", "class", "btn-yellow-small mb10 mr10", 3, "href", 4, "ngIf"], [1, "btn-white-small", "mb10", "mr10", 3, "click"], [1, "btn-yellow-small", "mb10", "mr10", 3, "click"], ["target", "_blank", 1, "btn-yellow-small", "mb10", "mr10", 3, "href"]], template: function CalendarEventDetailComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "ion-grid", 0);
        ɵɵelementStart(1, "ion-row");
        ɵɵelementStart(2, "ion-col", 1);
        ɵɵtext(3);
        ɵɵelementEnd();
        ɵɵtemplate(4, CalendarEventDetailComponent_ion_col_4_Template, 2, 1, "ion-col", 2);
        ɵɵelementEnd();
        ɵɵtemplate(5, CalendarEventDetailComponent_ion_row_5_Template, 3, 2, "ion-row", 3);
        ɵɵtemplate(6, CalendarEventDetailComponent_ion_row_6_Template, 9, 2, "ion-row", 3);
        ɵɵtemplate(7, CalendarEventDetailComponent_ion_row_7_Template, 5, 1, "ion-row", 3);
        ɵɵelementStart(8, "ion-row");
        ɵɵelementStart(9, "ion-col", 4);
        ɵɵelement(10, "div", 5);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(11, "ion-row");
        ɵɵtemplate(12, CalendarEventDetailComponent_ion_col_12_Template, 7, 3, "ion-col", 6);
        ɵɵtemplate(13, CalendarEventDetailComponent_ion_col_13_Template, 5, 1, "ion-col", 6);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(3);
        ɵɵtextInterpolate1(" ", (ctx.eventDetail == null ? null : ctx.eventDetail.summary) ? ctx.eventDetail.summary : ctx.eventDetail.name, " ");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.eventDetail == null ? null : ctx.eventDetail.creator);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.eventDetail.scheduleType != "assignment" && ctx.eventDetail.scheduleType != "class");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.eventDetail.scheduleType == "assignment" && ctx.eventDetail.isLocked);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.eventDetail.scheduleType == "class" && ctx.eventDetail.isLocked);
        ɵɵadvance(3);
        ɵɵproperty("innerHtml", ctx.vyasService.replaceHtml(ctx.eventDetail), ɵɵsanitizeHtml);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", !ctx.eventStatus);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.eventStatus == "previous");
    } }, directives: [IonGrid, IonRow, IonCol, NgIf, IonLabel, IonButton], pipes: [DateFormatPipe], styles: [".event-data[_ngcontent-%COMP%]{padding:20px 16px!important;width:100%}.event-data[_ngcontent-%COMP%]   ion-content[_ngcontent-%COMP%]{margin:0;padding:0}.event-data[_ngcontent-%COMP%]   ion-col[_ngcontent-%COMP%]{padding:0}.event-data[_ngcontent-%COMP%]   .event-summary[_ngcontent-%COMP%]{color:var(--ion-color-warning-contrast);font-size:16px;font-weight:700;line-height:22px}.event-data[_ngcontent-%COMP%]   .event-creator[_ngcontent-%COMP%]{color:#3b3b3b;font-size:14px;line-height:160%}.event-data[_ngcontent-%COMP%]   .event-date[_ngcontent-%COMP%]{color:#3b3b3b;font-size:14px;font-weight:400;line-height:16px}.event-data[_ngcontent-%COMP%]   .pt16[_ngcontent-%COMP%]{padding-top:16px}.event-data[_ngcontent-%COMP%]   .scroll[_ngcontent-%COMP%]{overflow-y:auto}.event-data[_ngcontent-%COMP%]   .event-description[_ngcontent-%COMP%]{color:var(--ion-color-warning-contrast);font-size:14px;font-weight:400;line-height:16px}.event-data[_ngcontent-%COMP%]   .mx-height[_ngcontent-%COMP%]{max-height:240px;overflow-y:scroll}.event-data[_ngcontent-%COMP%]   .mr10[_ngcontent-%COMP%]{margin-right:10px}@media (min-width:1366px){.tar[_ngcontent-%COMP%]{text-align:right}.fixedToBottom[_ngcontent-%COMP%]{bottom:20px;position:absolute;right:16px}}@media (min-width:576px) and (max-width:1365.98px){.tar[_ngcontent-%COMP%]{text-align:right}.fixedToBottom[_ngcontent-%COMP%]{bottom:20px;position:absolute;right:16px}}@media (max-width:575.98px){.event-data[_ngcontent-%COMP%]{padding:20px 16px!important;width:100%}.event-data[_ngcontent-%COMP%]   .btn-white-small[_ngcontent-%COMP%], .event-data[_ngcontent-%COMP%]   .btn-yellow-small[_ngcontent-%COMP%]{width:90%}.event-data[_ngcontent-%COMP%]   .mb10[_ngcontent-%COMP%]{margin-bottom:10px}.event-data[_ngcontent-%COMP%]   .mx-height[_ngcontent-%COMP%]{max-height:310px;overflow-y:scroll}.event-data[_ngcontent-%COMP%]   .fixedToBottom[_ngcontent-%COMP%]{bottom:20px;position:absolute}.event-description[_ngcontent-%COMP%]{max-width:330px}}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CalendarEventDetailComponent, [{
        type: Component,
        args: [{
                selector: 'terra-calendar-event-detail',
                templateUrl: './calendar-event-detail.component.html',
                styleUrls: ['./calendar-event-detail.component.scss'],
            }]
    }], function () { return [{ type: AddToCalendarService }, { type: Router }, { type: ModalController }, { type: TerraVyasService }, { type: MessagesService }]; }, { eventDetail: [{
            type: Input
        }], eventStatus: [{
            type: Input
        }] }); })();

function CalendarEventsComponent_ion_row_1_cl_image_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "cl-image", 15);
} if (rf & 2) {
    const event_r1 = ɵɵnextContext().$implicit;
    ɵɵproperty("public-id", event_r1.image);
} }
function CalendarEventsComponent_ion_row_1_img_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 16);
} }
function CalendarEventsComponent_ion_row_1_img_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 17);
} }
function CalendarEventsComponent_ion_row_1_img_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 18);
} }
function CalendarEventsComponent_ion_row_1_span_12_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 19);
    ɵɵelement(1, "ion-icon", 20);
    ɵɵtext(2, " Live now ");
    ɵɵelementEnd();
} }
function CalendarEventsComponent_ion_row_1_span_13_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 21);
    ɵɵtext(1, " Optional ");
    ɵɵelementEnd();
} }
function CalendarEventsComponent_ion_row_1_span_14_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 22);
    ɵɵtext(1);
    ɵɵpipe(2, "dateFormat");
    ɵɵelementEnd();
} if (rf & 2) {
    const event_r1 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind2(2, 1, event_r1.startDateTime, "h.mm a , do MMMM yyyy"), "");
} }
function CalendarEventsComponent_ion_row_1_ion_col_15_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-col", 23);
    ɵɵelementStart(1, "div", 24);
    ɵɵlistener("click", function CalendarEventsComponent_ion_row_1_ion_col_15_Template_div_click_1_listener() { ɵɵrestoreView(_r16); const event_r1 = ɵɵnextContext().$implicit; const ctx_r14 = ɵɵnextContext(); return ctx_r14.presentPopover(event_r1); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const event_r1 = ɵɵnextContext().$implicit;
    const ctx_r9 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("innerHtml", ctx_r9.terraVyasService.replaceHtml(event_r1), ɵɵsanitizeHtml);
} }
function CalendarEventsComponent_ion_row_1_ion_col_16_ng_container_1_ion_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-button", 30);
    ɵɵlistener("click", function CalendarEventsComponent_ion_row_1_ion_col_16_ng_container_1_ion_button_1_Template_ion_button_click_0_listener() { ɵɵrestoreView(_r25); const event_r1 = ɵɵnextContext(3).$implicit; const ctx_r23 = ɵɵnextContext(); return ctx_r23.terraVyasService.openZoomLink(event_r1); });
    ɵɵelementStart(1, "span");
    ɵɵtext(2, " Join event ");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function CalendarEventsComponent_ion_row_1_ion_col_16_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, CalendarEventsComponent_ion_row_1_ion_col_16_ng_container_1_ion_button_1_Template, 3, 0, "ion-button", 29);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const event_r1 = ɵɵnextContext(2).$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", event_r1 == null ? null : event_r1.zoomLink);
} }
function CalendarEventsComponent_ion_row_1_ion_col_16_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-button", 31);
    ɵɵlistener("click", function CalendarEventsComponent_ion_row_1_ion_col_16_ng_template_2_Template_ion_button_click_0_listener($event) { ɵɵrestoreView(_r28); const event_r1 = ɵɵnextContext(2).$implicit; const ctx_r27 = ɵɵnextContext(); return ctx_r27.addToCalendarService.addToCalendar($event, event_r1); });
    ɵɵelementStart(1, "span");
    ɵɵtext(2, "Add to Calendar");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function CalendarEventsComponent_ion_row_1_ion_col_16_ion_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r32 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-button", 32);
    ɵɵelementStart(1, "img", 33);
    ɵɵlistener("click", function CalendarEventsComponent_ion_row_1_ion_col_16_ion_button_4_Template_img_click_1_listener() { ɵɵrestoreView(_r32); const event_r1 = ɵɵnextContext(2).$implicit; const ctx_r30 = ɵɵnextContext(); return ctx_r30.manageCUEvent("update", event_r1); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function CalendarEventsComponent_ion_row_1_ion_col_16_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-col", 25);
    ɵɵtemplate(1, CalendarEventsComponent_ion_row_1_ion_col_16_ng_container_1_Template, 2, 1, "ng-container", 26);
    ɵɵtemplate(2, CalendarEventsComponent_ion_row_1_ion_col_16_ng_template_2_Template, 3, 0, "ng-template", null, 27, ɵɵtemplateRefExtractor);
    ɵɵtemplate(4, CalendarEventsComponent_ion_row_1_ion_col_16_ion_button_4_Template, 2, 0, "ion-button", 28);
    ɵɵelementEnd();
} if (rf & 2) {
    const _r19 = ɵɵreference(3);
    const event_r1 = ɵɵnextContext().$implicit;
    const ctx_r10 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !!event_r1.displayZoomButton)("ngIfElse", _r19);
    ɵɵadvance(3);
    ɵɵproperty("ngIf", (event_r1 == null ? null : event_r1.isEditEvent) || ctx_r10.isAdmin);
} }
function CalendarEventsComponent_ion_row_1_ion_col_17_ion_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r40 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-button", 30);
    ɵɵlistener("click", function CalendarEventsComponent_ion_row_1_ion_col_17_ion_button_1_Template_ion_button_click_0_listener() { ɵɵrestoreView(_r40); const event_r1 = ɵɵnextContext(2).$implicit; const ctx_r38 = ɵɵnextContext(); return ctx_r38.terraVyasService.openZoomLink(event_r1); });
    ɵɵelementStart(1, "span");
    ɵɵtext(2, " Join event ");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function CalendarEventsComponent_ion_row_1_ion_col_17_ion_button_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-button", 35);
    ɵɵelementStart(1, "span");
    ɵɵtext(2, " Go to assignment");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const event_r1 = ɵɵnextContext(2).$implicit;
    const ctx_r35 = ɵɵnextContext();
    ɵɵpropertyInterpolate2("href", "", ctx_r35.assignmentRedirectUrl, "/", event_r1.id, "");
} }
function CalendarEventsComponent_ion_row_1_ion_col_17_ion_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r44 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-button", 30);
    ɵɵlistener("click", function CalendarEventsComponent_ion_row_1_ion_col_17_ion_button_3_Template_ion_button_click_0_listener() { ɵɵrestoreView(_r44); const event_r1 = ɵɵnextContext(2).$implicit; const ctx_r42 = ɵɵnextContext(); return ctx_r42.terraVyasService.openRecordingLink(event_r1); });
    ɵɵelementStart(1, "span");
    ɵɵtext(2, " View recording");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function CalendarEventsComponent_ion_row_1_ion_col_17_ion_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r47 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-button", 32);
    ɵɵelementStart(1, "img", 33);
    ɵɵlistener("click", function CalendarEventsComponent_ion_row_1_ion_col_17_ion_button_4_Template_img_click_1_listener() { ɵɵrestoreView(_r47); const event_r1 = ɵɵnextContext(2).$implicit; const ctx_r45 = ɵɵnextContext(); return ctx_r45.manageCUEvent("update", event_r1); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function CalendarEventsComponent_ion_row_1_ion_col_17_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-col", 25);
    ɵɵtemplate(1, CalendarEventsComponent_ion_row_1_ion_col_17_ion_button_1_Template, 3, 0, "ion-button", 29);
    ɵɵtemplate(2, CalendarEventsComponent_ion_row_1_ion_col_17_ion_button_2_Template, 3, 2, "ion-button", 34);
    ɵɵtemplate(3, CalendarEventsComponent_ion_row_1_ion_col_17_ion_button_3_Template, 3, 0, "ion-button", 29);
    ɵɵtemplate(4, CalendarEventsComponent_ion_row_1_ion_col_17_ion_button_4_Template, 2, 0, "ion-button", 28);
    ɵɵelementEnd();
} if (rf & 2) {
    const event_r1 = ɵɵnextContext().$implicit;
    const ctx_r11 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (event_r1 == null ? null : event_r1.zoomLink) && !!event_r1.displayZoomButton);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", event_r1.type == "assignment");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (event_r1 == null ? null : event_r1.recordingLink) && !(event_r1 == null ? null : event_r1.isliveEvent));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (event_r1 == null ? null : event_r1.isEditEvent) || ctx_r11.isAdmin);
} }
function CalendarEventsComponent_ion_row_1_Template(rf, ctx) { if (rf & 1) {
    const _r50 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-row", 1);
    ɵɵelementStart(1, "ion-col", 2);
    ɵɵlistener("click", function CalendarEventsComponent_ion_row_1_Template_ion_col_click_1_listener() { ɵɵrestoreView(_r50); const event_r1 = ctx.$implicit; const ctx_r49 = ɵɵnextContext(); return ctx_r49.presentPopover(event_r1); });
    ɵɵtemplate(2, CalendarEventsComponent_ion_row_1_cl_image_2_Template, 1, 1, "cl-image", 3);
    ɵɵtemplate(3, CalendarEventsComponent_ion_row_1_img_3_Template, 1, 0, "img", 4);
    ɵɵtemplate(4, CalendarEventsComponent_ion_row_1_img_4_Template, 1, 0, "img", 5);
    ɵɵtemplate(5, CalendarEventsComponent_ion_row_1_img_5_Template, 1, 0, "img", 6);
    ɵɵelementEnd();
    ɵɵelementStart(6, "ion-col", 7);
    ɵɵelementStart(7, "ion-grid");
    ɵɵelementStart(8, "ion-row");
    ɵɵelementStart(9, "ion-col", 8);
    ɵɵlistener("click", function CalendarEventsComponent_ion_row_1_Template_ion_col_click_9_listener() { ɵɵrestoreView(_r50); const event_r1 = ctx.$implicit; const ctx_r51 = ɵɵnextContext(); return ctx_r51.presentPopover(event_r1); });
    ɵɵtext(10);
    ɵɵelementEnd();
    ɵɵelementStart(11, "ion-col", 9);
    ɵɵlistener("click", function CalendarEventsComponent_ion_row_1_Template_ion_col_click_11_listener() { ɵɵrestoreView(_r50); const event_r1 = ctx.$implicit; const ctx_r52 = ɵɵnextContext(); return ctx_r52.presentPopover(event_r1); });
    ɵɵtemplate(12, CalendarEventsComponent_ion_row_1_span_12_Template, 3, 0, "span", 10);
    ɵɵtemplate(13, CalendarEventsComponent_ion_row_1_span_13_Template, 2, 0, "span", 11);
    ɵɵtemplate(14, CalendarEventsComponent_ion_row_1_span_14_Template, 3, 4, "span", 12);
    ɵɵelementEnd();
    ɵɵtemplate(15, CalendarEventsComponent_ion_row_1_ion_col_15_Template, 2, 1, "ion-col", 13);
    ɵɵtemplate(16, CalendarEventsComponent_ion_row_1_ion_col_16_Template, 5, 3, "ion-col", 14);
    ɵɵtemplate(17, CalendarEventsComponent_ion_row_1_ion_col_17_Template, 5, 4, "ion-col", 14);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const event_r1 = ctx.$implicit;
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("id", event_r1.id);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", event_r1.image && event_r1.image != "" && event_r1.image != "none" && event_r1.image != "terra-logo");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (!(event_r1 == null ? null : event_r1.image) || event_r1.image == "" || event_r1.image == "none" || event_r1.image == "terra-logo") && event_r1.type != "class" && event_r1.type != "assignment");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (!(event_r1 == null ? null : event_r1.image) || event_r1.image == "" || event_r1.image == "none" || event_r1.image == "terra-logo") && event_r1.type == "assignment");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (!(event_r1 == null ? null : event_r1.image) || event_r1.image == "" || event_r1.image == "none" || event_r1.image == "terra-logo") && event_r1.type == "class");
    ɵɵadvance(5);
    ɵɵtextInterpolate1(" ", event_r1.summary, " ");
    ɵɵadvance(2);
    ɵɵproperty("ngIf", event_r1 == null ? null : event_r1.isliveEvent);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !event_r1.mandatory);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !(event_r1 == null ? null : event_r1.isliveEvent));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", event_r1 == null ? null : event_r1.description);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r0.eventStatus);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.eventStatus == "previous");
} }
class CalendarEventsComponent {
    constructor(addToCalendarService, popoverController, modalController, router, terraVyasService, messagesService, store) {
        this.addToCalendarService = addToCalendarService;
        this.popoverController = popoverController;
        this.modalController = modalController;
        this.router = router;
        this.terraVyasService = terraVyasService;
        this.messagesService = messagesService;
        this.store = store;
        this.events = [];
        //@Input() public token: String;
        this.selectCohorts$ = this.store.pipe(select(selectAllCourses));
    }
    ngOnInit() {
        this.selectCohorts$.subscribe(data => {
            console.log("i am cohortList", data);
            if (data) {
                this.cohortList = data;
            }
        });
    }
    presentPopover(ev) {
        return __awaiter(this, void 0, void 0, function* () {
            this.logCalEventClick(ev.eventId, ev.summary, 'calendar_event_click', 'calendar');
            const popover = yield this.modalController.create({
                component: CalendarEventDetailComponent,
                cssClass: 'event-description-popup',
                componentProps: {
                    eventDetail: ev,
                    eventStatus: this.eventStatus,
                },
            });
            popover.onWillDismiss().then(res => { });
            return yield popover.present();
        });
    }
    manageCUEvent(isCreate, ev) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log("#############", ev, this.cohortsFromInput, this.cohortList);
            const modal = yield this.modalController.create({
                component: ManageCalendarEventComponent,
                cssClass: 'manage-calendar-event',
                componentProps: {
                    isCreate,
                    eventData: ev,
                    cohortsFromInput: this.cohortsFromInput ? this.cohortsFromInput : this.cohortList,
                    userFromInput: this.userFromInput,
                    isAdmin: this.isAdmin,
                    token: this.token
                },
            });
            modal.onDidDismiss().then(f => {
                if (f.data) {
                    // this.filter(f.data);
                }
            });
            return yield modal.present();
        });
    }
    trackByFn(index, item) {
        return item.id;
    }
    logCalEventClick(eventId, eventName, eventType, from) {
        const pageViewEvent = {};
        pageViewEvent.type = eventType;
        pageViewEvent.event = -1;
        pageViewEvent.eventId = eventId;
        pageViewEvent.name = eventName;
        pageViewEvent.from = from;
        combineLatest([this.authServiceFromInput.profileDetail$, this.authServiceFromInput.user$])
            .pipe(first(), map(([profileDetail, userFire]) => {
            if (profileDetail != null && userFire != null) {
                let temp = profileDetail;
                pageViewEvent.profileId = temp === null || temp === void 0 ? void 0 : temp.id;
                //this.authServiceFromInput.logUserAction(pageViewEvent);
            }
            else {
            }
        }))
            .subscribe();
    }
    ago1(time) {
        return isAfter$1(new Date(), addDays(new Date(time), 1));
    }
    getLinkString(id) {
        return this.assignmentRedirectUrl + id;
    }
}
CalendarEventsComponent.ɵfac = function CalendarEventsComponent_Factory(t) { return new (t || CalendarEventsComponent)(ɵɵdirectiveInject(AddToCalendarService), ɵɵdirectiveInject(PopoverController), ɵɵdirectiveInject(ModalController), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(TerraVyasService), ɵɵdirectiveInject(MessagesService), ɵɵdirectiveInject(Store)); };
CalendarEventsComponent.ɵcmp = ɵɵdefineComponent({ type: CalendarEventsComponent, selectors: [["terra-calendar-events"]], inputs: { events: "events", eventStatus: "eventStatus", authServiceFromInput: "authServiceFromInput", cohortsFromInput: "cohortsFromInput", userFromInput: "userFromInput", assignmentRedirectUrl: "assignmentRedirectUrl", token: "token", isAdmin: "isAdmin" }, decls: 2, vars: 1, consts: [["class", "ion-pb30 fix-height", 4, "ngFor", "ngForOf"], [1, "ion-pb30", "fix-height"], ["size-xs", "12", "size-sm", "4", "size-md", "4", "size-lg", "4", "size-xl", "4", 1, "event-image", "cl-image", "cursor", 3, "id", "click"], ["class", "cl-image-4", "height", "212", "width", "204", "radius", "8", "crop", "fill", "format", "png", 3, "public-id", 4, "ngIf"], ["src", "assets/default-event.png", 4, "ngIf"], ["src", "assets/calendar/assignment_unlock.jpeg", 4, "ngIf"], ["src", "assets/calendar/class_unlock.jpeg", 4, "ngIf"], ["size-xs", "12", "size-sm", "8", "size-md", "8", "size-lg", "8", "size-xl", "8", 1, "plr10"], ["size", "12", 1, "event-title", "cursor", "event-description", "ellipsis-2", 3, "click"], ["size", "12", 1, "event-date", "cursor", "event-description", 3, "click"], ["class", "pright-live-event", 4, "ngIf"], ["class", "optional-event-tag", 4, "ngIf"], ["class", "event-date-bg", 4, "ngIf"], ["size", "12", "class", "cursor event-description", 4, "ngIf"], ["size", "12", "class", "fixedToBottom", 4, "ngIf"], ["height", "212", "width", "204", "radius", "8", "crop", "fill", "format", "png", 1, "cl-image-4", 3, "public-id"], ["src", "assets/default-event.png"], ["src", "assets/calendar/assignment_unlock.jpeg"], ["src", "assets/calendar/class_unlock.jpeg"], [1, "pright-live-event"], ["name", "radio-outline", 1, "live-event-icon"], [1, "optional-event-tag"], [1, "event-date-bg"], ["size", "12", 1, "cursor", "event-description"], [1, "event-desc", "ellipsis-3", "cursor", "maxWidth", 3, "innerHtml", "click"], ["size", "12", 1, "fixedToBottom"], [4, "ngIf", "ngIfElse"], ["addToCalendar", ""], ["class", "no-btn mb10 mr16 pl50", 4, "ngIf"], ["class", "btn-yellow-small mb10 mr16", 3, "click", 4, "ngIf"], [1, "btn-yellow-small", "mb10", "mr16", 3, "click"], [1, "btn-white-small", "mb10", "mr16", 3, "click"], [1, "no-btn", "mb10", "mr16", "pl50"], ["src", "/assets/edit-event.png", "title", "Edit event", 1, "edit-icon", "cursor", 3, "click"], ["class", "btn-white-small mb10 mr16", 3, "href", 4, "ngIf"], [1, "btn-white-small", "mb10", "mr16", 3, "href"]], template: function CalendarEventsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "ion-grid");
        ɵɵtemplate(1, CalendarEventsComponent_ion_row_1_Template, 18, 12, "ion-row", 0);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngForOf", ctx.events);
    } }, directives: [IonGrid, NgForOf, IonRow, IonCol, NgIf, CloudinaryImage, IonIcon, IonButton], pipes: [DateFormatPipe], styles: ["ion-col[_ngcontent-%COMP%]{padding:0}.plr10[_ngcontent-%COMP%]{padding-left:10px;padding-right:10px}ion-pb30[_ngcontent-%COMP%]{padding-bottom:30px}.event-title[_ngcontent-%COMP%]{color:#1f1f1f;font-size:18px;font-weight:700;line-height:140%;max-height:50px;overflow:hidden}.event-date[_ngcontent-%COMP%]{color:#1f1f1f;font-size:16px;line-height:150%}.event-date-bg[_ngcontent-%COMP%]{background:var(--ion-color-date-bg);border-radius:4px;padding:4px 6px}.optional-event-tag[_ngcontent-%COMP%]{background:var(--bullet-background-active);border-radius:4px;margin-right:8px;padding:4px 6px}.btn-white-small[_ngcontent-%COMP%]{--background:transparent;margin:0}.event-desc[_ngcontent-%COMP%]{color:#797979;margin-bottom:16px!important}.zoomIcon[_ngcontent-%COMP%]{height:24px;padding-right:10px;width:24px}.event-image[_ngcontent-%COMP%]{text-align:center}.event-image[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:212px;width:204px}.fix-height[_ngcontent-%COMP%]   .event-description[_ngcontent-%COMP%]{max-width:398px!important}.edit-icon[_ngcontent-%COMP%]{font-size:24px}.no-btn[_ngcontent-%COMP%]{--background:transparent;--border-color:transparent;--border-width:1px;--box-shadow:none;--padding-bottom:8px;--padding-end:16px;--padding-start:0;--padding-top:8px;border:none;line-height:150%;margin:0;text-transform:lowercase}.live-event-icon[_ngcontent-%COMP%]{margin-right:4px}@media (min-width:1366px){.fix-height[_ngcontent-%COMP%]{max-height:300px}.fix-height[_ngcontent-%COMP%]   .event-image[_ngcontent-%COMP%]{max-width:214px!important}.fix-height[_ngcontent-%COMP%]   .event-image.event-image[_ngcontent-%COMP%]{text-align:left}.maxWidth[_ngcontent-%COMP%]{max-width:450px}.event-title[_ngcontent-%COMP%]{margin-bottom:12px!important}.event-date[_ngcontent-%COMP%]{margin-bottom:9px!important}.mr16[_ngcontent-%COMP%]{margin-right:16px}.fixedToBottom[_ngcontent-%COMP%]{bottom:3px;position:absolute}.pright-live-event[_ngcontent-%COMP%]{background:#77e5a3;border-radius:4px;margin-right:8px;padding:4px 6px}}@media (min-width:576px) and (max-width:1365.98px){.fix-height[_ngcontent-%COMP%]{max-height:300px}.fix-height[_ngcontent-%COMP%]   .event-image[_ngcontent-%COMP%]{max-width:214px!important;padding-right:10px}.fix-height[_ngcontent-%COMP%]   .event-image.event-image[_ngcontent-%COMP%]{text-align:left}.maxWidth[_ngcontent-%COMP%]{max-width:50vw;max-width:450px}.event-title[_ngcontent-%COMP%]{margin-bottom:8px!important}.event-date[_ngcontent-%COMP%]{margin-bottom:9px!important}.event-desc[_ngcontent-%COMP%]{margin-bottom:20px!important}.mb10[_ngcontent-%COMP%]{margin-bottom:10px}.mr16[_ngcontent-%COMP%]{margin-right:16px}.fixedToBottom[_ngcontent-%COMP%]{bottom:3px;position:absolute}.pright-live-event[_ngcontent-%COMP%]{background:#77e5a3;border-radius:4px;margin-right:8px;padding:4px 6px}}@media (max-width:575.98px){.fix-height[_ngcontent-%COMP%]{max-height:auto!important}.fix-height[_ngcontent-%COMP%]   .event-image[_ngcontent-%COMP%]{padding-bottom:20px}.event-title[_ngcontent-%COMP%]{margin-bottom:8px!important}.event-date[_ngcontent-%COMP%], .event-desc[_ngcontent-%COMP%]{margin-bottom:16px!important}.btn-white-small[_ngcontent-%COMP%], .btn-yellow-small[_ngcontent-%COMP%]{width:100%}.mb10[_ngcontent-%COMP%]{margin-bottom:10px}.maxWidth[_ngcontent-%COMP%]{width:auto}.plr10[_ngcontent-%COMP%]{padding:0}.pl50[_ngcontent-%COMP%]{padding-left:45%}}ion-grid[_ngcontent-%COMP%]{padding:0}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CalendarEventsComponent, [{
        type: Component,
        args: [{
                selector: 'terra-calendar-events',
                templateUrl: './calendar-events.component.html',
                styleUrls: ['./calendar-events.component.scss']
            }]
    }], function () { return [{ type: AddToCalendarService }, { type: PopoverController }, { type: ModalController }, { type: Router }, { type: TerraVyasService }, { type: MessagesService }, { type: Store }]; }, { events: [{
            type: Input
        }], eventStatus: [{
            type: Input
        }], authServiceFromInput: [{
            type: Input
        }], cohortsFromInput: [{
            type: Input
        }], userFromInput: [{
            type: Input
        }], assignmentRedirectUrl: [{
            type: Input
        }], token: [{
            type: Input
        }], isAdmin: [{
            type: Input
        }] }); })();

function TerraUiCalendarComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 8);
    ɵɵelementStart(1, "ion-button", 9);
    ɵɵlistener("click", function TerraUiCalendarComponent_div_5_Template_ion_button_click_1_listener() { ɵɵrestoreView(_r6); const ctx_r5 = ɵɵnextContext(); return ctx_r5.manageCUEvent("create"); });
    ɵɵelementStart(2, "span");
    ɵɵtext(3, " Create an event ");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function TerraUiCalendarComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "mbsc-eventcalendar", 10);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const events_r7 = ctx.ngIf;
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("data", events_r7)("options", ctx_r1.eventSettings);
} }
function TerraUiCalendarComponent_ng_container_8_ion_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-button", 9);
    ɵɵlistener("click", function TerraUiCalendarComponent_ng_container_8_ion_button_2_Template_ion_button_click_0_listener() { ɵɵrestoreView(_r11); const ctx_r10 = ɵɵnextContext(2); return ctx_r10.manageCUEvent("create"); });
    ɵɵelementStart(1, "span");
    ɵɵtext(2, " Create an event ");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function TerraUiCalendarComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 11);
    ɵɵtemplate(2, TerraUiCalendarComponent_ng_container_8_ion_button_2_Template, 3, 0, "ion-button", 12);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const manageEvent_r8 = ctx.ngIf;
    ɵɵadvance(2);
    ɵɵproperty("ngIf", manageEvent_r8);
} }
function TerraUiCalendarComponent_ng_container_11_ng_container_7_ion_row_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "terra-calendar-events", 19);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const events_r14 = ɵɵnextContext(2).ngIf;
    const ctx_r17 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("events", events_r14.upcoming)("authServiceFromInput", ctx_r17.authServiceFromInput)("cohortsFromInput", ctx_r17.cohortList)("userFromInput", ctx_r17.userFromInput)("isAdmin", ctx_r17.isAdmin)("token", ctx_r17.token);
} }
function TerraUiCalendarComponent_ng_container_11_ng_container_7_ion_row_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "ion-grid");
    ɵɵelementStart(2, "ion-row");
    ɵɵelementStart(3, "ion-col", 20);
    ɵɵtext(4, " No Events found ! ");
    ɵɵelementEnd();
    ɵɵelementStart(5, "ion-col", 21);
    ɵɵelement(6, "img", 22);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} }
function TerraUiCalendarComponent_ng_container_11_ng_container_7_ion_row_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-row", 17);
    ɵɵelementStart(1, "ion-col", 18);
    ɵɵtemplate(2, TerraUiCalendarComponent_ng_container_11_ng_container_7_ion_row_1_ng_container_2_Template, 2, 6, "ng-container", 5);
    ɵɵtemplate(3, TerraUiCalendarComponent_ng_container_11_ng_container_7_ion_row_1_ng_container_3_Template, 7, 0, "ng-container", 5);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const events_r14 = ɵɵnextContext().ngIf;
    ɵɵadvance(2);
    ɵɵproperty("ngIf", events_r14.upcoming.length);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !events_r14.upcoming.length);
} }
function TerraUiCalendarComponent_ng_container_11_ng_container_7_ion_row_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "terra-calendar-events", 23);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const events_r14 = ɵɵnextContext(2).ngIf;
    const ctx_r21 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("events", events_r14.previous)("eventStatus", "previous")("assignmentRedirectUrl", ctx_r21.urlFromInput)("cohortsFromInput", ctx_r21.cohortList)("userFromInput", ctx_r21.userFromInput)("isAdmin", ctx_r21.isAdmin)("token", ctx_r21.token);
} }
function TerraUiCalendarComponent_ng_container_11_ng_container_7_ion_row_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "ion-grid");
    ɵɵelementStart(2, "ion-row");
    ɵɵelementStart(3, "ion-col", 20);
    ɵɵtext(4, " No Events found ! ");
    ɵɵelementEnd();
    ɵɵelementStart(5, "ion-col", 21);
    ɵɵelement(6, "img", 22);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} }
function TerraUiCalendarComponent_ng_container_11_ng_container_7_ion_row_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ion-row", 17);
    ɵɵelementStart(1, "ion-col", 18);
    ɵɵtemplate(2, TerraUiCalendarComponent_ng_container_11_ng_container_7_ion_row_2_ng_container_2_Template, 2, 7, "ng-container", 5);
    ɵɵtemplate(3, TerraUiCalendarComponent_ng_container_11_ng_container_7_ion_row_2_ng_container_3_Template, 7, 0, "ng-container", 5);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const events_r14 = ɵɵnextContext().ngIf;
    ɵɵadvance(2);
    ɵɵproperty("ngIf", true);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !events_r14.previous.length);
} }
function TerraUiCalendarComponent_ng_container_11_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, TerraUiCalendarComponent_ng_container_11_ng_container_7_ion_row_1_Template, 4, 2, "ion-row", 16);
    ɵɵtemplate(2, TerraUiCalendarComponent_ng_container_11_ng_container_7_ion_row_2_Template, 4, 2, "ion-row", 16);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const activeSegment_r12 = ɵɵnextContext().ngIf;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", activeSegment_r12 == "upcoming");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", activeSegment_r12 == "previous");
} }
function TerraUiCalendarComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "ion-row");
    ɵɵelementStart(2, "ion-segment", 13);
    ɵɵlistener("ionChange", function TerraUiCalendarComponent_ng_container_11_Template_ion_segment_ionChange_2_listener($event) { ɵɵrestoreView(_r27); const ctx_r26 = ɵɵnextContext(); return ctx_r26.segmentChanged($event); });
    ɵɵelementStart(3, "ion-segment-button", 14);
    ɵɵtext(4, "Upcoming Events");
    ɵɵelementEnd();
    ɵɵelementStart(5, "ion-segment-button", 15);
    ɵɵtext(6, "Previous Events");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(7, TerraUiCalendarComponent_ng_container_11_ng_container_7_Template, 3, 2, "ng-container", 5);
    ɵɵpipe(8, "async");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const activeSegment_r12 = ctx.ngIf;
    const ctx_r3 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵproperty("value", activeSegment_r12);
    ɵɵadvance(5);
    ɵɵproperty("ngIf", ɵɵpipeBind1(8, 2, ctx_r3.events$));
} }
function TerraUiCalendarComponent_ng_container_14_ion_fab_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r32 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-fab-button", 26);
    ɵɵlistener("click", function TerraUiCalendarComponent_ng_container_14_ion_fab_button_1_Template_ion_fab_button_click_0_listener() { ɵɵrestoreView(_r32); const ctx_r31 = ɵɵnextContext(2); return ctx_r31.loadFilter(); });
    ɵɵelement(1, "ion-icon", 27);
    ɵɵelementEnd();
} }
function TerraUiCalendarComponent_ng_container_14_ion_fab_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r34 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ion-fab-button", 28);
    ɵɵlistener("click", function TerraUiCalendarComponent_ng_container_14_ion_fab_button_2_Template_ion_fab_button_click_0_listener() { ɵɵrestoreView(_r34); const ctx_r33 = ɵɵnextContext(2); return ctx_r33.loadFilter(); });
    ɵɵelement(1, "img", 29);
    ɵɵelementEnd();
} }
function TerraUiCalendarComponent_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, TerraUiCalendarComponent_ng_container_14_ion_fab_button_1_Template, 2, 0, "ion-fab-button", 24);
    ɵɵtemplate(2, TerraUiCalendarComponent_ng_container_14_ion_fab_button_2_Template, 2, 0, "ion-fab-button", 25);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const isFiltered_r28 = ctx.ngIf;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !isFiltered_r28.noFilter);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", isFiltered_r28.noFilter);
} }
class TerraUiCalendarComponent {
    constructor(http, menuController, addToCalendarService, router, menuUIService, actionSheetController, modalController, store, platform) {
        this.http = http;
        this.menuController = menuController;
        this.addToCalendarService = addToCalendarService;
        this.router = router;
        this.menuUIService = menuUIService;
        this.actionSheetController = actionSheetController;
        this.modalController = modalController;
        this.store = store;
        this.platform = platform;
        this.filterCriteria = {
            courses: [],
            specific: [],
            isRemote: true,
        };
        this.selectCohorts$ = this.store.pipe(select(selectAllCourses));
        this.isManageEvent = false;
        this.view = 'month';
        this.cohortList = [];
        //this.store.dispatch(loadDashboard())
        if (this.platform.is('ios') || this.platform.is('android')) {
            this.eventSettings = {
                theme: 'ios',
                themeVariant: 'light',
                view: {
                    calendar: {
                    // popover: true,
                    },
                },
                onEventClick: (event, inst) => {
                    this.presentPopover(event.event);
                },
            };
        }
        else {
            this.eventSettings = {
                theme: 'ios',
                themeVariant: 'light',
                height: 697,
                view: {
                    calendar: {
                        labels: true,
                    },
                },
                onEventClick: (event, inst) => {
                    this.presentPopover(event.event);
                },
            };
        }
    }
    presentPopover(ev) {
        return __awaiter(this, void 0, void 0, function* () {
            this.logCalEventClick(ev.eventId, ev.summary, 'calendar_event_click');
            const popover = yield this.modalController.create({
                component: CalendarEventDetailComponent,
                cssClass: 'event-description-popup',
                componentProps: {
                    eventDetail: ev,
                    eventStatus: '',
                },
            });
            popover.onWillDismiss().then(res => { });
            return yield popover.present();
        });
    }
    scrollTo(id) {
        const el = document.getElementById(String(id));
        if (el) {
            el.scrollIntoView();
        }
        else {
            this.activeSegmentOnCalendar$.pipe(first()).subscribe(data => {
                if (data === 'upcoming') {
                    this.store.dispatch(calendarSegmentClick({
                        calendarSegment: 'previous',
                    }));
                }
                else if (data === 'previous') {
                    this.store.dispatch(calendarSegmentClick({
                        calendarSegment: 'upcoming',
                    }));
                }
                setTimeout(() => {
                    const els = document.getElementById(String(id));
                    if (els) {
                        els.scrollIntoView();
                    }
                });
            });
        }
    }
    ngOnInit() {
        var _a;
        if (this.usedIn === 'vyas') {
            console.log('line 153');
            this.store.dispatch(loadDashboard({ id: null }));
        }
        else {
            console.log('line 157');
            (_a = this.cohort) === null || _a === void 0 ? void 0 : _a.subscribe(data => {
                var _a, _b, _c;
                if (data) {
                    console.log(data, 'i am active cohort');
                    this.activeCohort = data;
                    if ((_a = data.roles) === null || _a === void 0 ? void 0 : _a.includes('Course Admin')) {
                        this.isAdmin = true;
                    }
                    else {
                        this.isAdmin = false;
                    }
                    if (((_b = data.roles) === null || _b === void 0 ? void 0 : _b.includes('Course Admin')) || ((_c = data.roles) === null || _c === void 0 ? void 0 : _c.includes('Event Creator'))) {
                        this.showPublishButton = true;
                    }
                    else {
                        this.showPublishButton = false;
                    }
                    this.store.dispatch(loadDashboard({ id: data === null || data === void 0 ? void 0 : data.id }));
                }
            });
        }
        console.log('i am in Ngoninit getting changed');
        this.selectCohorts$.subscribe(data => {
            console.log('i am cohortList 183', data, this.isAdmin);
            if (data) {
                this.cohortList = data;
            }
        });
        this.activeSegmentOnCalendar$ = this.store.pipe(select(selectActiveSegmentOnCalendar));
        this.manageEvent$ = this.manageEventFunction(this.cohortList, this.userFromInput);
        this.calendarAllEvents$ = this.store.pipe(select(selectAllEvents));
        this.events$ = combineLatest([
            this.store.pipe(select(selectUpcomingAllEvents)),
            this.store.pipe(select(selectPreviousEvents)),
            this.store.pipe(select(selectAllCourses)),
        ]).pipe(map(([upcoming, previous, cohorts]) => {
            let allCohorts = cohorts;
            this.cohortsFromInput = cohorts;
            let user = this.userFromInput;
            upcoming = upcoming.map(ev => {
                const eveData = Object.assign({}, ev);
                const obj = allCohorts.find(x => x.cohortId === eveData.cohortId);
                if (!!obj &&
                    obj.editors && (user === null || user === void 0 ? void 0 : user.email) &&
                    obj.cohortCalendar === eveData.calendarId) {
                    if (!!obj.editors && obj.editors.split(',').includes(user.email)) {
                        eveData.isEditEvent = true;
                    }
                    else {
                        eveData.isEditEvent = false;
                    }
                }
                if (!!obj &&
                    obj.groups &&
                    obj.groups.length > 0 &&
                    obj.cohortCalendar !== eveData.calendarId) {
                    for (const item of obj.groups) {
                        if (!!item.editors &&
                            item.editors.split(',').includes(user.email) &&
                            item.calendarId === eveData.calendarId) {
                            eveData.isEditEvent = true;
                            break;
                        }
                    }
                }
                return eveData;
            });
            previous = previous.map(ev => {
                const eveData = Object.assign({}, ev);
                const obj = allCohorts.find(x => x.cohortId === eveData.cohortId);
                if (!!obj &&
                    obj.editors && (user === null || user === void 0 ? void 0 : user.email) &&
                    obj.cohortCalendar === eveData.calendarId) {
                    if (!!obj.editors && obj.editors.split(',').includes(user.email)) {
                        eveData.isEditEvent = true;
                    }
                    else {
                        eveData.isEditEvent = false;
                    }
                }
                if (!!obj &&
                    !!obj.groups &&
                    obj.groups.length > 0 &&
                    obj.cohortCalendar !== eveData.calendarId) {
                    for (const item of obj.groups) {
                        if (!!item.editors &&
                            item.editors.split(',').includes(user.email) &&
                            item.calendarId === eveData.calendarId) {
                            eveData.isEditEvent = true;
                            break;
                        }
                    }
                }
                return eveData;
            });
            this.eventsCombined = [...upcoming, ...previous];
            return {
                upcoming,
                previous,
            };
        }));
        this.events$.subscribe(data => {
            this.events = data;
            console.log('Data for events', this.events);
        });
        this.isFiltered$ = this.store.pipe(select(selectCalendarFilterCriteria), map(data => {
            if (!!data && (data.courses.length > 0 || data.specific.length > 0)) {
                const noFilter = true;
                return { noFilter };
            }
            else {
                const noFilter = false;
                return { noFilter };
            }
        }));
    }
    manageEventFunction(cohorts, user) {
        if (!!cohorts && cohorts.length > 0) {
            for (const ele of cohorts) {
                if (!!ele.editors && (user === null || user === void 0 ? void 0 : user.email)) {
                    const emailList = !!ele.editors && ele.editors.split(',');
                    this.isManageEvent = !!emailList && emailList.includes(user.email);
                    if (this.isManageEvent) {
                        break;
                    }
                }
                if (!!ele.groups && ele.groups.length > 0) {
                    for (const item of ele.groups) {
                        const emailList = !!item.editors && item.editors.split(',');
                        this.isManageEvent = !!emailList && emailList.includes(user.email);
                        if (this.isManageEvent) {
                            break;
                        }
                    }
                    if (this.isManageEvent) {
                        break;
                    }
                }
            }
        }
        this.manageEvent = this.isManageEvent;
        return of(this.isManageEvent);
    }
    segmentChanged(ev) {
        const activeSegment = ev.detail.value;
        this.store.dispatch(calendarSegmentClick({ calendarSegment: activeSegment }));
    }
    loadFilter() {
        return __awaiter(this, void 0, void 0, function* () {
            const modal = yield this.modalController.create({
                component: FilterComponent,
                cssClass: 'filter-custom-class',
                componentProps: {
                    popup: true,
                    filter: this.filterCriteria,
                },
            });
            modal.onDidDismiss().then(f => {
                if (f.data) {
                    // this.filter(f.data);
                }
            });
            return yield modal.present();
        });
    }
    manageCUEvent(isCreate) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('i am cohortList', this.cohortList);
            const modal = yield this.modalController.create({
                component: ManageCalendarEventComponent,
                cssClass: 'manage-calendar-event',
                componentProps: {
                    isCreate,
                    eventData: '',
                    cohortsFromInput: this.cohortList,
                    userFromInput: this.userFromInput,
                    isAdmin: this.isAdmin,
                    token: this.token,
                },
            });
            modal.onDidDismiss().then(f => {
                if (f.data) {
                    // this.filter(f.data);
                }
            });
            return yield modal.present();
        });
    }
    logCalEventClick(eventId, eventName, eventType) {
        var _a;
        const pageViewEvent = {};
        pageViewEvent.type = eventType;
        pageViewEvent.event = -1;
        pageViewEvent.eventId = eventId;
        pageViewEvent.name = eventName;
        if (this.profileDetail != null && this.authServiceFromInput != null) {
            pageViewEvent.profileId = (_a = this.profileDetail) === null || _a === void 0 ? void 0 : _a.id;
            pageViewEvent.app = 'Learn';
            this.authServiceFromInput.logAuthUserAction(pageViewEvent);
        }
        else {
        }
    }
}
TerraUiCalendarComponent.ɵfac = function TerraUiCalendarComponent_Factory(t) { return new (t || TerraUiCalendarComponent)(ɵɵdirectiveInject(HttpClient), ɵɵdirectiveInject(MenuController), ɵɵdirectiveInject(AddToCalendarService), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(MenuUIService), ɵɵdirectiveInject(ActionSheetController), ɵɵdirectiveInject(ModalController), ɵɵdirectiveInject(Store), ɵɵdirectiveInject(Platform)); };
TerraUiCalendarComponent.ɵcmp = ɵɵdefineComponent({ type: TerraUiCalendarComponent, selectors: [["terra-terra-ui-calendar"]], inputs: { cohortsFromInput: "cohortsFromInput", userFromInput: "userFromInput", authServiceFromInput: "authServiceFromInput", profileDetail: "profileDetail", urlFromInput: "urlFromInput", cohort: "cohort", usedIn: "usedIn", token: "token" }, decls: 16, vars: 14, consts: [[1, "top-grid"], ["size-lg", "10", "size-sm", "9", 1, "p0", "pl10-dp"], ["animate", "pop", 3, "popup"], [1, "md-switching-view-cal-cont", "padtop-40"], ["class", "top-create-event", 4, "ngIf"], [4, "ngIf"], [1, "padding-top"], ["vertical", "bottom", "horizontal", "end", "slot", "fixed", 1, "ion-hide-sm-up", "filter"], [1, "top-create-event"], [1, "btn-yellow-small", 3, "click"], [3, "data", "options"], [1, "bottom-create-event"], ["class", "btn-yellow-small", 3, "click", 4, "ngIf"], ["scrollable", "", "mode", "md", "layout", "icon-bottom", 1, "segments", 3, "value", "ionChange"], ["value", "upcoming"], ["value", "previous"], ["class", "segment-event", 4, "ngIf"], [1, "segment-event"], ["size", "12", 1, "p0"], [3, "events", "authServiceFromInput", "cohortsFromInput", "userFromInput", "isAdmin", "token"], ["size", "12", 1, "not-found-title", "montserrat"], ["size", "12", 1, "img-center"], ["src", "/assets/assignment-not-found.svg", 1, "not-found-image"], [3, "events", "eventStatus", "assignmentRedirectUrl", "cohortsFromInput", "userFromInput", "isAdmin", "token"], ["size", "small", 3, "click", 4, "ngIf"], ["class", "filtered", "size", "small", 3, "click", 4, "ngIf"], ["size", "small", 3, "click"], ["name", "filter"], ["size", "small", 1, "filtered", 3, "click"], ["src", "/assets/filtered.png"]], template: function TerraUiCalendarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "ion-grid", 0);
        ɵɵelementStart(1, "ion-row");
        ɵɵelementStart(2, "ion-col", 1);
        ɵɵelement(3, "terra-calendar-filter-component", 2);
        ɵɵelementStart(4, "div", 3);
        ɵɵtemplate(5, TerraUiCalendarComponent_div_5_Template, 4, 0, "div", 4);
        ɵɵtemplate(6, TerraUiCalendarComponent_ng_container_6_Template, 2, 2, "ng-container", 5);
        ɵɵpipe(7, "async");
        ɵɵtemplate(8, TerraUiCalendarComponent_ng_container_8_Template, 3, 1, "ng-container", 5);
        ɵɵpipe(9, "async");
        ɵɵelementEnd();
        ɵɵelementStart(10, "div", 6);
        ɵɵtemplate(11, TerraUiCalendarComponent_ng_container_11_Template, 9, 4, "ng-container", 5);
        ɵɵpipe(12, "async");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(13, "ion-fab", 7);
        ɵɵtemplate(14, TerraUiCalendarComponent_ng_container_14_Template, 3, 2, "ng-container", 5);
        ɵɵpipe(15, "async");
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(3);
        ɵɵproperty("popup", false);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.showPublishButton);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ɵɵpipeBind1(7, 6, ctx.calendarAllEvents$));
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ɵɵpipeBind1(9, 8, ctx.manageEvent$));
        ɵɵadvance(3);
        ɵɵproperty("ngIf", ɵɵpipeBind1(12, 10, ctx.activeSegmentOnCalendar$));
        ɵɵadvance(3);
        ɵɵproperty("ngIf", ɵɵpipeBind1(15, 12, ctx.isFiltered$));
    } }, directives: [IonGrid, IonRow, IonCol, FilterComponent, NgIf, IonFab, IonButton, MbscEventcalendar, IonSegment, SelectValueAccessor, IonSegmentButton, CalendarEventsComponent, IonFabButton, IonIcon], pipes: [AsyncPipe], styles: [".top60[_ngcontent-%COMP%]{top:60px}.segments[_ngcontent-%COMP%]{margin-bottom:30px}#container[_ngcontent-%COMP%]   strong[_ngcontent-%COMP%]{font-size:20px;line-height:26px}#container[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#8c8c8c;font-size:16px;line-height:22px;margin:0}#container[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{text-decoration:none}.p0[_ngcontent-%COMP%]{padding:0}.not-found-title[_ngcontent-%COMP%]{color:var(--ion-color-black-600);font-size:20px;font-weight:500;line-height:26px;text-align:center}.not-found-description[_ngcontent-%COMP%]{color:#3b3b3b;font-size:16px;line-height:150%;text-align:center}.not-found-image[_ngcontent-%COMP%]{height:386px;width:300px}.img-center[_ngcontent-%COMP%]{text-align:center}.padtop-40[_ngcontent-%COMP%]{padding-top:40px}.padding-top[_ngcontent-%COMP%]{padding-top:30px}.filtered[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-width:-moz-fit-content!important;max-width:fit-content!important}.pl10-dp[_ngcontent-%COMP%]{padding:10px!important}.top-create-event[_ngcontent-%COMP%]{display:block}.bottom-create-event[_ngcontent-%COMP%]{display:none}@media (max-width:768px){.padtop-40[_ngcontent-%COMP%]{padding-top:20px}}.ios[_ngcontent-%COMP%]   .segment-button-checked[_ngcontent-%COMP%]{--indicator-height:3px!important}@media (max-width:575.98px){.top-grid[_ngcontent-%COMP%]{padding:0}.top-grid[_ngcontent-%COMP%]   .segment-event[_ngcontent-%COMP%]{padding:0 20px}.pl10-dp[_ngcontent-%COMP%]{padding:0!important}.padtop-40[_ngcontent-%COMP%]{padding-top:0}.padding-top[_ngcontent-%COMP%]{padding:0 20px!important}ion-segment[_ngcontent-%COMP%]   ion-segment-button[_ngcontent-%COMP%]{--padding-end:0;--padding-start:0}ion-segment[_ngcontent-%COMP%]   ion-segment-button[_ngcontent-%COMP%]:first-child{margin-right:20px}.top-create-event[_ngcontent-%COMP%]{display:none}.bottom-create-event[_ngcontent-%COMP%]{display:block;margin:16px 20px 6px}.bottom-create-event[_ngcontent-%COMP%]   ion-button[_ngcontent-%COMP%]{width:100%}}.top-create-event[_ngcontent-%COMP%]{padding:0;text-align:right}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TerraUiCalendarComponent, [{
        type: Component,
        args: [{
                selector: 'terra-terra-ui-calendar',
                templateUrl: './terra-ui-calendar.component.html',
                styleUrls: ['./terra-ui-calendar.component.scss'],
            }]
    }], function () { return [{ type: HttpClient }, { type: MenuController }, { type: AddToCalendarService }, { type: Router }, { type: MenuUIService }, { type: ActionSheetController }, { type: ModalController }, { type: Store }, { type: Platform }]; }, { cohortsFromInput: [{
            type: Input
        }], userFromInput: [{
            type: Input
        }], authServiceFromInput: [{
            type: Input
        }], profileDetail: [{
            type: Input
        }], urlFromInput: [{
            type: Input
        }], cohort: [{
            type: Input
        }], usedIn: [{
            type: Input
        }], token: [{
            type: Input
        }] }); })();

class ManageCalendarEventModule {
}
ManageCalendarEventModule.ɵmod = ɵɵdefineNgModule({ type: ManageCalendarEventModule });
ManageCalendarEventModule.ɵinj = ɵɵdefineInjector({ factory: function ManageCalendarEventModule_Factory(t) { return new (t || ManageCalendarEventModule)(); }, providers: [AddToCalendarService], imports: [[
            CommonModule,
            FormsModule,
            IonicModule,
            ReactiveFormsModule,
            // FeatureToggleLibModule,
            // UtilLibModule,
            CloudinaryModule.forRoot({ Cloudinary }, {
                cloud_name: 'terra-do',
                upload_preset: 'koitppzh',
            }),
            NgSelectModule,
            FileUploadModule,
            MbscModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(ManageCalendarEventModule, { declarations: [ManageCalendarEventComponent], imports: [CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule, CloudinaryModule, NgSelectModule,
        FileUploadModule,
        MbscModule], exports: [ManageCalendarEventComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(ManageCalendarEventModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    IonicModule,
                    ReactiveFormsModule,
                    // FeatureToggleLibModule,
                    // UtilLibModule,
                    CloudinaryModule.forRoot({ Cloudinary }, {
                        cloud_name: 'terra-do',
                        upload_preset: 'koitppzh',
                    }),
                    NgSelectModule,
                    FileUploadModule,
                    MbscModule
                ],
                declarations: [ManageCalendarEventComponent],
                entryComponents: [ManageCalendarEventComponent],
                exports: [ManageCalendarEventComponent],
                providers: [AddToCalendarService],
            }]
    }], null, null); })();

class CalendarEventDetailModule {
}
CalendarEventDetailModule.ɵmod = ɵɵdefineNgModule({ type: CalendarEventDetailModule });
CalendarEventDetailModule.ɵinj = ɵɵdefineInjector({ factory: function CalendarEventDetailModule_Factory(t) { return new (t || CalendarEventDetailModule)(); }, providers: [AddToCalendarService], imports: [[
            CommonModule,
            FormsModule,
            IonicModule,
            ReactiveFormsModule,
            FeatureToggleLibModule,
            UtilLibModule,
            CloudinaryModule.forRoot({ Cloudinary }, {
                cloud_name: 'terra-do',
            }),
            ManageCalendarEventModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(CalendarEventDetailModule, { declarations: [CalendarEventDetailComponent], imports: [CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        FeatureToggleLibModule,
        UtilLibModule, CloudinaryModule, ManageCalendarEventModule], exports: [CalendarEventDetailComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(CalendarEventDetailModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    IonicModule,
                    ReactiveFormsModule,
                    FeatureToggleLibModule,
                    UtilLibModule,
                    CloudinaryModule.forRoot({ Cloudinary }, {
                        cloud_name: 'terra-do',
                    }),
                    ManageCalendarEventModule,
                ],
                declarations: [CalendarEventDetailComponent],
                entryComponents: [CalendarEventDetailComponent],
                exports: [CalendarEventDetailComponent],
                providers: [AddToCalendarService],
            }]
    }], null, null); })();

class CalendarEventsModule {
}
CalendarEventsModule.ɵmod = ɵɵdefineNgModule({ type: CalendarEventsModule });
CalendarEventsModule.ɵinj = ɵɵdefineInjector({ factory: function CalendarEventsModule_Factory(t) { return new (t || CalendarEventsModule)(); }, providers: [AddToCalendarService], imports: [[
            CommonModule,
            FormsModule,
            IonicModule,
            ReactiveFormsModule,
            UtilLibModule,
            CloudinaryModule.forRoot({ Cloudinary }, {
                cloud_name: 'terra-do',
            }),
            CalendarEventDetailModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(CalendarEventsModule, { declarations: [CalendarEventsComponent], imports: [CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        UtilLibModule, CloudinaryModule, CalendarEventDetailModule], exports: [CalendarEventsComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(CalendarEventsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    IonicModule,
                    ReactiveFormsModule,
                    UtilLibModule,
                    CloudinaryModule.forRoot({ Cloudinary }, {
                        cloud_name: 'terra-do',
                    }),
                    CalendarEventDetailModule,
                ],
                declarations: [CalendarEventsComponent],
                exports: [CalendarEventsComponent],
                providers: [AddToCalendarService],
            }]
    }], null, null); })();

class FilterComponentModule {
}
FilterComponentModule.ɵmod = ɵɵdefineNgModule({ type: FilterComponentModule });
FilterComponentModule.ɵinj = ɵɵdefineInjector({ factory: function FilterComponentModule_Factory(t) { return new (t || FilterComponentModule)(); }, imports: [[
            CommonModule,
            TerraUIModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(FilterComponentModule, { declarations: [FilterComponent], imports: [CommonModule,
        TerraUIModule], exports: [FilterComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(FilterComponentModule, [{
        type: NgModule,
        args: [{
                declarations: [FilterComponent],
                imports: [
                    CommonModule,
                    TerraUIModule
                ],
                exports: [FilterComponent]
            }]
    }], null, null); })();

class CalendarEffects {
    constructor(actions, terraCohortsService, authStore, store, ngFireAuth, message, router, vyasService) {
        this.actions = actions;
        this.terraCohortsService = terraCohortsService;
        this.authStore = authStore;
        this.store = store;
        this.ngFireAuth = ngFireAuth;
        this.message = message;
        this.router = router;
        this.vyasService = vyasService;
        this.CalendarSegmentClick = createEffect(() => this.actions.pipe(ofType(calendarSegmentClick), map(segment => calendarSegmentSelected(segment))));
        this.CalendarFilterClick = createEffect(() => this.actions.pipe(ofType(filterClick), map(calenderFilterCriteria => filteredCriteriaClick(calenderFilterCriteria))));
        this.publishEvent = createEffect(() => this.actions.pipe(ofType(publishEvent), withLatestFrom(this.authStore.firebaseToken$), concatMap(([action, token]) => from(this.terraCohortsService.publishEvent(action.createEvent, token)).pipe(map(res => {
            const tempres = res;
            const createEventDate = Object.assign({}, action.createEvent);
            if (!!createEventDate.zoomLink &&
                !createEventDate.description.includes('terra.do/#/join')) {
                createEventDate.description =
                    createEventDate.description +
                        '\n' +
                        createEventDate.eventLink +
                        tempres.eventId;
            }
            createEventDate.eventId = tempres.eventId;
            //console.log(createEventDate);
            return createEventDate;
        }), catchError(error => {
            if (error.status === 401) {
                this.authStore.logout();
            }
            else if (error.status === 504 ||
                error.status === 503 ||
                error.status === 400 ||
                error.status === 500) {
                this.message.showMsg({
                    icon: 'close-circle-outline',
                    title1: 'Error!',
                    title2: 'Something went wrong. Please try again!',
                    type: 'error',
                });
            }
            return throwError(error.error);
        }))), filter(data => !!data), tap(action => {
            this.message.showMsg({
                icon: 'checkmark-circle-outline',
                title1: 'Published!',
                title2: 'Event successfully published',
            });
        }), map((createdEvent) => {
            return storePublishedEvent({ createdEvent });
        })));
        this.updateEvent = createEffect(() => this.actions.pipe(ofType(updateEvent), withLatestFrom(this.authStore.firebaseToken$), concatMap(([action, token]) => from(this.terraCohortsService.updateEvent(action.updateEvent, action.eventId, token)).pipe(map(res => {
            return action.updateEvent;
        }), catchError(error => {
            if (error.status === 401) {
                this.authStore.logout();
            }
            else if (error.status === 504 ||
                error.status === 503 ||
                error.status === 400 ||
                error.status === 500) {
                this.message.showMsg({
                    icon: 'close-circle-outline',
                    title1: 'Error!',
                    title2: 'Please try again!',
                    type: 'error',
                });
            }
            return throwError(error.error);
        }))), filter(data => !!data), tap(action => {
            this.message.showMsg({
                icon: 'checkmark-circle-outline',
                title1: 'Updated!',
                title2: 'Event successfully updated',
            });
        }), map((updateEventData) => {
            return updatePublishedEvent({ updateEventData });
        })));
        this.zoomAttendace = createEffect(() => this.actions.pipe(ofType(zoomAttendace), withLatestFrom(this.authStore.firebaseToken$), concatMap(([action, token]) => from(this.terraCohortsService.zoomAttendance(action.eventId, action.eventType, token)).pipe(map((res) => {
            this.vyasService.openZoomLinkLog(res.data, '_self');
            return res.zoomLink;
        }), catchError(error => {
            if (error.status === 401) {
                this.authStore.logout();
            }
            else if (error.status === 504 || error.status === 503) {
                this.message.showMsg({
                    icon: 'close-circle-outline',
                    title1: 'Error!',
                    title2: 'Please try again!',
                    type: 'error',
                });
            }
            else if (error.status === 404) {
                this.message.showMsg({
                    icon: 'close-circle-outline',
                    title1: 'Event Not found!',
                    title2: 'Calendar event not found!',
                    type: 'error',
                });
            }
            return throwError(error.error);
        }))), map((zoomLink) => attendanceAdded({ zoomLink }))));
        this.recordingAttendace = createEffect(() => this.actions.pipe(ofType(recordingAttendace), withLatestFrom(this.authStore.firebaseToken$), concatMap(([action, token]) => from(this.terraCohortsService.zoomAttendance(action.eventId, action.eventType, token)).pipe(map((res) => {
            this.vyasService.openRecordingLink(res.data, '_self');
            return res.data.recordingLink;
        }), catchError(error => {
            if (error.status === 401) {
                this.authStore.logout();
            }
            else if (error.status === 504 || error.status === 503) {
                this.message.showMsg({
                    icon: 'close-circle-outline',
                    title1: 'Error!',
                    title2: 'Please try again!',
                    type: 'error',
                });
            }
            else if (error.status === 404) {
                this.message.showMsg({
                    icon: 'close-circle-outline',
                    title1: 'Event Not found!',
                    title2: 'Calendar event not found!',
                    type: 'error',
                });
            }
            return throwError(error.error);
        }))), map((zoomLink) => attendanceAdded({ zoomLink }))));
        this.deleteEventClick = createEffect(() => this.actions.pipe(ofType(deleteEventClick), withLatestFrom(this.authStore.firebaseToken$), concatMap(([action, token]) => from(this.terraCohortsService.deleteEvent(action.eventData, token)).pipe(map(res => {
            return action.eventData;
        }), catchError(error => {
            if (error.status === 401) {
                this.authStore.logout();
            }
            else if (error.status === 504 ||
                error.status === 503 ||
                error.status === 400 ||
                error.status === 500) {
                this.message.showMsg({
                    icon: 'close-circle-outline',
                    title1: 'Error!',
                    title2: 'Please try again!',
                    type: 'error',
                });
            }
            else if (error.status === 410) {
                this.message.showMsg({
                    icon: 'close-circle-outline',
                    title1: 'Error!',
                    title2: 'Resource has been deleted!',
                    type: 'error',
                });
            }
            return throwError(error.error);
        }))), filter(data => !!data), tap(action => {
            this.message.showMsg({
                icon: 'checkmark-circle-outline',
                title1: 'Deleted!',
                title2: 'Event successfully deleted',
            });
        }), map((eventData) => deleteEventClickEffect({ eventData }))));
        this.loadDashboard = createEffect(() => this.actions.pipe(ofType(loadDashboard), withLatestFrom(this.authStore.user$, this.authStore.firebaseToken$), concatMap(([action, user, token]) => 
        // this.store.pipe(select(selectAllCohorts))
        this.vyasService.getFullCohortsDetailsByEmail(action.id, user === null || user === void 0 ? void 0 : user.email, token)), map(cohorts => {
            if (!(cohorts.length > 0)) {
                console.log('cohorts', cohorts);
                let temp = [];
                temp.push(cohorts);
                return temp;
            }
            return cohorts;
        }), filter((cohorts) => {
            console.log(cohorts);
            if (cohorts.length > 0) {
                return cohorts;
            }
            else {
                //this.router.navigate(['/no-data-found']);
            }
        }), map((cohorts) => {
            console.log("line 315 calendar Effects", cohorts);
            this.store.dispatch(allCohortsLoaded({ cohorts }));
            this.store.dispatch(allAssignmentLoaded({
                assignments: [
                    ...cohorts.map(co => {
                        return {
                            course: co.course,
                            classDetail: co.modules,
                            //assignments: co.assignments,
                            cohortId: co.cohortId,
                            classLoaded: true,
                            activeSegment: 'schedule',
                        };
                    }),
                ],
            }));
            this.store.dispatch(allEventsLoaded({
                events: [
                    ...cohorts.map(co => {
                        const newEvents = {};
                        //console.log(co)
                        for (const ev of co.events) {
                            if (ev[0] === 'announcement') {
                                newEvents.announcements = ev[1];
                            }
                            if (ev[0] === 'class') {
                                newEvents.classes = ev[1];
                            }
                            if (ev[0] === 'webinar') {
                                newEvents.webinars = ev[1];
                            }
                            if (ev[0] === 'assignment') {
                                newEvents.assignments = ev[1];
                            }
                            if (ev[0] === 'office-hours') {
                                newEvents.officeHours = ev[1];
                            }
                        }
                        return {
                            course: co.course,
                            cohortId: co.cohortId,
                            activeSegment: 'upcoming',
                            events: Object.assign({}, newEvents),
                        };
                    }),
                ],
            }));
            return dashboardLoaded({ cohorts });
        })));
    }
}
CalendarEffects.ɵfac = function CalendarEffects_Factory(t) { return new (t || CalendarEffects)(ɵɵinject(Actions), ɵɵinject(TerraCohortsService), ɵɵinject(AuthStoreService), ɵɵinject(Store), ɵɵinject(AngularFireAuth), ɵɵinject(MessagesService), ɵɵinject(Router), ɵɵinject(TerraVyasService)); };
CalendarEffects.ɵprov = ɵɵdefineInjectable({ token: CalendarEffects, factory: CalendarEffects.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CalendarEffects, [{
        type: Injectable
    }], function () { return [{ type: Actions }, { type: TerraCohortsService }, { type: AuthStoreService }, { type: Store }, { type: AngularFireAuth }, { type: MessagesService }, { type: Router }, { type: TerraVyasService }]; }, null); })();

const initialDashboardState = {
    cohortsLoaded: false,
    eventsLoaded: false,
    assignmentsLoaded: false,
    fullDashboardLoaded: false,
    otherAssignmentAPI: false,
    cohorts: [],
    events: [],
    assignments: [],
    activeCourse: 0,
    assignmentDetail: [],
};
const terraCalendarReducer = createReducer(initialDashboardState, on(calendarSegmentSelected, (state, action) => {
    return Object.assign(Object.assign({}, state), { events: state.events.map(event => {
            if (event) {
                return Object.assign(Object.assign({}, event), { activeSegment: action.calendarSegment });
            }
        }) });
}), on(filteredCriteriaClick, (state, action) => {
    return Object.assign(Object.assign({}, state), { calendarFilterCriteria: action.calendarFilterCriteria });
}), on(storePublishedEvent, (state, action) => {
    return Object.assign(Object.assign({}, state), { events: [
            ...state.events.map(event => {
                if (event.cohortId === action.createdEvent.cohortId) {
                    const overrideValue = {};
                    if (action.createdEvent.type === 'announcement') {
                        overrideValue.announcements = [
                            ...event.events.announcements,
                            action.createdEvent,
                        ];
                    }
                    else if (action.createdEvent.type === 'office-hours') {
                        overrideValue.officeHours = [
                            ...event.events.officeHours,
                            action.createdEvent,
                        ];
                    }
                    else if (action.createdEvent.type === 'assignment') {
                        overrideValue.assignments = [
                            ...event.events.assignments,
                            action.createdEvent,
                        ];
                    }
                    else if (action.createdEvent.type === 'webinar') {
                        overrideValue.webinars = [
                            ...event.events.webinars,
                            action.createdEvent,
                        ];
                    }
                    else if (action.createdEvent.type === 'class') {
                        overrideValue.classes = [
                            ...event.events.classes,
                            action.createdEvent,
                        ];
                    }
                    return Object.assign(Object.assign({}, event), { events: Object.assign(Object.assign({}, event.events), overrideValue) });
                }
                else {
                    return event;
                }
            }),
        ] });
}), on(updatePublishedEvent, (state, action) => {
    return Object.assign(Object.assign({}, state), { events: [
            ...state.events.map(event => {
                if (event.cohortId === action.updateEventData.cohortId) {
                    const overrideValue = {};
                    if (action.updateEventData.type === 'announcement') {
                        overrideValue.announcements = [
                            ...event.events.announcements.map(ann => {
                                const annData = Object.assign({}, ann);
                                if (annData.eventId === action.updateEventData.eventId) {
                                    return action.updateEventData;
                                }
                                else {
                                    return Object.assign({}, annData);
                                }
                            }),
                        ];
                    }
                    else if (action.updateEventData.type === 'office-hours') {
                        overrideValue.officeHours = [
                            ...event.events.officeHours.map(ann => {
                                const annData = Object.assign({}, ann);
                                if (annData.eventId === action.updateEventData.eventId) {
                                    return Object.assign({}, action.updateEventData);
                                }
                                else {
                                    return Object.assign({}, annData);
                                }
                            }),
                        ];
                    }
                    else if (action.updateEventData.type === 'assignment') {
                        overrideValue.assignments = [
                            ...event.events.assignments.map(ann => {
                                const annData = Object.assign({}, ann);
                                if (annData.eventId === action.updateEventData.eventId) {
                                    return Object.assign({}, action.updateEventData);
                                }
                                else {
                                    return Object.assign({}, annData);
                                }
                            }),
                        ];
                    }
                    else if (action.updateEventData.type === 'webinar') {
                        overrideValue.webinars = [
                            ...event.events.webinars.map(ann => {
                                const annData = Object.assign({}, ann);
                                if (annData.eventId === action.updateEventData.eventId) {
                                    return Object.assign({}, action.updateEventData);
                                }
                                else {
                                    return Object.assign({}, annData);
                                }
                            }),
                        ];
                    }
                    else if (action.updateEventData.type === 'class') {
                        overrideValue.classes = [
                            ...event.events.classes.map(ann => {
                                const annData = Object.assign({}, ann);
                                if (annData.eventId === action.updateEventData.eventId) {
                                    return Object.assign({}, action.updateEventData);
                                }
                                else {
                                    return Object.assign({}, annData);
                                }
                            }),
                        ];
                    }
                    return Object.assign(Object.assign({}, event), { events: Object.assign(Object.assign({}, event.events), overrideValue) });
                }
                else {
                    return event;
                }
            }),
        ] });
}), on(deleteEventClickEffect, (state, action) => {
    return Object.assign(Object.assign({}, state), { events: [
            ...state.events.map(event => {
                if (event.cohortId === action.eventData.cohortId) {
                    const overrideValue = {};
                    if (action.eventData.type === 'announcement') {
                        const index = event.events.announcements.findIndex(x => x.eventId === action.eventData.eventId);
                        const announcement = [...event.events.announcements];
                        if (index > -1) {
                            announcement.splice(index, 1);
                            overrideValue.announcements = [...announcement];
                        }
                    }
                    else if (action.eventData.type === 'office-hours') {
                        const index = event.events.officeHours.findIndex(x => x.eventId === action.eventData.eventId);
                        const ohours = [...event.events.officeHours];
                        if (index > -1) {
                            ohours.splice(index, 1);
                            overrideValue.officeHours = [...ohours];
                        }
                    }
                    else if (action.eventData.type === 'assignment') {
                        const index = event.events.assignments.findIndex(x => x.eventId === action.eventData.eventId);
                        const assignments = [...event.events.assignments];
                        if (index > -1) {
                            assignments.splice(index, 1);
                            overrideValue.assignments = [...assignments];
                        }
                    }
                    else if (action.eventData.type === 'webinar') {
                        const index = event.events.webinars.findIndex(x => x.eventId === action.eventData.eventId);
                        const webinars = [...event.events.webinars];
                        if (index > -1) {
                            webinars.splice(index, 1);
                            overrideValue.webinars = [...webinars];
                        }
                    }
                    else if (action.eventData.type === 'class') {
                        const index = event.events.classes.findIndex(x => x.eventId === action.eventData.eventId);
                        const classes = [...event.events.webinars];
                        if (index > -1) {
                            classes.splice(index, 1);
                            overrideValue.classes = [...classes];
                        }
                    }
                    return Object.assign(Object.assign({}, event), { events: Object.assign(Object.assign({}, event.events), overrideValue) });
                }
                else {
                    return event;
                }
            }),
        ] });
}), on(allEventsLoaded, (state, action) => {
    return Object.assign(Object.assign({}, state), { events: action.events, eventsLoaded: true });
}), on(allAssignmentLoaded, (state, action) => {
    const arr = [];
    action.assignments.filter(res => {
        let match = {};
        try {
            match = state.assignments.filter(sa => sa.cohortId === res.cohortId)[0];
        }
        catch (e) { }
        arr.push(Object.assign(Object.assign({}, res), match));
    });
    return Object.assign(Object.assign({}, state), { assignments: arr, assignmentsLoaded: true });
}), on(allCohortsLoaded, (state, action) => {
    return Object.assign(Object.assign({}, state), { cohorts: action.cohorts, cohortsLoaded: true });
}));
// export const { selectAll } = adapter.getSelectors();

class TerraUiCalendarModule {
}
TerraUiCalendarModule.ɵmod = ɵɵdefineNgModule({ type: TerraUiCalendarModule });
TerraUiCalendarModule.ɵinj = ɵɵdefineInjector({ factory: function TerraUiCalendarModule_Factory(t) { return new (t || TerraUiCalendarModule)(); }, providers: [AddToCalendarService], imports: [[
            CommonModule,
            UtilLibModule,
            CloudinaryModule.forRoot({ Cloudinary }, {
                cloud_name: 'terra-do',
            }),
            CalendarEventsModule,
            FilterComponentModule,
            StoreModule.forFeature('terraCalendar', terraCalendarReducer),
            EffectsModule.forFeature([CalendarEffects]),
            CommonModule,
            FormsModule,
            IonicModule,
            ReactiveFormsModule,
            HttpClientModule,
            HttpClientJsonpModule,
            CalendarEventDetailModule,
            MbscModule,
            ManageCalendarEventModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(TerraUiCalendarModule, { declarations: [TerraUiCalendarComponent], imports: [CommonModule,
        UtilLibModule, CloudinaryModule, CalendarEventsModule,
        FilterComponentModule, StoreFeatureModule, EffectsFeatureModule, CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        HttpClientModule,
        HttpClientJsonpModule,
        CalendarEventDetailModule,
        MbscModule,
        ManageCalendarEventModule], exports: [TerraUiCalendarComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(TerraUiCalendarModule, [{
        type: NgModule,
        args: [{
                declarations: [TerraUiCalendarComponent],
                imports: [
                    CommonModule,
                    UtilLibModule,
                    CloudinaryModule.forRoot({ Cloudinary }, {
                        cloud_name: 'terra-do',
                    }),
                    CalendarEventsModule,
                    FilterComponentModule,
                    StoreModule.forFeature('terraCalendar', terraCalendarReducer),
                    EffectsModule.forFeature([CalendarEffects]),
                    CommonModule,
                    FormsModule,
                    IonicModule,
                    ReactiveFormsModule,
                    HttpClientModule,
                    HttpClientJsonpModule,
                    CalendarEventDetailModule,
                    MbscModule,
                    ManageCalendarEventModule,
                ],
                entryComponents: [AddToCalendarService],
                exports: [TerraUiCalendarComponent],
                providers: [AddToCalendarService]
            }]
    }], null, null); })();

class TerraJoinService {
    constructor(auth, http, terraCohortsService, message) {
        this.auth = auth;
        this.http = http;
        this.terraCohortsService = terraCohortsService;
        this.message = message;
        this.COHORT_URL = this.terraCohortsService.COHORT_URL;
        this.auth.firebaseToken$.subscribe(token => this.token = token);
    }
    handleJoin(id, event) {
        // if (!!id && window.location.href.toString().includes('course-event')) {
        // 	this.zoomAttendance(id,'course-event',this.token)
        // }
        // if (!!id && window.location.href.toString().includes('public-event')) {
        // 	this.auth.isLoggedOut$.subscribe(loggedOut => {
        // 		if (!!loggedOut) {
        // 			window.open('https://my.terra.do');
        // 		} else {
        // 			this.zoomAttendance(id,'public-event',this.token)
        // 		}
        // 	});
        // }
        // if (!!id && window.location.href.toString().includes('view-recording')) {
        // 	this.auth.isLoggedOut$.subscribe(loggedOut => {
        // 		if (!!loggedOut) {
        // 			window.open('https://my.terra.do');
        // 		} else {
        // 			this.zoomAttendance(id,'view-recording',this.token)
        // 		}
        // 	});
        // }
        combineLatest$1([this.auth.firebaseToken$, this.auth.isLoggedOut$]).subscribe(([token, loggedOut]) => {
            if (event.includes('course-event')) {
                this.zoomAttendance(id, event, token);
                return;
            }
            if (!!loggedOut) {
                window.open('https://my.terra.do');
            }
            else {
                this.zoomAttendance(id, event, token);
            }
        });
    }
    zoomAttendance(eventId, eventType, accessToken) {
        console.log("i am zoom attenDance", eventId, eventType, accessToken);
        this.http
            .get(`https://terra-api.terra.do/dev/cohortdev/join/${eventType}/${eventId}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + accessToken,
            }),
        }).pipe(first(), catchError(error => {
            // if(!window.location.href.includes('join')){
            // 	return
            // }
            console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@", error);
            if (error.status === 401) {
            }
            else if (error.status === 504 || error.status === 503) {
                this.message.showMsg({
                    icon: 'close-circle-outline',
                    title1: 'Error!',
                    title2: 'Please try again!',
                    type: 'error',
                });
            }
            else if (error.status === 400) {
                this.message.showMsg({
                    icon: 'close-circle-outline',
                    title1: 'Error!',
                    title2: 'The event is yet to begin',
                    type: 'error',
                });
            }
            else if (error.status === 404) {
                this.message.showMsg({
                    icon: 'close-circle-outline',
                    title1: 'Event error!',
                    title2: error.error,
                    type: 'error',
                });
            }
            return throwError$1(error.error);
        })).subscribe(data => {
            console.log(" i am join response", data);
            let temp = data;
            if (temp === null || temp === void 0 ? void 0 : temp.zoomLink) {
                window.open(temp.zoomLink, '_self');
            }
            if (temp === null || temp === void 0 ? void 0 : temp.recordingLink) {
                window.open(temp.recordingLink, '_self');
            }
            else {
                let error = data;
                //return throw(error.error);
                throw (error);
            }
        });
    }
}
TerraJoinService.ɵfac = function TerraJoinService_Factory(t) { return new (t || TerraJoinService)(ɵɵinject(AuthStoreService), ɵɵinject(HttpClient), ɵɵinject(TerraCohortsService), ɵɵinject(MessagesService)); };
TerraJoinService.ɵprov = ɵɵdefineInjectable({ token: TerraJoinService, factory: TerraJoinService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TerraJoinService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: AuthStoreService }, { type: HttpClient }, { type: TerraCohortsService }, { type: MessagesService }]; }, null); })();

/*
 * Public API Surface of terra-ui
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AddMediaService, AddToCalendarService, ApplicationUiComponent, ApplicationUiModule, AutocompleteComponent, AutocompleteLibComponent, AutocompleteLibModule, BannerComponent, FilterPipe$1 as FilterPipe, FooterComponent, GooglePlacesComponent, GooglePlacesComponentModule, HeaderComponent, HighlightPipe, InviteMemberComponent, MenuUIService, PeopleNoteEffects, PeopleNoteFormComponent, PeopleNoteFormModule, PeopleNoteService, PeopleNoteViewComponent, PeopleNoteViewModule, PeopleService, PeopleTagComponent, PeopleTagsComponentModule, PopoverContentComponent, PopoverModule, PopoverPlacement, SelectionComponent$1 as SelectionComponent, SelectionComponentModule$1 as SelectionComponentModule, TagSliderComponent, TagSliderComponentModule, TerraAddMediaComponent, TerraAddMediaPageModule, TerraJoinService, TerraPopoverDirective, TerraUIComponent, TerraUIModule, TerraUIService, TerraUiCalendarComponent, TerraUiCalendarModule, activeProfile, addProfileMedia, addSearchFilter, clearNote, commonFileUpload, commonFileUploadSuccess, companiesLoaded, deleteFileForProfile, deleteNote, deleteProfileMedia, editProfileMedia, fieldsSearchChange, fieldsSearchChangeGotResults, fileUploadForProfile, fileUploadForProfileSuccess, initialProfileNoteState, initialProfileState, lastProfileSearch, loadCompanies, loadDefaultTags, loadDefaultTagsLoaded, loadProfileCompaniesFilter, loadProfileObservation, loadSearchFilter, loadedProfileObservation, overrideSearchFilter, peopleCollectionLoaded, peopleLoaderDisabled, peopleLoaderEnable, peopleNoteReducer, profileClick, resetPeople, resetSearchFilter, resetSearchFilters, searchFilterLoaded, searchProfiles, selectAllCollectionsFilters, selectCommonImageUploadPath, selectLastProfileSearch, selectPeopleNoteState, selectPeopleV2Filter, selectPeopleV2FilterSearch, selectProfileDetail, selectProfileObservations, selectSearchFilters, selectSearchFiltersWithText, selectSearchHasFilters };
//# sourceMappingURL=terra-ui.js.map
